// Auto-generated from C:/Users/Admin/Downloads/en.csv and cn.csv.
// Do not edit by hand; regenerate from the CSV files when spell data changes.

export const GENERATED_SPELL_ID_TRANSLATIONS: Record<number, string> = {
  "4": "召回他人之语",
  "5": "死亡之触",
  "7": "自杀",
  "11": "上古寒冰箭",
  "17": "真言术：盾",
  "25": "昏迷",
  "27": "闪金镇传送门",
  "31": "传送：闪金镇",
  "34": "传送：暮色森林",
  "35": "传送：艾尔文森林",
  "53": "背刺",
  "66": "隐形术",
  "71": "先锋",
  "75": "自动射击",
  "99": "夺魂咆哮",
  "100": "冲锋",
  "116": "寒冰箭",
  "118": "变形术",
  "120": "冰锥术",
  "122": "冰霜新星",
  "126": "基尔罗格之眼",
  "130": "缓落术",
  "133": "火球术",
  "136": "治疗宠物",
  "139": "恢复",
  "172": "腐蚀术",
  "339": "纠缠根须",
  "348": "献祭",
  "355": "嘲讽",
  "370": "净化术",
  "379": "大地之盾",
  "408": "肾击",
  "453": "安抚心灵",
  "465": "虔诚光环",
  "467": "荆棘术",
  "475": "解除诅咒",
  "498": "圣佑术",
  "527": "纯净术",
  "528": "驱散魔法",
  "546": "水上行走",
  "556": "星界传送",
  "585": "惩击",
  "586": "渐隐术",
  "589": "暗言术：痛",
  "596": "治疗祷言",
  "603": "末日降临",
  "605": "精神控制",
  "633": "圣疗术",
  "642": "圣盾术",
  "686": "暗影箭",
  "688": "召唤小鬼",
  "691": "召唤地狱猎犬",
  "697": "召唤虚空行者",
  "698": "召唤仪式",
  "702": "虚弱诅咒",
  "703": "锁喉",
  "710": "放逐术",
  "712": "召唤魅魔",
  "740": "宁静",
  "755": "生命通道",
  "759": "制造法力宝石",
  "768": "猎豹形态",
  "772": "撕裂",
  "774": "回春术",
  "781": "逃脱",
  "783": "旅行形态",
  "845": "顺劈斩",
  "853": "制裁之锤",
  "871": "盾墙",
  "883": "召唤宠物 1",
  "921": "搜索",
  "974": "大地之盾",
  "980": "痛楚",
  "982": "复活宠物",
  "1022": "保护祝福",
  "1044": "自由祝福",
  "1064": "治疗链",
  "1079": "割裂",
  "1098": "征服恶魔",
  "1122": "召唤地狱火",
  "1126": "野性印记",
  "1130": "猎人印记",
  "1160": "挫志怒吼",
  "1161": "挑战怒吼",
  "1329": "毁伤",
  "1449": "魔爆术",
  "1454": "生命分流",
  "1459": "奥术智慧",
  "1462": "野兽知识",
  "1463": "咒术洪流",
  "1464": "猛击",
  "1490": "混乱烙印",
  "1494": "追踪野兽",
  "1513": "恐吓野兽",
  "1515": "驯服野兽",
  "1543": "照明弹",
  "1680": "旋风斩",
  "1706": "漂浮术",
  "1714": "语言诅咒",
  "1715": "断筋",
  "1719": "鲁莽",
  "1725": "扰乱",
  "1752": "影袭",
  "1766": "脚踢",
  "1776": "凿击",
  "1784": "潜行",
  "1804": "开锁",
  "1822": "斜掠",
  "1833": "偷袭",
  "1850": "急奔",
  "1856": "消失",
  "1943": "割裂",
  "1949": "地狱烈焰",
  "1953": "闪现术",
  "1966": "佯攻",
  "2006": "复活术",
  "2008": "先祖之魂",
  "2050": "圣言术：静",
  "2060": "治疗术",
  "2061": "快速治疗",
  "2094": "致盲",
  "2096": "心灵视界",
  "2098": "斩击",
  "2120": "烈焰风暴",
  "2139": "法术反制",
  "2484": "地缚图腾",
  "2565": "盾牌格挡",
  "2637": "休眠",
  "2641": "解散宠物",
  "2643": "多重射击",
  "2645": "幽魂之狼",
  "2782": "清除腐蚀",
  "2812": "谴责",
  "2818": "夺命药膏",
  "2823": "夺命药膏",
  "2825": "嗜血",
  "2908": "安抚",
  "2948": "灼烧",
  "2983": "疾跑",
  "3110": "火焰箭",
  "3127": "招架",
  "3176": "强力巨魔之血药剂",
  "3177": "防御药剂",
  "3365": "开启",
  "3366": "开启",
  "3368": "喝下初级药水",
  "3369": "力量药水 II",
  "3370": "鳄鱼肉排",
  "3408": "减速药膏",
  "3411": "援护",
  "3594": "暗影之油",
  "3595": "冰霜之油",
  "3599": "灼热图腾",
  "3714": "冰霜之路",
  "3716": "吞噬之影",
  "3847": "红色毛纺靴",
  "4987": "清洁术",
  "5116": "震荡射击",
  "5143": "奥术飞弹",
  "5171": "切割",
  "5176": "愤怒",
  "5211": "蛮力猛击",
  "5215": "潜行",
  "5217": "猛虎之怒",
  "5221": "撕碎",
  "5246": "破胆怒吼",
  "5277": "闪避",
  "5302": "复仇！",
  "5308": "斩杀",
  "5374": "毁伤",
  "5384": "假死",
  "5394": "治疗之泉图腾",
  "5405": "补充法力",
  "5484": "恐惧嚎叫",
  "5487": "熊形态",
  "5502": "感知亡灵",
  "5697": "无尽呼吸",
  "5740": "火焰之雨",
  "5761": "迟钝药膏",
  "5782": "恐惧",
  "5784": "地狱战马",
  "5938": "毒刃",
  "6196": "视界术",
  "6197": "鹰眼术",
  "6201": "制造治疗石",
  "6203": "灵魂石",
  "6262": "治疗石",
  "6343": "雷霆一击",
  "6353": "灵魂之火",
  "6544": "英勇飞跃",
  "6552": "拳击",
  "6572": "复仇",
  "6673": "战斗怒吼",
  "6770": "闷棍",
  "6789": "死亡缠绕",
  "6795": "低吼",
  "6807": "重殴",
  "6940": "牺牲祝福",
  "6991": "喂养宠物",
  "7268": "奥术飞弹",
  "7328": "救赎",
  "7384": "压制",
  "7744": "被遗忘者的意志",
  "7814": "剧痛鞭笞",
  "8004": "治疗之涌",
  "8042": "大地震击",
  "8092": "心灵震爆",
  "8122": "心灵尖啸",
  "8143": "战栗图腾",
  "8190": "熔岩图腾",
  "8512": "风怒图腾",
  "8647": "玄秘掌",
  "8676": "伏击",
  "8679": "致伤药膏",
  "8737": "锁甲",
  "8921": "月火术",
  "8936": "愈合",
  "9484": "束缚恐惧",
  "9512": "恢复能量",
  "10060": "能量灌注",
  "10326": "超度邪恶",
  "10444": "火舌攻击",
  "10658": "元素制皮",
  "11327": "消失",
  "11366": "炎爆术",
  "11426": "寒冰护体",
  "12042": "奥术强化",
  "12051": "唤醒",
  "12294": "致死打击",
  "12323": "刺耳怒吼",
  "12472": "冰冷血脉",
  "12654": "点燃",
  "12805": "采集海潮之池样本#2",
  "12950": "强化旋风斩",
  "12975": "破釜沉舟",
  "13750": "冲动",
  "13809": "冰霜陷阱",
  "13813": "爆炸陷阱",
  "13877": "剑刃乱舞",
  "14161": "无情",
  "14189": "封印命运",
  "14190": "封印命运",
  "14914": "神圣之火",
  "14983": "精力",
  "15286": "吸血鬼的拥抱",
  "15407": "精神鞭笞",
  "15487": "沉默",
  "16166": "元素宗师",
  "16191": "法力之潮图腾",
  "16196": "复苏",
  "16511": "出血",
  "16827": "爪击",
  "16864": "清晰预兆",
  "16870": "节能施法",
  "16914": "飓风",
  "16931": "厚皮",
  "16953": "原始狂怒",
  "16979": "野性冲锋",
  "17253": "撕咬",
  "17364": "风暴打击",
  "17877": "暗影灼烧",
  "17941": "痛楚",
  "17962": "燃烧",
  "18499": "狂暴之怒",
  "18540": "召唤末日守卫",
  "18562": "迅捷治愈",
  "18960": "传送：月光林地",
  "19236": "绝望祷言",
  "19263": "威慑",
  "19386": "翼龙钉刺",
  "19387": "诱捕",
  "19434": "瞄准射击",
  "19574": "狂野怒火",
  "19577": "胁迫",
  "19750": "圣光闪现",
  "19801": "宁神射击",
  "19878": "追踪恶魔",
  "19879": "追踪龙类",
  "19880": "追踪元素生物",
  "19882": "追踪巨人",
  "19883": "追踪人型生物",
  "19884": "追踪亡灵",
  "19885": "追踪隐藏生物",
  "20066": "忏悔",
  "20153": "献祭",
  "20243": "毁灭打击",
  "20271": "审判",
  "20473": "神圣震击",
  "20484": "复生",
  "20549": "战争践踏",
  "20572": "血性狂怒",
  "20577": "食尸",
  "20589": "逃命专家",
  "20594": "石像形态",
  "20608": "复生",
  "20707": "灵魂石",
  "20736": "扰乱射击",
  "20925": "圣洁护盾",
  "21169": "复生",
  "21562": "真言术：韧",
  "22482": "剑刃乱舞",
  "22568": "凶猛撕咬",
  "22570": "割碎",
  "22703": "地狱火觉醒",
  "22812": "树皮术",
  "22842": "狂暴回复",
  "23161": "恐惧战马",
  "23881": "嗜血",
  "23920": "法术反射",
  "23922": "盾牌猛击",
  "24275": "愤怒之锤",
  "24858": "枭兽形态",
  "25046": "奥术洪流",
  "25504": "风怒攻击",
  "25780": "正义之怒",
  "25912": "神圣震击",
  "25914": "神圣震击",
  "26297": "狂暴",
  "26573": "奉献",
  "26679": "致命投掷",
  "27243": "腐蚀之种",
  "27285": "腐蚀之种",
  "27576": "毁伤",
  "27827": "救赎之魂",
  "28271": "变形术",
  "28272": "变形术",
  "28726": "梦魇草",
  "28730": "奥术洪流",
  "28880": "纳鲁的赐福",
  "29166": "激活",
  "29341": "暗影灼烧",
  "29722": "烧尽",
  "29725": "猝死",
  "29838": "复苏之风",
  "29858": "灵魂碎裂",
  "29893": "制造灵魂之井",
  "30108": "痛苦无常",
  "30146": "召唤恶魔卫士",
  "30153": "追杀",
  "30213": "军团打击",
  "30283": "暗影之怒",
  "30449": "法术吸取",
  "30451": "奥术冲击",
  "30455": "冰枪术",
  "30884": "自然守护者",
  "31117": "痛苦无常",
  "31224": "暗影斗篷",
  "31230": "装死",
  "31589": "减速",
  "31616": "自然守护者",
  "31661": "龙息术",
  "31687": "召唤水元素",
  "31707": "水箭",
  "31789": "正义防御",
  "31821": "光环掌握",
  "31850": "炽热防御者",
  "31884": "复仇之怒",
  "31935": "复仇者之盾",
  "32175": "风暴打击",
  "32176": "副手风暴打击",
  "32182": "英勇",
  "32223": "十字军光环",
  "32375": "群体驱散",
  "32379": "暗言术：灭",
  "32390": "暗影之拥",
  "32546": "联结治疗",
  "32612": "隐形术",
  "32645": "毒伤",
  "33076": "愈合祷言",
  "33110": "愈合祷言",
  "33206": "痛苦压制",
  "33395": "冰冻术",
  "33697": "血性狂怒",
  "33702": "血性狂怒",
  "33757": "风怒武器",
  "33763": "生命绽放",
  "33778": "生命绽放",
  "33786": "旋风",
  "33873": "治愈本能",
  "33891": "化身：生命之树",
  "33917": "裂伤",
  "34026": "杀戮命令",
  "34428": "乘胜追击",
  "34433": "暗影魔",
  "34477": "误导",
  "34650": "法力吸取",
  "34861": "圣言术：灵",
  "34914": "吸血鬼之触",
  "35079": "误导",
  "35395": "十字军打击",
  "35546": "索命强能",
  "35551": "索命强能",
  "36032": "奥术充能",
  "36554": "暗影步",
  "37111": "火球术",
  "37506": "驱散射击",
  "41635": "愈合祷言",
  "42223": "火焰之雨",
  "42650": "亡者大军",
  "42651": "亡者大军",
  "42955": "造餐术",
  "43265": "枯萎凋零",
  "44425": "奥术弹幕",
  "44457": "活动炸弹",
  "44461": "活动炸弹",
  "44544": "寒冰指",
  "44614": "冰风暴",
  "44949": "副手旋风斩",
  "45284": "闪电箭过载",
  "45297": "闪电链过载",
  "45438": "寒冰屏障",
  "45470": "灵界打击",
  "45524": "寒冰锁链",
  "45902": "鲜血打击",
  "46584": "亡者复生",
  "46585": "亡者复生",
  "46917": "泰坦之握",
  "46924": "剑刃风暴",
  "46968": "震荡波",
  "47476": "绞袭",
  "47515": "神圣庇护",
  "47528": "心灵冰冻",
  "47540": "苦修",
  "47541": "凋零缠绕",
  "47568": "符文武器增效",
  "47585": "消散",
  "47632": "凋零缠绕",
  "47666": "苦修",
  "47750": "苦修",
  "47755": "护盾戒律",
  "47788": "守护之魂",
  "48018": "恶魔法阵",
  "48020": "恶魔法阵：传送",
  "48107": "热力迸发",
  "48108": "炽热连击！",
  "48153": "守护之魂",
  "48181": "鬼影缠身",
  "48263": "三战老兵",
  "48265": "死亡脚步",
  "48438": "野性成长",
  "48484": "感染伤口",
  "48517": "日蚀",
  "48518": "月蚀",
  "48707": "反魔法护罩",
  "48743": "天灾契约",
  "48792": "冰封之韧",
  "49020": "湮灭",
  "49028": "符文刃舞",
  "49039": "巫妖之躯",
  "49088": "反魔法护罩",
  "49143": "冰霜打击",
  "49184": "凛风冲击",
  "49206": "召唤石像鬼",
  "49376": "野性冲锋",
  "49530": "末日突降",
  "49576": "死亡之握",
  "49966": "拍击",
  "49998": "灵界打击",
  "50198": "魔法燃烧",
  "50259": "眩晕",
  "50334": "狂暴",
  "50342": "合并魔像蓝图",
  "50343": "龙眠指挥官",
  "50348": "烈焰之怒",
  "50349": "冰冷触摸",
  "50353": "烈焰之怒",
  "50356": "注射疫病",
  "50357": "烈焰之怒",
  "50360": "陷阱",
  "50361": "腐烂护甲",
  "50363": "岩石护盾",
  "50364": "岩石护盾",
  "50401": "锋锐之霜",
  "50464": "滋养",
  "50613": "奥术洪流",
  "50622": "剑刃风暴",
  "50769": "起死回生",
  "50842": "血液沸腾",
  "50977": "黑锋之门",
  "51052": "反魔法领域",
  "51124": "杀戮机器",
  "51128": "杀戮机器",
  "51271": "冰霜之柱",
  "51460": "符文腐蚀",
  "51462": "符文腐蚀",
  "51485": "陷地图腾",
  "51490": "雷霆风暴",
  "51505": "熔岩爆裂",
  "51514": "妖术",
  "51533": "野性狼魂",
  "51564": "潮汐奔涌",
  "51570": "黑暗极地胸甲",
  "51572": "极地头盔",
  "51573": "巡逻",
  "51577": "哈克娅的锁链",
  "51579": "哈克娅的锁链",
  "51593": "获取始生雏龙",
  "51595": "召唤始生雏龙",
  "51599": "召唤被俘虏的步兵",
  "51601": "猛烈撞击",
  "51602": "唤醒",
  "51603": "投掷长矛",
  "51606": "伦诺克的锁链",
  "51622": "狂怒暗影",
  "51623": "索拉查卫士的心跳声",
  "51624": "格利基克的奴隶",
  "51637": "愤怒能量",
  "51690": "影舞步",
  "51723": "刀扇",
  "51886": "净化灵魂",
  "51986": "死神降临",
  "52042": "治疗之泉图腾",
  "52127": "水之护盾",
  "52128": "水之护盾",
  "52150": "亡者复生",
  "52174": "英勇飞跃",
  "52212": "枯萎凋零",
  "52437": "猝死",
  "52610": "野蛮咆哮",
  "53209": "奇美拉射击",
  "53271": "主人的召唤",
  "53343": "冰锋符文",
  "53344": "堕落十字军符文",
  "53351": "夺命射击",
  "53365": "不洁之力",
  "53376": "圣洁怒火",
  "53385": "神圣风暴",
  "53390": "潮汐奔涌",
  "53428": "符文熔铸",
  "53480": "牺牲咆哮",
  "53563": "圣光道标",
  "53576": "圣光灌注",
  "53595": "正义之锤",
  "53600": "正义盾击",
  "53652": "圣光道标",
  "54049": "暗影撕咬",
  "54149": "圣光灌注",
  "54861": "氮气推进器",
  "54968": "神圣之焰",
  "55001": "降落伞",
  "55078": "血之疫病",
  "55090": "天灾打击",
  "55095": "冰霜疫病",
  "55233": "吸血鬼之血",
  "55342": "镜像",
  "55676": "僵滞尖啸",
  "56222": "黑暗命令",
  "56244": "惊魂",
  "56246": "恶魔卫士雕文",
  "56377": "碎冰",
  "56393": "喂食雷羽鹰",
  "56488": "通用热力工程炸药",
  "56641": "稳固射击",
  "57097": "进食充分",
  "57100": "进食充分",
  "57102": "进食充分",
  "57107": "进食充分",
  "57111": "进食充分",
  "57139": "进食充分",
  "57286": "进食充分",
  "57288": "进食充分",
  "57291": "进食充分",
  "57294": "进食充分",
  "57325": "进食充分",
  "57327": "进食充分",
  "57329": "进食充分",
  "57330": "寒冬号角",
  "57332": "进食充分",
  "57334": "进食充分",
  "57356": "进食充分",
  "57358": "进食充分",
  "57360": "进食充分",
  "57365": "进食充分",
  "57367": "进食充分",
  "57371": "进食充分",
  "57399": "进食充分",
  "57755": "英勇投掷",
  "57870": "体型缩小雕文",
  "57934": "嫁祸诀窍",
  "57984": "火焰冲击",
  "57994": "风剪",
  "58081": "基尔罗格的狡诈",
  "58094": "灵魂之井雕文",
  "58099": "龟裂创伤雕文",
  "58104": "强力制胜雕文",
  "58180": "感染伤口",
  "58423": "无情打击",
  "58427": "灭绝",
  "58640": "恶鬼雕文",
  "58642": "邪恶兽群雕文",
  "58875": "幽魂步",
  "58984": "影遁",
  "59052": "白霜",
  "59224": "山丘之力",
  "59461": "被魔精浸湿",
  "59520": "水之冲击",
  "59542": "纳鲁的赐福",
  "59543": "纳鲁的赐福",
  "59544": "纳鲁的赐福",
  "59545": "纳鲁的赐福",
  "59547": "纳鲁的赐福",
  "59548": "纳鲁的赐福",
  "59752": "生存意志",
  "60103": "熔岩猛击",
  "60188": "元素之怒",
  "60229": "力量",
  "60233": "敏捷",
  "60234": "智力",
  "60478": "召唤末日守卫",
  "60513": "治疗入定",
  "61295": "激流",
  "61305": "变形术",
  "61329": "作战潜能",
  "61336": "生存本能",
  "61391": "台风",
  "61648": "变色龙守护",
  "61721": "变形术",
  "61780": "变形术",
  "61882": "地震术",
  "61999": "复活盟友",
  "62047": "制造完整的火鸡",
  "62124": "清算之手",
  "62158": "岩肤石像鬼符文",
  "62463": "雪流",
  "62464": "安全区域",
  "62465": "符文重击",
  "62618": "真言术：障",
  "63106": "生命虹吸",
  "63312": "猩红放逐雕文",
  "63560": "黑暗突变",
  "63733": "妙手回春",
  "64044": "心灵惊骇",
  "64129": "身心合一",
  "64382": "碎裂投掷",
  "64645": "冰锥术",
  "64843": "神圣赞美诗",
  "64844": "神圣赞美诗",
  "64901": "希望象征",
  "65026": "凝固汽油炸弹",
  "65072": "系在兽栏上",
  "65105": "压缩",
  "65116": "石像形态",
  "65124": "阿尔卡冯的宝库关闭警报",
  "65140": "骑乘克莉斯塔萨",
  "66196": "副手冰霜打击",
  "66198": "副手湮灭",
  "66842": "元素的召唤",
  "66843": "先祖的召唤",
  "66844": "灵魂的召唤",
  "68164": "雷霆一击雕文",
  "68992": "疾步夜行",
  "68996": "双形态",
  "69041": "火箭弹幕",
  "69046": "呼叫大胖",
  "69070": "火箭跳",
  "69179": "奥术洪流",
  "69369": "掠食者的迅捷",
  "70772": "祈福",
  "71401": "寒怒",
  "71403": "致命破绽",
  "71484": "牦牛人的蛮力",
  "71485": "维库人的迅捷",
  "71486": "牦牛人的锋芒",
  "71491": "铁矮人的专注",
  "71492": "维库人的急速",
  "71541": "寒怒",
  "71556": "维库人的迅捷",
  "71558": "牦牛人的锋芒",
  "71559": "铁矮人的专注",
  "71560": "维库人的急速",
  "71561": "牦牛人的蛮力",
  "71564": "致命精准",
  "71568": "刻不容缓",
  "71569": "强化坚韧",
  "71579": "能量动荡",
  "71584": "复苏",
  "71586": "硬化皮肤",
  "71601": "能量涌动",
  "71605": "虹吸能量",
  "71633": "皮糙肉厚",
  "71635": "达拉然的庇护",
  "71636": "虹吸能量",
  "71638": "达拉然的庇护",
  "71639": "皮糙肉厚",
  "71644": "能量涌动",
  "73325": "信仰飞跃",
  "73510": "暗影爆裂",
  "73685": "生命释放",
  "73899": "根源打击",
  "73920": "治疗之雨",
  "73921": "治疗之雨",
  "73975": "死疽打击",
  "74001": "备战就绪",
  "74221": "飓风",
  "74241": "能量洪流",
  "74645": "搜索古物",
  "74646": "搜索古物",
  "74648": "流星打击",
  "74652": "向前跳跃",
  "74653": "昏迷（永久）",
  "74655": "传送至东双塔山",
  "74656": "传送返回梦游者栖地",
  "74713": "流星打击",
  "74718": "流星打击",
  "74721": "牧绳",
  "74726": "棘刺喷射",
  "74919": "暗影导能",
  "75016": "污染的大地",
  "76577": "烟雾弹",
  "76613": "精通：冰刺",
  "76856": "精通：不羁之怒",
  "77130": "净化灵魂",
  "77215": "精通：剧痛",
  "77219": "精通：恶魔学识大师",
  "77220": "精通：混乱能量",
  "77226": "精通：深度治疗",
  "77442": "集中",
  "77443": "稳固射击",
  "77451": "熔岩爆裂过载",
  "77472": "治疗波",
  "77478": "地震术",
  "77485": "精通：圣光回响",
  "77489": "圣光回响",
  "77493": "精通：剃刀之爪",
  "77495": "精通：相生",
  "77505": "地震术",
  "77513": "精通：鲜血护盾",
  "77535": "鲜血护盾",
  "77575": "爆发",
  "77606": "黑暗模拟",
  "77758": "痛击",
  "77761": "狂奔怒吼",
  "77762": "熔岩奔腾",
  "77764": "狂奔怒吼",
  "77942": "闪电倾泻",
  "78674": "星涌术",
  "78675": "日光术",
  "79008": "飘忽不定",
  "79096": "无休锋刃",
  "79134": "剧毒创伤",
  "79140": "宿敌",
  "79206": "灵魂行者的恩赐",
  "79319": "虹吸能量",
  "79323": "解放你的思想",
  "79469": "钢皮合剂",
  "79470": "神龙心智合剂",
  "79471": "风行合剂",
  "79472": "泰坦之力合剂",
  "80240": "浩劫",
  "80313": "粉碎",
  "80353": "时间扭曲",
  "80483": "奥术洪流",
  "81099": "泰坦之握：一心狂怒",
  "81136": "赤色天灾",
  "81141": "赤色天灾",
  "81229": "符文强化",
  "81256": "符文刃舞",
  "81269": "百花齐放",
  "81297": "奉献",
  "81340": "末日突降",
  "81749": "救赎",
  "81751": "救赎",
  "81782": "真言术：障",
  "82170": "腐蚀：绝对",
  "82246": "招架",
  "82326": "圣光术",
  "82691": "冰霜之环",
  "82726": "热情",
  "83006": "吞噬魔法",
  "83242": "召唤宠物 2",
  "83243": "召唤宠物 3",
  "83244": "召唤宠物 4",
  "83245": "召唤宠物 5",
  "83381": "杀戮命令",
  "84714": "寒冰宝珠",
  "84721": "寒冰宝珠",
  "84963": "异端裁决",
  "85043": "大十字军",
  "85222": "黎明之光",
  "85256": "圣殿骑士的裁决",
  "85288": "怒击",
  "85384": "怒击",
  "85416": "大十字军",
  "85673": "荣耀圣令",
  "85692": "厄运箭",
  "85739": "旋风斩",
  "85948": "脓疮打击",
  "86040": "古尔丹之手",
  "86069": "火焰喷射器",
  "86070": "穿刺护甲",
  "86073": "火焰喷射器",
  "86074": "火焰喷射器",
  "86091": "驾驭虚空",
  "86101": "板甲专精",
  "86110": "板甲专精",
  "86392": "左右开弓",
  "86537": "板甲专精",
  "86538": "锁甲专精",
  "86659": "远古列王守卫",
  "86949": "灸灼",
  "87024": "灸灼",
  "87935": "毒蛇钉刺",
  "87946": "红龙精华",
  "88163": "攻击",
  "88423": "自然之愈",
  "88625": "圣言术：罚",
  "88747": "野性蘑菇",
  "88751": "野性蘑菇",
  "88852": "圣光道标",
  "89091": "火山毁灭",
  "89637": "王牌炸药",
  "89751": "魔刃风暴",
  "89753": "魔刃风暴",
  "91019": "灵魂之力",
  "91023": "洞悉弱点",
  "91047": "战斗魔法",
  "91173": "疾速",
  "91364": "振奋",
  "91828": "胜利之悦",
  "91836": "铸炼怒火",
  "92091": "终极密钥",
  "92099": "极速思维",
  "92104": "死亡之河",
  "92108": "鲁莽残杀",
  "92123": "神秘",
  "92318": "灾难魔法",
  "92320": "启示",
  "92332": "接地之魂",
  "92342": "生死极速",
  "92345": "狂怒之心",
  "92349": "邪恶意图",
  "92351": "扭曲",
  "92596": "重获法力",
  "92679": "战斗合剂",
  "93321": "控制宠物",
  "93322": "控制宠物",
  "93375": "控制恶魔",
  "93376": "控制恶魔",
  "93402": "阳炎术",
  "93622": "淤血",
  "93985": "迎头痛击",
  "94160": "流水合剂",
  "94472": "救赎",
  "95738": "副手剑刃风暴",
  "96103": "怒击",
  "96231": "责难",
  "97022": "哈卡之链",
  "97462": "集结呐喊",
  "97463": "集结呐喊",
  "97821": "虚空之触",
  "98008": "灵魂链接图腾",
  "98021": "灵魂链接",
  "98440": "无情打击",
  "100130": "狂暴挥砍",
  "100780": "猛虎掌",
  "100784": "幻灭踢",
  "101033": "复苏",
  "101508": "克萨雷斯魔典",
  "101545": "翔龙在天",
  "101546": "神鹤引项踢",
  "101643": "魂体双分",
  "101745": "闪电精灵榄石",
  "101746": "导师的精灵榄石",
  "101747": "灌能精灵榄石",
  "101748": "禅悟之精灵榄石",
  "101749": "平衡精灵榄石",
  "101750": "鲜亮精灵榄石",
  "102342": "铁木树皮",
  "102352": "塞纳里奥结界",
  "102359": "群体缠绕",
  "102383": "野性冲锋",
  "102401": "野性冲锋",
  "102417": "野性冲锋",
  "102543": "化身：阿莎曼之灵",
  "102547": "潜行",
  "102558": "化身：乌索克的守护者",
  "102560": "化身：艾露恩之眷",
  "102693": "林莽卫士",
  "102793": "乌索尔旋风",
  "103740": "暗月烟花",
  "103827": "再度冲锋",
  "103828": "战神",
  "103985": "猛虎式",
  "104316": "召唤恐惧猎犬",
  "104317": "野生小鬼",
  "104318": "恶魔火焰箭",
  "104773": "不灭决心",
  "104938": "邪甲术",
  "105174": "古尔丹之手",
  "105697": "兔妖之啮",
  "105701": "专注药水",
  "105702": "青龙药水",
  "105706": "魔古之力药水",
  "105708": "治疗药水",
  "105709": "恢复法力",
  "105771": "冲锋",
  "106785": "横扫",
  "106839": "迎头痛击",
  "106898": "狂奔怒吼",
  "106951": "狂暴",
  "107079": "震山掌",
  "107270": "神鹤引项踢",
  "107428": "旭日东升踢",
  "107570": "风暴之锤",
  "107574": "天神下凡",
  "108194": "窒息",
  "108196": "死亡虹吸",
  "108199": "血魔之握",
  "108201": "邪恶之地",
  "108208": "诡诈",
  "108209": "暗影集中",
  "108271": "星界转移",
  "108280": "治疗之潮图腾",
  "108287": "图腾投射",
  "108291": "野性之心",
  "108292": "野性之心",
  "108293": "野性之心",
  "108294": "野性之心",
  "108299": "杀手本能",
  "108359": "黑暗再生",
  "108366": "灵魂榨取",
  "108370": "灵魂榨取",
  "108396": "死亡缠绕",
  "108415": "灵魂链接",
  "108416": "黑暗契约",
  "108501": "侍从魔典",
  "108503": "牺牲魔典",
  "108558": "夜幕",
  "108853": "火焰冲击",
  "108942": "幻隐",
  "108945": "天使壁垒",
  "109132": "滚地翻",
  "109186": "圣光涌动",
  "109215": "迅疾如风",
  "109248": "束缚射击",
  "109260": "铁鹰守护",
  "109298": "险境求生",
  "109304": "意气风发",
  "110744": "神圣之星",
  "110959": "强化隐形术",
  "111400": "爆燃冲刺",
  "111673": "控制亡灵",
  "111771": "恶魔传送门",
  "111859": "魔典：小鬼",
  "111895": "魔典：虚空行者",
  "111896": "魔典：魅魔",
  "111897": "魔典：地狱猎犬",
  "111898": "魔典：恶魔卫士",
  "112866": "召唤邪能小鬼",
  "112867": "召唤空灵领主",
  "112868": "召唤破坏魔",
  "112869": "召唤眼魔",
  "112870": "召唤愤怒卫士",
  "112921": "召唤深渊魔",
  "112926": "召唤恐惧卫士",
  "112927": "召唤恐惧卫士",
  "112965": "寒冰指",
  "113043": "清晰预兆",
  "113344": "浴血奋战",
  "113656": "怒雷破",
  "113724": "冰霜之环",
  "113746": "玄秘掌",
  "113780": "夺命药膏",
  "113858": "黑暗灵魂：动荡",
  "113860": "黑暗灵魂：哀难",
  "113862": "强化隐形术",
  "113890": "恶魔传送门",
  "114014": "飞镖投掷",
  "114018": "潜伏帷幕",
  "114030": "警戒",
  "114050": "升腾",
  "114051": "升腾",
  "114052": "升腾",
  "114083": "恢复迷雾",
  "114089": "狂风鞭笞",
  "114093": "副手狂风鞭笞",
  "114107": "丛林之魂",
  "114108": "丛林之魂",
  "114113": "丛林之魂",
  "114154": "不败之魂",
  "114165": "神圣棱镜",
  "114255": "圣光涌动",
  "114282": "树人形态",
  "114556": "炼狱",
  "114852": "神圣棱镜",
  "114871": "神圣棱镜",
  "114893": "石壁",
  "114942": "治疗之潮",
  "115008": "真气突",
  "115057": "翔龙在天",
  "115069": "醉拳",
  "115072": "移花接木",
  "115078": "分筋错骨",
  "115080": "轮回之触",
  "115098": "真气波",
  "115129": "移花接木",
  "115151": "复苏之雾",
  "115173": "动如脱兔",
  "115175": "抚慰之雾",
  "115176": "禅悟冥想",
  "115178": "轮回转世",
  "115180": "迷醉酒雾",
  "115181": "火焰之息",
  "115191": "潜行",
  "115192": "诡诈",
  "115203": "壮胆酒",
  "115288": "豪能酒",
  "115294": "法力茶",
  "115295": "金钟罩",
  "115308": "铁骨酒",
  "115310": "还魂术",
  "115313": "召唤青龙雕像",
  "115315": "召唤玄牛雕像",
  "115356": "风切",
  "115357": "风切",
  "115360": "副手风切",
  "115396": "真气升腾",
  "115399": "玄牛酒",
  "115450": "清创生血",
  "115464": "疗伤珠",
  "115546": "嚎镇八方",
  "115636": "精通：组合拳",
  "115750": "盲目之光",
  "115804": "致死之伤",
  "115867": "法力茶",
  "115869": "法力茶",
  "115939": "野兽顺劈",
  "115943": "雄鹰盛宴雕文",
  "115946": "怒火冲天雕文",
  "115989": "邪恶虫群",
  "116092": "转生",
  "116095": "金刚震",
  "116645": "禅院教诲",
  "116670": "活血术",
  "116680": "雷光聚神茶",
  "116705": "切喉手",
  "116768": "幻灭踢！",
  "116812": "招架",
  "116841": "迅如猛虎",
  "116844": "平心之环",
  "116847": "碧玉疾风",
  "116849": "作茧缚命",
  "116858": "混乱之箭",
  "116888": "炼狱蔽体",
  "117013": "元素尊者",
  "117014": "元素冲击",
  "117216": "临界炽焰",
  "117313": "嗜血治疗",
  "117405": "束缚射击",
  "117418": "怒雷破",
  "117526": "束缚射击",
  "117588": "流星",
  "117679": "化身",
  "117828": "爆燃",
  "117906": "精通：醉拳大师",
  "117907": "精通：迷雾之风",
  "117952": "碎玉闪电",
  "117959": "碎玉闪电",
  "118000": "巨龙怒吼",
  "118009": "邪恶之地",
  "118022": "迷醉酒雾",
  "118038": "剑在人在",
  "118291": "原始火元素",
  "118297": "献祭",
  "118455": "野兽顺劈",
  "118459": "野兽顺劈",
  "118522": "元素冲击：爆击",
  "118699": "恐惧",
  "118779": "乘胜追击",
  "118905": "电能图腾",
  "118922": "迅疾如风",
  "119085": "真气突",
  "119381": "扫堂腿",
  "119392": "蛮牛冲",
  "119582": "活血酒",
  "119611": "复苏之雾",
  "119650": "能量使用",
  "119898": "恶魔掌控",
  "119905": "烧灼驱魔",
  "119911": "眼棱爆炸",
  "119914": "巨斧投掷",
  "119975": "符能转换",
  "119996": "魂体双分：转移",
  "120224": "皮甲专精",
  "120225": "皮甲专精",
  "120227": "皮甲专精",
  "120360": "弹幕射击",
  "120517": "光晕",
  "120588": "元素冲击过载",
  "120644": "光晕",
  "120679": "凶暴野兽",
  "120692": "光晕",
  "120696": "光晕",
  "120755": "飞刃",
  "120756": "飞刃",
  "120761": "飞刃",
  "120954": "壮胆酒",
  "121093": "纳鲁的赐福",
  "121128": "轮回之触通知驱动",
  "121153": "侧袭",
  "121253": "醉酿投",
  "121414": "飞刃",
  "121471": "暗影之刃",
  "121536": "天堂之羽",
  "121817": "战斗贤才",
  "121818": "群兽奔腾",
  "122278": "躯不坏",
  "122280": "金创药",
  "122281": "金创药",
  "122464": "大象无形",
  "122470": "业报之触",
  "122783": "散魔功",
  "123040": "摧心魔",
  "123586": "翔龙在天",
  "123693": "吸血瘟疫",
  "123725": "火焰之息",
  "123779": "烈焰开道雕文",
  "123829": "格挡",
  "123904": "白虎下凡",
  "123986": "真气爆裂",
  "123996": "伏虎闪雷",
  "124081": "禅意波",
  "124146": "双武器",
  "124255": "醉拳",
  "124273": "重度醉拳",
  "124274": "中度醉拳",
  "124275": "轻度醉拳",
  "124280": "业报之触",
  "124285": "死亡脚步",
  "124502": "玄牛之赐",
  "124503": "玄牛之赐",
  "124506": "玄牛之赐",
  "124507": "玄牛之赐",
  "124682": "氤氲之雾",
  "124991": "自然的守护",
  "125050": "拾回",
  "125084": "蛮牛冲",
  "125151": "猛虎出山雕文",
  "125355": "疗伤珠",
  "125732": "武道精神雕文",
  "125872": "战斗姿态雕文",
  "125883": "禅意飞行",
  "125931": "伏虎闪雷雕文",
  "126664": "冲锋",
  "126734": "神经元弹簧",
  "126819": "变形术",
  "126890": "禅院古训",
  "126892": "禅宗朝圣",
  "126895": "禅宗朝圣：返回",
  "126896": "禅宗朝圣：返回",
  "127344": "邪爆",
  "127757": "魅惑林地生物",
  "127802": "哀伤之触",
  "127845": "可怕的螳螂妖：召唤兰",
  "127933": "烟花",
  "128594": "意气风发",
  "128595": "进退自如",
  "129597": "奥术洪流",
  "130610": "武僧",
  "130654": "真气爆裂",
  "131347": "滑翔",
  "131768": "豹之迅捷",
  "131894": "夺命黑鸦",
  "131900": "夺命黑鸦",
  "132157": "神圣新星",
  "132158": "自然迅捷",
  "132169": "风暴之锤",
  "132403": "正义盾击",
  "132404": "盾牌格挡",
  "132413": "暗影壁垒",
  "132463": "真气波",
  "132467": "真气波",
  "132469": "台风",
  "132568": "吹响暗月哨子",
  "132578": "玄牛下凡",
  "132603": "暗影魔",
  "135286": "尖牙与利爪",
  "135299": "焦油陷阱",
  "135601": "尖牙与利爪",
  "135700": "节能施法",
  "137005": "死亡骑士",
  "137008": "鲜血死亡骑士",
  "137014": "猎人",
  "137017": "生存猎人",
  "137022": "武僧",
  "137023": "酒仙武僧",
  "137024": "织雾武僧",
  "137025": "踏风武僧",
  "137035": "敏锐潜行者",
  "137042": "术士",
  "137043": "痛苦术士",
  "137044": "恶魔学识术士",
  "137046": "毁灭术士",
  "137047": "战士",
  "137049": "武器战士",
  "137050": "狂怒战士",
  "137384": "踏风连击",
  "137639": "风火雷电",
  "138121": "风火雷电",
  "138123": "风火雷电",
  "138430": "远古赞达拉秘籍",
  "139546": "连击点数",
  "140763": "召唤深渊魔",
  "142421": "迅捷治愈",
  "143924": "吸血",
  "145108": "伊瑟拉之赐",
  "145109": "伊瑟拉之赐",
  "145110": "伊瑟拉之赐",
  "145152": "血腥爪击",
  "145196": "熊猫人八宝汤面餐车",
  "145205": "百花齐放",
  "145629": "反魔法领域",
  "146555": "暴怒之鼓",
  "146652": "骷髅雕文",
  "146739": "腐蚀术",
  "146956": "圣光决断",
  "146974": "武器大师雕文",
  "147362": "反制射击",
  "147833": "援护",
  "148022": "冰刺",
  "148135": "真气爆裂",
  "148467": "威慑",
  "148970": "地狱战马",
  "148972": "恐惧战马",
  "152108": "大灾变",
  "152175": "升龙霸",
  "152278": "愤怒掌控",
  "153561": "流星",
  "153595": "彗星风暴",
  "153596": "彗星风暴",
  "153626": "奥术宝珠",
  "153640": "奥术宝珠",
  "154743": "健硕",
  "155145": "奥术洪流",
  "155158": "流星灼烧",
  "155166": "冰龙吐息",
  "155271": "吉兆",
  "155578": "艾露恩的卫士",
  "155580": "月之灵",
  "155625": "月火术",
  "155675": "萌芽",
  "155722": "斜掠",
  "155777": "回春术（萌芽）",
  "155835": "鬃毛倒竖",
  "156287": "破坏者",
  "156322": "永恒之火",
  "156910": "信仰道标",
  "157047": "圣光救赎",
  "157228": "枭兽狂怒",
  "157331": "呼啸狂风",
  "157348": "召唤闪电",
  "157361": "滚翻控制",
  "157375": "风暴怒火",
  "157411": "疾风步",
  "157445": "致命攻击",
  "157644": "烟火之术",
  "157736": "献祭",
  "157980": "超级新星",
  "157982": "宁静",
  "157997": "寒冰新星",
  "158221": "升龙霸",
  "158476": "丛林之魂",
  "158477": "丛林之魂",
  "158478": "丛林之魂",
  "158504": "塞纳留斯的梦境",
  "159286": "原始狂怒",
  "160331": "血精灵幻象",
  "161353": "变形术",
  "161354": "变形术",
  "161355": "变形术",
  "161372": "变形术",
  "162243": "恶魔之咬",
  "162264": "恶魔变形",
  "162794": "混乱打击",
  "163073": "恶魔之魂",
  "163201": "斩杀",
  "163272": "真气珠",
  "163505": "斜掠",
  "163558": "副手斩杀",
  "164812": "月火术",
  "164815": "阳炎术",
  "164862": "振翅",
  "166646": "疾风步",
  "167105": "巨人打击",
  "168534": "精通：元素过载",
  "169340": "绝命之触",
  "170364": "凶暴野兽",
  "170374": "大地狂怒",
  "170379": "大地狂怒",
  "173183": "元素冲击：急速",
  "173184": "元素冲击：精通",
  "173841": "日升雾腾",
  "175821": "纯粹怒火",
  "178173": "玄牛之赐",
  "178207": "狂怒战鼓",
  "179057": "混乱新星",
  "183416": "黎明祝福",
  "183435": "惩戒光环",
  "183752": "瓦解",
  "183782": "瓦解之怒",
  "183811": "圣光审判",
  "183997": "精通：光明使者",
  "184362": "激怒",
  "184364": "狂怒回复",
  "184367": "暴怒",
  "184575": "公正之剑",
  "184662": "复仇之盾",
  "184707": "暴怒",
  "184709": "暴怒",
  "184783": "战术专家",
  "185099": "旭日东升踢",
  "185123": "投掷利刃",
  "185245": "折磨",
  "185311": "猩红之瓶",
  "185313": "暗影之舞",
  "185314": "侵蚀之影",
  "185358": "奥术射击",
  "185422": "暗影之舞",
  "185438": "暗影打击",
  "185565": "剧毒之刃",
  "185736": "进食充分",
  "185763": "手枪射击",
  "186254": "狂野怒火",
  "186257": "猎豹守护",
  "186265": "灵龟守护",
  "186270": "猛禽一击",
  "186289": "雄鹰守护",
  "186452": "能量再生",
  "187650": "冰冻陷阱",
  "187698": "焦油陷阱",
  "187707": "压制",
  "187827": "恶魔变形",
  "187874": "毁灭闪电",
  "187880": "漩涡武器",
  "187890": "漩涡武器",
  "188016": "古代治疗药水",
  "188018": "古代活力药水",
  "188028": "上古战神药水",
  "188031": "耳语契约合剂",
  "188033": "第七恶魔合剂",
  "188034": "无尽大军合剂",
  "188035": "千万战痕合剂",
  "188196": "闪电箭",
  "188290": "枯萎凋零",
  "188370": "奉献",
  "188389": "烈焰震击",
  "188443": "闪电链",
  "188499": "刃舞",
  "188501": "幽灵视觉",
  "188592": "火元素",
  "189096": "符文能量",
  "189110": "地狱火撞击",
  "189787": "自然精华",
  "189800": "自然精华",
  "190319": "燃烧",
  "190356": "暴风雪",
  "190357": "暴风雪",
  "190411": "旋风斩",
  "190446": "冰冷智慧",
  "190447": "冰冷智慧",
  "190456": "无视苦痛",
  "190740": "精通：法力专家",
  "190784": "神圣马驹",
  "190909": "利爪之印",
  "190925": "鱼叉猛刺",
  "190927": "鱼叉猛刺",
  "190984": "愤怒",
  "191034": "星辰坠落",
  "191037": "星辰坠落",
  "191384": "野兽守护",
  "191427": "恶魔变形",
  "191587": "恶性病变",
  "191634": "风暴守护者",
  "191717": "风暴之怒",
  "191861": "漩涡之力",
  "191894": "迷雾之风",
  "192058": "电能图腾",
  "192063": "阵风",
  "192077": "狂风图腾",
  "192081": "铁鬃",
  "192088": "恩赐之魂",
  "192090": "痛击",
  "192106": "闪电之盾",
  "192231": "岩浆",
  "192380": "淬毒刀刃",
  "192611": "邪能冲撞",
  "192660": "毒液炸弹",
  "193063": "防护圣光",
  "193065": "防护圣光",
  "193134": "惩罚",
  "193155": "启迪",
  "193157": "圣光复苏",
  "193265": "投掷手斧",
  "193315": "影袭",
  "193331": "召唤恐惧猎犬",
  "193332": "召唤恐惧猎犬",
  "193455": "眼镜蛇射击",
  "193473": "精神鞭笞",
  "193486": "符文强化",
  "193531": "深邃诡计",
  "193532": "血之气息",
  "193537": "武器掌握",
  "193539": "敏锐",
  "193546": "铜肠铁胃",
  "193641": "深谋远虑",
  "193753": "梦境行者",
  "193840": "混乱打击",
  "194153": "星火术",
  "194192": "暗影箭",
  "194223": "超凡之盟",
  "194249": "虚空形态",
  "194384": "救赎",
  "194509": "真言术：耀",
  "194594": "荷枪实弹",
  "194595": "荷枪实弹",
  "194662": "迅速凋零",
  "194878": "冰冷之爪",
  "194912": "风暴汇聚",
  "194913": "冰川突进",
  "194916": "万物臣服",
  "195072": "邪能冲撞",
  "195181": "白骨之盾",
  "195182": "精髓分裂",
  "195292": "死神的抚摩",
  "195452": "夜刃",
  "195457": "抓钩",
  "195519": "隐形",
  "195592": "毁灭闪电",
  "195617": "冰霜疫病",
  "195627": "可乘之机",
  "195645": "摔绊",
  "195679": "血虫",
  "195707": "怒气",
  "195897": "闪电链",
  "196055": "二段跳",
  "196099": "牺牲魔典",
  "196100": "牺牲魔典",
  "196103": "绝对腐蚀",
  "196226": "腐蚀播种",
  "196277": "内爆",
  "196278": "内爆",
  "196361": "血虫",
  "196406": "爆燃",
  "196408": "硫磺烈火",
  "196414": "灭杀",
  "196447": "引导恶魔之火",
  "196448": "引导恶魔之火",
  "196528": "白骨风暴",
  "196608": "猛虎之眼",
  "196704": "心灵之声",
  "196707": "死后余生",
  "196718": "黑暗",
  "196730": "特别快递",
  "196736": "幻灭连击",
  "196737": "坚定不屈",
  "196740": "连击",
  "196741": "连击",
  "196742": "升龙霸",
  "196770": "冷酷严冬",
  "196771": "冷酷严冬",
  "196810": "耀眼光芒",
  "196813": "祝福之光",
  "196816": "宁静之光",
  "196819": "刺骨",
  "196840": "冰霜震击",
  "196861": "铁线",
  "196881": "狂野扑击",
  "196884": "狂野扑击",
  "196909": "占位字符",
  "196911": "暗影技巧",
  "196922": "移形换位",
  "196926": "十字军之力",
  "196938": "快速拔枪",
  "196976": "暗影大师",
  "196980": "暗影大师",
  "196985": "纳鲁之光",
  "197045": "护盾戒律",
  "197061": "石木树皮",
  "197073": "平常心",
  "197130": "滑翔",
  "197214": "裂地术",
  "197277": "审判",
  "197446": "光明使者的道标",
  "197509": "血虫",
  "197524": "星界支配",
  "197625": "枭兽形态",
  "197626": "星涌术",
  "197628": "星火术",
  "197630": "阳炎术",
  "197721": "繁盛",
  "197834": "影袭",
  "197835": "袖剑风暴",
  "197862": "天使长",
  "197895": "雷光凝聚",
  "197900": "缭绕之雾",
  "197915": "生生不息",
  "197916": "生生不息",
  "197919": "生生不息",
  "197997": "奔涌之流",
  "198013": "眼棱",
  "198030": "眼棱",
  "198068": "阴暗面之力",
  "198103": "土元素",
  "198137": "神圣之锤",
  "198249": "元素治疗",
  "198395": "狂怒",
  "198487": "禅意波",
  "198533": "抚慰之雾",
  "198589": "疾影",
  "198590": "吸取灵魂",
  "198793": "复仇回避",
  "198898": "赤精之歌",
  "199053": "熔岩释放",
  "199054": "闪电释放",
  "199116": "毁灭漩涡",
  "199422": "神圣仪式",
  "199423": "神圣仪式",
  "199483": "伪装",
  "199484": "心智联结",
  "199486": "心智联结",
  "199530": "践踏",
  "199532": "杀戮眼镜蛇",
  "199547": "混乱打击",
  "199552": "刃舞",
  "199658": "旋风斩",
  "199667": "旋风斩",
  "199786": "冰川尖刺",
  "199844": "冰川尖刺！",
  "199850": "旋风斩",
  "199851": "副手旋风斩",
  "199852": "旋风斩",
  "199854": "战术专家",
  "199921": "开拓者",
  "200025": "美德道标",
  "200072": "洪流",
  "200076": "洪水",
  "200128": "光明尾迹",
  "200166": "恶魔变形",
  "200183": "神圣化身",
  "200196": "圣言术：罚",
  "200199": "谴罚",
  "200200": "圣言术：罚",
  "200209": "守护天使",
  "200383": "欣欣向荣",
  "200389": "栽培",
  "200390": "栽培",
  "200399": "乌索尔的坚韧",
  "200400": "荒野血肉",
  "200402": "永恒之春",
  "200430": "提尔的保护",
  "200654": "提尔的拯救",
  "200685": "刃舞",
  "200733": "刺激弥散",
  "200758": "幽暗之刃",
  "200829": "恳求",
  "200854": "血污毛皮",
  "200855": "梦魇之拥",
  "201363": "暴怒",
  "201364": "暴怒",
  "201427": "毁灭",
  "201428": "毁灭",
  "201453": "恶魔变形",
  "201467": "伊利达雷之怒",
  "201594": "群兽奔腾",
  "201628": "伊利达雷之怒",
  "201633": "大地之墙",
  "201637": "进食充分",
  "201638": "进食充分",
  "201639": "进食充分",
  "201640": "进食充分",
  "201657": "大地之墙",
  "201671": "血污毛皮",
  "201754": "践踏",
  "201789": "伊利达雷之怒",
  "201845": "风暴喷涌",
  "201846": "风暴喷涌",
  "201900": "灼热之手",
  "202021": "掠食者",
  "202031": "剑齿利刃",
  "202090": "禅院教诲",
  "202095": "百折不挠",
  "202126": "热酿",
  "202137": "沉默咒符",
  "202138": "锁链咒符",
  "202147": "复苏之风",
  "202163": "腾跃步伐",
  "202164": "腾跃步伐",
  "202166": "胜利在望",
  "202168": "胜利在望",
  "202192": "共鸣图腾",
  "202289": "狂暴复兴",
  "202316": "战斗狂热",
  "202342": "坠星",
  "202345": "星辰领主",
  "202424": "破蛹化蝶",
  "202425": "艾露恩的战士",
  "202430": "自然平衡",
  "202497": "坠星",
  "202560": "痛宰",
  "202602": "投入战斗",
  "202603": "投入战斗",
  "202688": "幽灵视觉",
  "202719": "奥术洪流",
  "202743": "震耳嗓音",
  "202770": "艾露恩之怒",
  "202918": "烈日之光",
  "203123": "割碎",
  "203177": "强力反击",
  "203201": "爆裂闪电",
  "203277": "烈焰触媒",
  "203550": "盲目之怒",
  "203555": "恶魔之刃",
  "203557": "邪能之刃",
  "203720": "恶魔尖刺",
  "203724": "招架",
  "203794": "吞噬灵魂",
  "203795": "灵魂残片",
  "203796": "恶魔之刃",
  "203819": "恶魔尖刺",
  "203953": "刺藤",
  "203961": "血性狂乱",
  "203962": "血性狂乱",
  "203964": "星河守护者",
  "203965": "优胜劣汰",
  "203975": "大地守卫者",
  "203981": "灵魂残片",
  "204018": "破咒祝福",
  "204019": "祝福之锤",
  "204021": "烈火烙印",
  "204023": "十字军审判",
  "204031": "鬃毛倒竖",
  "204053": "狂乱撕扯",
  "204054": "圣洁之地",
  "204062": "灵魂残片",
  "204066": "明月普照",
  "204074": "正义保护者",
  "204077": "决一死战",
  "204089": "正中靶心",
  "204090": "正中靶心",
  "204157": "投掷利刃",
  "204255": "灵魂残片",
  "204268": "巫毒掌握",
  "204301": "祝福之锤",
  "204304": "奇美拉射击",
  "204490": "沉默咒符",
  "204596": "烈焰咒符",
  "204598": "烈焰咒符",
  "204608": "邪能牢笼",
  "204843": "锁链咒符",
  "204880": "漩涡之灵",
  "204909": "灵魂劈裂",
  "205021": "冰霜射线",
  "205022": "奥术魔宠",
  "205024": "孤寂寒冬",
  "205025": "气定神闲",
  "205026": "纵火者",
  "205028": "共鸣",
  "205029": "烈焰飞舞",
  "205030": "冰冻之触",
  "205036": "寒冰结界",
  "205146": "魔性征召",
  "205148": "熵能返转",
  "205180": "召唤黑眼",
  "205224": "吞噬",
  "205231": "眼棱",
  "205246": "诡异魅影",
  "205292": "吸取灵魂",
  "205364": "统御意志",
  "205406": "神龙之赐",
  "205411": "绝望本能",
  "205448": "虚空箭",
  "205472": "烈焰之地",
  "205473": "冰刺",
  "205523": "幻灭踢",
  "205636": "自然之力",
  "205723": "赤红渴望",
  "205727": "反魔法屏障",
  "205766": "刺骨冰寒",
  "206315": "毁灭",
  "206416": "第一滴血",
  "206476": "能量放射",
  "206930": "心脏打击",
  "206967": "浮空城意志",
  "206974": "腐烂壁垒",
  "207057": "破碎之刃",
  "207061": "杀戮效率",
  "207062": "杀戮效率",
  "207104": "符文调谐",
  "207142": "雪崩",
  "207167": "致盲冰雨",
  "207200": "永冻",
  "207230": "冰霜之镰",
  "207269": "黑檀热",
  "207272": "感染之爪",
  "207317": "扩散",
  "207347": "痛苦光环",
  "207383": "丰饶",
  "207386": "春暖花开",
  "207387": "痛苦使者",
  "207400": "先祖活力",
  "207401": "先祖活力",
  "207407": "灵魂切削",
  "207495": "先祖护佑",
  "207548": "苦痛之焰",
  "207553": "图腾复生",
  "207631": "毁灭",
  "207640": "丰饶",
  "207684": "悲苦咒符",
  "207685": "悲苦咒符",
  "207693": "灵魂盛宴",
  "207697": "灵魂盛宴",
  "207739": "火刑",
  "207744": "烈火烙印",
  "207771": "烈火烙印",
  "207778": "倾盆大雨",
  "207995": "扭曲虚空的火焰",
  "207998": "扭曲虚空的冰冷",
  "207999": "扭曲虚空的冲击",
  "208086": "巨人打击",
  "208154": "战争印记",
  "208218": "斯凯塞克的坚守",
  "208440": "暗影萨特之步",
  "208628": "能量放射",
  "209258": "最后一搏",
  "209281": "快速咒符",
  "209389": "秩序壁垒",
  "209525": "抚慰之雾",
  "209785": "正义之火",
  "209997": "装死",
  "210000": "唤醒",
  "210041": "恶魔食欲",
  "210053": "坐骑形态",
  "210126": "奥术魔宠",
  "210152": "死亡横扫",
  "210153": "死亡横扫",
  "210155": "死亡横扫",
  "210291": "仁慈光环",
  "210476": "逃脱大师",
  "210660": "顺风图腾",
  "210689": "引雷针",
  "210706": "淤血",
  "210712": "余震",
  "210714": "冰怒",
  "210738": "碎心打击",
  "210824": "大法师之触",
  "210853": "元素突袭",
  "210873": "妖术",
  "211004": "妖术",
  "211010": "妖术",
  "211015": "妖术",
  "211094": "闪电链",
  "211140": "套装特效占位",
  "211142": "套装特效占位",
  "211415": "套装特效占位",
  "211545": "艾露恩之怒",
  "211793": "冷酷严冬",
  "211805": "风暴汇聚",
  "211878": "净化引爆",
  "211879": "翔龙吐息",
  "212084": "邪能毁灭",
  "212105": "邪能毁灭",
  "212239": "离场对话",
  "212240": "梦魇之握",
  "212241": "召唤",
  "212242": "召唤树妖",
  "212243": "召唤树妖",
  "212244": "套装特效占位",
  "212245": "精确格挡",
  "212246": "脆弱的雕像",
  "212247": "金睛凝视",
  "212248": "奥术之泉区域光环",
  "212249": "进场对话",
  "212250": "创建对话",
  "212251": "创建对话",
  "212252": "创建对话",
  "212253": "创建对话",
  "212254": "创建对话",
  "212255": "圣光术",
  "212256": "古尔丹之手",
  "212257": "传送",
  "212258": "古尔丹之手",
  "212262": "古尔丹之手",
  "212267": "侵蚀之影",
  "212431": "爆炸射击",
  "212552": "幻影步",
  "212611": "恶魔猎手",
  "212641": "远古列王守卫",
  "212653": "闪光术",
  "212680": "爆炸射击",
  "212739": "扩散",
  "212743": "袖剑风暴",
  "212800": "疾影",
  "212988": "痛苦使者",
  "213010": "焦油战刃",
  "213011": "焦油战刃",
  "213047": "金刚不坏",
  "213055": "醉拳步",
  "213241": "邪能之刃",
  "213243": "邪能之刃",
  "213405": "战刃大师",
  "213410": "魔化",
  "213453": "邪能熔炉强化",
  "213457": "生成",
  "213458": "玄牛之赐",
  "213460": "玄牛之赐",
  "213463": "支配恶魔",
  "213464": "玄牛之赐",
  "213466": "锁定",
  "213467": "天角空中扫射",
  "213469": "火焰箭",
  "213470": "火焰箭",
  "213471": "陈的防御",
  "213472": "猴王戏法",
  "213473": "治疗者希罗",
  "213474": "天角空中扫射",
  "213476": "奥术宝珠",
  "213477": "闪电吐息",
  "213479": "无尽愤怒",
  "213480": "无尽愤怒",
  "213481": "扔出丝囊",
  "213482": "制造钻石",
  "213483": "纠缠之网",
  "213484": "纠缠之网",
  "213485": "制造开锁工具",
  "213486": "恶魔视觉",
  "213487": "对话",
  "213488": "摧毁恶魔",
  "213489": "鸦熊死亡",
  "213491": "恶魔践踏",
  "213492": "猎豹形态",
  "213493": "对话",
  "213494": "酒有余香",
  "213495": "酒有余香",
  "213498": "超载",
  "213500": "匆匆装配的炸弹",
  "213503": "暗影之力",
  "213504": "奥术迷雾",
  "213506": "暗影之力",
  "213507": "驾船",
  "213509": "大地之刺",
  "213510": "奥术宝珠",
  "213511": "奥术宝珠",
  "213512": "尖刺盾牌",
  "213515": "亵渎之泉",
  "213516": "岩石箭",
  "213634": "净化疾病",
  "213644": "清毒术",
  "213680": "艾露恩的卫士",
  "213708": "星河守护者",
  "213709": "刺藤",
  "213738": "鲜血气息",
  "213739": "纪元宝珠",
  "213740": "阿古斯之印",
  "213741": "小蜘蛛毒素",
  "213742": "铁鳞",
  "213743": "战栗之地",
  "213748": "战栗之地",
  "213764": "横扫",
  "213771": "横扫",
  "213777": "灼热烈焰",
  "214373": "酒有余香",
  "214416": "玄牛之赐",
  "214417": "玄牛之赐",
  "214418": "玄牛之赐",
  "214420": "玄牛之赐",
  "214743": "灵魂切削",
  "214815": "闪电箭",
  "214816": "闪电箭过载",
  "214920": "云游者的坚韧",
  "215111": "恐惧利齿",
  "215178": "突袭",
  "215270": "脆弱回响",
  "215479": "酒醒入定",
  "215568": "新鲜血肉",
  "215725": "幽灵视觉",
  "215768": "圣光之耀",
  "215785": "灼热之手",
  "215799": "巨熊拥抱",
  "215802": "狂野扑击",
  "215942": "灵魂导管",
  "216251": "波动",
  "216331": "复仇十字军",
  "216371": "复仇十字军",
  "216519": "天神护佑",
  "216521": "天神护佑",
  "217113": "烈焰炸弹",
  "217114": "雷霆之穹",
  "217115": "雷霆之穹",
  "217200": "倒刺射击",
  "217694": "活动炸弹",
  "217832": "禁锢",
  "218164": "清创生血",
  "218508": "回归打击",
  "218558": "闪电链过载",
  "218612": "喂食恶魔",
  "218903": "瓦解",
  "219199": "凶暴野兽",
  "219271": "冰怒过载",
  "219272": "恶魔皮肤",
  "219321": "格斗家",
  "219786": "埋骨之所",
  "219788": "埋骨之所",
  "219906": "召唤雪羽",
  "219907": "玩家选择",
  "219909": "亵渎光环",
  "219911": "亵渎",
  "219912": "[DND]离开",
  "219913": "剧烈喷发",
  "219914": "漩涡激流",
  "220156": "易爆",
  "220305": "对话：赫尔库拉",
  "220357": "神鹤印记",
  "220637": "审判",
  "220890": "鲜血打击",
  "221177": "恶魔践踏",
  "221322": "符文调谐",
  "221536": "碎心打击",
  "221562": "窒息",
  "221771": "风火雷电：锁定",
  "221883": "神圣马驹",
  "221886": "神圣马驹",
  "221905": "取消骑乘光环",
  "221906": "变异软泥怪",
  "221908": "潜伏的鹰头小猫",
  "221909": "召唤鲜花",
  "221910": "对话：圣骑士出现",
  "222024": "湮灭",
  "222026": "冰霜打击",
  "222031": "混乱打击",
  "222502": "钢铁之耀",
  "222503": "钢铁之耀",
  "222504": "海洋的召唤",
  "222508": "不稳定的暗流",
  "222509": "野性狂乱",
  "222510": "不稳定的暗流",
  "222888": "对话",
  "222889": "暗影打击",
  "222890": "对话",
  "222891": "暗影打击",
  "222893": "对话",
  "222894": "对话",
  "222895": "炼狱箭",
  "222896": "玛法里奥的征服套装",
  "223573": "灵体果",
  "223595": "太阳果",
  "223618": "邪能战斧",
  "223650": "阴魂爆裂",
  "223652": "共鸣",
  "223653": "共鸣",
  "223654": "召唤小鬼",
  "223655": "软泥突袭",
  "223656": "触礁",
  "223657": "捍卫",
  "223658": "捍卫",
  "223659": "世界击碎者",
  "223660": "世界击碎者",
  "223661": "阻止古尔丹：接受任务",
  "223663": "触礁",
  "223664": "无法离开",
  "223665": "时髦的间谍眼镜",
  "223666": "世界击碎者",
  "223667": "荆棘丛",
  "223668": "软泥突袭",
  "223670": "加尼尔之花",
  "223671": "软泥突袭",
  "223672": "返转施法：侦测",
  "223673": "占位字符",
  "223674": "软泥突袭",
  "223675": "占位字符",
  "223676": "完美的梦境林地花蕾",
  "223677": "75份远古魔力",
  "223679": "陨落之星",
  "223680": "进场对话",
  "223681": "离场对话",
  "223683": "取消神圣愤怒",
  "223684": "取消奥术能量条",
  "223685": "永夜能量",
  "223686": "永夜能量",
  "223687": "骤然狂乱",
  "223688": "永夜能量",
  "223689": "永夜能量",
  "223690": "丹的陨落之星",
  "223692": "着火",
  "223708": "星移箭",
  "223709": "征服者套装",
  "223710": "爆发软泥",
  "223711": "无畏",
  "223712": "爆发软泥",
  "223714": "爆发软泥",
  "223715": "更多……更多更多更多！",
  "223716": "爆发软泥",
  "223717": "战神护甲套装",
  "223718": "爆发软泥",
  "223719": "渗漏之雾",
  "223720": "玩家选择",
  "223721": "死亡装饰状态",
  "223722": "太阳花粉",
  "223723": "更多……更多更多更多！",
  "223725": "更多……更多更多更多！",
  "223726": "黑暗能量",
  "223727": "兽王",
  "223728": "射击",
  "223729": "生存",
  "223730": "低沉咆哮",
  "223731": "树枝重击",
  "223732": "践踏",
  "223733": "古树树枝",
  "223734": "阳光坍缩",
  "223735": "渗漏之雾",
  "223736": "渗漏之雾",
  "223737": "更多……更多更多更多！",
  "223738": "装饰物 - 运输篮1",
  "223739": "毁灭者护甲套装",
  "223740": "伤害提高",
  "223757": "屠杀纹章",
  "223758": "毁灭纹章",
  "223759": "地狱咆哮的征服套装",
  "223760": "伊米亚之王套装",
  "223761": "伤害提高",
  "223762": "提高生命值",
  "223765": "神秘套装",
  "223766": "解散",
  "223768": "凯尔丹纳斯的法术石",
  "223770": "复仇者套装",
  "223771": "神谕者套装",
  "223772": "死亡执行者的拥抱",
  "223773": "在书中",
  "223774": "在书中",
  "223784": "奥术陷阱",
  "223785": "奥术陷阱",
  "223786": "奥术陷阱爆破",
  "223787": "奥术陷阱",
  "223788": "对话",
  "223789": "对话",
  "223790": "对话",
  "223791": "对话",
  "223792": "对话",
  "223793": "对话",
  "223794": "对话",
  "223795": "对话",
  "223796": "对话",
  "223798": "对话",
  "223799": "腐烂之罐",
  "223800": "邪能爆发",
  "223817": "神圣意志",
  "223819": "神圣意志",
  "224001": "亵渎强化",
  "224105": "烈焰领主",
  "224106": "清晰视界",
  "224107": "飞往风暴峡湾",
  "224108": "拿去",
  "224109": "飞往达拉然",
  "224111": "受伤",
  "224112": "复生",
  "224113": "棍子上的香肠",
  "224125": "熔岩武器",
  "224126": "寒冰刀锋",
  "224127": "爆裂涌动",
  "224149": "贾辛的诡计",
  "224239": "神圣风暴",
  "224266": "圣殿骑士的裁决",
  "224324": "盾牌猛击！",
  "224392": "变形印记",
  "224914": "暗影萨特之步",
  "225241": "涡轮顺劈斩",
  "225243": "虚空镇压",
  "225244": "阿鲁因贿赂检测器",
  "225409": "奥术能量 ",
  "225602": "进食充分",
  "225603": "进食充分",
  "225604": "进食充分",
  "225605": "进食充分",
  "225649": "暗影视界",
  "225919": "破裂",
  "225921": "破裂",
  "227034": "自然守护者",
  "227174": "爆燃",
  "227291": "践踏",
  "227445": "暗影导能",
  "227447": "反抗引力",
  "227448": "净化火焰",
  "227449": "翻卷的烈焰狂风",
  "227518": "毁灭",
  "227686": "沸腾血液",
  "227847": "剑刃风暴",
  "228260": "虚空形态",
  "228264": "虚空形态",
  "228287": "神鹤印记",
  "228354": "冰风暴",
  "228358": "深冬之寒",
  "228401": "古代女祭司之印",
  "228411": "法兰纳尔废墟通行证",
  "228477": "灵魂裂劈",
  "228478": "灵魂裂劈",
  "228532": "吞噬灵魂",
  "228563": "幻灭连击",
  "228597": "寒冰箭",
  "228598": "冰枪术",
  "228600": "冰川尖刺",
  "228649": "幻灭踢",
  "228920": "破坏者",
  "229206": "延时之力药水",
  "229837": "巨怒射线",
  "230332": "骑手",
  "230935": "高山战鼓",
  "231032": "强化愈合",
  "231040": "持续治疗",
  "231063": "无情爪击",
  "231390": "开拓者",
  "231548": "野兽之心",
  "231564": "弧光顺劈",
  "231602": "强化活血术",
  "231627": "风火雷电",
  "231644": "强效审判",
  "231663": "强效审判",
  "231682": "庇护",
  "231691": "强化疾跑",
  "231719": "麻木神经",
  "231793": "强化燃烧",
  "232378": "星界和谐",
  "232386": "黑暗映像",
  "232633": "奥术洪流",
  "232670": "暗影箭",
  "232698": "暗影形态",
  "232893": "邪能之刃",
  "233997": "卡姆·希拉夫",
  "234153": "吸取生命",
  "234278": "刀扇",
  "234299": "制裁之拳",
  "234876": "死亡之拥",
  "234946": "光明尾迹",
  "235027": "大师刺客的决意",
  "235219": "急速冷却",
  "235313": "烈焰护体",
  "235450": "棱光护体",
  "235484": "强化正中眉心",
  "235587": "创造奇迹",
  "236027": "冲锋",
  "236060": "狂热之速",
  "236068": "洞察秋毫",
  "236167": "邪能之刃",
  "236279": "灭绝者",
  "236282": "灭绝者",
  "236330": "星界易伤",
  "236457": "气流",
  "236479": "橡树之心的迷你牢笼",
  "236628": "增效",
  "237370": "位面撕碎",
  "237371": "平心之环",
  "238049": "耀眼月光",
  "238063": "仁慈",
  "238085": "血肉交织",
  "238100": "天使之慈",
  "238129": "浅斟快饮",
  "238135": "永恒屏障",
  "238136": "宇宙涟漪",
  "238558": "哀难",
  "239090": "巨大的帽子",
  "240094": "制造星纹布和暗影布",
  "240154": "水泡",
  "240155": "占位字符",
  "240156": "进入破碎海滩场景",
  "240266": "召唤暗影魅魔",
  "240855": "提高物品等级",
  "240856": "连枷挥砍",
  "240857": "提高物品等级",
  "240858": "提高物品等级",
  "240860": "制造护甲强化徽记",
  "240861": "奥丁之锤",
  "240862": "挥砍",
  "240863": "连枷挥砍",
  "240865": "森提纳克斯毁灭区域",
  "240868": "腐臭药剂",
  "240869": "腐臭药剂",
  "240870": "腐溃毒气",
  "240871": "腐溃毒气",
  "240874": "剧毒孢子",
  "240875": "剧毒孢子",
  "240877": "剧毒孢子",
  "240878": "剧毒孢子",
  "240880": "活性催化剂",
  "240883": "活性催化剂",
  "240884": "剧烈反应",
  "240885": "剧毒孢子",
  "240886": "剧毒孢子",
  "240887": "剧毒孢子",
  "240888": "石化",
  "240889": "剧毒孢子",
  "240890": "圣光冲撞",
  "240891": "剧毒孢子",
  "240893": "圣光冲撞",
  "240895": "石化",
  "240896": "卜雪大师",
  "240897": "觉醒！",
  "240898": "灭绝者：层数",
  "240903": "石化",
  "240904": "灭绝者：叠加层数",
  "240906": "打开裂隙",
  "240907": "邪能雾气",
  "240908": "末日冲击",
  "240909": "邪能灌注",
  "240910": "末日决战",
  "240911": "末日之雹",
  "240912": "末日之雹",
  "240913": "传送：达拉然",
  "240914": "魔能鞭笞",
  "240915": "末日之雹",
  "240916": "末日之雹",
  "240966": "邪能释放",
  "240967": "电能传送",
  "240968": "护盾光环",
  "240969": "电能传送",
  "240970": "暗影之刃",
  "240982": "暗影之刃的谋杀预兆",
  "240983": "无",
  "241131": "残寺派的坚韧",
  "241142": "通往苏拉玛的传送门",
  "241144": "月火术",
  "241286": "迷雾之池",
  "241287": "战争践踏",
  "241288": "暗影箭雨",
  "241289": "迷雾之池",
  "241293": "穿刺咆哮",
  "241294": "邪能之痛",
  "241295": "邪能爆破",
  "241296": "纳克萨玛斯挑战",
  "241298": "末日之墙",
  "241299": "末日之墙",
  "241300": "末日之墙",
  "241301": "末日之墙",
  "241305": "震击",
  "241306": "球形闪电",
  "241307": "传送",
  "241308": "悬浮",
  "241309": "悬浮",
  "242164": "杀戮冲动",
  "243073": "震波闪电",
  "243241": "宇宙涟漪",
  "243733": "制造物品",
  "243734": "制造物品",
  "243735": "制造物品",
  "243736": "制造物品",
  "243737": "卡扎克的印记",
  "243738": "制造物品",
  "243947": "阅读",
  "243949": "千魂之暗",
  "243952": "醒神宝典",
  "243954": "阅读",
  "243955": "伟大的海盗",
  "243957": "支配光环",
  "243958": "昏睡",
  "243960": "暗影突击",
  "243961": "哀难",
  "243962": "打断",
  "243963": "黑暗独行",
  "243967": "烈焰折磨",
  "243968": "烈焰折磨",
  "243973": "暗影折磨",
  "243974": "暗影折磨",
  "243975": "支配光环",
  "243976": "冰霜折磨",
  "243977": "冰霜折磨",
  "243979": "邪能折磨",
  "243980": "邪能折磨",
  "243982": "撕裂裂隙",
  "243983": "崩塌的世界",
  "243984": "崩塌的世界",
  "243988": "火焰之怒",
  "243991": "火焰之怒",
  "243992": "火焰之怒",
  "243993": "斩首",
  "243994": "苍穹击碎者",
  "243996": "苍穹击碎者",
  "243999": "黑暗裂隙",
  "244000": "邪能风暴扫射",
  "244001": "邪能风暴扫射",
  "244003": "黑暗裂隙",
  "244004": "邪能风暴扫射",
  "244005": "黑暗裂隙",
  "244006": "黑暗喷发",
  "244009": "标记中……",
  "244010": "召唤诺特利",
  "244011": "掠夺溅射",
  "244012": "燃烧的焦油",
  "244014": "绿色舞棍",
  "244015": "紫色舞棍",
  "244016": "时空裂痕",
  "244017": "传送通路：克索诺斯",
  "244018": "先知的指引石",
  "244020": "喂食中",
  "244021": "喷薄黑暗",
  "244022": "召唤虚空领主宠物",
  "244026": "关闭",
  "244027": "关闭",
  "244028": "关闭",
  "244030": "指挥舰轰炸",
  "244031": "指挥舰轰炸",
  "244641": "召唤维伦",
  "244642": "精准预判",
  "244645": "时间扭曲",
  "244813": "活动炸弹",
  "245013": "酒仙之道",
  "245389": "淬毒之刃",
  "245591": "能量割裂",
  "245687": "黑暗之影",
  "245862": "刃舞",
  "246152": "倒刺射击",
  "246945": "黑暗连结",
  "246985": "灵魂碎片",
  "247454": "幽魂炸弹",
  "247455": "幽魂炸弹",
  "247456": "脆弱",
  "248210": "亡者始祖",
  "248522": "自然之怒",
  "248622": "杀心骤起",
  "251645": "星界治疗药水",
  "251836": "湍流合剂",
  "251837": "无尽深邃合剂",
  "251838": "广阔天涯合剂",
  "251839": "暗潮合剂",
  "252071": "化身：阿莎曼之灵",
  "252216": "猛虎冲刺",
  "252732": "暗影姿态",
  "252750": "血腥伤口",
  "252752": "顶级捕食者",
  "253575": "复苏毛皮",
  "253593": "酷寒突袭",
  "254224": "光耀之子",
  "254232": "虚空之子",
  "254471": "神圣马驹",
  "255234": "图腾复生",
  "255260": "混乱烙印",
  "255283": "凶暴野兽",
  "255544": "毒液炸弹",
  "255647": "圣光裁决者",
  "255652": "圣光清算",
  "255654": "蛮牛冲撞",
  "255658": "登山家",
  "255661": "戏法",
  "255937": "灰烬觉醒",
  "256165": "致盲粉",
  "256170": "灌铅骰子",
  "256188": "伸缩钩",
  "256374": "熵能之拥",
  "256522": "药膏专家",
  "256735": "刺客大师",
  "256948": "空间裂隙",
  "257040": "空间裂隙",
  "257044": "急速射击",
  "257045": "急速射击",
  "257284": "猎人印记",
  "257408": "进食充分",
  "257410": "进食充分",
  "257413": "进食充分",
  "257415": "进食充分",
  "257418": "进食充分",
  "257420": "进食充分",
  "257422": "进食充分",
  "257424": "进食充分",
  "257505": "暗算",
  "257542": "不死鸟之焰",
  "257620": "多重射击",
  "257621": "技巧射击",
  "257622": "技巧射击",
  "257745": "抓钩射击",
  "257746": "抓钩射击",
  "257747": "撼地者",
  "257748": "致盲",
  "257749": "践踏",
  "257750": "借用的自拍神器",
  "257752": "取消自拍",
  "257945": "暗影姿态",
  "257946": "狩猎刺激",
  "258860": "精华破碎",
  "258881": "毁灭之痕",
  "258883": "毁灭之痕",
  "258887": "仇恨之轮",
  "258920": "献祭光环",
  "258921": "献祭光环",
  "258922": "献祭光环",
  "258926": "邪能弹幕",
  "259277": "杀戮命令",
  "259285": "杀戮命令",
  "259388": "猫鼬之怒",
  "259448": "进食充分",
  "259449": "进食充分",
  "259452": "进食充分",
  "259453": "进食充分",
  "259454": "进食充分",
  "259455": "进食充分",
  "259456": "进食充分",
  "259457": "进食充分",
  "259489": "杀戮命令",
  "259495": "野火炸弹",
  "259756": "熵能之拥",
  "259930": "圣光熔炉",
  "260240": "弹无虚发",
  "260242": "弹无虚发",
  "260243": "乱射",
  "260247": "乱射",
  "260248": "觅血者",
  "260249": "觅血者",
  "260285": "利矛之刃",
  "260286": "利矛之刃",
  "260309": "狙击高手",
  "260364": "奥术脉冲",
  "260402": "二连发",
  "260404": "箭在弦上",
  "260708": "横扫攻击",
  "260734": "元素宗师",
  "260798": "斩杀",
  "260878": "幽灵狼",
  "260881": "幽灵狼",
  "261682": "真气爆裂",
  "261917": "身法如风",
  "262111": "精通：重伤",
  "262115": "重伤",
  "262150": "悍勇无畏",
  "262231": "战争机器",
  "262232": "战争机器",
  "262417": "共鸣图腾",
  "262647": "强风",
  "262652": "强风",
  "262796": "选择奥姆哈恩",
  "263165": "虚空洪流",
  "263585": "急速射击",
  "263642": "破裂",
  "263648": "灵魂壁障",
  "263725": "节能施法",
  "263806": "呼啸狂风",
  "263897": "土拨鼠",
  "264000": "死亡蔓延",
  "264078": "恐惧奇袭",
  "264130": "能量虹吸",
  "264173": "恶魔之核",
  "264178": "恶魔之箭",
  "264332": "游击战术",
  "264348": "猛虎扫尾",
  "264571": "夜幕",
  "264667": "原始暴怒",
  "264735": "优胜劣汰",
  "265046": "静电充能",
  "265157": "野火炸弹",
  "265187": "召唤恶魔暴君",
  "265189": "猛禽一击",
  "265273": "恶魔之力",
  "265898": "接战协定",
  "265931": "燃烧",
  "266030": "熵能返转",
  "266086": "混乱之雨",
  "266134": "内燃",
  "266136": "内燃",
  "266921": "天生狂野",
  "267116": "动物伙伴",
  "267213": "灾怨轰炸",
  "267214": "献祭之魂",
  "267216": "内心之魔",
  "267218": "虚空传送门",
  "267611": "正义裁决",
  "267964": "灵魂打击",
  "267971": "恶魔吞噬",
  "267972": "恶魔吞噬",
  "267986": "召唤玛克扎尔王子",
  "267987": "召唤伊利达雷萨特",
  "267988": "召唤邪恶的冥狱猎犬",
  "267989": "召唤古尔丹之眼",
  "267991": "召唤虚空恐魔",
  "267992": "召唤灾怨蝇",
  "267994": "召唤破坏魔",
  "267995": "召唤愤怒卫士",
  "267996": "召唤黑暗犬",
  "267997": "胆汁喷吐",
  "267999": "迎头冲撞",
  "268001": "召唤乌祖尔",
  "268175": "虚空掠夺者",
  "268358": "恶魔法阵",
  "268877": "野兽顺劈",
  "269352": "妖术",
  "269576": "狙击高手",
  "269650": "火焰冲撞",
  "269737": "捕食者头领",
  "269747": "野火炸弹",
  "270232": "冰冻之雨",
  "270233": "冰冻之雨",
  "270481": "恶魔之火",
  "270501": "苦修",
  "270557": "灵魂打击",
  "270569": "邪恶之喉",
  "270581": "自然治愈",
  "271534": "精通：优雅",
  "271877": "刀锋冲刺",
  "271896": "刀锋冲刺",
  "271971": "恐惧之咬",
  "272012": "暗影鞭笞",
  "272026": "钢铁之舞",
  "272131": "古尔丹之眼",
  "272156": "双重吐息",
  "272167": "剧毒胆汁",
  "272172": "乱刀斩",
  "272432": "高空突袭",
  "272435": "邪能之咬",
  "272439": "多面之咬",
  "272678": "原始暴怒",
  "272682": "主人的召唤",
  "272728": "厄运",
  "272737": "无穷力量",
  "272790": "狂乱",
  "273221": "余震",
  "273887": "杀手本能",
  "273946": "鲜血禁闭",
  "273952": "亡者之握",
  "273953": "饮血",
  "274009": "饮血",
  "274062": "氤氲之雾",
  "274281": "新月",
  "274282": "半月",
  "274283": "满月",
  "274586": "振奋之雾",
  "274738": "先祖召唤",
  "274739": "嘲颅狞笑",
  "274740": "火刃热忱",
  "274741": "霜狼勇猛",
  "274742": "黑石伟力",
  "274837": "野性狂乱",
  "274838": "野性狂乱",
  "274902": "光合作用",
  "274909": "升腾迷雾",
  "274912": "升腾迷雾",
  "275334": "惩罚",
  "275335": "惩罚",
  "275336": "狂雷奔涌",
  "275339": "滚石",
  "275430": "次级食尸鬼",
  "275773": "审判",
  "275779": "审判",
  "276023": "末日使者",
  "276079": "死亡延伸",
  "276112": "神圣马驹",
  "277787": "变形术",
  "277792": "变形术",
  "277953": "暗夜恐怖",
  "278310": "连锁反应",
  "278326": "吞噬魔法",
  "279043": "暗影之刃",
  "279302": "冰霜巨龙之怒",
  "279423": "百战老兵",
  "279620": "双月",
  "279709": "星辰领主",
  "279876": "可乘之机",
  "279910": "野生小鬼",
  "280127": "恶魔之箭",
  "280197": "灵魂专注",
  "280373": "多面防御",
  "280375": "多面防御",
  "280391": "诸罪加身",
  "280392": "血肉顺劈",
  "280515": "闪避身法",
  "280615": "迅捷洪流",
  "280715": "旋风斩",
  "280716": "吸血药膏",
  "280719": "影分身",
  "280720": "影分身",
  "280735": "斩杀",
  "280773": "破城者",
  "280849": "斩杀",
  "281000": "斩杀",
  "281001": "毁灭",
  "281238": "湮没",
  "281265": "神圣新星",
  "281327": "湮没",
  "281465": "复仇十字军",
  "281469": "苦修",
  "281482": "回响",
  "281592": "灵魂碎片",
  "281954": "翼手龙滑翔",
  "285381": "原始之怒",
  "285452": "熔岩爆裂",
  "285466": "熔岩爆裂过载",
  "285719": "进食充分",
  "285720": "进食充分",
  "285721": "进食充分",
  "287712": "强力一击",
  "288074": "进食充分",
  "288075": "进食充分",
  "288613": "百发百中",
  "288675": "浪潮汹涌",
  "288733": "暗影无形",
  "288826": "强化狂奔怒吼",
  "288843": "恶魔之拥",
  "288848": "通灵师的狡诈",
  "288853": "培育憎恶",
  "289237": "变形大师",
  "289439": "冰霜震击",
  "289577": "虚空洪流",
  "289874": "驾驭雷电",
  "290467": "进食充分",
  "290468": "进食充分",
  "290469": "进食充分",
  "291944": "再生！",
  "293866": "禅宗朝圣",
  "294020": "恢复迷雾",
  "297034": "进食充分",
  "297035": "进食充分",
  "297037": "进食充分",
  "297039": "进食充分",
  "297040": "进食充分",
  "297116": "进食充分",
  "297117": "进食充分",
  "297118": "进食充分",
  "297119": "进食充分",
  "298765": "地震术过载",
  "298836": "强效湍流合剂",
  "298837": "强效无尽深邃合剂",
  "298839": "强效广阔天涯合剂",
  "298841": "强效暗潮合剂",
  "299788": "炼金师的力量",
  "299789": "炼金师的敏捷",
  "299790": "炼金师的智力",
  "301768": "青翠之心",
  "303753": "冰龙吐息",
  "305394": "无拘自由",
  "312425": "翻找背包",
  "315341": "正中眉心",
  "315496": "切割",
  "315585": "速效药膏",
  "315924": "守护者之手",
  "316220": "洞悉弱点",
  "316239": "符文打击",
  "316402": "强化斩杀",
  "316405": "强化斩杀",
  "316531": "援护",
  "316803": "符文溢能",
  "316916": "顺劈打击",
  "317133": "强化吸血鬼之血",
  "317138": "意志的力量",
  "317610": "猩红余味",
  "317614": "猩红余味",
  "317776": "诅咒大军",
  "317859": "龙族强化",
  "317920": "专注光环",
  "318038": "火舌武器",
  "319066": "强化致伤药膏",
  "319175": "黑火药",
  "319190": "黑火药",
  "319504": "毒刃",
  "319930": "风暴轰击",
  "319949": "强化背刺",
  "319951": "强化袖剑风暴",
  "320313": "吞噬愤怒",
  "320331": "地狱火护甲",
  "320338": "精华破碎",
  "320361": "强化瓦解",
  "320364": "献祭光环",
  "320374": "燃烧之恨",
  "320379": "幽灵视觉",
  "320386": "弹跳利刃",
  "320387": "完美平衡利刃",
  "320413": "致命混沌",
  "320416": "烈焰之径",
  "320418": "强化悲苦咒符",
  "320635": "复仇桎梏",
  "320654": "追踪",
  "320747": "大地激涌",
  "320763": "法力之潮",
  "320770": "无拘怒意",
  "320976": "夺命射击",
  "321014": "兽群战术",
  "321136": "闪耀之光",
  "321290": "强化野火炸弹",
  "321291": "癫狂陨灭",
  "321297": "野兽之眼",
  "321379": "祷言之环",
  "321387": "启发",
  "321395": "变形术",
  "321420": "强化节能施法",
  "321460": "夺命之眼",
  "321507": "大法师之触",
  "321526": "法力专家",
  "321529": "奥术弹幕",
  "321538": "血溅十方",
  "321708": "强化烈焰护体",
  "321745": "强化棱光护体",
  "321973": "癫狂陨灭",
  "322101": "移花接木",
  "322102": "移花接木",
  "322105": "暗影盟约",
  "322109": "轮回之触",
  "322113": "强化轮回之触",
  "322115": "圣光的许诺",
  "322118": "青龙下凡",
  "322120": "酒醒入定",
  "322507": "天神酒",
  "322700": "神鹤引项踢",
  "322729": "神鹤引项踢",
  "322740": "强力践踏",
  "322960": "壮胆酒：决绝",
  "323558": "申斥回响",
  "323559": "申斥回响",
  "323560": "申斥回响",
  "324393": "醉拳",
  "325093": "酒仙轻酿",
  "325095": "轮回之触",
  "325153": "爆炸酒桶",
  "325174": "灵魂链接图腾",
  "325197": "朱鹤下凡",
  "325201": "赤精之舞",
  "325202": "赤精之舞",
  "325217": "骨尘酒",
  "325218": "骨尘酒",
  "325461": "湮灭",
  "325464": "冰霜打击",
  "326732": "苍穹之力",
  "326733": "苍穹之力",
  "326734": "治疗之手",
  "326805": "鲜红符文",
  "326808": "鲜红符文",
  "326853": "毁灭壁垒",
  "326855": "护咒符文",
  "326867": "护咒符文",
  "326911": "癔狂符文",
  "326918": "癔狂符文",
  "326977": "无尽渴求符文",
  "326984": "无尽渴求符文",
  "327082": "天启符文",
  "327264": "妖魂踏",
  "327327": "冷锋",
  "327510": "闪耀之光",
  "327541": "虚渺延火",
  "327993": "强化树皮术",
  "328025": "强化野性成长",
  "328082": "刺骨",
  "328085": "侧袭",
  "328670": "疾言厉色",
  "328725": "致死舞步",
  "328957": "灵魂残片",
  "333889": "邪能统御",
  "333919": "元素回响",
  "333977": "火焰新星",
  "334033": "熔火突袭",
  "334046": "鞭笞烈焰",
  "334168": "鞭笞烈焰",
  "334196": "冰雹",
  "334275": "疲劳诅咒",
  "334294": "火舌武器",
  "334302": "风怒武器",
  "334308": "连锁风暴",
  "334320": "大难临头",
  "334581": "能量虹吸",
  "334779": "间接伤害",
  "334934": "破坏者",
  "335077": "狂乱",
  "335082": "狂乱",
  "335096": "浴血奋战",
  "335097": "碎甲猛击",
  "335467": "暗言术：癫",
  "335913": "伏虎强雷",
  "336639": "血肉灰烬",
  "337551": "混沌理论",
  "337775": "邪能轰炸",
  "337819": "投掷利刃",
  "339140": "顶级捕食者的渴望",
  "339145": "猫眼奇珍",
  "339232": "灵魂灌注",
  "340056": "狂乱攻击",
  "340698": "骤然突袭",
  "341167": "敏捷才思",
  "341240": "强化虚空形态",
  "341263": "暗影幻灵",
  "341491": "暗影幻灵",
  "341997": "恢复信仰",
  "342231": "奥能回响",
  "342232": "奥能回响",
  "342245": "操控时间",
  "342246": "操控时间",
  "342247": "操控时间",
  "342249": "时间大师",
  "342344": "涅槃重生",
  "342857": "战刃风暴",
  "343014": "痛苦狂欢",
  "343143": "恐惧之刃",
  "343160": "预谋",
  "343183": "强化冰霜新星",
  "343206": "强化混乱打击",
  "343207": "聚焦裂劈",
  "343216": "狂暴",
  "343223": "狂暴",
  "343230": "火屑",
  "343242": "荒野医疗",
  "343244": "干扰弹",
  "343247": "强化陷阱",
  "343248": "夺命打击",
  "343294": "灵魂收割",
  "343295": "灵魂收割",
  "343311": "狂怒凝视",
  "343312": "狂怒凝视",
  "343527": "处决宣判",
  "343539": "魂游天外",
  "343647": "至日",
  "343655": "天神融合",
  "343690": "精通：暗影交织",
  "343737": "抚慰之息",
  "343764": "静心步",
  "343819": "迷雾之风",
  "343820": "朱鹤下凡",
  "344174": "闪电之盾",
  "344179": "漩涡武器",
  "344357": "风暴之舞",
  "344359": "止戈古训",
  "344548": "升腾",
  "344859": "恶魔之咬",
  "344862": "混乱打击",
  "344865": "邪能冲撞",
  "344939": "移花接木",
  "345208": "感染伤口",
  "346279": "灼烧之伤",
  "346665": "投掷利刃",
  "347461": "释放混沌",
  "347462": "释放混沌",
  "347765": "恶魔之魂",
  "350570": "燃焰饲魂",
  "350631": "燃焰饲魂",
  "351140": "流星",
  "351239": "幻容",
  "351338": "镇压",
  "353759": "深呼吸",
  "355630": "风幕",
  "355913": "翡翠之花",
  "355916": "翡翠之花",
  "355936": "梦境吐息",
  "355941": "梦境吐息",
  "356367": "死亡回响",
  "356995": "裂解",
  "357170": "时间膨胀",
  "357208": "火焰吐息",
  "357209": "火焰吐息",
  "357210": "深呼吸",
  "357211": "葬火",
  "357212": "葬火",
  "357214": "飞翼打击",
  "358267": "悬空",
  "358268": "悬空",
  "358385": "山崩",
  "358520": "玄牛下凡",
  "358733": "滑翔",
  "359073": "永恒之涌",
  "359077": "永恒之涌",
  "359618": "精华迸发",
  "359793": "婆娑幼苗",
  "359816": "梦境飞行",
  "360194": "死亡印记",
  "360806": "梦游",
  "360823": "自然平衡",
  "360827": "炽火龙鳞",
  "360828": "炽火龙鳞",
  "360995": "青翠之拥",
  "361195": "青翠之拥",
  "361227": "生还",
  "361237": "轨道打击",
  "361361": "婆娑幼苗",
  "361469": "活化烈焰",
  "361500": "活化烈焰",
  "361509": "活化烈焰",
  "361582": "荒野的召唤",
  "361753": "激活",
  "362874": "时光压缩",
  "362877": "时光压缩",
  "362969": "碧蓝打击",
  "362980": "精通：巨人杀手",
  "363495": "幻磷化身",
  "363502": "梦境飞行",
  "363510": "精通：生命的缚誓者",
  "363534": "回溯",
  "363591": "宿怨之敌",
  "363734": "基元潜能",
  "363830": "狮王之镰",
  "363911": "基元潜能",
  "363916": "黑曜鳞片",
  "363924": "基元之力",
  "363928": "野性狼魂",
  "363932": "野性狼魂",
  "363933": "野性狼魂",
  "363941": "野性狼魂",
  "364342": "青铜龙的祝福",
  "364343": "回响",
  "364365": "复苏之花",
  "364416": "狮王之心",
  "364418": "基元之拳",
  "364668": "宿怨之敌",
  "364686": "复苏之花",
  "365350": "奥术涌动",
  "365362": "奥术涌动",
  "365575": "梦醒",
  "365585": "净除",
  "365933": "飞行掌握",
  "365937": "红玉灰烬",
  "366155": "逆转",
  "367230": "精神之花",
  "367231": "精神之花",
  "367364": "逆转",
  "368275": "联结愈疗",
  "368276": "联结治疗",
  "368412": "危急时刻",
  "368415": "危急时刻",
  "368838": "翅大力沉",
  "368970": "扫尾",
  "369089": "动燃",
  "369297": "精华迸发",
  "369299": "精华迸发",
  "369374": "火焰风暴",
  "369459": "魔力之源",
  "369846": "火上浇油",
  "369908": "能量枢纽",
  "369909": "延展利爪",
  "369913": "自然聚合",
  "369939": "飞扑烈焰",
  "369990": "上古之火",
  "370062": "梦境原野",
  "370454": "聚能冲击",
  "370455": "聚能冲击",
  "370537": "静滞",
  "370553": "扭转天平",
  "370562": "静滞",
  "370586": "艾露恩的青睐",
  "370665": "营救",
  "370695": "自然之怒",
  "370781": "毁灭将至",
  "370819": "灼火余灰",
  "370821": "能量闪烁",
  "370837": "噬体光焰",
  "370839": "能量汹涌",
  "370845": "织法者统御",
  "370867": "虹彩变换",
  "370886": "丰饶之花",
  "370888": "双生护卫",
  "370901": "飞扑烈焰",
  "370965": "恶魔追击",
  "370966": "恶魔追击",
  "370967": "恶魔追击",
  "370969": "恶魔追击",
  "370971": "恶魔追击",
  "370984": "翡翠交融",
  "371032": "天空霸主",
  "371034": "焦痕遍野",
  "371038": "锋锐侵攻",
  "371257": "新生吐息",
  "371426": "赐命者之焰",
  "371441": "赐命者之焰",
  "371806": "回归",
  "371871": "生生不息",
  "371877": "生生不息",
  "371879": "生生不息",
  "371905": "野火烧不尽",
  "372048": "压迫怒吼",
  "372119": "塞纳留斯的梦境",
  "372233": "能量循环",
  "372234": "能量循环",
  "372307": "炽燃圣火",
  "372313": "共鸣圣言",
  "372370": "雄浑圣歌",
  "372469": "绯红适性",
  "372527": "时光之主",
  "372567": "双生月火",
  "372571": "魔力之源",
  "372616": "苍穹之焰",
  "372618": "脆弱血肉",
  "372761": "神恩术：罚",
  "372787": "神言术：佑",
  "372791": "神恩术：静",
  "372847": "蒙恩飞弹",
  "372943": "狂野蛮兽",
  "372945": "重焕活力",
  "372969": "神圣射线",
  "372972": "沉溺黑暗",
  "372991": "痛苦转换",
  "373003": "黑暗狂欢",
  "373035": "护佑弱者",
  "373049": "圣障",
  "373054": "深渊遐思",
  "373180": "严酷戒律",
  "373183": "严酷戒律",
  "373202": "蚀心魔",
  "373204": "蚀心魔",
  "373212": "怒火暗生",
  "373213": "怒火暗生",
  "373218": "血色教义",
  "373223": "避缴奉纳",
  "373267": "缚誓生命",
  "373268": "缚誓生命",
  "373270": "缚誓生命",
  "373273": "尤格-萨隆的神像",
  "373279": "虚空之刺",
  "373280": "恩佐斯的神像",
  "373310": "亚煞极的神像",
  "373316": "亚煞极的神像",
  "373427": "折磨缠身",
  "373442": "折磨缠身",
  "373446": "通透影像",
  "373450": "圣光鼓舞",
  "373456": "坚定意志",
  "373466": "双子太阳女祭司",
  "373834": "伊瑟拉之唤",
  "373861": "时空畸体",
  "373862": "时空畸体",
  "373930": "寒意剧增",
  "374030": "血之气息",
  "374049": "压制",
  "374227": "微风",
  "374251": "灼烧之焰",
  "374261": "秽邪之缚",
  "374265": "邪恶动能",
  "374277": "强化灵界打击",
  "374346": "震魂摄魄",
  "374348": "新生光焰",
  "374349": "新生光焰",
  "374383": "同化",
  "374504": "羸弱",
  "374574": "符文掌握",
  "374598": "抽血",
  "374715": "强化白骨之盾",
  "374717": "强化心脏打击",
  "374747": "黑锋骑士团之毅",
  "374968": "时间螺旋",
  "375087": "狂龙之怒",
  "375226": "时间螺旋",
  "375229": "时间螺旋",
  "375230": "时间螺旋",
  "375234": "时间螺旋",
  "375238": "时间螺旋",
  "375240": "时间螺旋",
  "375252": "时间螺旋",
  "375253": "时间螺旋",
  "375254": "时间螺旋",
  "375255": "时间螺旋",
  "375256": "时间螺旋",
  "375257": "时间螺旋",
  "375258": "时间螺旋",
  "375406": "黑曜壁垒",
  "375443": "痛击横扫",
  "375510": "爆裂熔炉",
  "375517": "长期飞行",
  "375520": "内在魔法",
  "375528": "山脉塑造者",
  "375542": "精力旺盛",
  "375544": "原生抗性",
  "375554": "燃火",
  "375556": "顺风之力",
  "375561": "葱郁生长",
  "375574": "生命聚焦",
  "375576": "圣洁鸣钟",
  "375583": "上古之火",
  "375618": "奥能绽放",
  "375721": "碧蓝精华迸发",
  "375722": "精华协调",
  "375725": "热浪来袭",
  "375757": "永恒跨距",
  "375767": "虚空尖啸",
  "375777": "因果律",
  "375783": "魔法之泉",
  "375796": "贮藏能量",
  "375797": "憎恨不息",
  "375801": "燃尽",
  "375802": "燃尽",
  "375888": "暗影洞察",
  "375981": "暗影洞察",
  "375982": "始源之潮",
  "375984": "始源之潮",
  "375985": "始源之潮",
  "375986": "始源之潮",
  "375994": "精神腐烂",
  "376079": "勇士之矛",
  "376080": "勇士之矛",
  "376138": "移情共生",
  "376150": "精神澄澈",
  "376164": "本源奥秘",
  "376166": "巨龙传承",
  "376179": "生命之力治愈者",
  "376204": "恰逢其时",
  "376207": "延缓伤害",
  "376237": "诺兹多姆的讲义",
  "376239": "恩惠时刻",
  "376240": "越时魔法",
  "376251": "符文掌控",
  "376788": "梦境吐息",
  "376850": "能量汹涌",
  "376872": "红玉精华迸发",
  "376888": "残暴",
  "376930": "梦境同调",
  "376938": "永冻之冰",
  "377053": "雪恨圣印",
  "377056": "刺骨之寒",
  "377065": "意志坚定",
  "377073": "冬寒处刑者",
  "377076": "冰封勇士之怒",
  "377098": "断裂之痕",
  "377099": "洞察之火",
  "377100": "振奋迸发",
  "377102": "振奋迸发",
  "377128": "辉金之道",
  "377129": "辉金之道",
  "377190": "历久弥坚",
  "377210": "乌索克之怒",
  "377226": "冰霜统御",
  "377349": "克苏恩的神像",
  "377358": "克苏恩的神像",
  "377440": "邪恶光环",
  "377514": "割魂索命",
  "377580": "腐烂回响",
  "377587": "食尸鬼狂热",
  "377588": "食尸鬼狂热",
  "377590": "上古神力",
  "377592": "病变",
  "377629": "吸血打击",
  "377637": "无餍狂刃",
  "377668": "长久羁绊",
  "377796": "自然恢复",
  "377811": "固有决心",
  "377835": "兽群先锋",
  "377842": "巨熊活力",
  "377847": "精确本能",
  "377933": "星界壁垒",
  "378002": "寻路",
  "378004": "视力敏锐",
  "378075": "雷霆之爪",
  "378077": "灵魂行者的神盾",
  "378081": "自然迅捷",
  "378193": "原始狂怒",
  "378196": "黄金时刻",
  "378207": "杀戮顺劈",
  "378209": "训练专家",
  "378211": "复苏水域",
  "378213": "黄金时刻",
  "378244": "眼镜蛇感官",
  "378255": "火焰召唤",
  "378266": "釜镬之焰",
  "378270": "根深蒂固的元素",
  "378279": "金色瓦格里的礼物",
  "378285": "提尔的执行者",
  "378405": "泰坦之光",
  "378406": "寒冬狂潮",
  "378425": "乌瑟尔的劝谏",
  "378427": "心灵手巧",
  "378436": "毒物大师",
  "378442": "狂野本能",
  "378443": "酸雨",
  "378448": "碎裂寒冰",
  "378457": "飞舞之盾",
  "378597": "酸雨",
  "378743": "凶暴命令",
  "378747": "凶暴兽群",
  "378762": "费伦·玛库斯的狂热",
  "378767": "专注瞄准",
  "378770": "夺命打击",
  "378773": "强效净化术",
  "378807": "暗影奔行者",
  "378813": "健步如飞",
  "378845": "专注敌意",
  "378848": "冰冷渴望",
  "378913": "轻型弹药",
  "378919": "刺骨之冰",
  "378934": "突刺",
  "378937": "爆破专家",
  "378947": "冰河突击",
  "378950": "长矛横扫",
  "378955": "杀手伙伴",
  "378988": "莱卡拉的教诲",
  "378996": "休养疗伤",
  "379005": "劈头棒击",
  "379021": "庇护",
  "379022": "烈火奉献",
  "379391": "急促祷告",
  "379993": "冰霜速冻",
  "380188": "十字军的决心",
  "381542": "致命精准",
  "381543": "恶毒药膏",
  "381619": "经世之才",
  "381620": "强化伏击",
  "381621": "精打细算",
  "381623": "菊花茶",
  "381624": "强化药膏",
  "381626": "血肉相连",
  "381627": "内出血",
  "381628": "内出血",
  "381629": "精准投掷",
  "381630": "杀意已决",
  "381631": "匕首飞掷",
  "381632": "强化锁喉",
  "381637": "萎缩药膏",
  "381640": "致命剂量",
  "381647": "位面旅行者",
  "381650": "元素防护",
  "381652": "机能失调",
  "381655": "自然之怒",
  "381664": "增效药膏",
  "381673": "末日之刃",
  "381689": "生机盎然",
  "381707": "膨胀漩涡",
  "381708": "风暴之眼",
  "381725": "大地震击过载",
  "381726": "山峦将倾",
  "381773": "蚀骨之寒",
  "381782": "灼热烈焰",
  "381784": "炎魔之火",
  "381797": "冲动恶徒",
  "381798": "佐迪克配方",
  "381799": "血之气息",
  "381801": "龙淬之锋",
  "381828": "袖里乾坤",
  "381839": "手法娴熟",
  "381845": "胆大妄为",
  "381846": "迅疾连射",
  "381867": "图腾潮涌",
  "381877": "作战耐力",
  "381878": "矫捷灵动",
  "381885": "千钧重击",
  "381921": "衔尾轮回",
  "381922": "时光巧匠",
  "381930": "法力之泉",
  "381931": "法力之泉",
  "381936": "须臾闪电",
  "381946": "波涛语者祝福",
  "381988": "迅猛挥砍",
  "381989": "时运继延",
  "381990": "倏然斩击",
  "382015": "腐化印记",
  "382017": "虚帷之触",
  "382020": "大地祥和",
  "382021": "大地生命武器",
  "382024": "大地生命武器",
  "382030": "流水图腾掌握",
  "382032": "回声蓄能",
  "382039": "潮汐之流",
  "382042": "碎裂元素",
  "382043": "碎裂元素",
  "382045": "始源之潮核心",
  "382194": "暗流",
  "382197": "先祖狼魂亲和",
  "382201": "图腾集中",
  "382215": "奥拉基尔之风",
  "382238": "致命偷袭",
  "382245": "冷血杀手",
  "382258": "吸血打击",
  "382260": "迅疾步法",
  "382266": "火焰吐息",
  "382268": "时光飞逝",
  "382293": "迅捷祈咒",
  "382297": "慧心灵性",
  "382309": "先祖复苏",
  "382311": "先祖复苏",
  "382315": "强化大地生命武器",
  "382411": "永恒之涌",
  "382424": "冬日守护",
  "382482": "奔涌之泉",
  "382490": "安东尼达斯的魔典",
  "382493": "罗宁的魔典",
  "382503": "刹那抉择",
  "382504": "玄黑秘酿",
  "382505": "第一支舞",
  "382506": "暗影增生",
  "382507": "黑暗帷幕",
  "382508": "处决谋划",
  "382511": "影武终结",
  "382512": "强化洞悉弱点",
  "382513": "遁形无迹",
  "382514": "隐匿无踪",
  "382515": "暗影遮蔽",
  "382517": "深刺匕首",
  "382518": "铁拳穿刺",
  "382524": "纠缠暗影",
  "382525": "终结预兆",
  "382528": "断魂之舞",
  "382536": "圣洁庇护",
  "382549": "痛尽甘来",
  "382550": "季节变迁",
  "382552": "强化铁木树皮",
  "382559": "狂野生长",
  "382614": "梦境吐息",
  "382731": "精神之花",
  "382732": "先祖之触",
  "382764": "碾压之力",
  "382767": "怒不可挡",
  "382886": "冰火夹击",
  "382888": "乱舞",
  "382895": "单手武器专精",
  "382896": "双手武器专精",
  "382900": "双武器专精",
  "382939": "加固板甲",
  "382946": "狂野打击",
  "383010": "元素环绕",
  "383013": "清毒图腾",
  "383016": "强化净化灵魂",
  "383061": "岩浆喷发",
  "383082": "野蛮训练",
  "383092": "奥术防护",
  "383103": "残暴动力",
  "383121": "群体变形",
  "383154": "放血",
  "383155": "强化横扫攻击",
  "383191": "赋新源生",
  "383193": "林地护理",
  "383195": "劲烈星影",
  "383197": "偏轨星月",
  "383222": "溢流海滩",
  "383223": "溢流海滩",
  "383228": "迅捷审判",
  "383235": "暗流",
  "383269": "灾殃坟茔",
  "383281": "藏锋寻时",
  "383287": "浴血之躯",
  "383290": "主宰",
  "383295": "熟能生巧",
  "383297": "暴虐成性",
  "383313": "灾殃坟茔",
  "383328": "最终审判",
  "383329": "最终审判",
  "383341": "尖锐利刃",
  "383342": "神圣之刃",
  "383344": "异端逐除",
  "383346": "异端逐除",
  "383352": "不懈之能",
  "383388": "无情审讯",
  "383389": "无情审讯",
  "383391": "炽燃感触",
  "383395": "炽燃感触",
  "383396": "光明使者的风暴",
  "383405": "深刺匕首",
  "383410": "超凡之盟",
  "383430": "穿刺",
  "383468": "狂怒提振",
  "383486": "混沌专注",
  "383608": "强化灼烧",
  "383634": "炽烈冲动",
  "383648": "大地之盾",
  "383669": "掌控毁灭",
  "383676": "奥能动力",
  "383695": "强化幻灭踢",
  "383697": "萨萨拉比姆的力量",
  "383698": "滚烫烧酒",
  "383700": "盖平的御酒",
  "383703": "致死",
  "383704": "致死印记",
  "383706": "致死印记",
  "383707": "风暴烈酒的珍藏酒桶",
  "383714": "砮皂的试炼",
  "383785": "反击",
  "383800": "反击",
  "383810": "狂热法咒",
  "383811": "狂热法咒",
  "383848": "狂乱之怒",
  "383852": "敌意",
  "383854": "强化怒击",
  "383873": "劈斩",
  "383874": "过热高温",
  "383877": "劈斩",
  "383882": "太阳之王的祝福",
  "383883": "太阳王的怒火",
  "383885": "恶毒蔑视",
  "383959": "寒光热血",
  "383967": "文火慢灼",
  "383978": "寒光热血",
  "383980": "奥术迅疾",
  "383994": "龙焰酒",
  "384027": "圣洁共鸣",
  "384036": "野蛮活力",
  "384041": "战略专家",
  "384043": "破敌专注",
  "384060": "发散思维",
  "384063": "持久迅捷",
  "384067": "聚力",
  "384072": "磐固壁垒",
  "384088": "大分裂的回响",
  "384100": "狂暴之吼",
  "384110": "破裂投掷",
  "384124": "全副武装",
  "384143": "溢流漩涡",
  "384149": "暴怒漩涡",
  "384174": "烈焰大师",
  "384352": "毁灭之风",
  "384355": "元素武器",
  "384361": "血涌",
  "384363": "汇聚风暴",
  "384411": "静电积聚",
  "384444": "托里姆的祈咒",
  "384450": "闪电打击",
  "384451": "闪电打击",
  "384452": "奥术齐射",
  "384612": "超凡专家",
  "384651": "充能宝珠",
  "384665": "血腥气息",
  "384667": "骤然突袭",
  "384799": "猎人闪避",
  "384815": "明澈圣印",
  "384820": "正义牺牲",
  "384858": "宝珠弹幕",
  "384906": "怜悯圣印",
  "384909": "强化保护祝福",
  "384914": "牺牲报偿",
  "385059": "奥丁之怒",
  "385060": "奥丁之怒",
  "385061": "奥丁之怒副手",
  "385062": "奥丁之怒",
  "385126": "黄昏祝福",
  "385127": "黎明祝福",
  "385167": "无尽寒霜",
  "385391": "法术反射",
  "385408": "败血刃伤",
  "385414": "残光",
  "385427": "坚决",
  "385450": "力量圣印",
  "385478": "暗影窒息",
  "385515": "神圣护佑",
  "385539": "春回大地",
  "385540": "春回大地",
  "385571": "强化压制",
  "385616": "申斥回响",
  "385627": "君王之灾",
  "385633": "坚定光环",
  "385696": "心流状态",
  "385703": "浴血之躯",
  "385704": "浴血之躯",
  "385722": "静默风暴",
  "385737": "血腥之爪",
  "385786": "蓬乱毛皮",
  "385810": "凶猛狂暴",
  "385840": "雷霆之王",
  "385881": "黑暗收割者的教导",
  "385888": "坚如钢钉",
  "385899": "灵魂燃烧",
  "385952": "盾牌冲锋",
  "385954": "盾牌冲锋",
  "386011": "盾牌专精效果",
  "386027": "持久防御",
  "386029": "抵御冲击",
  "386030": "抵御冲击",
  "386071": "瓦解怒吼",
  "386110": "恶魔步",
  "386113": "邪能誓约",
  "386124": "邪甲术",
  "386164": "战斗姿态",
  "386185": "恶魔知识",
  "386194": "肉食追踪者",
  "386196": "狂暴姿态",
  "386208": "防御姿态",
  "386270": "胆大妄为",
  "386272": "泰坦之怒",
  "386283": "催化",
  "386348": "黑龙遗产",
  "386353": "虹彩变换：红龙",
  "386394": "历战老兵",
  "386399": "虹彩变换：蓝龙",
  "386405": "内心之光",
  "386477": "怒意迸发",
  "386478": "怒意迸发",
  "386617": "恶魔坚韧",
  "386628": "迷狂乱舞",
  "386630": "战争领主",
  "386633": "刽子手的精准",
  "386634": "刽子手的精准",
  "386648": "梦魇",
  "386653": "正义之怒壁垒",
  "386659": "黑暗协约",
  "386664": "恶魔灵液",
  "386686": "契约供体",
  "386689": "饕餮契约",
  "386730": "圣洁共鸣",
  "386738": "圣洁共鸣",
  "386760": "疫灾祷告",
  "386762": "疫灾祷告",
  "386763": "极寒",
  "386828": "充能护体",
  "386870": "残酷伙伴",
  "386937": "淬火神酿",
  "386959": "灼焰炙气",
  "386963": "灼焰炙气",
  "386965": "灼焰炙气",
  "386976": "凋零箭",
  "386986": "萨洛拉丝的黑暗之击",
  "387044": "烁焰闪闪",
  "387046": "醉踪步",
  "387103": "毁灭",
  "387108": "混沌燃烧",
  "387113": "处决宣判",
  "387154": "焚烧成灰",
  "387166": "愤怒魔火",
  "387170": "苍穹之遗",
  "387173": "天魔余烬",
  "387178": "苍穹之遗",
  "387184": "精序兵戈",
  "387219": "玄牛伴身",
  "387230": "流云身法",
  "387252": "灰烬残骸",
  "387259": "闪点",
  "387263": "闪点",
  "387275": "混乱具象",
  "387276": "灵魂之力",
  "387327": "暗影之咬",
  "387341": "遭受重击",
  "387350": "衔尾轮回",
  "387384": "反冲",
  "387393": "恐惧召唤",
  "387409": "阿兹亚基的疯狂",
  "387413": "阿兹亚基的疯狂",
  "387414": "阿兹亚基的疯狂",
  "387437": "邪能契约",
  "387506": "暴乱",
  "387570": "翻滚浩劫",
  "387621": "龙焰酒",
  "387625": "幻灭醉拳",
  "387638": "太极鞋",
  "387761": "万应灵药",
  "387763": "万应灵药",
  "387781": "统御圣光",
  "387786": "恻隐时刻",
  "387787": "再生魔法",
  "387791": "以太结界",
  "387801": "回响祝福",
  "387805": "神圣顿悟",
  "387807": "掌控时间",
  "387808": "神圣启示",
  "387812": "神圣启示",
  "387879": "破晓",
  "387991": "晨晖之露",
  "388007": "仲夏祝福",
  "388009": "仲夏祝福",
  "388010": "暮秋祝福",
  "388011": "凛冬祝福",
  "388013": "阳春祝福",
  "388020": "璀璨迷雾",
  "388023": "谆谆古训",
  "388024": "谆谆古训",
  "388025": "谆谆古训",
  "388026": "碧火之训",
  "388031": "翡翠羁绊",
  "388038": "玉珑的低语",
  "388039": "孤独幸存者",
  "388044": "玉珑的低语",
  "388106": "碎魂创痕",
  "388107": "怒焰",
  "388108": "先发制人",
  "388112": "混沌变身",
  "388113": "落单的猎物",
  "388116": "破碎的命运",
  "388118": "知己知彼",
  "388203": "碧火踏",
  "388207": "碧火踏",
  "388212": "天神之赐",
  "388218": "静心凝雾",
  "388220": "静心凝雾",
  "388480": "谐唱",
  "388491": "秘术传功",
  "388497": "秘术传功",
  "388498": "秘术传功",
  "388499": "秘术传功",
  "388500": "秘术传功",
  "388505": "浅斟快饮",
  "388510": "疗愈扩散",
  "388511": "浓雾弥漫",
  "388513": "浓雾弥漫",
  "388539": "撕裂",
  "388548": "生命之雾",
  "388551": "起死回生",
  "388555": "起死回生",
  "388593": "平静愈合",
  "388615": "还阳术",
  "388663": "祈求者之愉",
  "388664": "平心静气",
  "388667": "吸取灵魂",
  "388674": "雪怒之勇",
  "388681": "飘忽迷雾",
  "388682": "迷雾之峰",
  "388701": "缥缈之雾",
  "388779": "仙鹤之道",
  "388809": "无影步",
  "388811": "神鹤恩典",
  "388812": "活力苏醒",
  "388813": "迅疾豪胆",
  "388814": "铁壁酒",
  "388827": "爆破潜能",
  "388832": "炽烈火焰",
  "388847": "云雾飞散",
  "388848": "鹤舞龙卷",
  "388849": "东升之星",
  "388856": "猛虎之触",
  "388867": "爆炸酒桶",
  "388874": "强化清创生血",
  "388917": "壮胆酒",
  "389019": "子弹风暴",
  "389020": "子弹风暴",
  "389220": "炽烈灭亡",
  "389306": "暴虐成性",
  "389325": "仙鹤之道",
  "389328": "仙鹤之道",
  "389367": "邪能共效",
  "389539": "戒卫",
  "389579": "普度众生",
  "389590": "恶魔韧性",
  "389609": "深渊行者",
  "389623": "血魔的决心",
  "389682": "邪恶耐性",
  "389687": "混沌理论",
  "389688": "战术撤退",
  "389693": "内心之魔",
  "389695": "伊利达雷的意志",
  "389696": "伊利达雷的知识",
  "389705": "强固邪焰",
  "389708": "黑眼之赐",
  "389711": "贩卖灵魂",
  "389715": "愤怒锁链",
  "389718": "咒符之环",
  "389720": "钙化尖刺",
  "389724": "邪火之拳",
  "389729": "以牙还牙",
  "389732": "葬身火海",
  "389763": "战刃大师",
  "389781": "长夜",
  "389783": "漆黑",
  "389824": "碎魂恢复",
  "389845": "灾难痛苦",
  "389846": "邪火疾速",
  "389849": "黑暗迷失",
  "389860": "怨念咒符",
  "389868": "恐惧之触",
  "389890": "战术撤退",
  "389942": "迎面铁掌",
  "389958": "脆弱",
  "389976": "易伤",
  "389977": "无情强攻",
  "389978": "命运共舞",
  "389985": "灵魂重碾",
  "390105": "普度众生",
  "390137": "内心之魔",
  "390145": "内心之魔",
  "390152": "聚凝痛楚",
  "390154": "锯齿战刃",
  "390158": "滋长炼狱",
  "390163": "怨念咒符",
  "390166": "疫病掌控",
  "390181": "碎魂创痕",
  "390195": "混沌理论",
  "390196": "亡者魔导师",
  "390197": "怒焰",
  "390213": "炽燃之血",
  "390218": "溢流能量",
  "390259": "亡者指挥官",
  "390264": "亡者指挥官",
  "390270": "崩坏缠绕",
  "390283": "超级菌株",
  "390287": "风暴轰击",
  "390288": "不羁之风",
  "390370": "灰烬触媒",
  "390371": "灰烬触媒",
  "390378": "轨道打击",
  "390386": "守护巨龙之怒",
  "390414": "化身：艾露恩之眷",
  "390620": "优雅步态",
  "390632": "强化纯净术",
  "390667": "法术屏障",
  "390670": "强化渐隐术",
  "390676": "激励",
  "390684": "双目耀光",
  "390685": "持久之光",
  "390686": "痛苦惩罚",
  "390689": "饱受折磨",
  "390691": "争分夺秒",
  "390692": "争分夺秒",
  "390693": "心灵专注",
  "390772": "扑击",
  "390786": "祸福相倚",
  "390787": "祸福相倚",
  "390808": "动燃焰血",
  "390832": "赎罪",
  "390844": "赎罪",
  "390845": "神圣之星",
  "390864": "狂野切割",
  "390902": "捕食本能",
  "390919": "纯粹恐惧",
  "390954": "危机管理",
  "390964": "光晕",
  "390967": "棱光回响",
  "390971": "光晕",
  "390972": "命运多舛",
  "390977": "善德祷言",
  "390978": "命运多舛",
  "390981": "神圣之星",
  "390992": "织光者",
  "390993": "织光者",
  "390994": "和谐之声",
  "391045": "重度裂伤",
  "391054": "代祷",
  "391058": "眼棱",
  "391078": "狂热之怒",
  "391090": "碎裂心智",
  "391092": "碎裂心智",
  "391099": "黑暗福音",
  "391124": "代偿",
  "391142": "狂热圣贤",
  "391151": "神机妙算",
  "391159": "恶魔尖刺",
  "391174": "狂暴：狮王之心",
  "391178": "熊熊大火",
  "391186": "念诵祷言",
  "391189": "灼烧之伤",
  "391209": "漫长祈祷",
  "391215": "先发制人",
  "391228": "疯狂之触",
  "391232": "疯狂之触",
  "391233": "圣洁奉献",
  "391271": "干练反射",
  "391275": "狂飙利刃",
  "391284": "痛苦之魂",
  "391330": "精湛拳法",
  "391347": "撕裂切割",
  "391356": "撕裂",
  "391370": "角杯盖子",
  "391381": "绝望时刻",
  "391383": "硬化鞋底",
  "391386": "鲜血盛宴",
  "391395": "钢铁之心",
  "391397": "不稳定的恶魔之心",
  "391398": "充血之眼",
  "391399": "狂乱激涌",
  "391401": "精神鞭笞：狂",
  "391403": "精神鞭笞：狂",
  "391409": "奥达奇的设计",
  "391458": "血色之地",
  "391477": "凝血",
  "391517": "永恒脐带",
  "391527": "永恒脐带",
  "391528": "万灵之召",
  "391546": "黑暗行军",
  "391548": "阿莎曼的指引",
  "391559": "激涌射击",
  "391566": "阴险寒意",
  "391571": "晦暗结界",
  "391622": "变形术",
  "391700": "双爪斜掠",
  "391709": "野性难驯",
  "391710": "野性难驯",
  "391722": "剑齿利刃",
  "391872": "猛虎之韧",
  "391875": "狂乱动能",
  "391876": "狂乱动能",
  "391881": "顶级捕食者的渴望",
  "391882": "顶级捕食者的渴望",
  "391888": "激变蜂群",
  "391889": "激变蜂群",
  "391891": "激变蜂群",
  "391978": "血管裂创",
  "392053": "刺骨之牙",
  "392058": "哀恸箭",
  "392060": "哀恸箭",
  "392099": "滋养休眠",
  "392116": "再生心木",
  "392117": "再生心木",
  "392124": "梦境之拥",
  "392147": "梦境之拥",
  "392167": "永茂",
  "392221": "梦境初醒",
  "392256": "祥和绽放",
  "392268": "精华迸发",
  "392288": "自然的壮美",
  "392302": "大德鲁伊的力量",
  "392325": "新绿",
  "392329": "新绿",
  "392352": "风暴狂怒",
  "392356": "森林再生",
  "392375": "大地武器",
  "392378": "强化自然之愈",
  "392384": "致命药剂",
  "392403": "强化锁喉",
  "392410": "翡翠灌注",
  "392507": "亡语者",
  "392566": "衰弱",
  "392777": "残虐打击",
  "392778": "狂野打击",
  "392792": "暴乱狂战士",
  "392883": "活力苏醒",
  "392900": "生机蓬勃",
  "392902": "壮丽圣光",
  "392903": "壮丽圣光",
  "392907": "太阳井之花",
  "392910": "后发制人",
  "392911": "不屈精神",
  "392915": "治疗之泉图腾",
  "392916": "治疗之泉图腾",
  "392928": "提里奥的虔诚",
  "392931": "残酷",
  "392936": "愤与怒",
  "392937": "愤与怒",
  "392938": "崇圣",
  "392950": "破冰",
  "392956": "巨熊之韧",
  "392958": "旭日峥嵘",
  "392959": "旭日峥嵘",
  "392961": "强能灌注",
  "392979": "青玉破",
  "392982": "太极鞋",
  "392983": "风领主之击",
  "392985": "雷拳之怒",
  "392986": "雪怒羁绊",
  "392988": "神圣镜像",
  "392993": "雪怒的战甲",
  "392994": "碧玉通途",
  "393024": "强化清洁术",
  "393029": "愤怒投掷",
  "393035": "投掷利刃",
  "393039": "皇帝的容电器",
  "393053": "点穴踢",
  "393056": "真气破",
  "393057": "真气能量",
  "393071": "逆境搏力",
  "393114": "强化炽热防御者",
  "393357": "宁静之魂",
  "393371": "塞纳留斯的指引",
  "393414": "乌索克的指引",
  "393427": "掠袭之爪",
  "393516": "无常虚妄",
  "393611": "乌索尔的坚韧",
  "393617": "原始利爪",
  "393618": "强化鬃毛",
  "393646": "猎人野兽控制职业套装两件套",
  "393647": "猎人野兽控制职业套装四件套",
  "393648": "猎人射击职业套装两件套",
  "393649": "猎人射击职业套装四件套",
  "393760": "星影之拥",
  "393786": "气冲九霄",
  "393822": "内心冲突",
  "393827": "引火",
  "393834": "邪能毁灭",
  "393870": "强化快速治疗",
  "393933": "战争命令",
  "393940": "织星者",
  "393942": "织星者的经纱",
  "393944": "织星者的纬纱",
  "393950": "血腥疯狂",
  "393951": "血腥疯狂",
  "393954": "星辰轰鸣",
  "393957": "阑珊暮光",
  "393959": "自然的优雅",
  "393970": "抚慰之黯",
  "393991": "月神的守护",
  "394013": "化身：艾露恩之眷",
  "394026": "败血刃伤",
  "394036": "锯齿骨刺",
  "394038": "锯齿骨刺",
  "394046": "戈德林之力",
  "394048": "万物平衡",
  "394049": "万物平衡",
  "394050": "万物平衡",
  "394065": "梦境住民",
  "394083": "法夜之友",
  "394088": "复仇十字军",
  "394094": "碎裂天穹",
  "394108": "碎裂天穹",
  "394110": "魂游天外",
  "394111": "艾露恩之怒",
  "394121": "耀世月光",
  "394123": "致命之触",
  "394173": "要害打击",
  "394298": "致命指令",
  "394311": "斗志昂扬",
  "394320": "隐秘诡计",
  "394321": "狡诈计谋",
  "394371": "箭无虚发",
  "394384": "集中瞄准",
  "394412": "摘星揽月",
  "394414": "浩瀚之触",
  "394465": "锋利兽爪",
  "394544": "时间扭曲者",
  "394565": "临界成长",
  "394624": "宽恕之盾",
  "394709": "永恒圣光",
  "394776": "灼热流星",
  "394879": "恶意追击",
  "394930": "舞影成双",
  "394931": "蹈厉奋发",
  "394979": "精神灼烧",
  "395001": "魔怒烈焰",
  "395022": "超凡之盟",
  "395152": "黑檀之力",
  "395153": "时间之沙",
  "395160": "喷发",
  "395296": "黑檀之力",
  "395413": "碧火烙",
  "395414": "碧火烙",
  "395422": "强化冲动",
  "395424": "强化冲动",
  "395446": "灵魂咒符",
  "396167": "雪怒之怒",
  "396168": "雪怒之怒",
  "396187": "精华迸发",
  "396286": "地壳激变",
  "396288": "地壳激变",
  "396749": "肆意放纵",
  "396752": "碎甲猛击",
  "397103": "护卫神盾",
  "397768": "平常心",
  "399226": "生机迸发",
  "399230": "生机迸发",
  "399491": "神龙之赐",
  "399510": "神龙之赐",
  "400053": "傲之雾纱",
  "400059": "星月流转",
  "400129": "森林小径",
  "400140": "连绵狂风",
  "400142": "阵风",
  "400185": "邪能弹幕",
  "400205": "终结压制",
  "400254": "摧折",
  "400278": "隐月之夜",
  "400320": "生死循环",
  "400370": "炽燃圣火",
  "400456": "齐射",
  "400533": "繁茂合成",
  "400629": "玄牛之魂",
  "400803": "神兵之力",
  "400804": "不破之步",
  "401382": "活化烈焰",
  "402912": "正义感召",
  "402964": "圣化护甲",
  "402971": "神圣制裁",
  "403010": "受祝福的勇士",
  "403026": "燃烧的远征",
  "403208": "巨龙协调",
  "403264": "黑龙协调",
  "403479": "光铸祝福",
  "403495": "公正审判",
  "403509": "狂热者的赤诚",
  "403521": "宁静心灵",
  "403530": "惩罚",
  "403631": "亘古吐息",
  "403664": "圣光之剑",
  "403745": "强化公正之剑",
  "403826": "复仇之剑",
  "403876": "圣佑术",
  "404195": "驳斥命运",
  "404357": "向善祷言",
  "404408": "智慧遗产",
  "404436": "圣光的正义",
  "404512": "大领主之怒",
  "404521": "快速生长",
  "404523": "灵魂行者的潮汐图腾",
  "404542": "远征打击",
  "404550": "法力之泉",
  "404752": "惩戒律令",
  "404977": "时间跳跃",
  "405278": "无尽审判",
  "405355": "沸腾烈焰",
  "405461": "强化审判",
  "405746": "暗影幻灵",
  "406064": "战争艺术",
  "406086": "战争艺术",
  "406101": "信仰之盾",
  "406139": "真气之茧",
  "406154": "十字军之心",
  "406157": "判罚处刑人",
  "406220": "真气之茧",
  "406468": "光铸祝福",
  "406545": "神圣烈焰",
  "406646": "圣殿骑士之击",
  "406647": "圣殿骑士斩击",
  "406659": "翻飞火屑",
  "406732": "空间悖论",
  "406788": "心智收割者",
  "406834": "远征打击",
  "406872": "神圣愤怒",
  "406890": "狂野涌动",
  "406904": "火山效应",
  "406907": "愈复甲质",
  "406971": "压迫怒吼",
  "407065": "急促圣光",
  "407067": "急促圣光",
  "407243": "守护巨龙的青睐",
  "407412": "血腥狂乱",
  "407430": "灵媒",
  "407467": "光铸祝福",
  "407469": "惊惧幻灵",
  "407470": "心灵之眼",
  "407480": "圣殿骑士打击",
  "407576": "星界耀斑",
  "407814": "阿莱克丝塔萨的门徒",
  "407866": "谋划未来",
  "407869": "时空倒错",
  "407876": "激荡附岩",
  "408002": "构造位点",
  "408004": "动量转换",
  "408005": "动量转换",
  "408083": "魔法之泉",
  "408092": "地壳激变",
  "408233": "赋予军营之石",
  "408310": "坠落之星",
  "408385": "远征打击",
  "408458": "神圣意志",
  "408459": "神圣意志",
  "408546": "久远繁盛",
  "408775": "引火冲动",
  "409044": "扭曲现实",
  "409267": "机遇微粒",
  "409311": "先知先觉",
  "409329": "爆反外皮",
  "409560": "时光创伤",
  "409632": "亘古吐息",
  "409676": "时序结界",
  "409689": "土灵之力",
  "409776": "黑曜碎片",
  "409833": "熔火力量",
  "409834": "爆裂闪电",
  "409848": "耀光碎片",
  "409895": "青翠之拥",
  "409899": "精华奔涌",
  "409964": "燃焰之怒",
  "410089": "先知先觉",
  "410218": "坚如大地",
  "410219": "地覆猛击",
  "410253": "命途劫难",
  "410256": "爆反外皮",
  "410260": "霸王",
  "410261": "狱火祝福",
  "410263": "狱火祝福",
  "410265": "狱火祝福",
  "410352": "时光延展",
  "410638": "圣愿辉光",
  "410643": "熔火血脉",
  "410685": "共栖荣花",
  "410686": "共栖荣花",
  "410687": "芳蕊长春",
  "410784": "回响打击",
  "411055": "毁灭将至",
  "411164": "黑洞视界",
  "411165": "永恒之眼",
  "411212": "魔法之泉",
  "412710": "超脱时间",
  "412713": "丝缕交织",
  "412723": "明日今夕",
  "412733": "不屈领域",
  "412774": "命运明镜",
  "413231": "暗影幻灵",
  "413984": "变换流沙",
  "414019": "强效审判",
  "414073": "圣光决断",
  "414113": "公正审判",
  "414131": "玉珑的优雅",
  "414132": "风之舞",
  "414195": "觉醒",
  "414204": "璀璨旭日",
  "414379": "浓缩能量",
  "414407": "崇圣",
  "414408": "崇圣",
  "414443": "闪耀正义",
  "414553": "灵启神示",
  "414556": "灵启神示",
  "414658": "深寒凝冰",
  "414659": "深寒凝冰",
  "414664": "群体隐形",
  "414720": "提里奥的虔诚",
  "414969": "春晖梦晓",
  "415091": "正义盾击",
  "415364": "回收复用",
  "415388": "回收复用",
  "415416": "仁爱之心",
  "415673": "精华吞噬者",
  "416094": "火上浇油",
  "416230": "小鬼激励",
  "416615": "萨维斯的诡计",
  "416714": "强攻烈焰",
  "416719": "震爆区域",
  "416771": "十字军圣印",
  "417234": "粉碎混沌",
  "417467": "助火",
  "417489": "寒冬祝福",
  "417492": "低温症",
  "417855": "心敬则畏",
  "418101": "强效法力",
  "418359": "顺水推舟",
  "418733": "解离射线",
  "419110": "圣洁强音",
  "421432": "剑齿利喉",
  "421453": "终极苦修",
  "421543": "终极苦修",
  "421975": "腐蚀飞溅",
  "422031": "豪能酒",
  "422090": "滋养",
  "422751": "阴燃狂乱",
  "423054": "鲜血之路",
  "423136": "骤死",
  "423583": "诛灭烙印",
  "423584": "诛灭烙印",
  "423585": "诛灭魔",
  "423647": "优雅诡谋",
  "423662": "静影遮蔽",
  "423683": "轻若鸿毛",
  "423701": "卓越混合物",
  "423734": "厄运箭雨",
  "424058": "天涯共银辉",
  "424113": "月耀万世",
  "424155": "翡翠迷神",
  "424402": "翡翠迷神",
  "424454": "幻灭遒劲",
  "424557": "野蛮",
  "424558": "驯兽大师",
  "424742": "战地统帅",
  "425518": "圣光裁决",
  "425672": "烈焰咒符",
  "425804": "振奋之雾",
  "426115": "走火入魔",
  "426516": "野性狼魂",
  "426555": "警告标志",
  "426563": "瞬息纽带",
  "426591": "赤喉之咬",
  "426594": "迅影",
  "426702": "跃动活力",
  "426784": "德鲁伊长者之唤",
  "427445": "圣光指引",
  "427453": "圣光之锤",
  "427640": "冲撞惯性",
  "427641": "冲撞惯性",
  "427775": "焰由心生",
  "427776": "舞刃折光",
  "427794": "永不言弃",
  "427904": "献祭光环",
  "427905": "献祭光环",
  "427908": "献祭光环",
  "427910": "献祭光环",
  "427917": "献祭光环",
  "428078": "风雷打击",
  "428232": "苦难千疮",
  "428241": "恶魔之肤",
  "428377": "精准射击",
  "428387": "惊魂步法",
  "428394": "怨毒重构",
  "428455": "狱火气息",
  "428486": "振奋处刑",
  "428492": "混沌无常",
  "428514": "敬魔仪式",
  "428517": "溃解灵魂",
  "428518": "集会所的奥秘",
  "428522": "陨灭",
  "428544": "月照树人",
  "428565": "召唤混沌之母",
  "428571": "召唤主宰",
  "428603": "冲天怒焰",
  "428607": "刃以为骨",
  "428655": "艾露恩之光",
  "428731": "林中和谐",
  "428737": "林中和谐",
  "428859": "自然之威",
  "428866": "自然之威",
  "428911": "刻魂法阵",
  "428933": "洞察预兆",
  "428934": "慰藉预兆",
  "428937": "万物复苏",
  "429072": "安尼赫兰的咆哮",
  "429115": "狱火活力",
  "429130": "狱火壁垒",
  "429211": "飞刃勇士",
  "429215": "丰裕之花",
  "429227": "自然耐性",
  "429399": "广袤延伸",
  "429402": "林地启示",
  "429420": "持久魔效",
  "429433": "盛放注能",
  "429483": "迁跃",
  "429520": "辉月卫士",
  "429523": "皎月呼唤",
  "429530": "皎月洞察",
  "429532": "大气曝露",
  "429533": "闪耀毛皮",
  "429536": "星界洞察",
  "429538": "月尘",
  "429539": "朔望",
  "429540": "奥术亲和",
  "429581": "深渊支配",
  "429634": "巨人神力",
  "429636": "巨人威仪",
  "429637": "以一敌众",
  "429638": "武艺专家",
  "429639": "碎骨",
  "429641": "战斗之潮",
  "429642": "百战之创",
  "429644": "苦痛常客",
  "429647": "娴熟打击",
  "429657": "克索诺斯之焰",
  "429668": "星辰掌控",
  "429893": "拉恩科纳的抚触",
  "429899": "纳斯雷萨的幽冥",
  "429902": "科善的暴虐",
  "429917": "炼狱装置",
  "430014": "怨毒",
  "430023": "伏击",
  "430709": "障眼烟幕",
  "430712": "黑暗锁链",
  "431039": "冰霜精通",
  "431040": "火焰精通",
  "431044": "霜火之箭",
  "431066": "灌魔结界",
  "431067": "元素亲和",
  "431095": "等温之核",
  "431112": "焰霜相依",
  "431117": "热能调控",
  "431131": "消融",
  "431164": "火焰吐息",
  "431166": "霜火注能",
  "431176": "霜火增效",
  "431178": "瞬息霜灼",
  "431189": "剧烈温差",
  "431377": "晨光",
  "431380": "晨光",
  "431381": "晨光",
  "431382": "晨光",
  "431398": "苍穹之锤",
  "431402": "明灿",
  "431404": "灼阳恩典",
  "431406": "曙光意志",
  "431407": "余辉不散",
  "431413": "日灼",
  "431415": "日灼",
  "431416": "阿加治疗药水",
  "431418": "阿加法力药水",
  "431419": "洞穴住民的挚爱",
  "431422": "沉眠魂魄血清",
  "431423": "明耀",
  "431424": "踏雪无痕",
  "431425": "曜日化身",
  "431432": "震慑曝光饮剂",
  "431442": "时序烈焰",
  "431443": "时序烈焰",
  "431463": "狂热辩护",
  "431474": "旭日再升",
  "431480": "辉耀日光",
  "431482": "晨星",
  "431483": "时序烈焰",
  "431484": "不稳定矩阵",
  "431533": "倾天圣威",
  "431548": "精准之威",
  "431551": "天降忿怒",
  "431583": "时序烈焰",
  "431615": "回荡",
  "431620": "地壳激变",
  "431654": "首座",
  "431657": "首座",
  "431687": "崇高使命",
  "431695": "时空爆发",
  "431698": "时空爆发",
  "431715": "诺兹多姆精锐",
  "431730": "圣神征旅",
  "431873": "瞬息之隔",
  "431874": "再逢其时",
  "431875": "残光",
  "431911": "曜日化身",
  "431914": "专心致志药水",
  "431925": "前线药水",
  "431932": "淬火药水",
  "431939": "曜日化身",
  "431941": "重生猎豹药水",
  "431971": "淬火侵攻合剂",
  "431972": "淬火矫健合剂",
  "431973": "淬火全能合剂",
  "431974": "淬火精通合剂",
  "431984": "时光汇流",
  "431991": "时光汇流",
  "432004": "金色机遇",
  "432008": "加速微粒",
  "432021": "炼金混沌合剂",
  "432061": "加速微粒",
  "432120": "邪恶顺劈",
  "432181": "风之舞",
  "432459": "神圣壁垒",
  "432463": "圣锤降罚",
  "432472": "圣洁武器",
  "432473": "救赎恩典合剂",
  "432496": "神圣壁垒",
  "432502": "圣洁武器",
  "432596": "混乱齐射",
  "432607": "神圣壁垒",
  "432615": "无际愤怒",
  "432616": "圣洁武器",
  "432626": "公允裁定",
  "432802": "勠力同心",
  "432804": "先兆之备",
  "432821": "共志同心",
  "432866": "铸剑为光",
  "432919": "骁勇",
  "432929": "神圣之锤",
  "432964": "神圣鼓舞",
  "432977": "圣言",
  "432990": "冷酷战驹",
  "432992": "亲如手足",
  "433011": "锻炉的祝福",
  "433015": "圣眷在握",
  "433019": "圣眷在握",
  "433106": "神恩指引",
  "433568": "圣言祭礼",
  "433583": "恳求祭礼",
  "433718": "槌砧战术",
  "433722": "槌砧战术",
  "433748": "防护愈合",
  "433807": "神恩指引",
  "433808": "神恩指引",
  "433831": "梦境涌现",
  "433871": "战术机动",
  "433874": "深呼吸",
  "433895": "吸血鬼打击",
  "433899": "吸血鬼打击",
  "433901": "吸血鬼打击",
  "433905": "预言者的意志",
  "433925": "鲜血女王的精华",
  "433934": "返世新血",
  "434028": "吸血鬼之速",
  "434033": "血染之地",
  "434075": "疯狂嗜血",
  "434100": "吸血光环",
  "434136": "血腥之韧",
  "434141": "梦境盛放",
  "434143": "苦痛凌虐",
  "434144": "苦痛凌虐",
  "434151": "煽动惊恐",
  "434152": "萨莱因之赐",
  "434153": "萨莱因之赐",
  "434157": "脏腑之力",
  "434220": "梦境之力",
  "434249": "梦境掌控",
  "434260": "血为命源",
  "434261": "萨莱因之契",
  "434263": "腥红气息",
  "434300": "连环轰炸",
  "434400": "召唤深渊领主",
  "434404": "求邪无止",
  "434473": "连环轰炸",
  "434481": "连环轰炸",
  "434506": "狱火箭",
  "434635": "陨灭",
  "434636": "陨灭",
  "434763": "魂体双分",
  "434766": "魂体双分：转移",
  "434767": "魂体双分",
  "434774": "魂体双分：链接之魂",
  "434782": "魂体双分",
  "434905": "冷面死神",
  "434969": "闪电打击",
  "434970": "千钧之峰",
  "435005": "窒息攻势",
  "435010": "死亡寒潮",
  "435222": "雷霆轰击",
  "435607": "雷霆轰击",
  "435615": "雷霆轰击",
  "436148": "贯地电流",
  "436152": "托里姆之威",
  "436162": "风暴众锤",
  "436201": "召云聚雷",
  "436335": "群体裂解",
  "436336": "群体裂解",
  "436344": "艾泽里特涌动",
  "436358": "崩摧",
  "436687": "黑暗之爪",
  "436707": "崩解闪电",
  "437068": "群山之力",
  "437079": "断空霹雳",
  "437118": "能量爆发",
  "437121": "能量爆发",
  "437122": "死亡信使",
  "437134": "风暴的化身",
  "437161": "灵魂迸裂",
  "438324": "喂食",
  "438439": "赤精之舞",
  "438587": "大规模喷发",
  "438588": "大规模喷发",
  "438590": "脚踏实地",
  "438591": "脚踏实地",
  "438597": "风暴护盾",
  "438653": "喷发",
  "438672": "活动炸弹",
  "439528": "兴荣生长",
  "439530": "共生绽华",
  "439531": "觅血缠藤",
  "439760": "极光",
  "439843": "死神印记",
  "439851": "灵魂浪潮",
  "439868": "茫野猎手",
  "439880": "坚毅兴荣",
  "439882": "根须网道",
  "439888": "根须网道",
  "439890": "战略灌注",
  "439895": "纠缠旋风",
  "439901": "万华疾行",
  "439902": "万华疾行",
  "439926": "荒野追猎者之力",
  "439929": "自然牵绊",
  "439948": "反斥之盾",
  "440031": "黑暗之缚",
  "440040": "萨拉恩的暴虐",
  "440043": "黑化灵魂",
  "440044": "萨拉恩的凶狂",
  "440045": "佩罗萨恩的印记",
  "440046": "萨维斯的印记",
  "440048": "怨怒祭仪",
  "440051": "冷心策略",
  "440055": "葬身陨灭之种",
  "440057": "萨特诅咒",
  "440059": "虚弱光环",
  "440065": "瑟雷姆的坚韧",
  "440070": "邪蹄诡图",
  "440116": "祥和体质",
  "440117": "孪生双芽",
  "440118": "种植",
  "440119": "茁壮植被",
  "440120": "爆裂增生",
  "440121": "爆裂增生",
  "440122": "爆裂增生",
  "440277": "怒意生威",
  "440282": "符刻坚甲",
  "440476": "死亡使者契约",
  "440662": "防微杜渐",
  "440669": "救世时刻",
  "440670": "神圣之羽",
  "440671": "预见治疗",
  "440681": "分秒必争",
  "440738": "洞悉大局",
  "440742": "双重视界",
  "440766": "安全无虞",
  "440884": "崩摧",
  "440989": "巨人神力",
  "440992": "地崩山摧",
  "440993": "百战活力",
  "440995": "动脉出血",
  "441144": "隐秘之刃",
  "441146": "隐秘之刃",
  "441172": "熔化护甲",
  "441176": "熔化护甲",
  "441180": "硬化鳞片",
  "441181": "威慑英气",
  "441206": "群龙之首",
  "441212": "持久鏖战",
  "441219": "力量分流",
  "441245": "强攻",
  "441246": "无情围攻",
  "441247": "烟雾",
  "441248": "无情围攻",
  "441250": "镜影",
  "441253": "灵巧飞行",
  "441257": "冲流",
  "441263": "调虎离山",
  "441273": "出其不意",
  "441274": "惊惑突袭",
  "441321": "无瑕之形",
  "441346": "千刀万剐",
  "441359": "闪烁打击",
  "441367": "身轻如燕",
  "441378": "破灭",
  "441398": "胆大包天",
  "441403": "诡计多端",
  "441415": "不必多疑",
  "441416": "破灭",
  "441423": "致命一击",
  "441424": "破灭",
  "441426": "破灭",
  "441429": "云雾笼罩",
  "441583": "毁灭",
  "441585": "毁灭",
  "441590": "圣洁武器",
  "441591": "毁灭",
  "441605": "毁灭",
  "441675": "力量源泉",
  "441678": "兽形精通",
  "441689": "强化变形",
  "441691": "狂风奔涌",
  "441705": "黑龙军团之力",
  "441776": "致命一击",
  "441786": "锋化之刃",
  "441809": "恐惧创痕",
  "441812": "恐惧创痕",
  "441814": "无情攻势",
  "441824": "灭绝打击",
  "441829": "加深伤口",
  "441835": "利爪狂暴",
  "441841": "野兽之力",
  "441844": "兽群韧性",
  "441845": "直取要害",
  "441846": "不畏强敌",
  "441894": "枯败凋亡",
  "442204": "亘古吐息",
  "442290": "战刃绝技",
  "442294": "收割者战刃",
  "442419": "黑暗猎犬",
  "442435": "战刃乱舞",
  "442442": "撕裂猛击",
  "442492": "寒芒之刃",
  "442497": "锐意交锋",
  "442502": "战刃渴望",
  "442507": "战刃渴望",
  "442679": "收割者印记",
  "442683": "奥达奇战术",
  "442686": "酣战热血",
  "442687": "雪怒的指引",
  "442688": "酣战热血",
  "442695": "酣战热血",
  "442714": "一人成军",
  "442718": "奥达奇之怒",
  "442719": "恢复平衡",
  "442726": "怨毒",
  "442736": "不朽灵魂",
  "442743": "闭关修行",
  "442747": "砮皂之佑",
  "442749": "砮皂之佑",
  "442806": "穷寇当逐",
  "442808": "穷寇当逐",
  "443028": "天神御身",
  "443038": "天神御身",
  "443039": "天神御身",
  "443046": "艾露恩的赐福",
  "443059": "青玉庇护",
  "443087": "白虎之勇",
  "443106": "白虎之勇",
  "443110": "玄牛之力",
  "443112": "玄牛之力",
  "443113": "玄牛之力",
  "443124": "深渊饕餮",
  "443126": "虔敬",
  "443176": "生命火花",
  "443177": "生命火花",
  "443264": "泰坦之赐",
  "443272": "朱鹤天翔",
  "443294": "青龙之心",
  "443418": "元素余响",
  "443421": "青龙之心",
  "443423": "万古情谊",
  "443424": "青龙之心",
  "443425": "灵魂行者之势",
  "443441": "大地汇同",
  "443442": "自然和谐",
  "443444": "听从我的召唤",
  "443445": "例行交流",
  "443446": "最终使命",
  "443447": "漩涡统御",
  "443448": "始源并蓄",
  "443449": "潜在智慧",
  "443450": "先祖的召唤",
  "443451": "彼岸供奉",
  "443454": "先祖迅捷",
  "443506": "青龙之心",
  "443526": "慰藉预兆",
  "443531": "振奋之光",
  "443539": "米雷达尔洪钟",
  "443560": "凄惨痛快",
  "443566": "赤精迅捷",
  "443571": "心怀四方",
  "443589": "众神聚心",
  "443591": "众神聚心",
  "443614": "朱鹤天翔",
  "443616": "青龙之心",
  "443625": "玉珑之慧",
  "443722": "冰霜裂片",
  "443739": "裂解巫术",
  "443763": "奥术裂片",
  "443783": "裂片风暴",
  "443902": "蠕动装甲带",
  "444005": "冠军骑士",
  "444008": "告死苍驹",
  "444010": "死亡冲锋",
  "444016": "纵焰",
  "444017": "纵焰",
  "444020": "燃烧刺激",
  "444033": "怀特迈恩之饥荒",
  "444037": "贪噬饥渴",
  "444040": "天启现世",
  "444047": "莫格莱尼的力量",
  "444052": "纳兹戈林之征服",
  "444069": "天启骑士之怒",
  "444072": "飨魂",
  "444074": "天启骑士的援助",
  "444083": "天启契约",
  "444088": "吞噬烈焰",
  "444089": "吞噬烈焰",
  "444097": "托尔贝恩的冷冽怒火",
  "444099": "渊誓恫吓",
  "444248": "召唤莫格莱尼",
  "444251": "召唤怀特迈恩",
  "444252": "召唤纳兹戈林",
  "444254": "召唤托尔贝恩",
  "444256": "裂片宝珠",
  "444322": "生命烬火",
  "444347": "死亡冲锋",
  "444483": "受控本能",
  "444505": "莫格莱尼的力量",
  "444675": "变易碎片",
  "444719": "意志之力",
  "444752": "飘忽咒师",
  "444756": "蓦然回首",
  "444767": "屠戮之霸",
  "444769": "殒命在即",
  "444770": "夺命动力",
  "444771": "绝不留情",
  "444772": "压制之锋",
  "444773": "凶悍追击",
  "444774": "趁虚而入",
  "444775": "掠武风暴",
  "444776": "冷酷追杀",
  "444777": "奋勇矫健",
  "444778": "剔灭风暴",
  "444779": "屠戮者之怨",
  "444780": "无情强袭",
  "444784": "幻形幻象",
  "444806": "奥达奇之怒",
  "444827": "反馈壁垒",
  "444843": "烈焰导体",
  "444845": "肺活猛增",
  "444849": "开拓者",
  "444926": "规避行动",
  "444931": "无拘强袭",
  "444959": "间谍大师裹网",
  "444968": "大法师之怒",
  "444986": "法术冰霜之训",
  "444995": "涌动图腾",
  "444997": "先发制人",
  "445024": "飞旋元素",
  "445025": "图腾反弹",
  "445026": "巨型图腾",
  "445027": "迅捷召回",
  "445028": "灌魔精通",
  "445029": "增效核心",
  "445030": "涌动超载",
  "445031": "轻风屏障",
  "445032": "脉冲蓄容",
  "445033": "辅助灌魔",
  "445034": "生机图腾",
  "445035": "元素分流",
  "445036": "图腾协同",
  "445074": "烈焰之形",
  "445200": "安瑟的祝福",
  "445465": "枯萎",
  "445468": "枯萎",
  "445474": "枯萎",
  "445495": "吞噬烈焰",
  "445560": "暂停孵化",
  "445584": "处刑者",
  "445624": "先祖的召唤",
  "445625": "泰坦精准",
  "445740": "纵焰",
  "445958": "腾龙本能",
  "446035": "剑刃风暴",
  "446085": "残暴终结",
  "446260": "鹤形拳",
  "446285": "怨毒",
  "446326": "禅意波",
  "446334": "禅意波",
  "446345": "深彻明晰",
  "446663": "焚烧成灰",
  "446918": "残暴终结",
  "447131": "欣荣植被",
  "447132": "欣荣植被",
  "447244": "先祖的召唤",
  "447246": "圣洁之辞",
  "447250": "璀璨光环",
  "447258": "锻炉的清算",
  "447419": "熔岩爆裂",
  "447433": "治疗链",
  "447444": "熵能裂隙",
  "447448": "熵能裂隙",
  "447954": "破灭",
  "447985": "殉道者之光",
  "448040": "赋予圣光",
  "448227": "仲夏祝福",
  "448278": "内心寂灭",
  "448403": "崩塌虚空",
  "448405": "崩塌虚空",
  "448601": "法术火焰宝珠",
  "448623": "灿能威权",
  "448658": "祈咒：奥术凤凰",
  "448730": "灿能威权",
  "448744": "灿能威权",
  "448833": "空气威权",
  "448834": "空气威权",
  "448861": "先祖迅捷",
  "449023": "风暴威权",
  "449024": "风暴威权",
  "449099": "驭雷者之怒",
  "449100": "风暴之怒",
  "449182": "乌索克之魂",
  "449184": "利爪本能",
  "449185": "丛林智识",
  "449191": "橡木树皮",
  "449193": "自如变形",
  "449210": "焰心威权",
  "449212": "焰心威权",
  "449217": "窒息黑暗",
  "449218": "邃渊威权",
  "449293": "法力涌流",
  "449314": "法力涌流",
  "449322": "法力涌流",
  "449330": "挫折而已",
  "449349": "日怒之刑",
  "449382": "逐日者魔典",
  "449394": "白炽耀焰",
  "449412": "把握天时",
  "449537": "蓄势待发",
  "449569": "陨星",
  "449582": "身轻如羽",
  "449596": "辉圆火咒",
  "449614": "恶魔之魂",
  "449619": "奥之回忆",
  "449620": "通灵教义",
  "449624": "蚀魂之咒",
  "449627": "衰竭之训",
  "449629": "恶魔师的狂热",
  "449631": "邪毒收割",
  "449634": "寂灭",
  "449637": "萨泰尔的意志",
  "449638": "死亡之影",
  "449645": "野蛮暴怒",
  "449646": "野蛮暴怒",
  "449701": "血缚之韧",
  "449703": "黑暗中的朋友",
  "449704": "命运相连",
  "449706": "灵魂盛宴",
  "449707": "永恒奴役",
  "449793": "诱人灵魂",
  "449806": "神圣光晕",
  "449840": "光晕",
  "449874": "能量压缩",
  "449880": "虚空之心",
  "449912": "黑化视界",
  "449946": "密文指令",
  "450138": "虚空增效",
  "450154": "疾行反应",
  "450193": "熵能裂隙",
  "450212": "星辰强化",
  "450215": "虚空冲击",
  "450335": "迅威压迫",
  "450347": "自然的优雅",
  "450356": "浩瀚之触",
  "450373": "决意无悔",
  "450379": "活力脉动",
  "450391": "真气波",
  "450405": "虚空冲击",
  "450426": "真气熟稔",
  "450427": "以武立身",
  "450432": "正中死穴",
  "450448": "平和荣昌",
  "450503": "行如风",
  "450508": "和谐化身",
  "450514": "劲风展",
  "450520": "敏捷跃进",
  "450529": "大道同归",
  "450551": "米雷达尔洪钟",
  "450553": "踏玉步",
  "450558": "星月谐律",
  "450559": "治疗之风",
  "450560": "治疗之风",
  "450561": "米雷达尔洪钟",
  "450569": "真气流转",
  "450595": "精气萃华",
  "450598": "沟通星界",
  "450612": "虚空灌输",
  "450615": "疾风乱打",
  "450622": "迅风行",
  "450631": "能量转移",
  "450638": "天神决意",
  "450711": "和谐化身",
  "450746": "灼焦",
  "450763": "和谐化身",
  "450769": "和谐化身",
  "450831": "火焰之忿",
  "450867": "净化之魂",
  "450870": "以和致胜",
  "450875": "化气凝形",
  "450889": "平衡方略",
  "450892": "豪饮千杯",
  "450912": "复兴之路",
  "450965": "千击秘术",
  "450979": "潘达利亚之豪",
  "450982": "拳劲贯体",
  "450983": "虚空冲击",
  "450986": "不惧万难",
  "450987": "精兵之目",
  "450988": "只身克众",
  "450989": "高效演武",
  "450990": "武技精准",
  "450991": "钢铁漩涡",
  "450992": "先觉磨砺",
  "450993": "警戒戍望",
  "451017": "清晰使命",
  "451018": "黑暗能量",
  "451024": "无匹之劲",
  "451029": "坚韧真言",
  "451035": "力量的重担",
  "451036": "纯净真言",
  "451038": "奥术之魂",
  "451041": "龙腾虎蹴",
  "451043": "天威咆哮",
  "451049": "力量的重担",
  "451073": "白炽耀焰",
  "451199": "间谍大师的报告",
  "451204": "无路可逃",
  "451211": "星光导体",
  "451234": "虚空幽灵",
  "451235": "虚空幽灵",
  "451250": "疾风乱打",
  "451253": "纯净真言",
  "451294": "疾拳之势",
  "451311": "虚空抽取",
  "451435": "虚空鞭笞",
  "451447": "决意无悔",
  "451452": "纯净真言",
  "451466": "纵火成性",
  "451485": "勇夫之劲",
  "451498": "能量爆裂",
  "451515": "川流不息",
  "451524": "旋升劲风",
  "451529": "残寺秘学",
  "451569": "怀抱暗影",
  "451573": "奇聚之碧",
  "451576": "如风似岚",
  "451823": "拳脚齐施",
  "451840": "吞灭物质",
  "451875": "自燃",
  "451916": "进食充分",
  "451917": "进食充分",
  "451918": "进食充分",
  "451920": "进食充分",
  "452137": "雪怒之捷",
  "452198": "灵光乍现",
  "452201": "狂风怒号",
  "452288": "尊将之束",
  "452337": "扬升者之束",
  "452360": "女王之束",
  "452361": "碎裂者之束",
  "452365": "碎裂者之束",
  "452366": "碎裂者之束",
  "452367": "贤者之束",
  "452402": "魔涌",
  "452403": "衰竭波动",
  "452404": "怒意追击",
  "452405": "专注仇恨",
  "452406": "沐焰为殇",
  "452407": "强化灵魂劈裂",
  "452408": "燃烧剑刃",
  "452409": "猛烈变形",
  "452410": "弥久苦痛",
  "452411": "无拘之怒",
  "452412": "苦难修行",
  "452413": "火缚",
  "452414": "怪物现身",
  "452415": "魔化强度",
  "452416": "魔涌",
  "452436": "灵魂割裂",
  "452437": "灵魂爆裂",
  "452486": "邪能荒芜",
  "452487": "吞噬之焰",
  "452490": "末日咒符",
  "452494": "征战于烈焰",
  "452497": "深渊凝视",
  "452536": "命运之手",
  "452538": "命运硬币（反面）",
  "452902": "迅捷巧计",
  "452930": "恶魔治疗石",
  "452997": "聚能魔宠",
  "452999": "生命虹吸",
  "453080": "强化暗影箭",
  "453087": "邪咒",
  "453096": "扩散",
  "453105": "召唤者之拥",
  "453109": "能量涌动",
  "453172": "狡黠残酷",
  "453206": "暗影之拥",
  "453239": "苦难修行",
  "453250": "结晶化",
  "453282": "烈焰触媒",
  "453405": "飞旋之火",
  "453406": "飞旋之土",
  "453407": "飞旋之水",
  "453409": "飞旋之气",
  "453428": "连环恶行",
  "453457": "竖币稀景",
  "453678": "神圣牧师11.0职业套装4件套",
  "453699": "烈焰触痕",
  "453726": "至高真言",
  "453729": "强效升变",
  "453744": "暗影符文",
  "453783": "具象之力",
  "453799": "强化涌动",
  "453800": "强化恶魔战术",
  "453828": "能量循环",
  "453845": "共振能量",
  "453846": "共振能量",
  "453850": "共振能量",
  "453852": "振荡脉冲",
  "453908": "魔性凶暴",
  "453917": "完美形态",
  "453918": "无尽尖叫",
  "454001": "持续效能",
  "454002": "持续效能",
  "454009": "狂风怒号",
  "454015": "狂风怒号",
  "454021": "风暴召唤者",
  "454022": "电能震击",
  "454026": "滚雷",
  "454027": "自然之护",
  "454286": "挑战命运",
  "454351": "复仇之怒",
  "454372": "喷薄之流",
  "454373": "复仇之怒",
  "454391": "无穷力量",
  "454419": "命运交易",
  "454432": "命不可违",
  "454433": "绝命降临",
  "454435": "命数已定",
  "454483": "至尊之赐",
  "454484": "清风作伴",
  "454735": "湮灭",
  "454744": "余烬风暴",
  "454786": "寒冰牢笼",
  "454788": "符文防护",
  "454822": "镇压攫握",
  "454835": "渗透",
  "454842": "无效魔法",
  "454851": "存余护罩",
  "454919": "流电奔腾",
  "454969": "禅院故思",
  "454983": "奥术延展",
  "455068": "玄牛式",
  "455072": "迅捷注射",
  "455088": "风暴涌浪",
  "455096": "弧形放电",
  "455110": "超荷充能",
  "455123": "传导能量",
  "455129": "觉醒风暴",
  "455135": "阴险魔导师",
  "455139": "明志灵药",
  "455143": "杂耍打击",
  "455369": "进食充分",
  "455386": "末日难逃",
  "455396": "邪污感染",
  "455397": "脓疮毒镰",
  "455428": "屏障漫射",
  "455449": "沙图格的印记",
  "455450": "法尔格的印记",
  "455451": "迅芯的烛光微步",
  "455461": "极效防护",
  "455465": "召唤阴暗恶犬",
  "455476": "召唤灼焦恶犬",
  "455485": "绝命打击",
  "455491": "阴暗劈裂",
  "455499": "战略奇才",
  "455590": "大地奔涌",
  "455622": "震颤",
  "455630": "涌动图腾",
  "455797": "塞纳留斯之力",
  "455801": "塞纳留斯之力",
  "455993": "冰霜灾祸",
  "456120": "趁虚而入",
  "456230": "极地突袭",
  "456237": "低温冰冻",
  "456238": "霜侵热毒",
  "456240": "漫漫严冬",
  "456270": "惊霆感应",
  "456366": "治疗之雨",
  "456406": "进食充分",
  "456576": "蛋白奶昔",
  "456640": "吞噬之焰",
  "456757": "抓取脏器",
  "456766": "旭日再升",
  "456951": "强化混乱之箭",
  "457022": "虚渺斗篷",
  "457034": "诱导转向",
  "457052": "死亡猎手标记",
  "457054": "绝命猎杀",
  "457055": "殊刃同归",
  "457056": "徘徊黑暗",
  "457057": "影行者",
  "457058": "至黑之夜",
  "457062": "致胜符记",
  "457063": "夜幕遮掩",
  "457067": "绝望追击",
  "457068": "觅血寻踪",
  "457271": "行云功法",
  "457284": "进食充分",
  "457481": "唤潮者的护卫",
  "457512": "血色谋策",
  "457521": "法力炸弹",
  "457574": "不屈意志",
  "457594": "扬升",
  "457735": "热能闪光",
  "457803": "熔火之怒",
  "457917": "白虎之勇",
  "457974": "碧火踏",
  "458034": "强化鬼影缠身",
  "458128": "脓疮毒镰",
  "458357": "治疗链",
  "458359": "光辉荣耀",
  "458411": "法术冰霜之训",
  "458431": "玉莲灌注",
  "458437": "启迪智慧",
  "458502": "扬升",
  "458503": "扬升",
  "458524": "扬升",
  "458525": "扬升",
  "458572": "集骨者",
  "458623": "虎威",
  "458689": "凶悍追击",
  "458718": "孤注一掷",
  "458752": "屠戮",
  "458753": "染血利刃",
  "458964": "热能闪光",
  "459120": "滚石",
  "459440": "暴虐痛楚",
  "459450": "护身软甲",
  "459455": "斥候本能",
  "459460": "焦油缚链",
  "459488": "机遇时刻",
  "459497": "身轻如燕",
  "459502": "锯齿尖锋",
  "459506": "薪火照明弹",
  "459507": "领地意识",
  "459517": "紧急药膏",
  "459527": "非自然原因",
  "459534": "扳机指",
  "459537": "毁灭将至",
  "459542": "特化军火库",
  "459546": "不要见怪",
  "459550": "直取要害",
  "459552": "裂痕",
  "459559": "幻影延展",
  "459574": "毁灭将至",
  "459693": "轰雷蹄踏",
  "459730": "狩猎大师的召唤",
  "459783": "穿透射击",
  "459794": "快速拔枪",
  "459802": "肋排猎人",
  "459808": "哀恸箭",
  "459843": "榴弹杂耍",
  "459939": "外域之毒",
  "459964": "侧翼优势",
  "459983": "科多兽镇静剂",
  "459991": "魔暴龙镇静剂",
  "460074": "怪诞之瓶",
  "460127": "白虎之勇",
  "460198": "野火灌注",
  "460490": "真气爆裂",
  "460551": "末日降临",
  "460553": "末日降临",
  "460555": "末日降临",
  "460590": "永冻冰枪",
  "460720": "扭转邪恶",
  "460822": "神恩指引",
  "461243": "圣光之佑",
  "461244": "满溢之光",
  "461246": "辉光黎明",
  "461248": "高压",
  "461251": "充能飞弹",
  "461257": "聚焦水晶",
  "461260": "财团的点缀",
  "461261": "头脑风暴",
  "461273": "真理永存",
  "461278": "解救",
  "461287": "解放",
  "461288": "浴血奋战",
  "461499": "满溢之光",
  "461546": "真理永存",
  "461845": "进食充分",
  "461854": "进食充分",
  "461855": "进食充分",
  "461856": "进食充分",
  "461857": "进食充分",
  "461858": "进食充分",
  "461859": "进食充分",
  "461860": "进食充分",
  "461861": "进食充分",
  "461867": "圣神征旅",
  "461922": "进食充分",
  "461924": "进食充分",
  "461925": "进食充分",
  "461927": "进食充分",
  "461937": "进食充分",
  "461938": "进食充分",
  "461939": "进食充分",
  "461940": "进食充分",
  "461942": "进食充分",
  "461943": "进食充分",
  "461944": "进食充分",
  "461945": "进食充分",
  "461946": "进食充分",
  "461947": "进食充分",
  "461948": "进食充分",
  "461949": "进食充分",
  "461957": "进食充分",
  "461958": "进食充分",
  "461959": "进食充分",
  "461960": "进食充分",
  "462030": "末日咒符",
  "462036": "黑石军火",
  "462065": "恶魔猎手",
  "462087": "酒仙武僧",
  "462088": "武僧",
  "462140": "斩击（致命一击）",
  "462180": "丰盛进食充分",
  "462181": "丰盛进食充分",
  "462182": "丰盛进食充分",
  "462183": "丰盛进食充分",
  "462184": "丰盛进食充分",
  "462185": "丰盛进食充分",
  "462186": "丰盛进食充分",
  "462187": "丰盛进食充分",
  "462188": "丰盛进食充分",
  "462189": "丰盛进食充分",
  "462190": "丰盛进食充分",
  "462191": "丰盛进食充分",
  "462192": "丰盛进食充分",
  "462193": "丰盛进食充分",
  "462194": "丰盛进食充分",
  "462195": "丰盛进食充分",
  "462196": "丰盛进食充分",
  "462197": "丰盛进食充分",
  "462198": "丰盛进食充分",
  "462199": "丰盛进食充分",
  "462200": "丰盛进食充分",
  "462201": "丰盛进食充分",
  "462202": "丰盛进食充分",
  "462203": "丰盛进食充分",
  "462204": "丰盛进食充分",
  "462205": "丰盛进食充分",
  "462206": "丰盛进食充分",
  "462207": "丰盛进食充分",
  "462208": "丰盛进食充分",
  "462209": "丰盛进食充分",
  "462210": "丰盛进食充分",
  "462241": "刺骨（致命一击）",
  "462242": "刺骨（致命一击）",
  "462243": "刺骨（致命一击）",
  "462244": "刺骨（致命一击）",
  "462247": "刺骨（致命一击）",
  "462248": "刺骨（致命一击）",
  "462368": "元素抗性",
  "462383": "喷涌灵魂",
  "462424": "涛流",
  "462425": "涛流",
  "462440": "首席升腾者",
  "462443": "飞升卓越",
  "462454": "活性结界",
  "462486": "倾盆大雨",
  "462515": "族群之嚎",
  "462587": "急浪飞流",
  "462603": "倾盆大雨",
  "462620": "地震术",
  "462695": "风暴狂乱",
  "462757": "雷霆打击结界",
  "462762": "凝霜缠身",
  "462764": "极地雪暴",
  "462791": "升涌气流",
  "462796": "强化灌魔",
  "462817": "喷流",
  "462818": "冰怒",
  "462840": "元素融聚",
  "462844": "石壁",
  "462854": "天怒",
  "462862": "闪电容蓄",
  "462866": "元素团结",
  "462867": "恒久元素",
  "463074": "曜日化身",
  "463075": "曜日化身",
  "463351": "风暴超载",
  "465717": "元素冲击",
  "466772": "毁灭之风",
  "466867": "飞禽专精",
  "466872": "瞭望印记",
  "466904": "鹞鹰尖啸",
  "466930": "黑蚀箭",
  "466932": "黑蚀箭",
  "466990": "凋零射击",
  "466991": "凋零射击",
  "467059": "斩击",
  "467270": "进食饮水",
  "467283": "裂地术",
  "467293": "碧火之训",
  "467307": "疾风呼啸踢",
  "467316": "青玉赋能",
  "467317": "青玉赋能",
  "467341": "疾啸狂风",
  "467386": "火舌攻击",
  "467644": "钟鸣厄至",
  "467718": "黯然箭矢",
  "467741": "暗影匕首",
  "467749": "黯然箭矢",
  "467778": "雷电导管",
  "467897": "乌黑弓弦",
  "467902": "女妖的印记",
  "467911": "黯然火药",
  "467914": "黯然火药",
  "468037": "黑蚀箭",
  "468179": "疾风呼啸踢",
  "468571": "风暴先驱",
  "468572": "黑蚀箭",
  "468625": "盈电导体",
  "468626": "裂地猛击",
  "468655": "霜火之箭",
  "468695": "蛇皮箭袋",
  "468701": "毒蛇打击",
  "468743": "旋荡星辰",
  "468936": "向日蘑菇",
  "469004": "星落似霰",
  "469270": "毁灭之风",
  "469279": "无悔牺牲",
  "469304": "自由之驹",
  "469309": "以眼还眼",
  "469314": "野性狼魂",
  "469316": "淡泊",
  "469317": "抵御邪恶",
  "469321": "正义保护",
  "469325": "圣光面容",
  "469337": "圣洁力量",
  "469409": "神圣马刺",
  "469411": "公正嘉奖",
  "469416": "圣光使者",
  "469421": "圣光使者",
  "469434": "无私治愈",
  "469439": "奋发卫士",
  "469445": "神圣喘息",
  "469476": "神圣触及",
  "469638": "饮魂者",
  "469642": "死亡感知",
  "469701": "战火淬炼",
  "469770": "福佑召唤",
  "469779": "菊花茶",
  "469780": "带头冲锋",
  "469870": "死神强袭",
  "469880": "尖刺鳞片",
  "469883": "精炼圣火",
  "469886": "权令责难",
  "470021": "招牌秘法",
  "470057": "流电炽焰",
  "470076": "聚合流水",
  "470077": "聚合流水",
  "470347": "超荷充能",
  "470411": "烈焰震击",
  "470549": "强化迅捷治愈",
  "470562": "愈合之涌",
  "470668": "强制增压",
  "470669": "申斥回响",
  "470943": "冲冠一怒",
  "470945": "多头蛇守护",
  "471195": "圣疗术",
  "471306": "虚空变形",
  "471348": "锁定目标",
  "471350": "黑曜石箭头",
  "471363": "一枪爆头",
  "471366": "韧性弓弦",
  "471369": "精确引爆",
  "471428": "火力覆盖",
  "471492": "乌索尔之庇",
  "471504": "持久圣言",
  "471668": "黑暗中的光明",
  "471761": "皇帝的垂青",
  "471876": "猎群领袖之嚎",
  "471877": "猎群领袖之嚎",
  "471878": "猎群领袖之嚎",
  "471881": "双足飞龙之啸",
  "471936": "野猪冲锋",
  "471938": "野猪冲锋",
  "471990": "巨熊召唤",
  "471999": "撕裂肉体",
  "472324": "猎群领袖之嚎",
  "472325": "猎群领袖之嚎",
  "472352": "凶暴召唤",
  "472357": "强强联手",
  "472358": "兽群思维",
  "472361": "神圣巡游",
  "472433": "福音",
  "472476": "巨熊之怒",
  "472524": "锋利兽爪",
  "472550": "双足飞龙之怒",
  "472568": "渗透暗影",
  "472639": "猪突猛进",
  "472640": "猪突猛进",
  "472660": "从无怜悯",
  "472707": "龟壳庇护",
  "472719": "油滑之靴",
  "472729": "缰绳束缚",
  "472741": "奔踏！",
  "472743": "身先士卒",
  "473369": "鹰眼精准",
  "473370": "二连发",
  "473385": "闭镜疾射",
  "473520": "险变扳机",
  "473523": "风行者箭袋",
  "473662": "吞噬",
  "473728": "虚空射线",
  "474421": "胁迫",
  "474440": "狡诈",
  "474456": "坚韧",
  "474526": "伤口恶化",
  "474530": "荒野之环",
  "474541": "天堂之环",
  "474678": "艾森娜的复苏",
  "474738": "千里之目",
  "474746": "独行伙伴",
  "474750": "共生关系",
  "1213597": "精准本能",
  "1213636": "噬灭恶魔猎手",
  "1213649": "虚空射线",
  "1214442": "恶魔之火注能",
  "1214467": "火焰之雨",
  "1214595": "虚空射线",
  "1214909": "命运骨骰",
  "1214933": "独一无二",
  "1214934": "双重麻烦",
  "1214935": "三重威胁",
  "1214937": "头奖",
  "1215241": "圣洁",
  "1215245": "永恒圣洁",
  "1215265": "弥漫圣光",
  "1215275": "神圣迅捷",
  "1215534": "保险！",
  "1215535": "保险！",
  "1215544": "保险！",
  "1215545": "保险！",
  "1215550": "保险！",
  "1215553": "保险！",
  "1215617": "掠食者的渴望",
  "1216314": "圣洁",
  "1216552": "连胜！",
  "1216561": "连胜！",
  "1216953": "冻结寒风",
  "1217236": "连胜！",
  "1217245": "大赢家！！！",
  "1217413": "切削之风",
  "1217524": "凶暴顺劈",
  "1217605": "虚空变形",
  "1217607": "虚空变形",
  "1217610": "吞噬",
  "1217615": "召唤强能恐惧猎犬",
  "1217622": "塞拉赞恩的韧性",
  "1217769": "头奖！",
  "1217941": "生命流转",
  "1217999": "投机打击",
  "1218047": "始源风暴",
  "1218090": "始源风暴",
  "1218113": "始源火焰",
  "1218116": "始源冰霜",
  "1218118": "始源闪电",
  "1218125": "始源风暴",
  "1218447": "迅雷咆哮",
  "1219182": "进食充分",
  "1219183": "进食充分",
  "1219185": "进食充分",
  "1219480": "升腾",
  "1219723": "碧蓝迅捷",
  "1220506": "呼啸暴虐",
  "1220679": "相位闪现",
  "1221150": "坍缩之星",
  "1221167": "坍缩之星",
  "1221348": "涌动图腾",
  "1221389": "冻结",
  "1223157": "虚空瞬步",
  "1223171": "诡计",
  "1223323": "不破之谊",
  "1223412": "灵魂残片",
  "1223798": "敏锐直觉",
  "1223918": "杜绝浪费",
  "1225074": "弱效暮光毁灭符文",
  "1225789": "虚空变形",
  "1225826": "根除",
  "1225873": "强效虚空回响符文",
  "1226019": "收割",
  "1226033": "根除",
  "1226140": "林莽卫士",
  "1227009": "莉亚德琳之光",
  "1227206": "强效无尽之星符文",
  "1227280": "触须猛击",
  "1227311": "强效虚空仪式符文",
  "1227619": "破碎灵魂",
  "1227621": "触须猛击",
  "1227707": "天启将至",
  "1228516": "仆侍之影",
  "1229376": "一键辅助",
  "1230076": "暗月徽记：狩猎",
  "1230153": "血性大发",
  "1230223": "啸风冰刃",
  "1230272": "冷冽强袭",
  "1230284": "北境霜风",
  "1230301": "掠霜使者",
  "1230339": "摧心魔",
  "1231346": "远古疯狂",
  "1232076": "丰盛进食充分",
  "1232078": "丰盛进食充分",
  "1232080": "丰盛进食充分",
  "1232082": "丰盛进食充分",
  "1232086": "进食充分",
  "1232087": "进食充分",
  "1232089": "进食充分",
  "1232091": "进食充分",
  "1232313": "进食充分",
  "1232316": "进食充分",
  "1232317": "进食充分",
  "1232318": "进食充分",
  "1232320": "进食充分",
  "1232321": "进食充分",
  "1232324": "进食充分",
  "1232325": "进食充分",
  "1232492": "进食充分",
  "1232567": "苦修",
  "1232571": "苦修",
  "1232585": "进食充分",
  "1232616": "圣光之柱",
  "1232739": "荒语者",
  "1232897": "莱卡拉的启发",
  "1232955": "不失毫厘",
  "1233223": "强效暮光毁灭符文",
  "1233272": "月蚀",
  "1233346": "日蚀",
  "1233355": "弱效虚空回响符文",
  "1233375": "弱效无尽之星符文",
  "1233385": "弱效龟裂创伤符文",
  "1233392": "弱效扭曲的附肢符文",
  "1233394": "弱效虚空仪式符文",
  "1233400": "进食充分",
  "1233401": "进食充分",
  "1233402": "进食充分",
  "1233404": "进食充分",
  "1233405": "进食充分",
  "1233406": "进食充分",
  "1233407": "进食充分",
  "1233448": "黑暗突变",
  "1233703": "丰盛进食充分",
  "1233704": "丰盛进食充分",
  "1233705": "丰盛进食充分",
  "1233706": "丰盛进食充分",
  "1233707": "丰盛进食充分",
  "1233708": "丰盛进食充分",
  "1233709": "丰盛进食充分",
  "1233710": "丰盛进食充分",
  "1233711": "丰盛进食充分",
  "1233712": "丰盛进食充分",
  "1233714": "丰盛进食充分",
  "1233719": "丰盛进食充分",
  "1233724": "丰盛进食充分",
  "1233726": "丰盛进食充分",
  "1233727": "丰盛进食充分",
  "1233729": "丰盛进食充分",
  "1233730": "丰盛进食充分",
  "1233731": "丰盛进食充分",
  "1233732": "丰盛进食充分",
  "1234195": "虚空新星",
  "1234559": "亵渎",
  "1234768": "银月城生命药水",
  "1234769": "护甲专精",
  "1234772": "痛宰",
  "1234796": "变换",
  "1235022": "蹲姿防御",
  "1235023": "破法者",
  "1235047": "刚毅姿态",
  "1235057": "萨拉斯抗性合剂",
  "1235088": "遒劲猛击",
  "1235108": "魔导师合剂",
  "1235110": "血骑士合剂",
  "1235111": "破碎残阳合剂",
  "1235113": "剑刃旋风",
  "1235211": "暗影分流",
  "1235391": "黑暗突变",
  "1235397": "幽影之触",
  "1235568": "圣光之护",
  "1236342": "准备出击",
  "1236590": "基础活力药水",
  "1236616": "圣光潜力",
  "1236648": "光注法力药水",
  "1236671": "蛮荒暴怒",
  "1236942": "神圣之锤",
  "1236970": "葬火",
  "1236994": "鲁莽药水",
  "1236998": "狂放恣意饮剂",
  "1237270": "灵魂盛宴",
  "1237885": "荆棘绽放",
  "1237978": "律节充能",
  "1238443": "狂热药水",
  "1238488": "噬欲时刻",
  "1238495": "噬欲时刻",
  "1238675": "恶魔之魂",
  "1238676": "恶魔之魂",
  "1238680": "霜缚意志",
  "1238739": "塑灵者",
  "1238810": "恶魔邪眼",
  "1238855": "精通：内在恶魔",
  "1238900": "墓穴精通",
  "1238901": "青龙的祝福",
  "1238904": "青龙之心",
  "1239123": "饥渴斩击",
  "1239443": "和谐涌动",
  "1239479": "吞噬之梦药水",
  "1239510": "魔眼冲击",
  "1239519": "饥渴斩击",
  "1239525": "饥渴斩击",
  "1239537": "欲求难满",
  "1239581": "不可动摇",
  "1239669": "日月之蚀",
  "1239714": "灵魂交换",
  "1240185": "天界之火",
  "1240188": "雕刻星辰",
  "1240189": "召唤大师",
  "1240201": "吞噬者之咬",
  "1240202": "虚空眩光之赐",
  "1240203": "聚焦射线",
  "1240204": "星辰碎片",
  "1240206": "全蚀",
  "1240262": "流星风暴",
  "1240283": "艾露恩的挑战",
  "1240364": "灭尽折磨",
  "1240388": "黑暗思维",
  "1240394": "疯狂编织",
  "1240906": "强化日月之蚀",
  "1240907": "陨星",
  "1240996": "恐惧瘟疫",
  "1241059": "天神灌注",
  "1241077": "脓疮毒镰",
  "1241097": "砮皂的决心",
  "1241109": "砮皂的决心",
  "1241136": "禅悟状态",
  "1241275": "提尔的拯救",
  "1241288": "愤怒之锤",
  "1241358": "苍穹之遗",
  "1241462": "奥术脉冲",
  "1241511": "正义召唤",
  "1241521": "灵魂收割",
  "1241542": "天堂回响",
  "1241567": "暗影之爪",
  "1241669": "梦境幻影",
  "1241704": "自由之翼",
  "1241705": "以众凌寡",
  "1241714": "炽天使屏障",
  "1241762": "狂乱专注",
  "1241805": "闪亮辉煌",
  "1241858": "冒渎虔诚",
  "1241937": "灵魂献祭",
  "1241945": "黄昏祝福",
  "1241958": "愤怒复仇",
  "1242008": "神性之手",
  "1242031": "双重回响",
  "1242147": "召唤石像鬼",
  "1242158": "禁断知识",
  "1242172": "死灵缠绕",
  "1242173": "虚空齐射",
  "1242174": "死灵缠绕",
  "1242178": "死灵缠绕",
  "1242189": "虚空齐射",
  "1242223": "禁断知识",
  "1242294": "诅咒大军",
  "1242373": "践踏",
  "1242486": "至暗之夜",
  "1242492": "万界空虚",
  "1242495": "灾厄临世",
  "1242604": "邪灾鞭挞",
  "1242608": "培育憎恶",
  "1242666": "降世黑暗",
  "1242745": "心灵之火",
  "1242759": "双重回响",
  "1242768": "甜蜜的解脱",
  "1242779": "幻影威胁",
  "1242862": "植入疑虑",
  "1242910": "玉龙灌注",
  "1242956": "虚空邪怒",
  "1242974": "奥术齐射",
  "1242998": "次级食尸鬼",
  "1243105": "惊魂幻象",
  "1243106": "恩佐斯的幻象",
  "1243155": "青龙之道",
  "1243287": "散魔功",
  "1243307": "以太调谐",
  "1243435": "法球精通",
  "1243507": "艾格文秘术",
  "1243542": "洞见溢流",
  "1243557": "心智洞开",
  "1243659": "破釜沉舟",
  "1243660": "震音回荡",
  "1243807": "怒意狂乱",
  "1244001": "奥术奇点",
  "1244019": "不灭余烬",
  "1244025": "强效咒术",
  "1244031": "空间操控",
  "1244069": "强化寒冰护体",
  "1244070": "灼日之光",
  "1244079": "怒意狂乱",
  "1244087": "时空漫步",
  "1244088": "截拦掩护",
  "1244090": "时光重组",
  "1244102": "疾病之云",
  "1244105": "艾格文的护符",
  "1244107": "麦迪文的护符",
  "1244110": "冰川壁垒",
  "1244220": "虚空净化",
  "1244222": "吞噬者之刃",
  "1244237": "翻滚折磨",
  "1244258": "啃噬",
  "1244284": "混沌研习",
  "1244295": "甜蜜的痛苦",
  "1244310": "咆哮烈焰",
  "1244329": "过载飞弹",
  "1244331": "永茂",
  "1244340": "强化闪现",
  "1244341": "永茂",
  "1244410": "虚体精华吞噬者",
  "1244460": "强化浩劫",
  "1244470": "永茂",
  "1244483": "骤然突袭",
  "1244532": "鲜血飞溅",
  "1244544": "专注狂乱",
  "1244547": "战斗渴望",
  "1244557": "战刃风暴",
  "1244632": "裂爪猛击",
  "1244788": "混乱狱火",
  "1244877": "烈火之池",
  "1244878": "救世道标",
  "1244893": "救世道标",
  "1244928": "迅捷毁灭",
  "1244941": "奥蕾塞丝之怒",
  "1245089": "毁灭化身",
  "1245354": "圣洁幻象",
  "1245367": "救世道标",
  "1245368": "救世道标",
  "1245369": "救世道标",
  "1245412": "虚空之刃",
  "1245414": "虚空之刃",
  "1245453": "剔除",
  "1245470": "死神丧钟",
  "1245483": "穿刺帷幕",
  "1245523": "死神丧钟",
  "1245577": "灵魂残片",
  "1245633": "魔性凶残",
  "1245891": "圣光慰藉",
  "1245979": "英勇征伐",
  "1246030": "爆破潜能",
  "1246167": "恶魔追击",
  "1246169": "恶魔追击",
  "1246481": "苍穹之谕",
  "1246488": "扫荡裁决",
  "1246517": "至静化身",
  "1246549": "光芒爆裂",
  "1246555": "淬炼之魂",
  "1246556": "自发献祭",
  "1246558": "镰刀之拥",
  "1246562": "永恒职责",
  "1246768": "真言术：盾",
  "1246799": "迅愈祷言",
  "1246802": "虔敬",
  "1246811": "强化碎裂",
  "1246832": "冰刺",
  "1246949": "碎裂",
  "1247025": "深度碎裂",
  "1247055": "严寒专注",
  "1247090": "寒霜冰锥",
  "1247131": "祈愿精通",
  "1247166": "治疗专注",
  "1247178": "灵泉",
  "1247227": "猩红风暴",
  "1247378": "腐化",
  "1247534": "灵魂饕餮",
  "1247538": "恶魔本能",
  "1247544": "晶化折射",
  "1247729": "热能真空",
  "1247730": "热能真空",
  "1247742": "冰雹",
  "1247743": "霜语者",
  "1247759": "冰川调谐",
  "1247769": "强化冰风暴",
  "1247777": "彗星风暴",
  "1247798": "冻结",
  "1247799": "寒冰之心",
  "1247993": "嗜血杀意",
  "1248002": "热能汇聚",
  "1248014": "双系精锐",
  "1248016": "爆裂所及",
  "1248418": "星界灵涌",
  "1248423": "指引之光",
  "1248704": "天火踢",
  "1248747": "霹雳拳",
  "1248749": "旋风流转",
  "1248774": "杀意不移",
  "1248785": "腐蚀血液",
  "1248793": "见者尽灭",
  "1248815": "碧火踏",
  "1248825": "冰霜撕咬",
  "1248829": "暴风雪",
  "1248833": "凌空韵动",
  "1248837": "飓风腾跃",
  "1248970": "幸运硬币",
  "1248989": "天神御身",
  "1248992": "天神御身",
  "1249190": "金袋满盈",
  "1249194": "劫运降临",
  "1249201": "天选者盛宴",
  "1249204": "宿命奔袭",
  "1249215": "命途纠缠",
  "1249230": "聚焦能量",
  "1249233": "永续之光",
  "1249625": "乾元之巅",
  "1249658": "冰龙吐息",
  "1249802": "利刃铁丝",
  "1249809": "乘胜追击",
  "1249832": "黑曜石螺旋",
  "1250036": "鼓舞打击",
  "1250041": "谐律连击",
  "1250042": "回响技法",
  "1250088": "至暗之夜",
  "1250094": "至暗之夜",
  "1250141": "二次浸毒",
  "1250218": "净化邪恶",
  "1250271": "杀机涌现",
  "1250273": "古尔丹之手",
  "1250293": "秘术师",
  "1250315": "冰霜适应",
  "1250318": "淬毒冲动",
  "1250325": "弑君之赏",
  "1250358": "撕脱",
  "1250359": "精明打击",
  "1250364": "元素节奏",
  "1250372": "邪能才智",
  "1250375": "练习仪式",
  "1250378": "幽魂幻象",
  "1250492": "折磨低语",
  "1250554": "疾风呼啸踢",
  "1250562": "振奋圣言",
  "1250565": "天使之触",
  "1250566": "疾风呼啸踢",
  "1250646": "狩魂一击",
  "1250684": "辉光祈请",
  "1250691": "虚空触须",
  "1250768": "小鬼首领",
  "1250806": "虚假自主",
  "1250818": "精神指引",
  "1250820": "坚毅之力",
  "1250835": "黑暗启迪",
  "1250897": "冷酷统御",
  "1250906": "伊瑟拉之忆",
  "1250914": "远景洞察",
  "1250921": "安托兰军械",
  "1250923": "林域庇护",
  "1251026": "过载",
  "1251029": "心灵穿刺",
  "1251030": "致痛祈咒",
  "1251069": "风暴束缚",
  "1251077": "双生戒律",
  "1251406": "延绵不绝",
  "1251417": "幽灵视觉",
  "1251592": "燎焰沥青",
  "1251707": "幽灵视觉",
  "1251717": "羁绊共狩",
  "1251718": "以二敌多",
  "1251778": "召唤邪犬",
  "1251779": "羁绊共狩",
  "1251790": "野蛮",
  "1251876": "远古守卫赠礼",
  "1252373": "风暴释放",
  "1252415": "毁灭闪电",
  "1252431": "毁灭闪电（释放）",
  "1252486": "疾速狩猎",
  "1252487": "专注狩猎",
  "1252488": "娴熟狩猎",
  "1252489": "变通狩猎",
  "1252708": "猫鼬之怒",
  "1252738": "重击",
  "1252741": "重击",
  "1252818": "埃基尔松的胜利怒吼",
  "1252841": "静水流深",
  "1252871": "赤红之月",
  "1252874": "宁静之雨",
  "1252882": "双重浸润",
  "1252931": "弹壳震击",
  "1252943": "野火灌注",
  "1252994": "致命一击",
  "1253014": "激流喷发",
  "1253035": "驾驭怒火",
  "1253053": "锋刃旋击",
  "1253090": "碎浪",
  "1253093": "潮汐掌控",
  "1253099": "迅流",
  "1253137": "干掉他们",
  "1253172": "散射炸弹",
  "1253176": "断焰",
  "1253304": "虚落",
  "1253377": "迅疾冲霄",
  "1253391": "迅疾流星",
  "1253399": "湮灭之路",
  "1253402": "物态",
  "1253415": "天界回响",
  "1253461": "梦魇乍醒",
  "1253590": "黑暗主宰",
  "1253591": "黑暗主宰",
  "1253593": "虚空之盾",
  "1253598": "征伐",
  "1253599": "哨兵",
  "1253601": "哨兵印记",
  "1253668": "迅捷抹消",
  "1253676": "末日预言者",
  "1253724": "强效惩击",
  "1253732": "皎月风暴",
  "1253733": "皎月风暴",
  "1253750": "星眼",
  "1253751": "星眼",
  "1253769": "大灭",
  "1253799": "碎甲咆哮",
  "1253805": "终末时刻",
  "1253807": "破空枪鸣",
  "1253817": "异界专注",
  "1253825": "月神之赐",
  "1253827": "黑暗主宰",
  "1253830": "矢无虚发",
  "1253831": "圣洁武装",
  "1253836": "圣洁武装",
  "1253845": "黑暗主宰",
  "1253846": "奥术利爪",
  "1253852": "皎月呼唤",
  "1253859": "狩魂一击",
  "1253862": "狩魂一击",
  "1253887": "环境适应",
  "1253892": "斥候警戒",
  "1253945": "猫鼬弹药",
  "1254194": "薪火",
  "1254210": "大地编织者",
  "1254251": "激流涌动",
  "1254252": "次级食尸鬼",
  "1254512": "尽数焚燃",
  "1254552": "腐化喷射",
  "1254756": "燃烧",
  "1254828": "野火",
  "1254851": "烈焰风暴",
  "1254857": "天地大冲撞",
  "1254865": "燃烬风暴",
  "1255166": "扭转时光",
  "1255476": "沉溺虚空之眼",
  "1256245": "相位变换",
  "1256295": "质量加速",
  "1256307": "暗物质",
  "1256353": "灭世灾星",
  "1256565": "禁断知识",
  "1256566": "禁断知识",
  "1256577": "麦琳瑟拉的祝福",
  "1256579": "麦琳瑟拉的祝福",
  "1256581": "麦琳瑟拉的祝福",
  "1256630": "威势突袭",
  "1256682": "麦琳瑟拉的祝福",
  "1256688": "麦琳瑟拉的祝福",
  "1256689": "麦琳瑟拉的祝福",
  "1256813": "亡者之主",
  "1256938": "侧翼夹击",
  "1256964": "噬灭恶魔猎手",
  "1256968": "噬灭恶魔猎手",
  "1256978": "酒仙武僧",
  "1257011": "易伤",
  "1257052": "幽冥收割",
  "1257343": "焚烧殆尽",
  "1257348": "焚烧殆尽",
  "1257349": "焚烧殆尽",
  "1257350": "焚烧殆尽",
  "1257942": "大法师之抚",
  "1257947": "大法师之抚",
  "1257950": "大法师之抚",
  "1258153": "酒仙武僧",
  "1258338": "奔踏！",
  "1258345": "奔踏",
  "1258402": "青草之触",
  "1258404": "灵猫敏捷",
  "1258407": "强化猎豹守护",
  "1258485": "强化灵龟守护",
  "1258486": "强化假死",
  "1258509": "低沉咆哮",
  "1258534": "虚空弥散",
  "1258843": "熔岩之怒",
  "1258889": "风暴灌注",
  "1258895": "元素共鸣",
  "1258899": "大地坍缩",
  "1259003": "猛禽横扫",
  "1259017": "猛禽横扫",
  "1259019": "猛禽横扫",
  "1259047": "炼狱弧光",
  "1259171": "复制",
  "1259172": "喷发",
  "1259173": "复制",
  "1259174": "复制",
  "1259175": "复制",
  "1259431": "掠食者尾迹",
  "1259457": "洞察先机",
  "1259465": "亢奋之血",
  "1259469": "大乱斗",
  "1259471": "净化烈焰",
  "1259480": "迅捷行动",
  "1259481": "龙骨骰子",
  "1259485": "锁定",
  "1259492": "闪烁钢铁",
  "1259498": "专家决斗者",
  "1259499": "暴戾狂潮",
  "1259612": "致命追击",
  "1259790": "痛苦无常",
  "1259811": "娴熟疫疾",
  "1259815": "强力的灵魂碎片",
  "1259825": "苦痛共享",
  "1259838": "毁灭之种",
  "1259886": "恃强凌弱",
  "1260008": "冷酷专注",
  "1260209": "钻心剧痛",
  "1260229": "致命回响",
  "1260251": "处决宣判",
  "1260264": "碎片动荡",
  "1260271": "幽影蒙福",
  "1260272": "灵感灰烬",
  "1260277": "弱效时间扭曲",
  "1260285": "零号病患",
  "1260429": "神圣之征",
  "1260484": "时光赐福",
  "1260511": "灵泉",
  "1260565": "灵泉",
  "1260616": "咒焰齐射",
  "1260617": "抚慰之雾",
  "1260619": "强化醉拳",
  "1260644": "图腾势能",
  "1260647": "超频",
  "1260666": "火焰新星",
  "1260670": "灵泉",
  "1260673": "烬灭寰宇",
  "1260677": "灵泉",
  "1260680": "灵泉",
  "1260681": "真气之茧",
  "1260745": "特遣动员",
  "1260874": "原始催化",
  "1260880": "原始催化",
  "1261046": "野蛮之力",
  "1261047": "高超效率",
  "1261048": "战前热身",
  "1261049": "广域打击",
  "1261050": "奔战之姿",
  "1261051": "战术优势",
  "1261056": "粉碎连击",
  "1261057": "战术大师",
  "1261060": "重伤",
  "1261062": "致死之伤",
  "1261080": "注能碎片",
  "1261082": "磨砺专注",
  "1261106": "调和使者",
  "1261111": "内在之光",
  "1261113": "内在之光",
  "1261124": "灾难瀑流",
  "1261149": "灾难之握",
  "1261159": "内在之光",
  "1261193": "爆裂火铳",
  "1261215": "爆裂火铳",
  "1261229": "野火弹药",
  "1261448": "浓缩能量",
  "1261452": "提炼精华",
  "1261525": "圣光执行官",
  "1261543": "无影步",
  "1261562": "复仇之盾",
  "1261564": "蚀相升格",
  "1261565": "蚀相升格",
  "1261566": "蚀相升格",
  "1261684": "熵灭",
  "1261703": "虎眼酒",
  "1261844": "虎眼酒",
  "1261849": "虎眼酒",
  "1261867": "野性之心",
  "1261984": "纳斯雷萨之影",
  "1261990": "纳斯雷萨之影",
  "1261992": "纳斯雷萨之影",
  "1262017": "火上浇油",
  "1262034": "野性赐福",
  "1262293": "猛禽横扫",
  "1262329": "清空地窖",
  "1262334": "青翠玉闪",
  "1262343": "猛禽横扫",
  "1262409": "致命校准",
  "1262442": "野兽之心",
  "1262603": "准备就绪",
  "1262610": "城壁兵械",
  "1262612": "战场隐踪",
  "1262628": "觉醒之魂",
  "1262635": "雷霆容蓄",
  "1262659": "生命之焰",
  "1262667": "玉珑化身",
  "1262672": "流转之智",
  "1262713": "风暴释放",
  "1262755": "祈福",
  "1262756": "远古奔踏",
  "1262758": "祈福",
  "1262760": "祈福",
  "1262761": "风暴释放",
  "1262763": "祈福",
  "1262765": "清空地窖",
  "1262830": "风暴释放",
  "1262843": "成双成对",
  "1262844": "熔融寒意",
  "1262845": "元素导能",
  "1262857": "强效治疗药水",
  "1262935": "寒冰之手",
  "1262981": "寒冰之手",
  "1263074": "阿曼尼提取物",
  "1263245": "玄牛之心",
  "1263249": "寒冰之手",
  "1263252": "圣殿骑士圣印",
  "1263288": "元素协调",
  "1263346": "利涉大川",
  "1263353": "天神烈焰",
  "1263408": "生命之焰",
  "1263438": "清空地窖",
  "1263569": "憎恶附肢",
  "1263657": "隐秘捕食者",
  "1263658": "隐秘捕食者",
  "1263660": "隐秘捕食者",
  "1263743": "血腥之雾",
  "1263781": "血腥爆裂",
  "1263782": "向光而行",
  "1263787": "无尽辉光",
  "1263824": "吞噬",
  "1263879": "自然的慷慨",
  "1263920": "诞于日光",
  "1263935": "邪能装备",
  "1263941": "迅捷狱火",
  "1264096": "虚空幻灵",
  "1264104": "虚空幻灵",
  "1264107": "虚空幻灵",
  "1264235": "致命延伸",
  "1264269": "生命缚誓者的传承",
  "1264289": "唤尸者",
  "1264290": "哀嚎死者",
  "1264291": "枯萎箭袋",
  "1264296": "生命之血",
  "1264321": "深层吐息",
  "1264330": "毁灭专注",
  "1264345": "黑暗爪牙",
  "1264351": "午夜舞步",
  "1264357": "射击",
  "1264359": "狂野鞭笞",
  "1264364": "枯萎箭矢",
  "1264365": "飞灰流转",
  "1264376": "自然的慷慨",
  "1264378": "拆解",
  "1264379": "拆解",
  "1264397": "断魂刃舞",
  "1264405": "午夜舞步",
  "1264426": "虚触",
  "1264506": "午夜舞步",
  "1264614": "森野感召",
  "1264618": "森野感召",
  "1264649": "强效",
  "1264659": "宁静",
  "1264664": "愈合",
  "1264688": "天穹崩落",
  "1264690": "空洞契约",
  "1264691": "自然赠礼",
  "1264762": "风暴之井",
  "1264764": "袖剑旋风",
  "1264775": "尖锐獠牙",
  "1264776": "树妖之舞",
  "1264781": "致命倒钩",
  "1264792": "双足飞龙之视",
  "1264797": "铁蹄利刃",
  "1264899": "林地仙灵",
  "1264902": "月光战轮",
  "1264903": "光耀之锋",
  "1264904": "暮光安魂曲",
  "1264905": "林地仙灵",
  "1264911": "林地仙灵",
  "1264934": "狂乱",
  "1264946": "月光战轮",
  "1264948": "宇宙潮音",
  "1264949": "月光战轮",
  "1265019": "宇宙圣歌",
  "1265044": "锯齿创伤",
  "1265051": "狩猎刺激",
  "1265052": "嗜血利齿",
  "1265129": "再来一桶",
  "1265138": "再来一桶",
  "1265141": "再来一桶",
  "1265307": "空酒桶",
  "1265355": "血之气息",
  "1265356": "啜饮怒火",
  "1265357": "暴怒毁灭",
  "1265359": "蛮力爆发",
  "1265361": "生死决战",
  "1265385": "无赦",
  "1265386": "无赦",
  "1265387": "无赦",
  "1265517": "永冻缀饰",
  "1265541": "不惧妖邪",
  "1265547": "血腥刺激",
  "1265549": "皈依圣光",
  "1265570": "处决者的愤怒",
  "1265574": "鲜血灌注",
  "1265632": "霜巢之眷",
  "1265633": "霜巢之眷",
  "1265637": "霜巢之眷",
  "1265770": "奈兰之烬",
  "1265772": "奈兰之烬",
  "1265774": "奈兰之烬",
  "1265790": "沸点",
  "1265799": "虚弱灾厄",
  "1265800": "淬炼钢铁",
  "1265801": "旅行常客",
  "1265802": "碎裂星辰",
  "1265804": "碎裂星辰",
  "1265810": "狱火之益",
  "1265813": "邪污巨口",
  "1265816": "强化死亡缠绕",
  "1265818": "复仇凶兽",
  "1265826": "星辰齐射",
  "1265855": "回响狂怒",
  "1265859": "冷冽决心",
  "1265861": "掘墓者",
  "1265862": "掘墓者",
  "1265863": "掘墓者",
  "1265867": "碧蓝横扫",
  "1265869": "瘟疫灌注",
  "1265871": "碧蓝横扫",
  "1265872": "碧蓝横扫",
  "1265924": "灵魂壁障",
  "1265932": "致命打击",
  "1265949": "恐惧之治",
  "1265952": "强效火药",
  "1265959": "生死驰骋",
  "1265971": "邪恶军备",
  "1265979": "孪生烈焰",
  "1265980": "孪生烈焰",
  "1265992": "烈火洪流",
  "1265993": "精华之泉",
  "1266069": "潜隐突袭",
  "1266081": "月光战轮",
  "1266151": "掠空扫射",
  "1266165": "掠空扫射",
  "1266296": "凝神之怒",
  "1266299": "狂热灵感",
  "1266307": "恶魔韧性",
  "1266316": "幽焰祛除",
  "1266326": "狂怒",
  "1266328": "无悯",
  "1266329": "恶魔笼头",
  "1266330": "灵魂分裂者",
  "1266493": "盛怒之翼",
  "1266496": "灵魂净化",
  "1266497": "陷阵殿后",
  "1266500": "终结吐息",
  "1266719": "静谧圣所",
  "1266733": "盘蛇静步",
  "1266734": "静水奔流",
  "1266740": "重焕活力",
  "1266748": "心神澄明",
  "1266762": "邪能束缚",
  "1266799": "邪蔓穿行",
  "1266803": "奥兹恩的罪孽",
  "1266805": "恶魔果实",
  "1266811": "召雾者",
  "1266818": "违抗死亡",
  "1266819": "死亡笔记",
  "1266845": "加速脉冲",
  "1266856": "虚空之触",
  "1266883": "暗影压制",
  "1267003": "精准打击",
  "1267016": "风暴涌流图腾",
  "1267028": "鲜血羁绊",
  "1267068": "风暴涌流图腾",
  "1267089": "风暴涌流图腾",
  "1267093": "风暴涌流图腾",
  "1267120": "风暴涌流图腾",
  "1267182": "剧毒短匕",
  "1267203": "先锋军荣耀",
  "1267206": "凌空突袭",
  "1267210": "迅捷之手",
  "1267211": "先锋军荣耀",
  "1267215": "先锋军荣耀",
  "1267216": "深可见骨",
  "1267218": "甲壳壁垒",
  "1267220": "危险感知",
  "1267745": "风暴涌流图腾",
  "1268671": "临阵畏缩",
  "1268684": "风暴激荡",
  "1268705": "娴熟召唤",
  "1268709": "天魔邪眼",
  "1268713": "致命凝视",
  "1268716": "心灵之眼",
  "1268807": "皇帝琼浆",
  "1268817": "凝雾汇涌",
  "1268868": "强化诱捕",
  "1268871": "实战经验",
  "1268881": "强化驳斥命运",
  "1268884": "具现贪欲",
  "1268889": "共享容器",
  "1268903": "无尽饥渴",
  "1268917": "邪恶光环",
  "1268932": "诡谋承袭",
  "1268936": "诡谋承袭",
  "1268939": "诡谋承袭",
  "1269159": "疾风呼啸踢",
  "1269205": "刺骨",
  "1269215": "爆裂狂怒",
  "1269306": "战争大师",
  "1269307": "战争大师",
  "1269308": "怒火狂战",
  "1269309": "怒火狂战",
  "1269310": "怒火狂战",
  "1269311": "英武方阵",
  "1269312": "英武方阵",
  "1269313": "英武方阵",
  "1269314": "战争大师",
  "1269360": "能量超载",
  "1269364": "先知之路",
  "1269383": "英勇打击",
  "1269391": "战争大师",
  "1269565": "黑火药",
  "1269614": "荒野守护者",
  "1269617": "荒野守护者",
  "1269619": "荒野守护者",
  "1270061": "反馈连锁",
  "1270062": "反馈连锁",
  "1270064": "反馈连锁",
  "1270255": "窒息之暗",
  "1270350": "本能灌注",
  "1270375": "魂之启迪",
  "1270444": "无羁邪怒",
  "1270446": "先祖加持",
  "1270447": "风语者",
  "1270448": "无羁邪怒",
  "1270449": "无羁邪怒",
  "1270450": "灵性学识",
  "1270565": "护花能手",
  "1270586": "恣意蔓生",
  "1270592": "恒久守护",
  "1270621": "宁神茶",
  "1270690": "纳斯雷兹姆契约",
  "1270691": "萨特契约",
  "1270693": "安尼赫兰契约",
  "1270695": "艾瑞达契约",
  "1270701": "血魔贪欲",
  "1270704": "屠戮殆尽",
  "1270709": "削肉剔骨",
  "1270710": "凌厉终结",
  "1270717": "狂烈快感",
  "1270718": "致命专注",
  "1270723": "导电",
  "1270724": "电容",
  "1270731": "狂烈快感",
  "1270827": "强化法术吸取",
  "1270829": "闪回",
  "1270845": "法力汇流",
  "1270847": "强化解除诅咒",
  "1270865": "强化法术反制",
  "1270872": "俘获思绪",
  "1270898": "永恒追猎",
  "1270900": "永恒追猎",
  "1270901": "永恒追猎",
  "1270916": "神恩术",
  "1270958": "和谐涌动",
  "1271016": "寻求超脱",
  "1271048": "潜在能量",
  "1271077": "神圣过载",
  "1271104": "大地之律",
  "1271105": "冥想专注",
  "1271144": "强化眼棱",
  "1271171": "洪荒烈火",
  "1271177": "薪尽火灭",
  "1271206": "星辰奔流",
  "1271221": "永恒圣光",
  "1271261": "半影汹潮",
  "1271305": "沐浴月光",
  "1271387": "大师杰作",
  "1271431": "强化突进",
  "1271466": "光辉映象",
  "1271540": "肢体撕裂",
  "1271553": "回响打击",
  "1271635": "双重爪击",
  "1271687": "冲天怒火",
  "1271689": "强化生命吸取",
  "1271694": "强韧灵魂",
  "1271699": "强化治疗石",
  "1271783": "冲天怒火",
  "1271788": "冲天怒火",
  "1271796": "冲天怒火",
  "1271799": "渐怒",
  "1271802": "语言灾厄",
  "1271839": "创伤加剧",
  "1271925": "无所畏惧",
  "1271926": "战场急救",
  "1271948": "破天投枪",
  "1271974": "瘟疫降临",
  "1272094": "守护者之皮",
  "1272099": "血溅十方",
  "1272101": "雷霆急速",
  "1272136": "迅捷装填",
  "1272138": "利刃",
  "1272139": "双生利牙",
  "1272143": "碎裂精魂",
  "1272153": "利刃之艺",
  "1272154": "原初涌动",
  "1272175": "宇宙能量",
  "1272308": "能量储备",
  "1272320": "专注爆发",
  "1272326": "成真的潜力",
  "1272352": "睿智之语",
  "1272359": "预言者的洞察",
  "1272363": "展开视界",
  "1272364": "盲眼专注",
  "1272405": "不灭余烬",
  "1272415": "阳炎螺旋",
  "1272422": "虚空奔涌",
  "1272432": "灵魂锻刃",
  "1272452": "真气转移",
  "1272453": "暴烈本能",
  "1272464": "烈酒连踢",
  "1272678": "风之武器",
  "1272685": "尚武敏捷",
  "1272694": "乾元镇踏",
  "1272696": "乾元镇踏",
  "1272770": "奇点斩击",
  "1272781": "猛虎之牙",
  "1272817": "强化吞噬",
  "1272821": "城壁之智",
  "1272832": "灼烧灵魂",
  "1272842": "晦暗之刃",
  "1272844": "作战姿态",
  "1272847": "虚空之赐",
  "1272849": "意到锋至",
  "1272989": "精准杀手",
  "1273017": "迅速寂灭",
  "1273035": "绝命屠戮",
  "1273043": "自然之友",
  "1273062": "武技神威",
  "1273065": "自然之友",
  "1273075": "全面处决",
  "1273126": "自然之友",
  "1273128": "凝神瞄准",
  "1273129": "凝神瞄准",
  "1273132": "凝神瞄准",
  "1273154": "流星轨迹",
  "1273155": "猛禽横扫！",
  "1273485": "熔岩涌流",
  "1275630": "猛禽横扫！",
  "1276163": "阿古斯支配",
  "1276166": "阿古斯支配",
  "1276190": "阿古斯支配",
  "1276222": "阿古斯支配",
  "1276433": "支配之手",
  "1276452": "魔典：小鬼领主",
  "1276467": "魔典：邪能破坏者",
  "1276488": "灵魂爆炸",
  "1276626": "欺瞒",
  "1276630": "闪刃",
  "1276661": "稳定传送门",
  "1276672": "召唤末日守卫",
  "1276679": "灵巧争斗者",
  "1276720": "自然之友",
  "1276746": "暴君的献祭",
  "1276748": "暴君统治",
  "1276809": "拉文霍德薄荷糖",
  "1276816": "约束混沌",
  "1276945": "灌魔盾牌",
  "1276947": "魔性征召",
  "1276956": "凋零巨口",
  "1277005": "裁定",
  "1277030": "时至运来",
  "1277098": "次级食尸鬼",
  "1277162": "圣裁之器",
  "1277297": "无视苦痛",
  "1277302": "晨风拂露",
  "1277443": "圣光神兵",
  "1277444": "真气结界",
  "1277482": "虚空欲望",
  "1277546": "集中火力",
  "1277548": "火力倾泻",
  "1277565": "千里猎目",
  "1277572": "透颅穿心",
  "1277651": "璀璨旭日",
  "1277734": "皮甲专精",
  "1277736": "恶魔结界",
  "1277933": "伺机待发",
  "1278009": "英武方阵",
  "1278789": "自然韧性",
  "1278886": "梦境向导",
  "1279247": "掌驭宇宙",
  "1279347": "快速拔枪",
  "1279350": "被唤起的梦魇",
  "1279353": "疯狂触须",
  "1279354": "碾压虚空",
  "1279355": "捕风捉影",
  "1279444": "强化影分身",
  "1279510": "尼斯卡兰术法",
  "1279521": "邪眼契约",
  "1279575": "强化邪能风暴",
  "1279633": "鲜血反射",
  "1279819": "始源羁绊",
  "1280131": "灼热之光",
  "1280137": "摧心魔",
  "1280165": "满目征兆",
  "1280297": "灵雾通径",
  "1280316": "黑豹的诡计",
  "1280483": "地狱火",
  "1280658": "无法阻挡",
  "1280733": "虚空铠甲",
  "1280779": "冰川之寒",
  "1280780": "冰川粉碎",
  "1280868": "次元裂隙",
  "1280961": "姿态掌握",
  "1281468": "幽影之锋",
  "1281511": "地狱一游",
  "1281638": "雪茫危机",
  "1282535": "次级食尸鬼",
  "1282660": "倒刺射击",
  "1282710": "毒蛇打击",
  "1283372": "进食充分",
  "1283818": "凶暴野兽",
  "1284616": "进食充分",
  "1284617": "进食充分",
  "1284618": "进食充分",
  "1284619": "进食充分",
  "1284641": "丰盛进食充分",
  "1284642": "丰盛进食充分",
  "1284643": "丰盛进食充分",
  "1284644": "丰盛进食充分",
  "1284650": "丰盛进食充分",
  "1285644": "丰盛进食充分",
  "1289728": "神圣军备",
  "1290864": "死亡轮回",
  "1291457": "强盛狱火",
  "1291484": "乾元镇踏",
  "1291522": "时空发电机",
  "1291636": "时光屏障",
  "1292996": "可协商契约",
  "1293135": "嗜血之瓶"
};

export const GENERATED_SPELL_NAME_TRANSLATIONS: Record<string, string> = {
  "Word of Recall Other": "召回他人之语",
  "Death Touch": "死亡之触",
  "Suicide": "自杀",
  "Frostbolt of Ages": "上古寒冰箭",
  "Power Word: Shield": "真言术：盾",
  "Stun": "昏迷",
  "Goldshire Portal": "闪金镇传送门",
  "Teleport Goldshire": "传送：闪金镇",
  "Teleport Duskwood": "传送：暮色森林",
  "Teleport Elwynn": "传送：艾尔文森林",
  "Backstab": "背刺",
  "Invisibility": "隐形术",
  "Vanguard": "先锋",
  "Auto Shot": "自动射击",
  "Incapacitating Roar": "夺魂咆哮",
  "Charge": "冲锋",
  "Frostbolt": "寒冰箭",
  "Polymorph": "变形术",
  "Cone of Cold": "冰锥术",
  "Frost Nova": "冰霜新星",
  "Eye of Kilrogg": "基尔罗格之眼",
  "Slow Fall": "缓落术",
  "Fireball": "火球术",
  "Mend Pet": "治疗宠物",
  "Renew": "恢复",
  "Corruption": "腐蚀术",
  "Entangling Roots": "纠缠根须",
  "Immolate": "献祭",
  "Taunt": "嘲讽",
  "Purge": "净化术",
  "Earth Shield": "大地之盾",
  "Kidney Shot": "肾击",
  "Mind Soothe": "安抚心灵",
  "Devotion Aura": "虔诚光环",
  "Thorns": "荆棘术",
  "Remove Curse": "解除诅咒",
  "Divine Protection": "圣佑术",
  "Purify": "纯净术",
  "Dispel Magic": "驱散魔法",
  "Water Walking": "水上行走",
  "Astral Recall": "星界传送",
  "Smite": "惩击",
  "Fade": "渐隐术",
  "Shadow Word: Pain": "暗言术：痛",
  "Prayer of Healing": "治疗祷言",
  "Doom": "末日降临",
  "Mind Control": "精神控制",
  "Lay on Hands": "圣疗术",
  "Divine Shield": "圣盾术",
  "Shadow Bolt": "暗影箭",
  "Summon Imp": "召唤小鬼",
  "Summon Felhunter": "召唤地狱猎犬",
  "Summon Voidwalker": "召唤虚空行者",
  "Ritual of Summoning": "召唤仪式",
  "Curse of Weakness": "虚弱诅咒",
  "Garrote": "锁喉",
  "Banish": "放逐术",
  "Summon Succubus": "召唤魅魔",
  "Tranquility": "宁静",
  "Health Funnel": "生命通道",
  "Conjure Mana Gem": "制造法力宝石",
  "Cat Form": "猎豹形态",
  "Rend": "撕裂",
  "Rejuvenation": "回春术",
  "Disengage": "逃脱",
  "Travel Form": "旅行形态",
  "Cleave": "顺劈斩",
  "Hammer of Justice": "制裁之锤",
  "Shield Wall": "盾墙",
  "Call Pet 1": "召唤宠物 1",
  "Pick Pocket": "搜索",
  "Agony": "痛楚",
  "Revive Pet": "复活宠物",
  "Blessing of Protection": "保护祝福",
  "Blessing of Freedom": "自由祝福",
  "Chain Heal": "治疗链",
  "Rip": "割裂",
  "Subjugate Demon": "征服恶魔",
  "Summon Infernal": "召唤地狱火",
  "Mark of the Wild": "野性印记",
  "Hunter's Mark": "猎人印记",
  "Demoralizing Shout": "挫志怒吼",
  "Challenging Shout": "挑战怒吼",
  "Mutilate": "毁伤",
  "Arcane Explosion": "魔爆术",
  "Life Tap": "生命分流",
  "Arcane Intellect": "奥术智慧",
  "Beast Lore": "野兽知识",
  "Incanter's Flow": "咒术洪流",
  "Slam": "猛击",
  "Chaos Brand": "混乱烙印",
  "Track Beasts": "追踪野兽",
  "Scare Beast": "恐吓野兽",
  "Tame Beast": "驯服野兽",
  "Flare": "照明弹",
  "Whirlwind": "旋风斩",
  "Levitate": "漂浮术",
  "Curse of Tongues": "语言诅咒",
  "Hamstring": "断筋",
  "Recklessness": "鲁莽",
  "Distract": "扰乱",
  "Sinister Strike": "影袭",
  "Kick": "脚踢",
  "Gouge": "凿击",
  "Stealth": "潜行",
  "Pick Lock": "开锁",
  "Rake": "斜掠",
  "Cheap Shot": "偷袭",
  "Dash": "急奔",
  "Vanish": "消失",
  "Rupture": "割裂",
  "Hellfire": "地狱烈焰",
  "Blink": "闪现术",
  "Feint": "佯攻",
  "Resurrection": "复活术",
  "Ancestral Spirit": "先祖之魂",
  "Holy Word: Serenity": "圣言术：静",
  "Heal": "治疗术",
  "Flash Heal": "快速治疗",
  "Blind": "致盲",
  "Mind Vision": "心灵视界",
  "Dispatch": "斩击",
  "Flamestrike": "烈焰风暴",
  "Counterspell": "法术反制",
  "Earthbind Totem": "地缚图腾",
  "Shield Block": "盾牌格挡",
  "Hibernate": "休眠",
  "Dismiss Pet": "解散宠物",
  "Multi-Shot": "多重射击",
  "Ghost Wolf": "幽魂之狼",
  "Remove Corruption": "清除腐蚀",
  "Denounce": "谴责",
  "Deadly Poison": "夺命药膏",
  "Bloodlust": "嗜血",
  "Soothe": "安抚",
  "Scorch": "灼烧",
  "Sprint": "疾跑",
  "Firebolt": "火焰箭",
  "Parry": "招架",
  "Strong Troll's Blood Elixir": "强力巨魔之血药剂",
  "Elixir of Defense": "防御药剂",
  "Opening": "开启",
  "Drink Minor Potion": "喝下初级药水",
  "Potion of Strength II": "力量药水 II",
  "Crocolisk Steak": "鳄鱼肉排",
  "Crippling Poison": "减速药膏",
  "Intervene": "援护",
  "Shadow Oil": "暗影之油",
  "Frost Oil": "冰霜之油",
  "Searing Totem": "灼热图腾",
  "Path of Frost": "冰霜之路",
  "Consuming Shadows": "吞噬之影",
  "Red Woolen Boots": "红色毛纺靴",
  "Cleanse": "清洁术",
  "Concussive Shot": "震荡射击",
  "Arcane Missiles": "奥术飞弹",
  "Slice and Dice": "切割",
  "Wrath": "愤怒",
  "Mighty Bash": "蛮力猛击",
  "Prowl": "潜行",
  "Tiger's Fury": "猛虎之怒",
  "Shred": "撕碎",
  "Intimidating Shout": "破胆怒吼",
  "Evasion": "闪避",
  "Revenge!": "复仇！",
  "Execute": "斩杀",
  "Feign Death": "假死",
  "Healing Stream Totem": "治疗之泉图腾",
  "Replenish Mana": "补充法力",
  "Howl of Terror": "恐惧嚎叫",
  "Bear Form": "熊形态",
  "Sense Undead": "感知亡灵",
  "Unending Breath": "无尽呼吸",
  "Rain of Fire": "火焰之雨",
  "Numbing Poison": "迟钝药膏",
  "Fear": "恐惧",
  "Felsteed": "地狱战马",
  "Shiv": "毒刃",
  "Far Sight": "视界术",
  "Eagle Eye": "鹰眼术",
  "Create Healthstone": "制造治疗石",
  "Soulstone": "灵魂石",
  "Healthstone": "治疗石",
  "Thunder Clap": "雷霆一击",
  "Soul Fire": "灵魂之火",
  "Heroic Leap": "英勇飞跃",
  "Pummel": "拳击",
  "Revenge": "复仇",
  "Battle Shout": "战斗怒吼",
  "Sap": "闷棍",
  "Mortal Coil": "死亡缠绕",
  "Growl": "低吼",
  "Maul": "重殴",
  "Blessing of Sacrifice": "牺牲祝福",
  "Feed Pet": "喂养宠物",
  "Redemption": "救赎",
  "Overpower": "压制",
  "Will of the Forsaken": "被遗忘者的意志",
  "Lash of Pain": "剧痛鞭笞",
  "Healing Surge": "治疗之涌",
  "Earth Shock": "大地震击",
  "Mind Blast": "心灵震爆",
  "Psychic Scream": "心灵尖啸",
  "Tremor Totem": "战栗图腾",
  "Magma Totem": "熔岩图腾",
  "Windfury Totem": "风怒图腾",
  "Mystic Touch": "玄秘掌",
  "Ambush": "伏击",
  "Wound Poison": "致伤药膏",
  "Mail": "锁甲",
  "Moonfire": "月火术",
  "Regrowth": "愈合",
  "Shackle Horror": "束缚恐惧",
  "Restore Energy": "恢复能量",
  "Power Infusion": "能量灌注",
  "Turn Evil": "超度邪恶",
  "Flametongue Attack": "火舌攻击",
  "Elemental Leatherworking": "元素制皮",
  "Pyroblast": "炎爆术",
  "Ice Barrier": "寒冰护体",
  "Arcane Power": "奥术强化",
  "Evocation": "唤醒",
  "Mortal Strike": "致死打击",
  "Piercing Howl": "刺耳怒吼",
  "Icy Veins": "冰冷血脉",
  "Ignite": "点燃",
  "Getting Tide Pool Sample #2": "采集海潮之池样本#2",
  "Improved Whirlwind": "强化旋风斩",
  "Last Stand": "破釜沉舟",
  "Adrenaline Rush": "冲动",
  "Ice Trap": "冰霜陷阱",
  "Explosive Trap": "爆炸陷阱",
  "Blade Flurry": "剑刃乱舞",
  "Ruthlessness": "无情",
  "Seal Fate": "封印命运",
  "Holy Fire": "神圣之火",
  "Vigor": "精力",
  "Vampiric Embrace": "吸血鬼的拥抱",
  "Mind Flay": "精神鞭笞",
  "Silence": "沉默",
  "Master of the Elements": "元素宗师",
  "Mana Tide Totem": "法力之潮图腾",
  "Resurgence": "复苏",
  "Hemorrhage": "出血",
  "Claw": "爪击",
  "Omen of Clarity": "清晰预兆",
  "Clearcasting": "节能施法",
  "Hurricane": "飓风",
  "Thick Hide": "厚皮",
  "Primal Fury": "原始狂怒",
  "Wild Charge": "野性冲锋",
  "Bite": "撕咬",
  "Stormstrike": "风暴打击",
  "Shadowburn": "暗影灼烧",
  "Conflagrate": "燃烧",
  "Berserker Rage": "狂暴之怒",
  "Summon Doomguard": "召唤末日守卫",
  "Swiftmend": "迅捷治愈",
  "Teleport: Moonglade": "传送：月光林地",
  "Desperate Prayer": "绝望祷言",
  "Deterrence": "威慑",
  "Wyvern Sting": "翼龙钉刺",
  "Entrapment": "诱捕",
  "Aimed Shot": "瞄准射击",
  "Bestial Wrath": "狂野怒火",
  "Intimidation": "胁迫",
  "Flash of Light": "圣光闪现",
  "Tranquilizing Shot": "宁神射击",
  "Track Demons": "追踪恶魔",
  "Track Dragonkin": "追踪龙类",
  "Track Elementals": "追踪元素生物",
  "Track Giants": "追踪巨人",
  "Track Humanoids": "追踪人型生物",
  "Track Undead": "追踪亡灵",
  "Track Hidden": "追踪隐藏生物",
  "Repentance": "忏悔",
  "Immolation": "献祭",
  "Devastate": "毁灭打击",
  "Judgment": "审判",
  "Holy Shock": "神圣震击",
  "Rebirth": "复生",
  "War Stomp": "战争践踏",
  "Blood Fury": "血性狂怒",
  "Cannibalize": "食尸",
  "Escape Artist": "逃命专家",
  "Stoneform": "石像形态",
  "Reincarnation": "复生",
  "Distracting Shot": "扰乱射击",
  "Sacred Shield": "圣洁护盾",
  "Power Word: Fortitude": "真言术：韧",
  "Ferocious Bite": "凶猛撕咬",
  "Maim": "割碎",
  "Infernal Awakening": "地狱火觉醒",
  "Barkskin": "树皮术",
  "Frenzied Regeneration": "狂暴回复",
  "Dreadsteed": "恐惧战马",
  "Bloodthirst": "嗜血",
  "Spell Reflection": "法术反射",
  "Shield Slam": "盾牌猛击",
  "Hammer of Wrath": "愤怒之锤",
  "Moonkin Form": "枭兽形态",
  "Arcane Torrent": "奥术洪流",
  "Windfury Attack": "风怒攻击",
  "Righteous Fury": "正义之怒",
  "Berserking": "狂暴",
  "Consecration": "奉献",
  "Deadly Throw": "致命投掷",
  "Seed of Corruption": "腐蚀之种",
  "Spirit of Redemption": "救赎之魂",
  "Nightmare Seed": "梦魇草",
  "Gift of the Naaru": "纳鲁的赐福",
  "Innervate": "激活",
  "Incinerate": "烧尽",
  "Sudden Death": "猝死",
  "Second Wind": "复苏之风",
  "Soulshatter": "灵魂碎裂",
  "Create Soulwell": "制造灵魂之井",
  "Unstable Affliction": "痛苦无常",
  "Summon Felguard": "召唤恶魔卫士",
  "Pursuit": "追踪",
  "Legion Strike": "军团打击",
  "Shadowfury": "暗影之怒",
  "Spellsteal": "法术吸取",
  "Arcane Blast": "奥术冲击",
  "Ice Lance": "冰枪术",
  "Nature's Guardian": "自然守护者",
  "Cloak of Shadows": "暗影斗篷",
  "Cheat Death": "装死",
  "Slow": "减速",
  "Dragon's Breath": "龙息术",
  "Summon Water Elemental": "召唤水元素",
  "Waterbolt": "水箭",
  "Righteous Defense": "正义防御",
  "Aura Mastery": "光环掌握",
  "Ardent Defender": "炽热防御者",
  "Avenging Wrath": "复仇之怒",
  "Avenger's Shield": "复仇者之盾",
  "Stormstrike Off-Hand": "副手风暴打击",
  "Heroism": "英勇",
  "Crusader Aura": "十字军光环",
  "Mass Dispel": "群体驱散",
  "Shadow Word: Death": "暗言术：灭",
  "Shadow Embrace": "暗影之拥",
  "Binding Heal": "联结治疗",
  "Envenom": "毒伤",
  "Prayer of Mending": "愈合祷言",
  "Pain Suppression": "痛苦压制",
  "Freeze": "冰冻术",
  "Windfury Weapon": "风怒武器",
  "Lifebloom": "生命绽放",
  "Cyclone": "旋风",
  "Nurturing Instinct": "治愈本能",
  "Incarnation: Tree of Life": "化身：生命之树",
  "Mangle": "裂伤",
  "Kill Command": "杀戮命令",
  "Victory Rush": "乘胜追击",
  "Shadowfiend": "暗影魔",
  "Misdirection": "误导",
  "Mana Leech": "法力吸取",
  "Holy Word: Sanctify": "圣言术：灵",
  "Vampiric Touch": "吸血鬼之触",
  "Crusader Strike": "十字军打击",
  "Fatal Flourish": "索命强能",
  "Arcane Charge": "奥术充能",
  "Shadowstep": "暗影步",
  "Scatter Shot": "驱散射击",
  "Army of the Dead": "亡者大军",
  "Conjure Refreshment": "造餐术",
  "Death and Decay": "枯萎凋零",
  "Arcane Barrage": "奥术弹幕",
  "Living Bomb": "活动炸弹",
  "Fingers of Frost": "寒冰指",
  "Flurry": "乱舞",
  "Whirlwind Off-Hand": "副手旋风斩",
  "Lightning Bolt Overload": "闪电箭过载",
  "Chain Lightning Overload": "闪电链过载",
  "Ice Block": "寒冰屏障",
  "Death Strike": "灵界打击",
  "Chains of Ice": "寒冰锁链",
  "Blood Strike": "鲜血打击",
  "Raise Dead": "亡者复生",
  "Titan's Grip": "泰坦之握",
  "Bladestorm": "剑刃风暴",
  "Shockwave": "震荡波",
  "Strangulate": "绞袭",
  "Divine Aegis": "神圣庇护",
  "Mind Freeze": "心灵冰冻",
  "Penance": "苦修",
  "Death Coil": "凋零缠绕",
  "Empower Rune Weapon": "符文武器增效",
  "Dispersion": "消散",
  "Shield Discipline": "护盾戒律",
  "Guardian Spirit": "守护之魂",
  "Demonic Circle": "恶魔法阵",
  "Demonic Circle: Teleport": "恶魔法阵：传送",
  "Heating Up": "热力迸发",
  "Hot Streak!": "炽热连击！",
  "Haunt": "鬼影缠身",
  "Veteran of the Third War": "三战老兵",
  "Death's Advance": "死亡脚步",
  "Wild Growth": "野性成长",
  "Infected Wounds": "感染伤口",
  "Eclipse (Solar)": "日蚀",
  "Eclipse (Lunar)": "月蚀",
  "Anti-Magic Shell": "反魔法护罩",
  "Death Pact": "天灾契约",
  "Icebound Fortitude": "冰封之韧",
  "Obliterate": "湮灭",
  "Dancing Rune Weapon": "符文刃舞",
  "Lichborne": "巫妖之躯",
  "Frost Strike": "冰霜打击",
  "Howling Blast": "凛风冲击",
  "Summon Gargoyle": "召唤石像鬼",
  "Sudden Doom": "末日突降",
  "Death Grip": "死亡之握",
  "Smack": "拍击",
  "Magic Burn": "魔法燃烧",
  "Dazed": "眩晕",
  "Berserk": "狂暴",
  "Combine Golem Schematics": "合并魔像蓝图",
  "Wyrmrest Commander": "龙眠指挥官",
  "Flame Fury": "烈焰之怒",
  "Icy Touch": "冰冷触摸",
  "Inject Plague": "注射疫病",
  "Pit Trap": "陷阱",
  "Rot Armor": "腐烂护甲",
  "Rock Shield": "岩石护盾",
  "Razorice": "锋锐之霜",
  "Nourish": "滋养",
  "Revive": "起死回生",
  "Blood Boil": "血液沸腾",
  "Death Gate": "黑锋之门",
  "Anti-Magic Zone": "反魔法领域",
  "Killing Machine": "杀戮机器",
  "Pillar of Frost": "冰霜之柱",
  "Runic Corruption": "符文腐蚀",
  "Earthgrab Totem": "陷地图腾",
  "Thunderstorm": "雷霆风暴",
  "Lava Burst": "熔岩爆裂",
  "Hex": "妖术",
  "Feral Spirit": "野性狼魂",
  "Tidal Waves": "潮汐奔涌",
  "Dark Arctic Chestpiece": "黑暗极地胸甲",
  "Arctic Helm": "极地头盔",
  "On Patrol": "巡逻",
  "Har'koa's Chains": "哈克娅的锁链",
  "Pickup Primordial Hatchling": "获取始生雏龙",
  "Summon Primordial Hatchling": "召唤始生雏龙",
  "Summon Captive Footman": "召唤被俘虏的步兵",
  "Bonk": "猛烈撞击",
  "Throw Spear": "投掷长矛",
  "Rhunok's Chains": "伦诺克的锁链",
  "Raging Shadows": "狂怒暗影",
  "Sholazar Guardian Heartbeat": "索拉查卫士的心跳声",
  "Goregek's Slave": "格利基克的奴隶",
  "Venomous Vim": "愤怒能量",
  "Killing Spree": "影舞步",
  "Fan of Knives": "刀扇",
  "Cleanse Spirit": "净化灵魂",
  "On a Pale Horse": "死神降临",
  "Water Shield": "水之护盾",
  "Savage Roar": "野蛮咆哮",
  "Chimaera Shot": "奇美拉射击",
  "Master's Call": "主人的召唤",
  "Rune of Razorice": "冰锋符文",
  "Rune of the Fallen Crusader": "堕落十字军符文",
  "Kill Shot": "夺命射击",
  "Unholy Strength": "不洁之力",
  "Sanctified Wrath": "圣洁怒火",
  "Divine Storm": "神圣风暴",
  "Runeforging": "符文熔铸",
  "Roar of Sacrifice": "牺牲咆哮",
  "Beacon of Light": "圣光道标",
  "Infusion of Light": "圣光灌注",
  "Hammer of the Righteous": "正义之锤",
  "Shield of the Righteous": "正义盾击",
  "Shadow Bite": "暗影撕咬",
  "Nitro Boosts": "氮气推进器",
  "Divine Flame": "神圣之焰",
  "Parachute": "降落伞",
  "Blood Plague": "血之疫病",
  "Scourge Strike": "天灾打击",
  "Frost Fever": "冰霜疫病",
  "Vampiric Blood": "吸血鬼之血",
  "Mirror Image": "镜像",
  "Petrifying Scream": "僵滞尖啸",
  "Dark Command": "黑暗命令",
  "Horrify": "惊魂",
  "Glyph of Felguard": "恶魔卫士雕文",
  "Splitting Ice": "碎冰",
  "Feed Stormcrest Eagle": "喂食雷羽鹰",
  "Global Thermal Sapper Charge": "通用热力工程炸药",
  "Steady Shot": "稳固射击",
  "Well Fed": "进食充分",
  "Horn of Winter": "寒冬号角",
  "Heroic Throw": "英勇投掷",
  "Glyph of Lesser Proportion": "体型缩小雕文",
  "Tricks of the Trade": "嫁祸诀窍",
  "Fire Blast": "火焰冲击",
  "Wind Shear": "风剪",
  "Kilrogg's Cunning": "基尔罗格的狡诈",
  "Glyph of Soulwell": "灵魂之井雕文",
  "Glyph of Gushing Wound": "龟裂创伤雕文",
  "Glyph of Mighty Victory": "强力制胜雕文",
  "Relentless Strikes": "无情打击",
  "Overkill": "灭绝",
  "Glyph of the Geist": "恶鬼雕文",
  "Glyph of Foul Menagerie": "邪恶兽群雕文",
  "Spirit Walk": "幽魂步",
  "Shadowmeld": "影遁",
  "Rime": "白霜",
  "Might of the Mountain": "山丘之力",
  "Drenched in Mojo": "被魔精浸湿",
  "Water Blast": "水之冲击",
  "Will to Survive": "生存意志",
  "Lava Lash": "熔岩猛击",
  "Elemental Fury": "元素之怒",
  "Strength": "力量",
  "Agility": "敏捷",
  "Intellect": "智力",
  "Healing Trance": "治疗入定",
  "Riptide": "激流",
  "Combat Potency": "作战潜能",
  "Survival Instincts": "生存本能",
  "Typhoon": "台风",
  "Aspect of the Chameleon": "变色龙守护",
  "Earthquake": "地震术",
  "Raise Ally": "复活盟友",
  "Create Whole Turkey": "制造完整的火鸡",
  "Hand of Reckoning": "清算之手",
  "Rune of the Stoneskin Gargoyle": "岩肤石像鬼符文",
  "Snowdrift": "雪流",
  "Safe Area": "安全区域",
  "Runic Smash": "符文重击",
  "Power Word: Barrier": "真言术：障",
  "Siphon Life": "生命虹吸",
  "Glyph of Crimson Banish": "猩红放逐雕文",
  "Dark Transformation": "黑暗突变",
  "Serendipity": "妙手回春",
  "Psychic Horror": "心灵惊骇",
  "Body and Soul": "身心合一",
  "Shattering Throw": "碎裂投掷",
  "Divine Hymn": "神圣赞美诗",
  "Symbol of Hope": "希望象征",
  "Napalm Shell": "凝固汽油炸弹",
  "Chained to Stables": "系在兽栏上",
  "Compacted": "压缩",
  "Vault of Archavon Closure Warning": "阿尔卡冯的宝库关闭警报",
  "Ride Keristrasza": "骑乘克莉斯塔萨",
  "Frost Strike Off-Hand": "副手冰霜打击",
  "Obliterate Off-Hand": "副手湮灭",
  "Call of the Elements": "元素的召唤",
  "Call of the Ancestors": "先祖的召唤",
  "Call of the Spirits": "灵魂的召唤",
  "Glyph of Thunder Strike": "雷霆一击雕文",
  "Darkflight": "疾步夜行",
  "Two Forms": "双形态",
  "Rocket Barrage": "火箭弹幕",
  "Pack Hobgoblin": "呼叫大胖",
  "Rocket Jump": "火箭跳",
  "Predatory Swiftness": "掠食者的迅捷",
  "Blessed Healing": "祈福",
  "Icy Rage": "寒怒",
  "Fatal Flaws": "致命破绽",
  "Strength of the Taunka": "牦牛人的蛮力",
  "Agility of the Vrykul": "维库人的迅捷",
  "Power of the Taunka": "牦牛人的锋芒",
  "Aim of the Iron Dwarves": "铁矮人的专注",
  "Speed of the Vrykul": "维库人的急速",
  "Deadly Precision": "致命精准",
  "Urgency": "刻不容缓",
  "Increased Fortitude": "强化坚韧",
  "Elusive Power": "能量动荡",
  "Revitalized": "复苏",
  "Hardened Skin": "硬化皮肤",
  "Surge of Power": "能量涌动",
  "Siphoned Power": "虹吸能量",
  "Thick Skin": "皮糙肉厚",
  "Aegis of Dalaran": "达拉然的庇护",
  "Leap of Faith": "信仰飞跃",
  "Shadeburst": "暗影爆裂",
  "Unleash Life": "生命释放",
  "Primal Strike": "根源打击",
  "Healing Rain": "治疗之雨",
  "Necrotic Strike": "死疽打击",
  "Combat Readiness": "备战就绪",
  "Power Torrent": "能量洪流",
  "Searching for Artifacts": "搜索古物",
  "Meteor Strike": "流星打击",
  "Leap Ahead": "向前跳跃",
  "Stun (Permanent)": "昏迷（永久）",
  "Teleport to East Colossal": "传送至东双塔山",
  "Teleport Back To Dreamer's Rest": "传送返回梦游者栖地",
  "Wrangling Rope": "牧绳",
  "Shoot Thorns": "棘刺喷射",
  "Shadow Channeling": "暗影导能",
  "Defiled Ground": "污染的大地",
  "Smoke Bomb": "烟雾弹",
  "Mastery: Icicles": "精通：冰刺",
  "Mastery: Unshackled Fury": "精通：不羁之怒",
  "Purify Spirit": "净化灵魂",
  "Mastery: Potent Afflictions": "精通：剧痛",
  "Mastery: Master Demonologist": "精通：恶魔学识大师",
  "Mastery: Chaotic Energies": "精通：混乱能量",
  "Mastery: Deep Healing": "精通：深度治疗",
  "Focus": "集中",
  "Lava Burst Overload": "熔岩爆裂过载",
  "Healing Wave": "治疗波",
  "Mastery: Echo of Light": "精通：圣光回响",
  "Echo of Light": "圣光回响",
  "Mastery: Razor Claws": "精通：剃刀之爪",
  "Mastery: Harmony": "精通：相生",
  "Mastery: Blood Shield": "精通：鲜血护盾",
  "Blood Shield": "鲜血护盾",
  "Outbreak": "爆发",
  "Dark Simulacrum": "黑暗模拟",
  "Thrash": "痛击",
  "Stampeding Roar": "狂奔怒吼",
  "Lava Surge": "熔岩奔腾",
  "Lightning Discharge": "闪电倾泻",
  "Starsurge": "星涌术",
  "Solar Beam": "日光术",
  "Elusiveness": "飘忽不定",
  "Restless Blades": "无休锋刃",
  "Venomous Wounds": "剧毒创伤",
  "Vendetta": "宿敌",
  "Spiritwalker's Grace": "灵魂行者的恩赐",
  "Siphon Power": "虹吸能量",
  "Free Your Mind": "解放你的思想",
  "Flask of Steelskin": "钢皮合剂",
  "Flask of the Draconic Mind": "神龙心智合剂",
  "Flask of the Winds": "风行合剂",
  "Flask of Titanic Strength": "泰坦之力合剂",
  "Havoc": "浩劫",
  "Pulverize": "粉碎",
  "Time Warp": "时间扭曲",
  "Titan's Grip: Single-Minded Fury": "泰坦之握：一心狂怒",
  "Crimson Scourge": "赤色天灾",
  "Runic Empowerment": "符文强化",
  "Efflorescence": "百花齐放",
  "Atonement": "救赎",
  "Corruption: Absolute": "腐蚀：绝对",
  "Holy Light": "圣光术",
  "Ring of Frost": "冰霜之环",
  "Fervor": "热情",
  "Devour Magic": "吞噬魔法",
  "Call Pet 2": "召唤宠物 2",
  "Call Pet 3": "召唤宠物 3",
  "Call Pet 4": "召唤宠物 4",
  "Call Pet 5": "召唤宠物 5",
  "Frozen Orb": "寒冰宝珠",
  "Inquisition": "异端裁决",
  "Grand Crusader": "大十字军",
  "Light of Dawn": "黎明之光",
  "Templar's Verdict": "圣殿骑士的裁决",
  "Raging Blow": "怒击",
  "Word of Glory": "荣耀圣令",
  "Doom Bolt": "厄运箭",
  "Festering Strike": "脓疮打击",
  "Hand of Gul'dan": "古尔丹之手",
  "Flamethrower": "火焰喷射器",
  "Pierce Armor": "穿刺护甲",
  "Nethermancy": "驾驭虚空",
  "Plate Specialization": "板甲专精",
  "Main Gauche": "左右开弓",
  "Mail Specialization": "锁甲专精",
  "Guardian of Ancient Kings": "远古列王守卫",
  "Cauterize": "灸灼",
  "Cauterized": "灸灼",
  "Serpent Sting": "毒蛇钉刺",
  "Essence of the Red": "红龙精华",
  "Attack": "攻击",
  "Nature's Cure": "自然之愈",
  "Holy Word: Chastise": "圣言术：罚",
  "Wild Mushroom": "野性蘑菇",
  "Volcanic Destruction": "火山毁灭",
  "Big Daddy": "王牌炸药",
  "Felstorm": "魔刃风暴",
  "Soul Power": "灵魂之力",
  "Find Weakness": "洞悉弱点",
  "Battle Magic": "战斗魔法",
  "Celerity": "动如脱兔",
  "Heartened": "振奋",
  "Thrill of Victory": "胜利之悦",
  "Forged Fury": "铸炼怒火",
  "Final Key": "终极密钥",
  "Speed of Thought": "极速思维",
  "River of Death": "死亡之河",
  "Heedless Carnage": "鲁莽残杀",
  "Enigma": "神秘",
  "Dire Magic": "灾难魔法",
  "Revelation": "启示",
  "Grounded Soul": "接地之魂",
  "Race Against Death": "生死极速",
  "Rageheart": "狂怒之心",
  "Nefarious Plot": "邪恶意图",
  "Twisted": "扭曲",
  "Recaptured Mana": "重获法力",
  "Flask of Battle": "战斗合剂",
  "Control Pet": "控制宠物",
  "Control Demon": "控制恶魔",
  "Sunfire": "阳炎术",
  "Gore": "淤血",
  "Skull Bash": "迎头痛击",
  "Flask of Flowing Water": "流水合剂",
  "Bladestorm Off-Hand": "副手剑刃风暴",
  "Rebuke": "责难",
  "Hakkar's Chains": "哈卡之链",
  "Rallying Cry": "集结呐喊",
  "Void-Touched": "虚触",
  "Spirit Link Totem": "灵魂链接图腾",
  "Spirit Link": "灵魂链接",
  "Furious Slash": "狂暴挥砍",
  "Tiger Palm": "猛虎掌",
  "Blackout Kick": "幻灭踢",
  "The Codex of Xerrath": "克萨雷斯魔典",
  "Flying Serpent Kick": "翔龙在天",
  "Spinning Crane Kick": "神鹤引项踢",
  "Transcendence": "魂体双分",
  "Lightning Elven Peridot": "闪电精灵榄石",
  "Sensei's Elven Peridot": "导师的精灵榄石",
  "Infused Elven Peridot": "灌能精灵榄石",
  "Zen Elven Peridot": "禅悟之精灵榄石",
  "Balanced Elven Peridot": "平衡精灵榄石",
  "Vivid Elven Peridot": "鲜亮精灵榄石",
  "Ironbark": "铁木树皮",
  "Cenarion Ward": "塞纳里奥结界",
  "Mass Entanglement": "群体缠绕",
  "Incarnation: Avatar of Ashamane": "化身：阿莎曼之灵",
  "Incarnation: Guardian of Ursoc": "化身：乌索克的守护者",
  "Incarnation: Chosen of Elune": "化身：艾露恩之眷",
  "Grove Guardians": "林莽卫士",
  "Ursol's Vortex": "乌索尔旋风",
  "Darkmoon Firework": "暗月烟花",
  "Double Time": "再度冲锋",
  "Warbringer": "战神",
  "Stance of the Fierce Tiger": "猛虎式",
  "Call Dreadstalkers": "召唤恐惧猎犬",
  "Wild Imp": "野生小鬼",
  "Fel Firebolt": "恶魔火焰箭",
  "Unending Resolve": "不灭决心",
  "Fel Armor": "邪甲术",
  "Virmen's Bite": "兔妖之啮",
  "Potion of Focus": "专注药水",
  "Potion of the Jade Serpent": "青龙药水",
  "Potion of Mogu Power": "魔古之力药水",
  "Healing Potion": "治疗药水",
  "Restore Mana": "恢复法力",
  "Swipe": "横扫",
  "Quaking Palm": "震山掌",
  "Rising Sun Kick": "旭日东升踢",
  "Storm Bolt": "风暴之锤",
  "Avatar": "天神下凡",
  "Asphyxiate": "窒息",
  "Death Siphon": "死亡虹吸",
  "Gorefiend's Grasp": "血魔之握",
  "Desecrated Ground": "邪恶之地",
  "Subterfuge": "诡诈",
  "Shadow Focus": "暗影集中",
  "Astral Shift": "星界转移",
  "Healing Tide Totem": "治疗之潮图腾",
  "Totemic Projection": "图腾投射",
  "Heart of the Wild": "野性之心",
  "Killer Instinct": "杀手本能",
  "Dark Regeneration": "黑暗再生",
  "Soul Leech": "灵魂榨取",
  "Soul Link": "灵魂链接",
  "Dark Pact": "黑暗契约",
  "Grimoire of Service": "侍从魔典",
  "Grimoire of Sacrifice": "牺牲魔典",
  "Nightfall": "夜幕",
  "Phantasm": "幻隐",
  "Angelic Bulwark": "天使壁垒",
  "Roll": "滚地翻",
  "Surge of Light": "圣光涌动",
  "Posthaste": "迅疾如风",
  "Binding Shot": "束缚射击",
  "Iron Hawk": "铁鹰守护",
  "Narrow Escape": "险境求生",
  "Exhilaration": "意气风发",
  "Divine Star": "神圣之星",
  "Greater Invisibility": "强化隐形术",
  "Burning Rush": "爆燃冲刺",
  "Control Undead": "控制亡灵",
  "Demonic Gateway": "恶魔传送门",
  "Grimoire: Imp": "魔典：小鬼",
  "Grimoire: Voidwalker": "魔典：虚空行者",
  "Grimoire: Succubus": "魔典：魅魔",
  "Grimoire: Felhunter": "魔典：地狱猎犬",
  "Grimoire: Felguard": "魔典：恶魔卫士",
  "Summon Fel Imp": "召唤邪能小鬼",
  "Summon Voidlord": "召唤空灵领主",
  "Summon Shivarra": "召唤破坏魔",
  "Summon Observer": "召唤眼魔",
  "Summon Wrathguard": "召唤愤怒卫士",
  "Summon Abyssal": "召唤深渊魔",
  "Summon Terrorguard": "召唤恐惧卫士",
  "Bloodbath": "浴血奋战",
  "Fists of Fury": "怒雷破",
  "Dark Soul: Instability": "黑暗灵魂：动荡",
  "Dark Soul: Misery": "黑暗灵魂：哀难",
  "Shuriken Toss": "飞镖投掷",
  "Shroud of Concealment": "潜伏帷幕",
  "Vigilance": "警戒",
  "Ascendance": "升腾",
  "Restorative Mists": "恢复迷雾",
  "Windlash": "狂风鞭笞",
  "Windlash Off-Hand": "副手狂风鞭笞",
  "Soul of the Forest": "丛林之魂",
  "Unbreakable Spirit": "不败之魂",
  "Holy Prism": "神圣棱镜",
  "Treant Form": "树人形态",
  "Purgatory": "炼狱",
  "Stone Bulwark": "石壁",
  "Healing Tide": "治疗之潮",
  "Chi Torpedo": "真气突",
  "Stagger": "醉拳",
  "Expel Harm": "移花接木",
  "Paralysis": "分筋错骨",
  "Touch of Death": "轮回之触",
  "Chi Wave": "真气波",
  "Renewing Mist": "复苏之雾",
  "Soothing Mist": "抚慰之雾",
  "Zen Meditation": "禅悟冥想",
  "Resuscitate": "轮回转世",
  "Dizzying Haze": "迷醉酒雾",
  "Breath of Fire": "火焰之息",
  "Fortifying Brew": "壮胆酒",
  "Energizing Elixir": "豪能酒",
  "Mana Tea": "法力茶",
  "Guard": "金钟罩",
  "Ironskin Brew": "铁骨酒",
  "Revival": "还魂术",
  "Summon Jade Serpent Statue": "召唤青龙雕像",
  "Summon Black Ox Statue": "召唤玄牛雕像",
  "Windstrike": "风切",
  "Windstrike Off-Hand": "副手风切",
  "Ascension": "扬升",
  "Black Ox Brew": "玄牛酒",
  "Detox": "清创生血",
  "Healing Sphere": "疗伤珠",
  "Provoke": "嚎镇八方",
  "Mastery: Combo Strikes": "精通：组合拳",
  "Blinding Light": "盲目之光",
  "Mortal Wounds": "致死之伤",
  "Beast Cleave": "野兽顺劈",
  "Glyph of Hawk Feast": "雄鹰盛宴雕文",
  "Glyph of Burning Anger": "怒火冲天雕文",
  "Unholy Blight": "邪恶虫群",
  "Afterlife": "死后余生",
  "Disable": "金刚震",
  "Teachings of the Monastery": "禅院教诲",
  "Vivify": "活血术",
  "Thunder Focus Tea": "雷光聚神茶",
  "Spear Hand Strike": "切喉手",
  "Blackout Kick!": "幻灭踢！",
  "Tiger's Lust": "迅如猛虎",
  "Ring of Peace": "平心之环",
  "Rushing Jade Wind": "碧玉疾风",
  "Life Cocoon": "作茧缚命",
  "Chaos Bolt": "混乱之箭",
  "Shroud of Purgatory": "炼狱蔽体",
  "Primal Elementalist": "元素尊者",
  "Elemental Blast": "元素冲击",
  "Critical Mass": "临界炽焰",
  "Bloodthirst Heal": "嗜血治疗",
  "Meteor": "流星",
  "Incarnation": "化身",
  "Backdraft": "爆燃",
  "Mastery: Elusive Brawler": "精通：醉拳大师",
  "Mastery: Gust of Mists": "精通：迷雾之风",
  "Crackling Jade Lightning": "碎玉闪电",
  "Dragon Roar": "巨龙怒吼",
  "Die by the Sword": "剑在人在",
  "Primal Fire Elemental": "原始火元素",
  "Elemental Blast: Critical Strike": "元素冲击：爆击",
  "Capacitor Totem": "电能图腾",
  "Leg Sweep": "扫堂腿",
  "Charging Ox Wave": "蛮牛冲",
  "Purifying Brew": "活血酒",
  "Energy Usage": "能量使用",
  "Command Demon": "恶魔掌控",
  "Singe Magic": "烧灼驱魔",
  "Optical Blast": "眼棱爆炸",
  "Axe Toss": "巨斧投掷",
  "Conversion": "符能转换",
  "Transcendence: Transfer": "魂体双分：转移",
  "Leather Specialization": "皮甲专精",
  "Barrage": "弹幕射击",
  "Halo": "光晕",
  "Elemental Blast Overload": "元素冲击过载",
  "Dire Beast": "凶暴野兽",
  "Glaive Toss": "飞刃",
  "Touch of Death Notification Driver": "轮回之触通知驱动",
  "Blindside": "侧袭",
  "Keg Smash": "醉酿投",
  "Shadow Blades": "暗影之刃",
  "Angelic Feather": "天堂之羽",
  "Combat Wisdom": "战斗贤才",
  "Stampede": "奔踏",
  "Dampen Harm": "躯不坏",
  "Healing Elixir": "金创药",
  "Dematerialize": "大象无形",
  "Touch of Karma": "业报之触",
  "Diffuse Magic": "散魔功",
  "Mindbender": "摧心魔",
  "Plague Leech": "吸血瘟疫",
  "Glyph of the Blazing Trail": "烈焰开道雕文",
  "Block": "格挡",
  "Invoke Xuen, the White Tiger": "白虎下凡",
  "Chi Burst": "真气爆裂",
  "Crackling Tiger Lightning": "伏虎闪雷",
  "Zen Pulse": "禅意波",
  "Dual Wield": "双武器",
  "Heavy Stagger": "重度醉拳",
  "Moderate Stagger": "中度醉拳",
  "Light Stagger": "轻度醉拳",
  "Gift of the Ox": "玄牛之赐",
  "Enveloping Mist": "氤氲之雾",
  "Nature's Vigil": "自然的守护",
  "Fetch": "拾回",
  "Glyph of Rising Tiger Kick": "猛虎出山雕文",
  "Glyph of Honor": "武道精神雕文",
  "Glyph of Fighting Pose": "战斗姿态雕文",
  "Zen Flight": "禅意飞行",
  "Glyph of Crackling Tiger Lightning": "伏虎闪雷雕文",
  "Synapse Springs": "神经元弹簧",
  "Ancient Teachings of the Monastery": "禅院古训",
  "Zen Pilgrimage": "禅宗朝圣",
  "Zen Pilgrimage: Return": "禅宗朝圣：返回",
  "Corpse Exploder": "邪爆",
  "Charm Woodland Creature": "魅惑林地生物",
  "Touch of the Grave": "哀伤之触",
  "Psycho Mantid: Summon Lann": "可怕的螳螂妖：召唤兰",
  "Fireworks": "烟花",
  "Combat Conditioning": "进退自如",
  "Monk": "武僧",
  "Glide": "滑翔",
  "Feline Swiftness": "豹之迅捷",
  "A Murder of Crows": "夺命黑鸦",
  "Holy Nova": "神圣新星",
  "Nature's Swiftness": "自然迅捷",
  "Shadow Bulwark": "暗影壁垒",
  "Blow Darkmoon Whistle": "吹响暗月哨子",
  "Invoke Niuzao, the Black Ox": "玄牛下凡",
  "Tooth and Claw": "尖牙与利爪",
  "Tar Trap": "焦油陷阱",
  "Death Knight": "死亡骑士",
  "Blood Death Knight": "鲜血死亡骑士",
  "Hunter": "猎人",
  "Survival Hunter": "生存猎人",
  "Brewmaster Monk": "酒仙武僧",
  "Mistweaver Monk": "织雾武僧",
  "Windwalker Monk": "踏风武僧",
  "Subtlety Rogue": "敏锐潜行者",
  "Warlock": "术士",
  "Affliction Warlock": "痛苦术士",
  "Demonology Warlock": "恶魔学识术士",
  "Destruction Warlock": "毁灭术士",
  "Warrior": "战士",
  "Arms Warrior": "武器战士",
  "Fury Warrior": "狂怒战士",
  "Combo Breaker": "踏风连击",
  "Storm, Earth, and Fire": "风火雷电",
  "Ancient Zandalari Knowledge": "远古赞达拉秘籍",
  "Combo Point": "连击点数",
  "Leech": "吸血",
  "Ysera's Gift": "伊瑟拉之赐",
  "Bloodtalons": "血腥爪击",
  "Pandaren Treasure Noodle Cart": "熊猫人八宝汤面餐车",
  "Drums of Rage": "暴怒之鼓",
  "Glyph of the Skeleton": "骷髅雕文",
  "Light's Revocation": "圣光决断",
  "Glyph of the Weaponmaster": "武器大师雕文",
  "Counter Shot": "反制射击",
  "Icicle": "冰刺",
  "Cataclysm": "大灾变",
  "Whirling Dragon Punch": "升龙霸",
  "Anger Management": "愤怒掌控",
  "Comet Storm": "彗星风暴",
  "Arcane Orb": "奥术宝珠",
  "Brawn": "健硕",
  "Meteor Burn": "流星灼烧",
  "Breath of Sindragosa": "冰龙吐息",
  "Auspicious Spirits": "吉兆",
  "Guardian of Elune": "艾露恩的卫士",
  "Lunar Inspiration": "月之灵",
  "Germination": "萌芽",
  "Rejuvenation (Germination)": "回春术（萌芽）",
  "Bristling Fur": "鬃毛倒竖",
  "Ravager": "破坏者",
  "Eternal Flame": "永恒之火",
  "Beacon of Faith": "信仰道标",
  "Saved by the Light": "圣光救赎",
  "Owlkin Frenzy": "枭兽狂怒",
  "Wind Gust": "呼啸狂风",
  "Call Lightning": "召唤闪电",
  "Roll Speed Controls": "滚翻控制",
  "Stormfury": "风暴怒火",
  "Windwalking": "疾风步",
  "Critical Strikes": "致命攻击",
  "Pyrotechnics": "烟火之术",
  "Supernova": "超级新星",
  "Ice Nova": "寒冰新星",
  "Dream of Cenarius": "塞纳留斯的梦境",
  "Blood Elf Illusion": "血精灵幻象",
  "Demon's Bite": "恶魔之咬",
  "Metamorphosis": "恶魔变形",
  "Chaos Strike": "混乱打击",
  "Demon Soul": "恶魔之魂",
  "Chi Sphere": "真气珠",
  "Execute Off-Hand": "副手斩杀",
  "Flap": "振翅",
  "Colossus Smash": "巨人打击",
  "Mastery: Elemental Overload": "精通：元素过载",
  "Touch of Fatality": "绝命之触",
  "Earthen Rage": "大地狂怒",
  "Elemental Blast: Haste": "元素冲击：急速",
  "Elemental Blast: Mastery": "元素冲击：精通",
  "Pool of Mists": "日升雾腾",
  "Pure Rage": "纯粹怒火",
  "Drums of Fury": "狂怒战鼓",
  "Chaos Nova": "混乱新星",
  "Blessing of Dawn": "黎明祝福",
  "Retribution Aura": "惩戒光环",
  "Disrupt": "瓦解",
  "Disrupting Fury": "瓦解之怒",
  "Judgment of Light": "圣光审判",
  "Mastery: Lightbringer": "精通：光明使者",
  "Enrage": "激怒",
  "Enraged Regeneration": "狂怒回复",
  "Rampage": "暴怒",
  "Blade of Justice": "公正之剑",
  "Shield of Vengeance": "复仇之盾",
  "Tactician": "战术专家",
  "Throw Glaive": "投掷利刃",
  "Torment": "折磨",
  "Crimson Vial": "猩红之瓶",
  "Shadow Dance": "暗影之舞",
  "Deepening Shadows": "侵蚀之影",
  "Arcane Shot": "奥术射击",
  "Shadowstrike": "暗影打击",
  "Poisoned Knife": "剧毒之刃",
  "Pistol Shot": "手枪射击",
  "Aspect of the Cheetah": "猎豹守护",
  "Aspect of the Turtle": "灵龟守护",
  "Raptor Strike": "猛禽一击",
  "Aspect of the Eagle": "雄鹰守护",
  "Energy Regen": "能量再生",
  "Freezing Trap": "冰冻陷阱",
  "Muzzle": "压制",
  "Crash Lightning": "毁灭闪电",
  "Maelstrom Weapon": "漩涡武器",
  "Ancient Healing Potion": "古代治疗药水",
  "Ancient Rejuvenation Potion": "古代活力药水",
  "Potion of the Old War": "上古战神药水",
  "Flask of the Whispered Pact": "耳语契约合剂",
  "Flask of the Seventh Demon": "第七恶魔合剂",
  "Flask of the Countless Armies": "无尽大军合剂",
  "Flask of Ten Thousand Scars": "千万战痕合剂",
  "Lightning Bolt": "闪电箭",
  "Flame Shock": "烈焰震击",
  "Chain Lightning": "闪电链",
  "Blade Dance": "刃舞",
  "Spectral Sight": "幽灵视觉",
  "Fire Elemental": "火元素",
  "Runic Power": "符文能量",
  "Infernal Strike": "地狱火撞击",
  "Nature's Essence": "自然精华",
  "Combustion": "燃烧",
  "Blizzard": "暴风雪",
  "Brain Freeze": "冰冷智慧",
  "Ignore Pain": "无视苦痛",
  "Mastery: Savant": "精通：法力专家",
  "Divine Steed": "神圣马驹",
  "Mark of the Claw": "利爪之印",
  "Harpoon": "鱼叉猛刺",
  "Starfall": "星辰坠落",
  "Aspect of the Beast": "野兽守护",
  "Virulent Plague": "恶性病变",
  "Stormkeeper": "风暴守护者",
  "Fury of the Storms": "风暴之怒",
  "Power of the Maelstrom": "漩涡之力",
  "Gust of Mists": "迷雾之风",
  "Gust of Wind": "阵风",
  "Wind Rush Totem": "狂风图腾",
  "Ironfur": "铁鬃",
  "Graceful Spirit": "恩赐之魂",
  "Lightning Shield": "闪电之盾",
  "Liquid Magma": "岩浆",
  "Poison Knives": "淬毒刀刃",
  "Fel Rush": "邪能冲撞",
  "Poison Bomb": "毒液炸弹",
  "Protective Light": "防护圣光",
  "Castigation": "惩罚",
  "Enlightenment": "启迪",
  "Light's Resurgence": "圣光复苏",
  "Hatchet Toss": "投掷手斧",
  "Cobra Shot": "眼镜蛇射击",
  "Deeper Stratagem": "深邃诡计",
  "Scent of Blood": "血之气息",
  "Weaponmaster": "武器掌握",
  "Alacrity": "敏锐",
  "Iron Stomach": "铜肠铁胃",
  "Elaborate Planning": "深谋远虑",
  "Dreamwalk": "梦境行者",
  "Starfire": "星火术",
  "Celestial Alignment": "超凡之盟",
  "Voidform": "虚空形态",
  "Power Word: Radiance": "真言术：耀",
  "Lock and Load": "荷枪实弹",
  "Rapid Decomposition": "迅速凋零",
  "Icy Talons": "冰冷之爪",
  "Gathering Storm": "风暴汇聚",
  "Glacial Advance": "冰川突进",
  "All Will Serve": "万物臣服",
  "Bone Shield": "白骨之盾",
  "Marrowrend": "精髓分裂",
  "Death's Caress": "死神的抚摩",
  "Nightblade": "夜刃",
  "Grappling Hook": "抓钩",
  "Shroud": "隐形",
  "Opportunity": "可乘之机",
  "Wing Clip": "摔绊",
  "Bloodworms": "血虫",
  "Rage": "狂怒",
  "Double Jump": "二段跳",
  "Absolute Corruption": "绝对腐蚀",
  "Sow the Seeds": "腐蚀播种",
  "Implosion": "内爆",
  "Bloodworm": "血虫",
  "Fire and Brimstone": "硫磺烈火",
  "Eradication": "灭杀",
  "Channel Demonfire": "引导恶魔之火",
  "Bonestorm": "白骨风暴",
  "Eye of the Tiger": "猛虎之眼",
  "Psychic Voice": "心灵之声",
  "Darkness": "黑暗",
  "Special Delivery": "特别快递",
  "Blackout Combo": "幻灭连击",
  "High Tolerance": "坚定不屈",
  "Hit Combo": "连击",
  "Remorseless Winter": "冷酷严冬",
  "Dazzling Lights": "耀眼光芒",
  "Blessed Light": "祝福之光",
  "Tranquil Light": "宁静之光",
  "Eviscerate": "刺骨",
  "Frost Shock": "冰霜震击",
  "Iron Wire": "铁线",
  "Feral Lunge": "狂野扑击",
  "Hunter Artifacts - Dalaran Aura": "占位字符",
  "Shadow Techniques": "暗影技巧",
  "Hit and Run": "移形换位",
  "Crusader's Might": "十字军之力",
  "Quick Draw": "快速拔枪",
  "Master of Shadows": "暗影大师",
  "Light of the Naaru": "纳鲁之光",
  "Stonebark": "石木树皮",
  "Inner Peace": "平常心",
  "Sundering": "裂地术",
  "Beacon of the Lightbringer": "光明使者的道标",
  "Astral Influence": "星界支配",
  "Flourish": "繁盛",
  "Shuriken Storm": "袖剑风暴",
  "Archangel": "天使长",
  "Focused Thunder": "雷光凝聚",
  "Mist Wrap": "缭绕之雾",
  "Lifecycles": "生生不息",
  "Wellspring": "奔涌之流",
  "Eye Beam": "眼棱",
  "Power of the Dark Side": "阴暗面之力",
  "Earth Elemental": "土元素",
  "Divine Hammer": "神圣之锤",
  "Elemental Healing": "元素治疗",
  "Blur": "疾影",
  "Drain Soul": "吸取灵魂",
  "Vengeful Retreat": "复仇回避",
  "Song of Chi-Ji": "赤精之歌",
  "Unleash Lava": "熔岩释放",
  "Unleash Lightning": "闪电释放",
  "Doom Vortex": "毁灭漩涡",
  "Holy Ritual": "神圣仪式",
  "Camouflage": "伪装",
  "Psychic Link": "心智联结",
  "Stomp": "践踏",
  "Killer Cobra": "杀戮眼镜蛇",
  "Glacial Spike": "冰川尖刺",
  "Glacial Spike!": "冰川尖刺！",
  "Trailblazer": "开拓者",
  "Beacon of Virtue": "美德道标",
  "Torrent": "洪流",
  "Deluge": "洪水",
  "Trail of Light": "光明尾迹",
  "Apotheosis": "神圣化身",
  "Censure": "谴罚",
  "Guardian Angel": "守护天使",
  "Prosperity": "欣欣向荣",
  "Cultivation": "栽培",
  "Ursoc's Endurance": "乌索尔的坚韧",
  "Wildflesh": "荒野血肉",
  "Perpetual Spring": "永恒之春",
  "Protection of Tyr": "提尔的保护",
  "Tyr's Deliverance": "提尔的拯救",
  "Airborne Irritant": "刺激弥散",
  "Gloomblade": "幽暗之刃",
  "Plea": "恳求",
  "Gory Fur": "血污毛皮",
  "Embrace of the Nightmare": "梦魇之拥",
  "Annihilation": "毁灭",
  "Fury of the Illidari": "伊利达雷之怒",
  "Earthen Wall": "大地之墙",
  "Stormsurge": "风暴喷涌",
  "Hot Hand": "灼热之手",
  "Predator": "掠食者",
  "Sabertooth": "剑齿利刃",
  "Indomitable": "百折不挠",
  "Hot Trub": "热酿",
  "Sigil of Silence": "沉默咒符",
  "Sigil of Chains": "锁链咒符",
  "Bounding Stride": "腾跃步伐",
  "Impending Victory": "胜利在望",
  "Resonance Totem": "共鸣图腾",
  "Renewed Fury": "狂暴复兴",
  "Fervor of Battle": "战斗狂热",
  "Shooting Stars": "坠星",
  "Starlord": "星辰领主",
  "Chrysalis": "破蛹化蝶",
  "Warrior of Elune": "艾露恩的战士",
  "Nature's Balance": "自然平衡",
  "Best Served Cold": "痛宰",
  "Into the Fray": "投入战斗",
  "Booming Voice": "震耳嗓音",
  "Fury of Elune": "艾露恩之怒",
  "Light of the Sun": "烈日之光",
  "Heavy Repercussions": "强力反击",
  "Crackling Thunder": "爆裂闪电",
  "Flame Accelerant": "烈焰触媒",
  "Blind Fury": "盲目之怒",
  "Demon Blades": "恶魔之刃",
  "Felblade": "邪能之刃",
  "Demon Spikes": "恶魔尖刺",
  "Consume Soul": "吞噬灵魂",
  "Soul Fragment": "灵魂残片",
  "Brambles": "刺藤",
  "Blood Frenzy": "血性狂乱",
  "Galactic Guardian": "星河守护者",
  "Survival of the Fittest": "优胜劣汰",
  "Earthwarden": "大地守卫者",
  "Soul Fragments": "灵魂残片",
  "Blessing of Spellwarding": "破咒祝福",
  "Blessed Hammer": "祝福之锤",
  "Fiery Brand": "烈火烙印",
  "Crusader's Judgment": "十字军审判",
  "Rend and Tear": "狂乱撕扯",
  "Consecrated Ground": "圣洁之地",
  "Lunar Beam": "明月普照",
  "Righteous Protector": "正义保护者",
  "Final Stand": "决一死战",
  "Bullseye": "正中靶心",
  "Voodoo Mastery": "巫毒掌握",
  "Sigil of Flame": "烈焰咒符",
  "Fel Prison": "邪能牢笼",
  "Spirit of the Maelstrom": "漩涡之灵",
  "Soul Rending": "灵魂劈裂",
  "Ray of Frost": "冰霜射线",
  "Arcane Familiar": "奥术魔宠",
  "Lonely Winter": "孤寂寒冬",
  "Presence of Mind": "气定神闲",
  "Firestarter": "纵火者",
  "Resonance": "共鸣",
  "Flame On": "烈焰飞舞",
  "Frozen Touch": "冰冻之触",
  "Ice Ward": "寒冰结界",
  "Demonic Calling": "魔性征召",
  "Reverse Entropy": "熵能返转",
  "Summon Darkglare": "召唤黑眼",
  "Consumption": "吞噬",
  "Phantom Singularity": "诡异魅影",
  "Dominate Mind": "统御意志",
  "Sheilun's Gift": "神龙之赐",
  "Desperate Instincts": "绝望本能",
  "Void Bolt": "虚空箭",
  "Flame Patch": "烈焰之地",
  "Icicles": "冰刺",
  "Force of Nature": "自然之力",
  "Red Thirst": "赤红渴望",
  "Anti-Magic Barrier": "反魔法屏障",
  "Bone Chilling": "刺骨冰寒",
  "Massacre": "毁灭",
  "First Blood": "第一滴血",
  "Exergy": "能量放射",
  "Heart Strike": "心脏打击",
  "Will of the Necropolis": "浮空城意志",
  "Foul Bulwark": "腐烂壁垒",
  "Shattering Blade": "破碎之刃",
  "Murderous Efficiency": "杀戮效率",
  "Runic Attenuation": "符文调谐",
  "Avalanche": "雪崩",
  "Blinding Sleet": "致盲冰雨",
  "Permafrost": "永冻",
  "Frostscythe": "冰霜之镰",
  "Ebon Fever": "黑檀热",
  "Infected Claws": "感染之爪",
  "Epidemic": "扩散",
  "Aura of Pain": "痛苦光环",
  "Abundance": "丰饶",
  "Spring Blossoms": "春暖花开",
  "Painbringer": "痛苦使者",
  "Ancestral Vigor": "先祖活力",
  "Soul Carver": "灵魂切削",
  "Ancestral Protection": "先祖护佑",
  "Agonizing Flames": "苦痛之焰",
  "Totemic Revival": "图腾复生",
  "Sigil of Misery": "悲苦咒符",
  "Feast of Souls": "灵魂盛宴",
  "Burning Alive": "火刑",
  "Downpour": "倾盆大雨",
  "Fire of the Twisting Nether": "扭曲虚空的火焰",
  "Chill of the Twisting Nether": "扭曲虚空的冰冷",
  "Shock of the Twisting Nether": "扭曲虚空的冲击",
  "Warpaint": "战争印记",
  "Skysec's Hold": "斯凯塞克的坚守",
  "Shadow Satyr's Walk": "暗影萨特之步",
  "Last Resort": "最后一搏",
  "Quickened Sigils": "快速咒符",
  "Bulwark of Order": "秩序壁垒",
  "Fires of Justice": "正义之火",
  "Play Dead": "装死",
  "Wake Up": "唤醒",
  "Demonic Appetite": "恶魔食欲",
  "Mount Form": "坐骑形态",
  "Death Sweep": "死亡横扫",
  "Merciful Auras": "仁慈光环",
  "Master of Escape": "逃脱大师",
  "Tailwind Totem": "顺风图腾",
  "Lightning Rod": "引雷针",
  "Aftershock": "余震",
  "Icefury": "冰怒",
  "Heartbreaker": "碎心打击",
  "Touch of the Magi": "大法师之触",
  "Elemental Assault": "元素突袭",
  "Item - Druid T19 Feral 2P Bonus": "套装特效占位",
  "Item - Druid T19 Feral 4P Bonus": "套装特效占位",
  "Item - Monk T19 Brewmaster 2P Bonus": "套装特效占位",
  "Cleansing Detonate": "净化引爆",
  "Serpent Breath": "翔龙吐息",
  "Fel Devastation": "邪能毁灭",
  "Outro Conversation": "离场对话",
  "Grip of Nightmare": "梦魇之握",
  "Summoning": "召唤",
  "Summon Dryad": "召唤树妖",
  "Item - Warrior T19 Protection 4P Bonus": "套装特效占位",
  "Critical Block": "精确格挡",
  "Brittle Statue": "脆弱的雕像",
  "The Golden Gaze": "金睛凝视",
  "Arcane Font Area Aura": "奥术之泉区域光环",
  "Intro Conversation": "进场对话",
  "Create Conversation": "创建对话",
  "Teleport": "传送",
  "Explosive Shot": "爆炸射击",
  "Wraith Walk": "幻影步",
  "Demon Hunter": "恶魔猎手",
  "Shimmer": "闪光术",
  "Charred Warblades": "焦油战刃",
  "Potent Kick": "金刚不坏",
  "Staggering Around": "醉拳步",
  "Master of the Glaive": "战刃大师",
  "Demonic": "魔化",
  "Felforge Enhancement": "邪能熔炉强化",
  "Spawn": "生成",
  "Dominate Demon": "支配恶魔",
  "Fixate": "锁定",
  "Skyhorn Strafing Run": "天角空中扫射",
  "Chen's Defense": "陈的防御",
  "Monkey Magic": "猴王戏法",
  "Hiro the Healer": "治疗者希罗",
  "Lightning Breath": "闪电吐息",
  "Unending Hatred": "无尽愤怒",
  "Throw Web Gland": "扔出丝囊",
  "Create Diamond": "制造钻石",
  "Web Patch": "纠缠之网",
  "Create Lockpicks": "制造开锁工具",
  "Demonic Vision": "恶魔视觉",
  "Conversation": "对话",
  "Destroy Demon": "摧毁恶魔",
  "Ravenbear Death": "鸦熊死亡",
  "Demonic Trample": "恶魔践踏",
  "Brew-Stache": "酒有余香",
  "Overcharge": "过载",
  "Hastily-Rigged Bomb": "匆匆装配的炸弹",
  "Shadowforce": "暗影之力",
  "Arcane Fog": "奥术迷雾",
  "Ride Boat": "驾船",
  "Ground Spike": "大地之刺",
  "Spiked Shield": "尖刺盾牌",
  "Defiled Font": "亵渎之泉",
  "Stone Bolt": "岩石箭",
  "Purify Disease": "净化疾病",
  "Cleanse Toxins": "清毒术",
  "Taste of Blood": "鲜血气息",
  "Epocheric Orb": "纪元宝珠",
  "Brand of Argus": "阿古斯之印",
  "Spiderling Venom": "小蜘蛛毒素",
  "Iron Scale": "铁鳞",
  "Quaking Sands": "战栗之地",
  "Searing Flames": "灼热烈焰",
  "Wanderer's Hardiness": "云游者的坚韧",
  "Sharpened Dreadfangs": "恐惧利齿",
  "Pounce": "突袭",
  "Fragile Echo": "脆弱回响",
  "Shuffle": "酒醒入定",
  "Fresh Meat": "新鲜血肉",
  "Blaze of Light": "圣光之耀",
  "Bear Hug": "巨熊拥抱",
  "Soul Conduit": "灵魂导管",
  "Undulation": "波动",
  "Avenging Crusader": "复仇十字军",
  "Celestial Fortune": "天神护佑",
  "Flame Bomb": "烈焰炸弹",
  "Thunderdome": "雷霆之穹",
  "Barbed Shot": "倒刺射击",
  "Imprison": "禁锢",
  "Recursive Strikes": "回归打击",
  "Feed the Demon": "喂食恶魔",
  "Icefury Overload": "冰怒过载",
  "Demon Skin": "恶魔皮肤",
  "Duelists": "格斗家",
  "Ossuary": "埋骨之所",
  "Summon Snowfeather": "召唤雪羽",
  "Player Choice": "玩家选择",
  "Aura of Defilement": "亵渎光环",
  "Defilement": "亵渎",
  "[DND] Leave": "[DND]离开",
  "Violent Eruption": "剧烈喷发",
  "Rushing Waters": "漩涡激流",
  "Volatile": "易爆",
  "Conversation: Helcular": "对话：赫尔库拉",
  "Mark of the Crane": "神鹤印记",
  "Fel Stomp": "恶魔践踏",
  "Storm, Earth, and Fire: Fixate": "风火雷电：锁定",
  "Cancel Ride Aura": "取消骑乘光环",
  "Transmutant": "变异软泥怪",
  "Lurking Owl Kitten": "潜伏的鹰头小猫",
  "Summon Flower": "召唤鲜花",
  "Conversation: Paladin Appears": "对话：圣骑士出现",
  "Flashes of Steel": "钢铁之耀",
  "Call of the Seas": "海洋的召唤",
  "Volatile Outpouring": "不稳定的暗流",
  "Feral Frenzy": "野性狂乱",
  "Conversation - Val'sharah Terrorguard": "对话",
  "Shadow Strike": "暗影突击",
  "Conversation - Val'sharah Voidlord": "对话",
  "Shadow Strikes": "暗影打击",
  "Conversation - Val'sharah Observer": "对话",
  "Conversation - Val'sharah": "对话",
  "Inferno Bolt": "炼狱箭",
  "Malfurion's Conquest Set": "玛法里奥的征服套装",
  "Spirit Berries": "灵体果",
  "Sunfruit": "太阳果",
  "Fel Axe": "邪能战斧",
  "Haunting Burst": "阴魂爆裂",
  "Oozing Rush": "软泥突袭",
  "Running Aground": "触礁",
  "Safeguard": "捍卫",
  "World Breaker": "世界击碎者",
  "Stop Gul'dan: Quest Accept": "阻止古尔丹：接受任务",
  "No Leaving": "无法离开",
  "Stylish Spy Glasses": "时髦的间谍眼镜",
  "Thornstalk": "荆棘丛",
  "G'Hanir's Blossom": "加尼尔之花",
  "Reverse Cast: Reveal": "返转施法：侦测",
  "Holy Wrath Small Fill": "占位字符",
  "Perfect Dreamgrove Blossom": "完美的梦境林地花蕾",
  "75 Ancient Mana": "75份远古魔力",
  "A Falling Star": "陨落之星",
  "Cancel Holy Wrath": "取消神圣愤怒",
  "Cancel Arcane Bar": "取消奥术能量条",
  "Nightstable Energy": "永夜能量",
  "Sudden Insanity": "骤然狂乱",
  "A Falling Star for Dan": "丹的陨落之星",
  "On Fire": "着火",
  "Nightshifted Bolts": "星移箭",
  "Conqueror's Battlegear Set": "征服者套装",
  "Bursting Slime": "爆发软泥",
  "Dreadnaught's Battlegear": "无畏",
  "More... MORE MORE MORE!": "更多……更多更多更多！",
  "Warbringer Armor Set": "战神护甲套装",
  "Seeping Fog": "渗漏之雾",
  "Death Cosmetic State": "死亡装饰状态",
  "Sunblossom Pollen": "太阳花粉",
  "Dark Energy": "黑暗能量",
  "Beastmaster": "兽王",
  "Marksmanship": "射击",
  "Survival": "生存",
  "Rumbling Roar": "低沉咆哮",
  "Limb Smash": "树枝重击",
  "Ancient Branch": "古树树枝",
  "Solar Collapse": "阳光坍缩",
  "Cosmetic - Carrying Basket 1": "装饰物 - 运输篮1",
  "Destroyer Armor Set": "毁灭者护甲套装",
  "Increase Damage": "伤害提高",
  "Crest of Carnage": "屠杀纹章",
  "Crest of Devastation": "毁灭纹章",
  "Hellscream's Conquest Set": "地狱咆哮的征服套装",
  "Ymirjar Lord's Set": "伊米亚之王套装",
  "Increased Damage": "伤害提高",
  "Increased Health": "提高生命值",
  "Enigma Vestments Set": "神秘套装",
  "Dismiss": "解散",
  "Spellstone of Kel'danath": "凯尔丹纳斯的法术石",
  "Avenger's Battlegear Set": "复仇者套装",
  "Garments of the Oracle Set": "神谕者套装",
  "Deathdealer's Embrace": "死亡执行者的拥抱",
  "In A Book": "在书中",
  "Arcane Trap": "奥术陷阱",
  "Arcane Trap Detonation": "奥术陷阱爆破",
  "Putrid Jar": "腐烂之罐",
  "Fel Eruption": "邪能爆发",
  "Divine Purpose": "神圣意志",
  "Defiled Augmentation": "亵渎强化",
  "Lord of Flames": "烈焰领主",
  "Clarity of Vision": "清晰视界",
  "Fly to Stormheim": "飞往风暴峡湾",
  "Take": "拿去",
  "Fly to Dalaran": "飞往达拉然",
  "Wounded": "受伤",
  "Sausage On a Stick": "棍子上的香肠",
  "Molten Weapon": "熔岩武器",
  "Icy Edge": "寒冰刀锋",
  "Crackling Surge": "爆裂涌动",
  "Jacin's Ruse": "贾辛的诡计",
  "Shield Slam!": "盾牌猛击！",
  "Mark of Shifting": "变形印记",
  "Turbo Cleave": "涡轮顺劈斩",
  "Nether Suppression": "虚空镇压",
  "Arluin Bribe Checker": "阿鲁因贿赂检测器",
  "Arcane Energy": "奥术能量 ",
  "Shadow Sight": "暗影视界",
  "Fracture": "破裂",
  "Fallout": "爆燃",
  "Defy Gravity": "反抗引力",
  "Cleansing Flame": "净化火焰",
  "Dashing Flame Gale": "翻卷的烈焰狂风",
  "Hot Blooded": "沸腾血液",
  "Winter's Chill": "深冬之寒",
  "Mark of the Ancient Priestess": "古代女祭司之印",
  "Access to the Ruins of Falanaar": "法兰纳尔废墟通行证",
  "Soul Cleave": "灵魂裂劈",
  "Potion of Prolonged Power": "延时之力药水",
  "Big Red Rays": "巨怒射线",
  "Cavalier": "骑手",
  "Drums of the Mountain": "高山战鼓",
  "Improved Regrowth": "强化愈合",
  "Lingering Healing": "持续治疗",
  "Merciless Claws": "无情爪击",
  "The Beast Within": "野兽之心",
  "Arcing Cleave": "弧光顺劈",
  "Improved Vivify": "强化活血术",
  "Greater Judgment": "强效审判",
  "Sanctuary": "庇护",
  "Improved Sprint": "强化疾跑",
  "Deadened Nerves": "麻木神经",
  "Improved Conflagrate": "强化燃烧",
  "Astral Harmony": "星界和谐",
  "Dark Reflection": "黑暗映像",
  "Shadowform": "暗影形态",
  "Kam Xi'raff": "卡姆·希拉夫",
  "Drain Life": "吸取生命",
  "Fist of Justice": "制裁之拳",
  "Death's Embrace": "死亡之拥",
  "Master Assassin's Initiative": "大师刺客的决意",
  "Cold Snap": "急速冷却",
  "Blazing Barrier": "烈焰护体",
  "Prismatic Barrier": "棱光护体",
  "Improved Between the Eyes": "强化正中眉心",
  "Miracle Worker": "创造奇迹",
  "Frenetic Speed": "狂热之速",
  "Moment of Clarity": "洞察秋毫",
  "Devastator": "灭绝者",
  "Astral Vulnerability": "星界易伤",
  "Slipstream": "冲流",
  "Oakheart's Puny Quods": "橡树之心的迷你牢笼",
  "Amplification": "增效",
  "Planar Rip": "位面撕碎",
  "Scintillating Moonlight": "耀眼月光",
  "Lenience": "仁慈",
  "Fleshknitting": "血肉交织",
  "Angel's Mercy": "天使之慈",
  "Quick Sip": "浅斟快饮",
  "Eternal Barrier": "永恒屏障",
  "Cosmic Ripple": "宇宙涟漪",
  "Misery": "哀难",
  "Giant Hat": "巨大的帽子",
  "Create Starweave and Shadowcloth": "制造星纹布和暗影布",
  "Water Bubble": "水泡",
  "Intro Scene": "占位字符",
  "Enter Broken Shore Scenario": "进入破碎海滩场景",
  "Summon Shadow Succubus": "召唤暗影魅魔",
  "Increase Item Level": "提高物品等级",
  "Flail Applicator": "连枷挥砍",
  "Create Armor Enhancement": "制造护甲强化徽记",
  "Odyn's Hammer": "奥丁之锤",
  "Flail": "挥砍",
  "Sentinax Destruction Zone": "森提纳克斯毁灭区域",
  "Foul Concoction": "腐臭药剂",
  "Putrid Gas": "腐溃毒气",
  "Toxic Spores": "剧毒孢子",
  "Volatile Catalyst": "活性催化剂",
  "Volatile Reaction": "剧烈反应",
  "Petrification": "石化",
  "Crash of Light": "圣光冲撞",
  "Master Bu Snow": "卜雪大师",
  "Awaken!": "觉醒！",
  "Exterminators: Stacks": "灭绝者：层数",
  "Exterminators: Increase Stacks": "灭绝者：叠加层数",
  "Open Rift": "打开裂隙",
  "Fel Fog": "邪能雾气",
  "Armageddon Blast": "末日冲击",
  "Fel Infused": "邪能灌注",
  "Armageddon": "末日决战",
  "Armageddon Hail": "末日之雹",
  "Teleport: Dalaran": "传送：达拉然",
  "Fel Lash": "魔能鞭笞",
  "Frothing Fel": "邪能释放",
  "Electroport": "电能传送",
  "Shield Aura": "护盾光环",
  "Shadowy Blades": "暗影之刃",
  "Shadowblade's Murderous Omen": "暗影之刃的谋杀预兆",
  "NONE": "无",
  "Endurance of the Broken Temple": "残寺派的坚韧",
  "Portal to Suramar": "通往苏拉玛的传送门",
  "Mist Filled Pool": "迷雾之池",
  "Shadow Bolt Volley": "暗影箭雨",
  "Mist Filled Pools": "迷雾之池",
  "Piercing Cry": "穿刺咆哮",
  "Fel Gout": "邪能之痛",
  "Fel Explosion": "邪能爆破",
  "Naxxramas Challenge": "纳克萨玛斯挑战",
  "Wall of Doom": "末日之墙",
  "Zap": "震击",
  "Lob Lightning": "球形闪电",
  "Hover": "悬空",
  "Urge to Kill": "杀戮冲动",
  "Seismic Lightning": "震波闪电",
  "Create Item": "制造物品",
  "Mark of Kazzak": "卡扎克的印记",
  "Reading": "阅读",
  "Darkness of a Thousand Souls": "千魂之暗",
  "Tome of Unraveling Sanity": "醒神宝典",
  "A Mighty Pirate": "伟大的海盗",
  "Control Aura": "支配光环",
  "Asleep": "昏睡",
  "Disturbing": "打断",
  "Alone in the Darkness": "黑暗独行",
  "Torment of Flames": "烈焰折磨",
  "Torment of Shadows": "暗影折磨",
  "Torment of Frost": "冰霜折磨",
  "Torment of Fel": "邪能折磨",
  "Tear Rift": "撕裂裂隙",
  "Collapsing World": "崩塌的世界",
  "Blazefury Medallion": "火焰之怒",
  "Decapitated": "斩首",
  "Empyrean Demolisher": "苍穹击碎者",
  "Dark Fissure": "黑暗裂隙",
  "Felstorm Barrage": "邪能风暴扫射",
  "Dark Eruption": "黑暗喷发",
  "Marking...": "标记中……",
  "Summon Notley": "召唤诺特利",
  "Plundering Splash": "掠夺溅射",
  "Flaming Pitch": "燃烧的焦油",
  "Green Dance Sticks": "绿色舞棍",
  "Purple Dance Sticks": "紫色舞棍",
  "Reality Tear": "时空裂痕",
  "Gateway: Xoroth": "传送通路：克索诺斯",
  "Prophet's Guidestone": "先知的指引石",
  "Feeding...": "喂食中",
  "Bursting Darkness": "喷薄黑暗",
  "Summon Void Lord Pet": "召唤虚空领主宠物",
  "Deactivate": "关闭",
  "Command Ship Bombardment": "指挥舰轰炸",
  "Summon Velen": "召唤维伦",
  "Foresight": "精准预判",
  "Brewmaster's Balance": "酒仙之道",
  "Toxic Blade": "淬毒之刃",
  "Energetic Rip": "能量割裂",
  "Dark Shadow": "黑暗之影",
  "Dark Bond": "黑暗连结",
  "Soul Shards": "灵魂碎片",
  "Spirit Bomb": "幽魂炸弹",
  "Frailty": "脆弱",
  "The First of the Dead": "亡者始祖",
  "Fury of Nature": "自然之怒",
  "In For The Kill": "杀心骤起",
  "Astral Healing Potion": "星界治疗药水",
  "Flask of the Currents": "湍流合剂",
  "Flask of Endless Fathoms": "无尽深邃合剂",
  "Flask of the Vast Horizon": "广阔天涯合剂",
  "Flask of the Undertow": "暗潮合剂",
  "Tiger Dash": "猛虎冲刺",
  "Shadow Gestures": "暗影姿态",
  "Bloody Gash": "血腥伤口",
  "Apex Predator": "顶级捕食者",
  "Regenerative Fur": "复苏毛皮",
  "Inexorable Assault": "酷寒突袭",
  "Lightspawn": "光耀之子",
  "Voidling": "虚空之子",
  "Light's Judgment": "圣光裁决者",
  "Light's Reckoning": "圣光清算",
  "Bull Rush": "蛮牛冲撞",
  "Mountaineer": "登山家",
  "Cantrips": "戏法",
  "Wake of Ashes": "灰烬觉醒",
  "Blinding Powder": "致盲粉",
  "Loaded Dice": "灌铅骰子",
  "Retractable Hook": "伸缩钩",
  "Entropic Embrace": "熵能之拥",
  "Venom Rush": "药膏专家",
  "Master Assassin": "刺客大师",
  "Spatial Rift": "空间裂隙",
  "Rapid Fire": "急速射击",
  "Shot in the Dark": "暗算",
  "Phoenix Flames": "不死鸟之焰",
  "Trick Shots": "技巧射击",
  "Grappling Shot": "抓钩射击",
  "Earth Shaker": "撼地者",
  "Trample": "践踏",
  "Loaned S.E.L.F.I.E. Camera": "借用的自拍神器",
  "Cancel S.E.L.F.I.E. Camera.": "取消自拍",
  "Thrill of the Hunt": "狩猎刺激",
  "Essence Break": "精华破碎",
  "Trail of Ruin": "毁灭之痕",
  "Cycle of Hatred": "仇恨之轮",
  "Immolation Aura": "献祭光环",
  "Fel Barrage": "邪能弹幕",
  "Mongoose Fury": "猫鼬之怒",
  "Wildfire Bomb": "野火炸弹",
  "Forge of Light": "圣光熔炉",
  "Precise Shots": "弹无虚发",
  "Volley": "乱射",
  "Bloodseeker": "觅血者",
  "Tip of the Spear": "利矛之刃",
  "Master Marksman": "狙击高手",
  "Arcane Pulse": "奥术脉冲",
  "Double Tap": "二连发",
  "Calling the Shots": "箭在弦上",
  "Sweeping Strikes": "横扫攻击",
  "Spirit Wolf": "幽灵狼",
  "Sharp Reflexes": "身法如风",
  "Mastery: Deep Wounds": "精通：重伤",
  "Deep Wounds": "重伤",
  "Dreadnaught": "悍勇无畏",
  "War Machine": "战争机器",
  "Forceful Winds": "强风",
  "Ormhun Chosen": "选择奥姆哈恩",
  "Void Torrent": "虚空洪流",
  "Soul Barrier": "灵魂壁障",
  "Woodchuck": "土拨鼠",
  "Creeping Death": "死亡蔓延",
  "Dreadlash": "恐惧奇袭",
  "Power Siphon": "能量虹吸",
  "Demonic Core": "恶魔之核",
  "Demonbolt": "恶魔之箭",
  "Guerrilla Tactics": "游击战术",
  "Tiger Tail Sweep": "猛虎扫尾",
  "Primal Rage": "原始暴怒",
  "Static Charge": "静电充能",
  "Summon Demonic Tyrant": "召唤恶魔暴君",
  "Demonic Power": "恶魔之力",
  "Terms of Engagement": "接战协定",
  "Rain of Chaos": "混乱之雨",
  "Internal Combustion": "内燃",
  "Born To Be Wild": "天生狂野",
  "Animal Companion": "动物伙伴",
  "Bilescourge Bombers": "灾怨轰炸",
  "Sacrificed Souls": "献祭之魂",
  "Inner Demons": "内心之魔",
  "Nether Portal": "虚空传送门",
  "Righteous Verdict": "正义裁决",
  "Soul Strike": "灵魂打击",
  "Demonic Consumption": "恶魔吞噬",
  "Summon Prince Malchezaar": "召唤玛克扎尔王子",
  "Summon Illidari Satyr": "召唤伊利达雷萨特",
  "Summon Vicious Hellhound": "召唤邪恶的冥狱猎犬",
  "Summon Eyes of Gul'dan": "召唤古尔丹之眼",
  "Summon Void Terror": "召唤虚空恐魔",
  "Summon Bilescourge": "召唤灾怨蝇",
  "Summon Darkhound": "召唤黑暗犬",
  "Bile Spit": "胆汁喷吐",
  "Headbutt": "迎头冲撞",
  "Summon Ur'zul": "召唤乌祖尔",
  "Void Reaver": "虚空掠夺者",
  "Pyroclasm": "火焰冲撞",
  "Alpha Predator": "捕食者头领",
  "Freezing Rain": "冰冻之雨",
  "Demonfire": "恶魔之火",
  "Wicked Maw": "邪恶之喉",
  "Natural Mending": "自然治愈",
  "Mastery: Grace": "精通：优雅",
  "Blade Rush": "刀锋冲刺",
  "Dreadbite": "恐惧之咬",
  "Shadow Slash": "暗影鞭笞",
  "Dancing Steel": "钢铁之舞",
  "Eye of Gul'dan": "古尔丹之眼",
  "Double Breath": "双重吐息",
  "Toxic Bile": "剧毒胆汁",
  "Multi-Slash": "乱刀斩",
  "Overhead Assault": "高空突袭",
  "Fel Bite": "邪能之咬",
  "Many Faced Bite": "多面之咬",
  "Unlimited Power": "无穷力量",
  "Frenzy": "狂乱",
  "Hemostasis": "鲜血禁闭",
  "Grip of the Dead": "亡者之握",
  "Voracious": "饮血",
  "New Moon": "新月",
  "Half Moon": "半月",
  "Full Moon": "满月",
  "Invigorating Mists": "振奋之雾",
  "Ancestral Call": "先祖召唤",
  "Rictus of the Laughing Skull": "嘲颅狞笑",
  "Zeal of the Burning Blade": "火刃热忱",
  "Ferocity of the Frostwolf": "霜狼勇猛",
  "Might of the Blackrock": "黑石伟力",
  "Photosynthesis": "光合作用",
  "Rising Mist": "升腾迷雾",
  "Punish": "惩罚",
  "Storm Surge": "狂雷奔涌",
  "Rumbling Earth": "滚石",
  "Lesser Ghoul": "次级食尸鬼",
  "Harbinger of Doom": "末日使者",
  "Death's Reach": "死亡延伸",
  "Night Terrors": "暗夜恐怖",
  "Chain Reaction": "连锁反应",
  "Consume Magic": "吞噬魔法",
  "Frostwyrm's Fury": "冰霜巨龙之怒",
  "Seasoned Soldier": "百战老兵",
  "Twin Moons": "双月",
  "Spiritual Focus": "灵魂专注",
  "Redoubt": "多面防御",
  "Sins of the Many": "诸罪加身",
  "Meat Cleaver": "血肉顺劈",
  "Bob and Weave": "闪避身法",
  "Flash Flood": "迅捷洪流",
  "Leeching Poison": "吸血药膏",
  "Secret Technique": "影分身",
  "Siegebreaker": "破城者",
  "Obliteration": "湮没",
  "Reverberate": "回响",
  "Soul Shard": "灵魂碎片",
  "Pterrordax Swoop": "翼手龙滑翔",
  "Primal Wrath": "原始之怒",
  "Haymaker": "强力一击",
  "Trueshot": "百发百中",
  "High Tide": "浪潮汹涌",
  "Intangibility": "暗影无形",
  "Improved Stampeding Roar": "强化狂奔怒吼",
  "Demonic Embrace": "恶魔之拥",
  "Necromancer's Cunning": "通灵师的狡诈",
  "Raise Abomination": "培育憎恶",
  "Master Shapeshifter": "变形大师",
  "Ride the Lightning": "驾驭雷电",
  "Regeneratin'": "再生！",
  "Earthquake Overload": "地震术过载",
  "Greater Flask of the Currents": "强效湍流合剂",
  "Greater Flask of Endless Fathoms": "强效无尽深邃合剂",
  "Greater Flask of the Vast Horizon": "强效广阔天涯合剂",
  "Greater Flask of the Undertow": "强效暗潮合剂",
  "Alchemist's Strength": "炼金师的力量",
  "Alchemist's Agility": "炼金师的敏捷",
  "Alchemist's Intellect": "炼金师的智力",
  "Verdant Heart": "青翠之心",
  "Unbound Freedom": "无拘自由",
  "Rummage Your Bag": "翻找背包",
  "Between the Eyes": "正中眉心",
  "Instant Poison": "速效药膏",
  "Hand of the Protector": "守护者之手",
  "Rune Strike": "符文打击",
  "Improved Execute": "强化斩杀",
  "Runic Overflow": "符文溢能",
  "Cleaving Strikes": "顺劈打击",
  "Improved Vampiric Blood": "强化吸血鬼之血",
  "Strength of Will": "意志的力量",
  "Relish in Blood": "猩红余味",
  "Army of the Damned": "诅咒大军",
  "Draconic Empowerment": "龙族强化",
  "Concentration Aura": "专注光环",
  "Flametongue Weapon": "火舌武器",
  "Improved Wound Poison": "强化致伤药膏",
  "Black Powder": "黑火药",
  "Stormblast": "风暴轰击",
  "Improved Backstab": "强化背刺",
  "Improved Shuriken Storm": "强化袖剑风暴",
  "Swallowed Anger": "吞噬愤怒",
  "Infernal Armor": "地狱火护甲",
  "Improved Disrupt": "强化瓦解",
  "Burning Hatred": "燃烧之恨",
  "Bouncing Glaives": "弹跳利刃",
  "Perfectly Balanced Glaive": "完美平衡利刃",
  "Critical Chaos": "致命混沌",
  "Blazing Path": "烈焰之径",
  "Improved Sigil of Misery": "强化悲苦咒符",
  "Vengeful Bonds": "复仇桎梏",
  "Surge of Earth": "大地激涌",
  "Mana Tide": "法力之潮",
  "Unrestrained Fury": "无拘怒意",
  "Pack Tactics": "兽群战术",
  "Shining Light": "闪耀之光",
  "Improved Wildfire Bomb": "强化野火炸弹",
  "Death and Madness": "癫狂陨灭",
  "Eyes of the Beast": "野兽之眼",
  "Prayer Circle": "祷言之环",
  "Enlightened": "启发",
  "Improved Clearcasting": "强化节能施法",
  "Deadeye": "夺命之眼",
  "Mana Adept": "法力专家",
  "Bloodshed": "血溅十方",
  "Improved Blazing Barrier": "强化烈焰护体",
  "Improved Prismatic Barrier": "强化棱光护体",
  "Shadow Covenant": "暗影盟约",
  "Improved Touch of Death": "强化轮回之触",
  "Light's Promise": "圣光的许诺",
  "Invoke Yu'lon, the Jade Serpent": "青龙下凡",
  "Celestial Brew": "天神酒",
  "Mighty Stomp": "强力践踏",
  "Fortifying Brew: Determination": "壮胆酒：决绝",
  "Echoing Reprimand": "申斥回响",
  "Light Brewing": "酒仙轻酿",
  "Exploding Keg": "爆炸酒桶",
  "Invoke Chi-Ji, the Red Crane": "朱鹤下凡",
  "Dance of Chi-Ji": "赤精之舞",
  "Bonedust Brew": "骨尘酒",
  "Empyrean Power": "苍穹之力",
  "Healing Hands": "治疗之手",
  "Rune of Sanguination": "鲜红符文",
  "Ruinous Bulwark": "毁灭壁垒",
  "Rune of Spellwarding": "护咒符文",
  "Rune of Hysteria": "癔狂符文",
  "Rune of Unending Thirst": "无尽渴求符文",
  "Rune of the Apocalypse": "天启符文",
  "Faeline Stomp": "妖魂踏",
  "Cold Front": "冷锋",
  "Aetherial Kindling": "虚渺延火",
  "Improved Barkskin": "强化树皮术",
  "Improved Wild Growth": "强化野性成长",
  "Hasty Provocation": "疾言厉色",
  "Mortal Dance": "致死舞步",
  "Fel Domination": "邪能统御",
  "Echo of the Elements": "元素回响",
  "Fire Nova": "火焰新星",
  "Molten Assault": "熔火突袭",
  "Lashing Flames": "鞭笞烈焰",
  "Hailstorm": "冰雹",
  "Curse of Exhaustion": "疲劳诅咒",
  "Chaining Storms": "连锁风暴",
  "Inevitable Demise": "大难临头",
  "Collateral Damage": "间接伤害",
  "Crushing Blow": "碎甲猛击",
  "Shadow Word: Madness": "暗言术：癫",
  "Empowered Tiger Lightning": "伏虎强雷",
  "Charred Flesh": "血肉灰烬",
  "Chaos Theory": "混沌理论",
  "Fel Bombardment": "邪能轰炸",
  "Apex Predator's Craving": "顶级捕食者的渴望",
  "Cat-Eye Curio": "猫眼奇珍",
  "Soul Infusion": "灵魂灌注",
  "Frenzied Assault": "狂乱攻击",
  "Sudden Ambush": "骤然突袭",
  "Mental Agility": "敏捷才思",
  "Improved Voidform": "强化虚空形态",
  "Shadowy Apparition": "暗影幻灵",
  "Shadowy Apparitions": "暗影幻灵",
  "Renewed Faith": "恢复信仰",
  "Arcane Echo": "奥能回响",
  "Alter Time": "操控时间",
  "Master of Time": "时间大师",
  "From the Ashes": "涅槃重生",
  "Glaive Tempest": "战刃风暴",
  "Revel in Pain": "痛苦狂欢",
  "Dreadblades": "恐惧之刃",
  "Premeditation": "预谋",
  "Improved Frost Nova": "强化冰霜新星",
  "Improved Chaos Strike": "强化混乱打击",
  "Focused Cleave": "聚焦裂劈",
  "Mote of Flame": "火屑",
  "Wilderness Medicine": "荒野医疗",
  "Disruptive Rounds": "干扰弹",
  "Improved Traps": "强化陷阱",
  "Deathblow": "夺命打击",
  "Soul Reaper": "灵魂收割",
  "Furious Gaze": "狂怒凝视",
  "Execution Sentence": "处决宣判",
  "Escape from Reality": "魂游天外",
  "Solstice": "至日",
  "Celestial Harmony": "天神融合",
  "Mastery: Shadow Weaving": "精通：暗影交织",
  "Soothing Breath": "抚慰之息",
  "Evasive Stride": "静心步",
  "Stormflurry": "风暴之舞",
  "Ancient Arts": "诡谋承袭",
  "Burning Wound": "灼烧之伤",
  "Unbound Chaos": "释放混沌",
  "Fodder to the Flame": "燃焰饲魂",
  "Visage": "幻容",
  "Quell": "镇压",
  "Deep Breath": "深呼吸",
  "Windveil": "风幕",
  "Emerald Blossom": "翡翠之花",
  "Dream Breath": "梦境吐息",
  "Death's Echo": "死亡回响",
  "Disintegrate": "裂解",
  "Time Dilation": "时间膨胀",
  "Fire Breath": "火焰吐息",
  "Pyre": "葬火",
  "Wing Buffet": "飞翼打击",
  "Landslide": "山崩",
  "Eternity Surge": "永恒之涌",
  "Essence Burst": "精华迸发",
  "Fluttering Seedlings": "婆娑幼苗",
  "Dream Flight": "梦境飞行",
  "Deathmark": "死亡印记",
  "Sleep Walk": "梦游",
  "Naturalize": "自然平衡",
  "Blistering Scales": "炽火龙鳞",
  "Verdant Embrace": "青翠之拥",
  "Return": "生还",
  "Orbital Strike": "轨道打击",
  "Living Flame": "活化烈焰",
  "Call of the Wild": "荒野的召唤",
  "Activating": "激活",
  "Temporal Compression": "时光压缩",
  "Azure Strike": "碧蓝打击",
  "Mastery: Giantkiller": "精通：巨人杀手",
  "Ephemeral Incarnation": "幻磷化身",
  "Mastery: Life-Binder": "精通：生命的缚誓者",
  "Rewind": "回溯",
  "Grudge Match": "宿怨之敌",
  "Primordial Potential": "基元潜能",
  "Sickle of the Lion": "狮王之镰",
  "Obsidian Scales": "黑曜鳞片",
  "Primordial Power": "基元之力",
  "Blessing of the Bronze": "青铜龙的祝福",
  "Echo": "回响",
  "Renewing Bloom": "复苏之花",
  "Heart of the Lion": "狮王之心",
  "Fists of Primordium": "基元之拳",
  "Arcane Surge": "奥术涌动",
  "Awakened": "梦醒",
  "Expunge": "净除",
  "Aerial Mastery": "飞行掌握",
  "Ruby Embers": "红玉灰烬",
  "Reversion": "逆转",
  "Spiritbloom": "精神之花",
  "Binding Heals": "联结愈疗",
  "Time of Need": "危急时刻",
  "Heavy Wingbeats": "翅大力沉",
  "Tail Swipe": "扫尾",
  "Volatility": "动燃",
  "Firestorm": "火焰风暴",
  "Source of Magic": "魔力之源",
  "Feed the Flames": "火上浇油",
  "Power Nexus": "能量枢纽",
  "Protracted Talons": "延展利爪",
  "Natural Convergence": "自然聚合",
  "Leaping Flames": "飞扑烈焰",
  "Ancient Flame": "上古之火",
  "Field of Dreams": "梦境原野",
  "Charged Blast": "聚能冲击",
  "Stasis": "静滞",
  "Tip the Scales": "扭转天平",
  "Elune's Favored": "艾露恩的青睐",
  "Rescue": "营救",
  "Imminent Destruction": "毁灭将至",
  "Scorching Embers": "灼火余灰",
  "Scintillation": "能量闪烁",
  "Engulfing Blaze": "噬体光焰",
  "Power Swell": "能量汹涌",
  "Spellweaver's Dominance": "织法者统御",
  "Iridescence": "虹彩变换",
  "Bountiful Bloom": "丰饶之花",
  "Twin Guardian": "双生护卫",
  "The Hunt": "恶魔追击",
  "Emerald Communion": "翡翠交融",
  "Terror of the Skies": "天空霸主",
  "Lay Waste": "焦痕遍野",
  "Honed Aggression": "锋锐侵攻",
  "Renewing Breath": "新生吐息",
  "Life-Giver's Flame": "赐命者之焰",
  "Recall": "回归",
  "Cycle of Life": "生生不息",
  "After the Wildfire": "野火烧不尽",
  "Oppressing Roar": "压迫怒吼",
  "Energy Loop": "能量循环",
  "Burning Vehemence": "炽燃圣火",
  "Resonant Words": "共鸣圣言",
  "Gales of Song": "雄浑圣歌",
  "Scarlet Adaptation": "绯红适性",
  "Time Lord": "时光之主",
  "Twin Moonfire": "双生月火",
  "Empyreal Blaze": "苍穹之焰",
  "Vulnerable Flesh": "脆弱血肉",
  "Divine Favor: Chastise": "神恩术：罚",
  "Divine Word: Sanctuary": "神言术：佑",
  "Divine Favor: Serenity": "神恩术：静",
  "Blessed Bolt": "蒙恩飞弹",
  "Untamed Savagery": "狂野蛮兽",
  "Reinvigoration": "重焕活力",
  "Holy Ray": "神圣射线",
  "Dark Indulgence": "沉溺黑暗",
  "Pain Transformation": "痛苦转换",
  "Revel in Darkness": "黑暗狂欢",
  "Protector of the Frail": "护佑弱者",
  "Indemnity": "圣障",
  "Abyssal Reverie": "深渊遐思",
  "Harsh Discipline": "严酷戒律",
  "Mind Devourer": "蚀心魔",
  "Insidious Ire": "怒火暗生",
  "Sanguine Teachings": "血色教义",
  "Tithe Evasion": "避缴奉纳",
  "Lifebind": "缚誓生命",
  "Idol of Yogg-Saron": "尤格-萨隆的神像",
  "Void Spike": "虚空之刺",
  "Idol of N'Zoth": "恩佐斯的神像",
  "Idol of Y'Shaarj": "亚煞极的神像",
  "Inescapable Torment": "折磨缠身",
  "Translucent Image": "通透影像",
  "Light's Inspiration": "圣光鼓舞",
  "Unwavering Will": "坚定意志",
  "Twins of the Sun Priestess": "双子太阳女祭司",
  "Call of Ysera": "伊瑟拉之唤",
  "Temporal Anomaly": "时空畸体",
  "Proliferating Chill": "寒意剧增",
  "Blood Scent": "血之气息",
  "Suppression": "压制",
  "Zephyr": "微风",
  "Cauterizing Flame": "灼烧之焰",
  "Unholy Bond": "秽邪之缚",
  "Unholy Momentum": "邪恶动能",
  "Improved Death Strike": "强化灵界打击",
  "Overawe": "震魂摄魄",
  "Renewing Blaze": "新生光焰",
  "Assimilation": "同化",
  "Brittle": "羸弱",
  "Rune Mastery": "符文掌握",
  "Blood Draw": "抽血",
  "Improved Bone Shield": "强化白骨之盾",
  "Improved Heart Strike": "强化心脏打击",
  "Perseverance of the Ebon Blade": "黑锋骑士团之毅",
  "Time Spiral": "时间螺旋",
  "Dragonrage": "狂龙之怒",
  "Obsidian Bulwark": "黑曜壁垒",
  "Clobbering Sweep": "痛击横扫",
  "Blast Furnace": "爆裂熔炉",
  "Extended Flight": "长期飞行",
  "Innate Magic": "内在魔法",
  "Forger of Mountains": "山脉塑造者",
  "Exuberance": "精力旺盛",
  "Inherent Resistance": "原生抗性",
  "Enkindled": "燃火",
  "Tailwind": "顺风之力",
  "Lush Growth": "葱郁生长",
  "Foci of Life": "生命聚焦",
  "Divine Toll": "圣洁鸣钟",
  "Arcane Intensity": "奥能绽放",
  "Azure Essence Burst": "碧蓝精华迸发",
  "Essence Attunement": "精华协调",
  "Heat Wave": "热浪来袭",
  "Eternity's Span": "永恒跨距",
  "Screams of the Void": "虚空尖啸",
  "Causality": "因果律",
  "Font of Magic": "魔法之泉",
  "Hoarded Power": "贮藏能量",
  "Animosity": "憎恨不息",
  "Burnout": "薪尽火灭",
  "Shadowy Insight": "暗影洞察",
  "Primordial Wave": "始源之潮",
  "Mental Decay": "精神腐烂",
  "Champion's Spear": "勇士之矛",
  "Empath": "移情共生",
  "Spiritual Clarity": "精神澄澈",
  "Instinctive Arcana": "本源奥秘",
  "Draconic Legacy": "巨龙传承",
  "Lifeforce Mender": "生命之力治愈者",
  "Just in Time": "恰逢其时",
  "Delay Harm": "延缓伤害",
  "Nozdormu's Teachings": "诺兹多姆的讲义",
  "Grace Period": "恩惠时刻",
  "Timeless Magic": "越时魔法",
  "Runic Command": "符文掌控",
  "Ruby Essence Burst": "红玉精华迸发",
  "Tyranny": "残暴",
  "Attuned to the Dream": "梦境同调",
  "Everfrost": "永冻之冰",
  "Seal of Reprisal": "雪恨圣印",
  "Biting Cold": "刺骨之寒",
  "Mental Fortitude": "意志坚定",
  "Frigid Executioner": "冬寒处刑者",
  "Rage of the Frozen Champion": "冰封勇士之怒",
  "Bonegrinder": "断裂之痕",
  "Spark of Insight": "洞察之火",
  "Exhilarating Burst": "振奋迸发",
  "Golden Path": "辉金之道",
  "Enduring Strength": "历久弥坚",
  "Ursoc's Fury": "乌索克之怒",
  "Frozen Dominion": "冰霜统御",
  "Idol of C'Thun": "克苏恩的神像",
  "Unholy Aura": "邪恶光环",
  "Reaping": "割魂索命",
  "Putrid Echoes": "腐烂回响",
  "Ghoulish Frenzy": "食尸鬼狂热",
  "Ancient Power": "上古神力",
  "Morbidity": "病变",
  "Leeching Strike": "吸血打击",
  "Insatiable Blade": "无餍狂刃",
  "Everlasting Bond": "长久羁绊",
  "Natural Recovery": "自然恢复",
  "Innate Resolve": "固有决心",
  "Front of the Pack": "兽群先锋",
  "Ursine Vigor": "巨熊活力",
  "Well-Honed Instincts": "精确本能",
  "Astral Bulwark": "星界壁垒",
  "Pathfinding": "寻路",
  "Keen Eyesight": "视力敏锐",
  "Thunderous Paws": "雷霆之爪",
  "Spiritwalker's Aegis": "灵魂行者的神盾",
  "Primordial Fury": "原始狂怒",
  "Golden Hour": "黄金时刻",
  "Kill Cleave": "杀戮顺劈",
  "Training Expert": "训练专家",
  "Refreshing Waters": "复苏水域",
  "Cobra Senses": "眼镜蛇感官",
  "Call of Fire": "火焰召唤",
  "Flames of the Cauldron": "釜镬之焰",
  "Deeply Rooted Elements": "根深蒂固的元素",
  "Gift of the Golden Val'kyr": "金色瓦格里的礼物",
  "Tyr's Enforcer": "提尔的执行者",
  "Light of the Titans": "泰坦之光",
  "Wintertide": "寒冬狂潮",
  "Uther's Counsel": "乌瑟尔的劝谏",
  "Nimble Fingers": "心灵手巧",
  "Master Poisoner": "毒物大师",
  "Wild Instincts": "狂野本能",
  "Acid Rain": "酸雨",
  "Fractured Frost": "碎裂寒冰",
  "Soaring Shield": "飞舞之盾",
  "Dire Command": "凶暴命令",
  "Dire Pack": "凶暴兽群",
  "Ferren Marcus's Fervor": "费伦·玛库斯的狂热",
  "Focused Aim": "专注瞄准",
  "Greater Purge": "强效净化术",
  "Shadowrunner": "暗影奔行者",
  "Fleet Footed": "健步如飞",
  "Focused Enmity": "专注敌意",
  "Coldthirst": "冰冷渴望",
  "Light Ammo": "轻型弹药",
  "Piercing Cold": "刺骨之冰",
  "Lunge": "突刺",
  "Explosives Expert": "爆破专家",
  "Glacial Assault": "冰河突击",
  "Sweeping Spear": "长矛横扫",
  "Killer Companion": "杀手伙伴",
  "Lycara's Teachings": "莱卡拉的教诲",
  "Recuperator": "休养疗伤",
  "Blackjack": "劈头棒击",
  "Consecration in Flame": "烈火奉献",
  "Quickened Invocation": "急促祷告",
  "Flash Freeze": "冰霜速冻",
  "Crusader's Resolve": "十字军的决心",
  "Virulent Poisons": "恶毒药膏",
  "Thief's Versatility": "经世之才",
  "Improved Ambush": "强化伏击",
  "Tight Spender": "精打细算",
  "Thistle Tea": "菊花茶",
  "Improved Poisons": "强化药膏",
  "Bloody Mess": "血肉相连",
  "Internal Bleeding": "内出血",
  "Thrown Precision": "精准投掷",
  "Intent to Kill": "杀意已决",
  "Flying Daggers": "匕首飞掷",
  "Improved Garrote": "强化锁喉",
  "Atrophic Poison": "萎缩药膏",
  "Lethal Dose": "致命剂量",
  "Planes Traveler": "位面旅行者",
  "Elemental Warding": "元素防护",
  "Systemic Failure": "机能失调",
  "Nature's Fury": "自然之怒",
  "Amplifying Poison": "增效药膏",
  "Doomblade": "末日之刃",
  "Brimming with Life": "生机盎然",
  "Swelling Maelstrom": "膨胀漩涡",
  "Eye of the Storm": "风暴之眼",
  "Earth Shock Overload": "大地震击过载",
  "Mountains Will Fall": "山峦将倾",
  "Permeating Chill": "蚀骨之寒",
  "Flames of the Firelord": "炎魔之火",
  "Dashing Scoundrel": "冲动恶徒",
  "Zoldyck Recipe": "佐迪克配方",
  "Dragon-Tempered Blades": "龙淬之锋",
  "Ace Up Your Sleeve": "袖里乾坤",
  "Sleight of Hand": "手法娴熟",
  "Audacity": "胆大妄为",
  "Fan the Hammer": "迅疾连射",
  "Totemic Surge": "图腾潮涌",
  "Combat Stamina": "作战耐力",
  "Deft Maneuvers": "矫捷灵动",
  "Heavy Hitter": "千钧重击",
  "Ouroboros": "衔尾轮回",
  "Temporal Artificer": "时光巧匠",
  "Mana Spring": "法力之泉",
  "Flash of Lightning": "须臾闪电",
  "Wavespeaker's Blessing": "波涛语者祝福",
  "Swift Slasher": "迅猛挥砍",
  "Keep It Rolling": "时运继延",
  "Summarily Dispatched": "倏然斩击",
  "The Rotten": "腐化印记",
  "Veiltouched": "虚帷之触",
  "Earthen Harmony": "大地祥和",
  "Earthliving Weapon": "大地生命武器",
  "Water Totem Mastery": "流水图腾掌握",
  "Echo Chamber": "回声蓄能",
  "Flow of the Tides": "潮汐之流",
  "Surging Elements": "碎裂元素",
  "Primal Tide Core": "始源之潮核心",
  "Undercurrent": "暗流",
  "Ancestral Wolf Affinity": "先祖狼魂亲和",
  "Totemic Focus": "图腾集中",
  "Winds of Al'Akir": "奥拉基尔之风",
  "Lethality": "致命偷袭",
  "Cold Blooded Killer": "冷血杀手",
  "Leeching Strikes": "吸血打击",
  "Fast Footwork": "迅疾步法",
  "Flow of Time": "时光飞逝",
  "Incantation of Swiftness": "迅捷祈咒",
  "Quick Witted": "慧心灵性",
  "Ancestral Awakening": "先祖复苏",
  "Improved Earthliving Weapon": "强化大地生命武器",
  "Winter's Protection": "冬日守护",
  "Living Stream": "奔涌之泉",
  "Tome of Antonidas": "安东尼达斯的魔典",
  "Tome of Rhonin": "罗宁的魔典",
  "Quick Decisions": "刹那抉择",
  "Dark Brew": "玄黑秘酿",
  "The First Dance": "第一支舞",
  "Replicating Shadows": "暗影增生",
  "Shrouded in Darkness": "黑暗帷幕",
  "Planned Execution": "处决谋划",
  "Shadowed Finishers": "影武终结",
  "Improved Find Weakness": "强化洞悉弱点",
  "Without a Trace": "遁形无迹",
  "Fade to Nothing": "隐匿无踪",
  "Cloaked in Shadows": "暗影遮蔽",
  "Deeper Daggers": "深刺匕首",
  "Perforated Veins": "铁拳穿刺",
  "Lingering Shadow": "纠缠暗影",
  "Finality": "终结预兆",
  "Danse Macabre": "断魂之舞",
  "Sanctify": "圣洁庇护",
  "Pain and Gain": "痛尽甘来",
  "Passing Seasons": "季节变迁",
  "Improved Ironbark": "强化铁木树皮",
  "Unstoppable Growth": "狂野生长",
  "Ancestral Reach": "先祖之触",
  "Crushing Force": "碾压之力",
  "Overwhelming Rage": "怒不可挡",
  "Fire and Ice": "冰火夹击",
  "One-Handed Weapon Specialization": "单手武器专精",
  "Two-Handed Weapon Specialization": "双手武器专精",
  "Dual Wield Specialization": "双武器专精",
  "Reinforced Plates": "加固板甲",
  "Wild Strikes": "狂野打击",
  "Elemental Orbit": "元素环绕",
  "Poison Cleansing Totem": "清毒图腾",
  "Improved Purify Spirit": "强化净化灵魂",
  "Magma Eruption": "岩浆喷发",
  "Barbaric Training": "野蛮训练",
  "Arcane Warding": "奥术防护",
  "Fueled by Violence": "残暴动力",
  "Mass Polymorph": "群体变形",
  "Bloodletting": "放血",
  "Improved Sweeping Strikes": "强化横扫攻击",
  "Regenesis": "赋新源生",
  "Grove Tending": "林地护理",
  "Umbral Intensity": "劲烈星影",
  "Orbit Breaker": "偏轨星月",
  "Overflowing Shores": "溢流海滩",
  "Swift Justice": "迅捷审判",
  "Graveyard": "灾殃坟茔",
  "Hidden Opportunity": "藏锋寻时",
  "Bloodborne": "浴血之躯",
  "Juggernaut": "主宰",
  "Deft Experience": "熟能生巧",
  "Critical Thinking": "暴虐成性",
  "Final Verdict": "最终审判",
  "Sharpened Blades": "尖锐利刃",
  "Holy Blade": "神圣之刃",
  "Expurgation": "异端逐除",
  "Tireless Energy": "不懈之能",
  "Relentless Inquisitor": "无情审讯",
  "Feel the Burn": "炽燃感触",
  "Tempest of the Lightbringer": "光明使者的风暴",
  "Impale": "穿刺",
  "Invigorating Fury": "狂怒提振",
  "Focus in Chaos": "混沌专注",
  "Improved Scorch": "强化灼烧",
  "Fiery Rush": "炽烈冲动",
  "Controlled Destruction": "掌控毁灭",
  "Impetus": "奥能动力",
  "Improved Blackout Kick": "强化幻灭踢",
  "Sal'salabim's Strength": "萨萨拉比姆的力量",
  "Scalding Brew": "滚烫烧酒",
  "Gai Plin's Imperial Brew": "盖平的御酒",
  "Fatality": "致死",
  "Fatal Mark": "致死印记",
  "Stormstout's Last Keg": "风暴烈酒的珍藏酒桶",
  "Training of Niuzao": "砮皂的试炼",
  "Counterstrike": "反击",
  "Fevered Incantation": "狂热法咒",
  "Frenzied Enrage": "狂乱之怒",
  "Spite": "敌意",
  "Improved Raging Blow": "强化怒击",
  "Hack and Slash": "劈斩",
  "Hyperthermia": "过热高温",
  "Sun King's Blessing": "太阳之王的祝福",
  "Fury of the Sun King": "太阳王的怒火",
  "Vicious Contempt": "恶毒蔑视",
  "Cold Steel, Hot Blood": "寒光热血",
  "Slow Burn": "文火慢灼",
  "Arcane Tempo": "奥术迅疾",
  "Dragonfire Brew": "龙焰酒",
  "Divine Resonance": "圣洁共鸣",
  "Brutal Vitality": "野蛮活力",
  "Strategist": "战略专家",
  "Unnerving Focus": "破敌专注",
  "Illuminated Thoughts": "发散思维",
  "Enduring Alacrity": "持久迅捷",
  "Focused Vigor": "聚力",
  "Impenetrable Wall": "磐固壁垒",
  "Echoes of Great Sundering": "大分裂的回响",
  "Berserker Shout": "狂暴之吼",
  "Wrecking Throw": "破裂投掷",
  "Armored to the Teeth": "全副武装",
  "Overflowing Maelstrom": "溢流漩涡",
  "Raging Maelstrom": "暴怒漩涡",
  "Master of Flame": "烈焰大师",
  "Doom Winds": "毁灭之风",
  "Elemental Weapons": "元素武器",
  "Bloodsurge": "血涌",
  "Converging Storms": "汇聚风暴",
  "Static Accumulation": "静电积聚",
  "Thorim's Invocation": "托里姆的祈咒",
  "Lightning Strikes": "闪电打击",
  "Arcane Salvo": "奥术齐射",
  "Prodigious Savant": "超凡专家",
  "Charged Orb": "充能宝珠",
  "Taste for Blood": "血腥气息",
  "Hunter's Avoidance": "猎人闪避",
  "Seal of Charity": "明澈圣印",
  "Sacrifice of the Just": "正义牺牲",
  "Orb Barrage": "宝珠弹幕",
  "Seal of Mercy": "怜悯圣印",
  "Improved Blessing of Protection": "强化保护祝福",
  "Recompense": "牺牲报偿",
  "Odyn's Fury": "奥丁之怒",
  "Odyn's Fury Off-Hand": "奥丁之怒副手",
  "Blessing of Dusk": "黄昏祝福",
  "Everlasting Frost": "无尽寒霜",
  "Sepsis": "败血刃伤",
  "Afterimage": "残光",
  "Obduracy": "坚决",
  "Seal of Might": "力量圣印",
  "Shrouded Suffocation": "暗影窒息",
  "Holy Aegis": "神圣护佑",
  "Rejuvenating Wind": "春回大地",
  "Improved Overpower": "强化压制",
  "Kingsbane": "君王之灾",
  "Auras of the Resolute": "坚定光环",
  "Flow State": "心流状态",
  "Silent Storm": "静默风暴",
  "Bloody Claws": "血腥之爪",
  "Matted Fur": "蓬乱毛皮",
  "Dire Frenzy": "凶猛狂暴",
  "Thunderlord": "雷霆之王",
  "Teachings of the Black Harvest": "黑暗收割者的教导",
  "Tough as Nails": "坚如钢钉",
  "Soulburn": "灵魂燃烧",
  "Shield Charge": "盾牌冲锋",
  "Shield Specialization": "盾牌专精效果",
  "Enduring Defenses": "持久防御",
  "Brace For Impact": "抵御冲击",
  "Disrupting Shout": "瓦解怒吼",
  "Fiendish Stride": "恶魔步",
  "Fel Pact": "邪能誓约",
  "Battle Stance": "战斗姿态",
  "Demonic Knowledge": "恶魔知识",
  "Carnivorous Stalkers": "肉食追踪者",
  "Berserker Stance": "狂暴姿态",
  "Defensive Stance": "防御姿态",
  "Titanic Wrath": "泰坦之怒",
  "Catalyze": "催化",
  "Onyx Legacy": "黑龙遗产",
  "Iridescence: Red": "虹彩变换：红龙",
  "Battle-Scarred Veteran": "历战老兵",
  "Iridescence: Blue": "虹彩变换：蓝龙",
  "Inner Radiance": "内心之光",
  "Violent Outburst": "怒意迸发",
  "Demonic Fortitude": "恶魔坚韧",
  "Unhinged": "迷狂乱舞",
  "Battlelord": "战争领主",
  "Executioner's Precision": "刽子手的精准",
  "Nightmare": "梦魇",
  "Bulwark of Righteous Fury": "正义之怒壁垒",
  "Dark Accord": "黑暗协约",
  "Ichor of Devils": "恶魔灵液",
  "Frequent Donor": "契约供体",
  "Pact of Gluttony": "饕餮契约",
  "Pandemic Invocation": "疫灾祷告",
  "Freezing Cold": "极寒",
  "Energized Barriers": "充能护体",
  "Brutal Companion": "残酷伙伴",
  "Anvil and Stave": "淬火神酿",
  "Charred Passions": "灼焰炙气",
  "Withering Bolt": "凋零箭",
  "Sacrolash's Dark Strike": "萨洛拉丝的黑暗之击",
  "Fervent Flickering": "烁焰闪闪",
  "Elusive Footwork": "醉踪步",
  "Ruin": "毁灭",
  "Conflagration of Chaos": "混沌燃烧",
  "Burn to Ashes": "焚烧成灰",
  "Raging Demonfire": "愤怒魔火",
  "Empyrean Legacy": "苍穹之遗",
  "Diabolic Embers": "天魔余烬",
  "Weapons of Order": "精序兵戈",
  "Walk with the Ox": "玄牛伴身",
  "Fluidity of Motion": "流云身法",
  "Ashen Remains": "灰烬残骸",
  "Flashpoint": "闪点",
  "Chaos Incarnate": "混乱具象",
  "Strength of Spirit": "灵魂之力",
  "Shadow's Bite": "暗影之咬",
  "Walloping Blow": "遭受重击",
  "Backlash": "反冲",
  "Dread Calling": "恐惧召唤",
  "Madness of the Azj'Aqir": "阿兹亚基的疯狂",
  "Fel Covenant": "邪能契约",
  "Mayhem": "暴乱",
  "Rolling Havoc": "翻滚浩劫",
  "Staggering Strikes": "幻灭醉拳",
  "Shadowboxing Treads": "太极鞋",
  "Panacea": "万应灵药",
  "Commanding Light": "统御圣光",
  "Moment of Compassion": "恻隐时刻",
  "Regenerative Magic": "再生魔法",
  "Empyreal Ward": "以太结界",
  "Echoing Blessings": "回响祝福",
  "Divine Glimpse": "神圣顿悟",
  "Time Manipulation": "掌控时间",
  "Divine Revelations": "神圣启示",
  "Breaking Dawn": "破晓",
  "Tear of Morning": "晨晖之露",
  "Blessing of Summer": "仲夏祝福",
  "Blessing of Autumn": "暮秋祝福",
  "Blessing of Winter": "凛冬祝福",
  "Blessing of Spring": "阳春祝福",
  "Resplendent Mist": "璀璨迷雾",
  "Ancient Teachings": "谆谆古训",
  "Jadefire Teachings": "碧火之训",
  "Jade Bond": "翡翠羁绊",
  "Yu'lon's Whisper": "玉珑的低语",
  "Lone Survivor": "孤独幸存者",
  "Soulscar": "碎魂创痕",
  "Ragefire": "怒焰",
  "Initiative": "先发制人",
  "Chaotic Transformation": "混沌变身",
  "Isolated Prey": "落单的猎物",
  "Shattered Destiny": "破碎的命运",
  "Know Your Enemy": "知己知彼",
  "Jadefire Stomp": "碧火踏",
  "Gift of the Celestials": "天神之赐",
  "Calming Coalescence": "静心凝雾",
  "Unison": "谐唱",
  "Secret Infusion": "秘术传功",
  "Mending Proliferation": "疗愈扩散",
  "Overflowing Mists": "浓雾弥漫",
  "Mists of Life": "生命之雾",
  "Uplifted Spirits": "起死回生",
  "Peaceful Mending": "平静愈合",
  "Restoral": "还阳术",
  "Invoker's Delight": "祈求者之愉",
  "Calming Presence": "平心静气",
  "Ferocity of Xuen": "雪怒之勇",
  "Elusive Mists": "飘忽迷雾",
  "Misty Peaks": "迷雾之峰",
  "Dancing Mists": "缥缈之雾",
  "Way of the Crane": "仙鹤之道",
  "Fast Feet": "无影步",
  "Grace of the Crane": "神鹤恩典",
  "Vivacious Vivification": "活力苏醒",
  "Expeditious Fortification": "迅疾豪胆",
  "Ironshell Brew": "铁壁酒",
  "Explosive Potential": "爆破潜能",
  "Scalding Flames": "炽烈火焰",
  "Rapid Diffusion": "云雾飞散",
  "Crane Vortex": "鹤舞龙卷",
  "Rising Star": "东升之星",
  "Touch of the Tiger": "猛虎之触",
  "Improved Detox": "强化清创生血",
  "Bulletstorm": "子弹风暴",
  "Fiery Demise": "炽烈灭亡",
  "Fel Synergy": "邪能共效",
  "Sentinel": "哨兵",
  "Save Them All": "普度众生",
  "Demonic Resilience": "恶魔韧性",
  "Abyss Walker": "深渊行者",
  "Gorefiend's Resolve": "血魔的决心",
  "Unholy Endurance": "邪恶耐性",
  "Tactical Retreat": "战术撤退",
  "Inner Demon": "内心之魔",
  "Will of the Illidari": "伊利达雷的意志",
  "Illidari Knowledge": "伊利达雷的知识",
  "Fel Flame Fortification": "强固邪焰",
  "Darkglare Boon": "黑眼之赐",
  "Soulmonger": "贩卖灵魂",
  "Chains of Anger": "愤怒锁链",
  "Cycle of Binding": "咒符之环",
  "Calcified Spikes": "钙化尖刺",
  "Felfire Fist": "邪火之拳",
  "Retaliation": "以牙还牙",
  "Down in Flames": "葬身火海",
  "Long Night": "长夜",
  "Pitch Black": "漆黑",
  "Shattered Restoration": "碎魂恢复",
  "Malefic Affliction": "灾难痛苦",
  "Felfire Haste": "邪火疾速",
  "Lost in Darkness": "黑暗迷失",
  "Sigil of Spite": "怨念咒符",
  "Dread Touch": "恐惧之触",
  "Face Palm": "迎面铁掌",
  "Vulnerability": "易伤",
  "Relentless Onslaught": "无情强攻",
  "Dancing with Fate": "命运共舞",
  "Soulcrush": "灵魂重碾",
  "Collective Anguish": "聚凝痛楚",
  "Serrated Glaive": "锯齿战刃",
  "Growing Inferno": "滋长炼狱",
  "Plague Mastery": "疫病掌控",
  "Magus of the Dead": "亡者魔导师",
  "Burning Blood": "炽燃之血",
  "Overflowing Energy": "溢流能量",
  "Commander of the Dead": "亡者指挥官",
  "Coil of Devastation": "崩坏缠绕",
  "Superstrain": "超级菌株",
  "Unruly Winds": "不羁之风",
  "Ashen Catalyst": "灰烬触媒",
  "Fury of the Aspects": "守护巨龙之怒",
  "Move with Grace": "优雅步态",
  "Improved Purify": "强化纯净术",
  "Spell Warding": "法术屏障",
  "Improved Fade": "强化渐隐术",
  "Inspiration": "激励",
  "Bright Pupil": "双目耀光",
  "Enduring Luminescence": "持久之光",
  "Painful Punishment": "痛苦惩罚",
  "Pain and Suffering": "饱受折磨",
  "Borrowed Time": "争分夺秒",
  "Inner Focus": "心灵专注",
  "Pouncing Strikes": "扑击",
  "Weal and Woe": "祸福相倚",
  "Volatile Flameblood": "动燃焰血",
  "Expiation": "赎罪",
  "Wild Slashes": "狂野切割",
  "Carnivorous Instinct": "捕食本能",
  "Sheer Terror": "纯粹恐惧",
  "Crisis Management": "危机管理",
  "Prismatic Echoes": "棱光回响",
  "Twist of Fate": "命运多舛",
  "Prayers of the Virtuous": "善德祷言",
  "Lightweaver": "织光者",
  "Voice of Harmony": "和谐之声",
  "Dreadful Bleeding": "重度裂伤",
  "Intercession": "代祷",
  "Raging Fury": "狂热之怒",
  "Shattered Psyche": "碎裂心智",
  "Dark Evangelism": "黑暗福音",
  "Restitution": "代偿",
  "Zealot's Paragon": "狂热圣贤",
  "Mastermind": "神机妙算",
  "Berserk: Heart of the Lion": "狂暴：狮王之心",
  "Roaring Fire": "熊熊大火",
  "Say Your Prayers": "念诵祷言",
  "Prayerful Litany": "漫长祈祷",
  "Maddening Touch": "疯狂之触",
  "Divine Service": "圣洁奉献",
  "Honed Reflexes": "干练反射",
  "Accelerated Blade": "狂飙利刃",
  "Tormented Spirits": "痛苦之魂",
  "Meridian Strikes": "精湛拳法",
  "Rip and Tear": "撕裂切割",
  "Tear": "撕裂",
  "Drinking Horn Cover": "角杯盖子",
  "Desperate Times": "绝望时刻",
  "Hardened Soles": "硬化鞋底",
  "Blood Feast": "鲜血盛宴",
  "Iron Heart": "钢铁之心",
  "Erratic Felheart": "不稳定的恶魔之心",
  "Bloodshot": "充血之眼",
  "Surge of Insanity": "狂乱激涌",
  "Mind Flay: Insanity": "精神鞭笞：狂",
  "Aldrachi Design": "奥达奇的设计",
  "Sanguine Ground": "血色之地",
  "Coagulopathy": "凝血",
  "Umbilicus Eternus": "永恒脐带",
  "Convoke the Spirits": "万灵之召",
  "March of Darkness": "黑暗行军",
  "Ashamane's Guidance": "阿莎曼的指引",
  "Surging Shots": "激涌射击",
  "Insidious Chill": "阴险寒意",
  "Gloom Ward": "晦暗结界",
  "Double-Clawed Rake": "双爪斜掠",
  "Rampant Ferocity": "野性难驯",
  "Tiger's Tenacity": "猛虎之韧",
  "Frantic Momentum": "狂乱动能",
  "Adaptive Swarm": "激变蜂群",
  "Veinripper": "血管裂创",
  "Piercing Fangs": "刺骨之牙",
  "Wailing Arrow": "哀恸箭",
  "Nurturing Dormancy": "滋养休眠",
  "Regenerative Heartwood": "再生心木",
  "Embrace of the Dream": "梦境之拥",
  "Everbloom": "永茂",
  "Waking Dream": "梦境初醒",
  "Harmonious Blooming": "祥和绽放",
  "Nature's Splendor": "自然的壮美",
  "Power of the Archdruid": "大德鲁伊的力量",
  "Verdancy": "新绿",
  "Storm's Wrath": "风暴狂怒",
  "Reforestation": "森林再生",
  "Earthen Weapon": "大地武器",
  "Improved Nature's Cure": "强化自然之愈",
  "Fatal Concoction": "致命药剂",
  "Verdant Infusion": "翡翠灌注",
  "Deathspeaker": "亡语者",
  "Enfeeble": "衰弱",
  "Cruel Strikes": "残虐打击",
  "Frothing Berserker": "暴乱狂战士",
  "Vigorous Expulsion": "生机蓬勃",
  "Resplendent Light": "壮丽圣光",
  "Inflorescence of the Sunwell": "太阳井之花",
  "Profound Rebuttal": "后发制人",
  "Unwavering Spirit": "不屈精神",
  "Tirion's Devotion": "提里奥的虔诚",
  "Cruelty": "残酷",
  "Wrath and Fury": "愤与怒",
  "Veneration": "崇圣",
  "Icebreaker": "破冰",
  "Fortitude of the Bear": "巨熊之韧",
  "Glory of the Dawn": "旭日峥嵘",
  "Imbued Infusions": "强能灌注",
  "Jade Ignition": "青玉破",
  "Strike of the Windlord": "风领主之击",
  "Thunderfist": "雷拳之怒",
  "Xuen's Bond": "雪怒羁绊",
  "Divine Image": "神圣镜像",
  "Xuen's Battlegear": "雪怒的战甲",
  "Path of Jade": "碧玉通途",
  "Improved Cleanse": "强化清洁术",
  "Furious Throws": "愤怒投掷",
  "The Emperor's Capacitor": "皇帝的容电器",
  "Pressure Point": "点穴踢",
  "Chi Explosion": "真气破",
  "Chi Energy": "真气能量",
  "Strength in Adversity": "逆境搏力",
  "Improved Ardent Defender": "强化炽热防御者",
  "Tranquil Spirit": "宁静之魂",
  "Cenarius' Guidance": "塞纳留斯的指引",
  "Ursoc's Guidance": "乌索克的指引",
  "Flashing Claws": "掠袭之爪",
  "Pretense of Instability": "无常虚妄",
  "Primal Claws": "原始利爪",
  "Reinforced Fur": "强化鬃毛",
  "Hunter Beast Mastery Class Set 2pc": "猎人野兽控制职业套装两件套",
  "Hunter Beast Mastery Class Set 4pc": "猎人野兽控制职业套装四件套",
  "Hunter Marksmanship Class Set 2pc": "猎人射击职业套装两件套",
  "Hunter Marksmanship Class Set 4pc": "猎人射击职业套装四件套",
  "Umbral Embrace": "星影之拥",
  "Chi Surge": "气冲九霄",
  "Internal Struggle": "内心冲突",
  "Stoke the Flames": "引火",
  "Improved Flash Heal": "强化快速治疗",
  "War Orders": "战争命令",
  "Starweaver": "织星者",
  "Starweaver's Warp": "织星者的经纱",
  "Starweaver's Weft": "织星者的纬纱",
  "Bloodcraze": "血腥疯狂",
  "Rattle the Stars": "星辰轰鸣",
  "Waning Twilight": "阑珊暮光",
  "Nature's Grace": "自然的优雅",
  "Soothing Darkness": "抚慰之黯",
  "Elune's Guidance": "月神的守护",
  "Serrated Bone Spike": "锯齿骨刺",
  "Power of Goldrinn": "戈德林之力",
  "Balance of All Things": "万物平衡",
  "Denizen of the Dream": "梦境住民",
  "Friend of the Fae": "法夜之友",
  "Sundered Firmament": "碎裂天穹",
  "Radiant Moonlight": "耀世月光",
  "Fatal Touch": "致命之触",
  "Strike Vulnerabilities": "要害打击",
  "Lethal Command": "致命指令",
  "Instigate": "斗志昂扬",
  "Secret Stratagem": "隐秘诡计",
  "Devious Stratagem": "狡诈计谋",
  "Hit the Mark": "箭无虚发",
  "Focusing Aim": "集中瞄准",
  "Gathering Starstuff": "摘星揽月",
  "Touch the Cosmos": "浩瀚之触",
  "Sharpened Claws": "锋利兽爪",
  "Time Bender": "时间扭曲者",
  "Critical Growth": "临界成长",
  "Shield of Absolution": "宽恕之盾",
  "Unending Light": "永恒圣光",
  "Blazing Meteor": "灼热流星",
  "Vicious Follow-Up": "恶意追击",
  "Double Dance": "舞影成双",
  "Thrill Seeking": "蹈厉奋发",
  "Mind Sear": "精神灼烧",
  "Flames of Fury": "魔怒烈焰",
  "Ebon Might": "黑檀之力",
  "Sands of Time": "时间之沙",
  "Eruption": "喷发",
  "Jadefire Brand": "碧火烙",
  "Improved Adrenaline Rush": "强化冲动",
  "Soul Sigils": "灵魂咒符",
  "Fury of Xuen": "雪怒之怒",
  "Upheaval": "地壳激变",
  "Reckless Abandon": "肆意放纵",
  "Defender's Aegis": "护卫神盾",
  "Burst of Life": "生机迸发",
  "Veil of Pride": "傲之雾纱",
  "Cosmic Rapidity": "星月流转",
  "Forestwalk": "森林小径",
  "Incessant Tempest": "连绵狂风",
  "Gale Winds": "阵风",
  "Overpowering Finish": "终结压制",
  "Raze": "摧折",
  "Moonless Night": "隐月之夜",
  "Circle of Life and Death": "生死循环",
  "Salvo": "齐射",
  "Wild Synthesis": "繁茂合成",
  "Spirit of the Ox": "玄牛之魂",
  "Strength of Arms": "神兵之力",
  "Unbreakable Stride": "不破之步",
  "Righteous Cause": "正义感召",
  "Sanctified Plates": "圣化护甲",
  "Jurisdiction": "神圣制裁",
  "Blessed Champion": "受祝福的勇士",
  "Burning Crusade": "燃烧的远征",
  "Draconic Attunements": "巨龙协调",
  "Black Attunement": "黑龙协调",
  "Lightforged Blessing": "光铸祝福",
  "Judgment of Justice": "公正审判",
  "Zealot's Fervor": "狂热者的赤诚",
  "Tranquil Mind": "宁静心灵",
  "Punishment": "惩罚",
  "Breath of Eons": "亘古吐息",
  "Blades of Light": "圣光之剑",
  "Improved Blade of Justice": "强化公正之剑",
  "Blade of Vengeance": "复仇之剑",
  "Defy Fate": "驳斥命运",
  "Guided Prayer": "向善祷言",
  "Legacy of Wisdom": "智慧遗产",
  "Light of Justice": "圣光的正义",
  "Highlord's Wrath": "大领主之怒",
  "Rampant Growth": "快速生长",
  "Spiritwalker's Tidal Totem": "灵魂行者的潮汐图腾",
  "Crusading Strikes": "远征打击",
  "Instrument of Retribution": "惩戒律令",
  "Time Skip": "时间跳跃",
  "Boundless Judgment": "无尽审判",
  "Seething Flames": "沸腾烈焰",
  "Improved Judgment": "强化审判",
  "Art of War": "战争艺术",
  "Faith's Armor": "信仰之盾",
  "Chi Cocoon": "真气之茧",
  "Heart of the Crusader": "十字军之心",
  "Judge, Jury and Executioner": "判罚处刑人",
  "Holy Flames": "神圣烈焰",
  "Templar Strikes": "圣殿骑士之击",
  "Templar Slash": "圣殿骑士斩击",
  "Ricocheting Pyroclast": "翻飞火屑",
  "Spatial Paradox": "空间悖论",
  "Thought Harvester": "心智收割者",
  "Divine Wrath": "神圣愤怒",
  "Wild Surges": "狂野涌动",
  "Volcanism": "火山效应",
  "Regenerative Chitin": "愈复甲质",
  "Rush of Light": "急促圣光",
  "Aspects' Favor": "守护巨龙的青睐",
  "Bloody Frenzy": "血腥狂乱",
  "Voidtouched": "灵媒",
  "Spectral Horrors": "惊惧幻灵",
  "Mind's Eye": "心灵之眼",
  "Templar Strike": "圣殿骑士打击",
  "Astral Flare": "星界耀斑",
  "Pupil of Alexstrasza": "阿莱克丝塔萨的门徒",
  "Plot the Future": "谋划未来",
  "Anachronism": "时空倒错",
  "Accretion": "激荡附岩",
  "Tectonic Locus": "构造位点",
  "Momentum Shift": "动量转换",
  "Bestow Weyrnstone": "赋予军营之石",
  "Crashing Star": "坠落之星",
  "Tenacious Flourishing": "久远繁盛",
  "Ignition Rush": "引火冲动",
  "Distorted Reality": "扭曲现实",
  "Motes of Possibility": "机遇微粒",
  "Prescience": "先知先觉",
  "Reactive Hide": "爆反外皮",
  "Temporal Wound": "时光创伤",
  "Chrono Ward": "时序结界",
  "Earthen Might": "土灵之力",
  "Obsidian Shards": "黑曜碎片",
  "Volcanic Strength": "熔火力量",
  "Blazing Shards": "耀光碎片",
  "Essence Rush": "精华奔涌",
  "Flame's Fury": "燃焰之怒",
  "Earthen Tenacity": "坚如大地",
  "Earthen Smash": "地覆猛击",
  "Perilous Fate": "命途劫难",
  "Overlord": "霸王",
  "Inferno's Blessing": "狱火祝福",
  "Stretch Time": "时光延展",
  "Radiant Providence": "圣愿辉光",
  "Molten Blood": "熔火血脉",
  "Symbiotic Bloom": "共栖荣花",
  "Prolong Life": "芳蕊长春",
  "Echoing Strike": "回响打击",
  "Event Horizon": "黑洞视界",
  "Eye of Infinity": "永恒之眼",
  "Timelessness": "超脱时间",
  "Interwoven Threads": "丝缕交织",
  "Tomorrow, Today": "明日今夕",
  "Unyielding Domain": "不屈领域",
  "Fate Mirror": "命运明镜",
  "Shifting Sands": "变换流沙",
  "Light's Conviction": "圣光决断",
  "Righteous Judgment": "公正审判",
  "Yu'lon's Grace": "玉珑的优雅",
  "Dance of the Wind": "风之舞",
  "Awakening": "觉醒",
  "Rising Sunlight": "璀璨旭日",
  "Concentrated Power": "浓缩能量",
  "Shining Righteousness": "闪耀正义",
  "Epiphany": "灵启神示",
  "Ice Cold": "深寒凝冰",
  "Mass Invisibility": "群体隐形",
  "Dream of Spring": "春晖梦晓",
  "Reclamation": "回收复用",
  "Benevolence": "仁爱之心",
  "Essence Devourer": "精华吞噬者",
  "Fuel the Fire": "火上浇油",
  "Imp-erator": "小鬼激励",
  "Xavius' Gambit": "萨维斯的诡计",
  "Intensifying Flame": "强攻烈焰",
  "Blast Zone": "震爆区域",
  "Seal of the Crusader": "十字军圣印",
  "Crashing Chaos": "粉碎混沌",
  "Inflame": "助火",
  "Winter's Blessing": "寒冬祝福",
  "Cryopathy": "低温症",
  "Awestruck": "心敬则畏",
  "Potent Mana": "强效法力",
  "Press the Advantage": "顺水推舟",
  "Splintering Ray": "解离射线",
  "Seraphic Crescendo": "圣洁强音",
  "Saber Jaws": "剑齿利喉",
  "Ultimate Penitence": "终极苦修",
  "Caustic Spatter": "腐蚀飞溅",
  "Energizing Brew": "豪能酒",
  "Smoldering Frenzy": "阴燃狂乱",
  "Path of Blood": "鲜血之路",
  "Sudden Demise": "骤死",
  "Doom Brand": "诛灭烙印",
  "Doomfiend": "诛灭魔",
  "Graceful Guile": "优雅诡谋",
  "Stillshroud": "静影遮蔽",
  "Featherfoot": "轻若鸿毛",
  "Superior Mixture": "卓越混合物",
  "Doom Bolt Volley": "厄运箭雨",
  "Boundless Moonlight": "天涯共银辉",
  "The Eternal Moon": "月耀万世",
  "Emerald Trance": "翡翠迷神",
  "Blackout Reinforcement": "幻灭遒劲",
  "Savagery": "野蛮",
  "Master Handler": "驯兽大师",
  "Battlefield Commander": "战地统帅",
  "Light's Deliverance": "圣光裁决",
  "Demoniac": "走火入魔",
  "Warning Signs": "警告标志",
  "Ephemeral Bond": "瞬息纽带",
  "Goremaw's Bite": "赤喉之咬",
  "Shadowcraft": "迅影",
  "Liveliness": "跃动活力",
  "Call of the Elder Druid": "德鲁伊长者之唤",
  "Light's Guidance": "圣光指引",
  "Hammer of Light": "圣光之锤",
  "Inertia": "冲撞惯性",
  "A Fire Inside": "焰由心生",
  "Deflecting Dance": "舞刃折光",
  "Never Say Die": "永不言弃",
  "Tempest Strikes": "风雷打击",
  "Scars of Suffering": "苦难千疮",
  "Demon Hide": "恶魔之肤",
  "Precision Shot": "精准射击",
  "Terrifying Pace": "惊魂步法",
  "Spiteful Reconstitution": "怨毒重构",
  "Infernal Presence": "狱火气息",
  "Exhilarating Execution": "振奋处刑",
  "Chaotic Disposition": "混沌无常",
  "Diabolic Ritual": "敬魔仪式",
  "Cloven Souls": "溃解灵魂",
  "Secrets of the Coven": "集会所的奥秘",
  "Ruination": "陨灭",
  "Treants of the Moon": "月照树人",
  "Summon Mother of Chaos": "召唤混沌之母",
  "Summon Overlord": "召唤主宰",
  "Ascending Flame": "冲天怒焰",
  "Live by the Glaive": "刃以为骨",
  "The Light of Elune": "艾露恩之光",
  "Harmony of the Grove": "林中和谐",
  "Power of Nature": "自然之威",
  "Soul-Etched Circles": "刻魂法阵",
  "Premonition of Insight": "洞察预兆",
  "Premonition of Solace": "慰藉预兆",
  "Early Spring": "万物复苏",
  "Annihilan's Bellow": "安尼赫兰的咆哮",
  "Infernal Vitality": "狱火活力",
  "Infernal Bulwark": "狱火壁垒",
  "Champion of the Glaive": "飞刃勇士",
  "Bounteous Bloom": "丰裕之花",
  "Durability of Nature": "自然耐性",
  "Expansiveness": "广袤延伸",
  "Grove's Inspiration": "林地启示",
  "Potent Enchantments": "持久魔效",
  "Blooming Infusion": "盛放注能",
  "Warp": "迁跃",
  "Moon Guardian": "辉月卫士",
  "Lunar Calling": "皎月呼唤",
  "Lunar Insight": "皎月洞察",
  "Atmospheric Exposure": "大气曝露",
  "Glistening Fur": "闪耀毛皮",
  "Astral Insight": "星界洞察",
  "Moondust": "月尘",
  "Lunation": "朔望",
  "Arcane Affinity": "奥术亲和",
  "Abyssal Dominion": "深渊支配",
  "Colossal Might": "巨人神力",
  "Dominance of the Colossus": "巨人威仪",
  "One Against Many": "以一敌众",
  "Martial Expert": "武艺专家",
  "Boneshaker": "碎骨",
  "Tide of Battle": "战斗之潮",
  "Mountain of Muscle and Scars": "百战之创",
  "No Stranger to Pain": "苦痛常客",
  "Practiced Strikes": "娴熟打击",
  "Flames of Xoroth": "克索诺斯之焰",
  "Stellar Command": "星辰掌控",
  "Touch of Rancora": "拉恩科纳的抚触",
  "Gloom of Nathreza": "纳斯雷萨的幽冥",
  "Cruelty of Kerxan": "科善的暴虐",
  "Infernal Machine": "炼狱装置",
  "Malevolence": "怨毒",
  "Smoke Screen": "障眼烟幕",
  "Dark Chains": "黑暗锁链",
  "Frost Mastery": "冰霜精通",
  "Fire Mastery": "火焰精通",
  "Frostfire Bolt": "霜火之箭",
  "Imbued Warding": "灌魔结界",
  "Elemental Affinity": "元素亲和",
  "Isothermic Core": "等温之核",
  "Flame and Frost": "焰霜相依",
  "Thermal Conditioning": "热能调控",
  "Meltdown": "消融",
  "Frostfire Infusion": "霜火注能",
  "Frostfire Empowerment": "霜火增效",
  "Flash Freezeburn": "瞬息霜灼",
  "Severe Temperatures": "剧烈温差",
  "Dawnlight": "晨光",
  "Empyrean Hammer": "苍穹之锤",
  "Luminosity": "明灿",
  "Solar Grace": "灼阳恩典",
  "Will of the Dawn": "曙光意志",
  "Lingering Radiance": "余辉不散",
  "Sun Sear": "日灼",
  "Algari Healing Potion": "阿加治疗药水",
  "Algari Mana Potion": "阿加法力药水",
  "Cavedweller's Delight": "洞穴住民的挚爱",
  "Slumbering Soul Serum": "沉眠魂魄血清",
  "Illumine": "明耀",
  "Treading Lightly": "踏雪无痕",
  "Sun's Avatar": "曜日化身",
  "Draught of Shocking Revelations": "震慑曝光饮剂",
  "Chrono Flame": "时序烈焰",
  "Chrono Flames": "时序烈焰",
  "Zealous Vindication": "狂热辩护",
  "Second Sunrise": "旭日再升",
  "Gleaming Rays": "辉耀日光",
  "Morning Star": "晨星",
  "Instability Matrix": "不稳定矩阵",
  "Shake the Heavens": "倾天圣威",
  "Precise Might": "精准之威",
  "Wrathful Descent": "天降忿怒",
  "Reverberations": "回荡",
  "Primacy": "首座",
  "Higher Calling": "崇高使命",
  "Temporal Burst": "时空爆发",
  "Nozdormu Adept": "诺兹多姆精锐",
  "Sacrosanct Crusade": "圣神征旅",
  "Temporality": "瞬息之隔",
  "Double-time": "再逢其时",
  "Potion of Unwavering Focus": "专心致志药水",
  "Frontline Potion": "前线药水",
  "Tempered Potion": "淬火药水",
  "Potion of the Reborn Cheetah": "重生猎豹药水",
  "Flask of Tempered Aggression": "淬火侵攻合剂",
  "Flask of Tempered Swiftness": "淬火矫健合剂",
  "Flask of Tempered Versatility": "淬火全能合剂",
  "Flask of Tempered Mastery": "淬火精通合剂",
  "Time Convergence": "时光汇流",
  "Golden Opportunity": "金色机遇",
  "Motes of Acceleration": "加速微粒",
  "Flask of Alchemical Chaos": "炼金混沌合剂",
  "Wicked Cleave": "邪恶顺劈",
  "Holy Bulwark": "神圣壁垒",
  "Hammerfall": "圣锤降罚",
  "Sacred Weapon": "圣洁武器",
  "Flask of Saving Graces": "救赎恩典合剂",
  "Chaos Salvo": "混乱齐射",
  "Endless Wrath": "无际愤怒",
  "Undisputed Ruling": "公允裁定",
  "Solidarity": "勠力同心",
  "Forewarning": "先兆之备",
  "Shared Resolve": "共志同心",
  "Laying Down Arms": "铸剑为光",
  "Valiance": "骁勇",
  "Divine Inspiration": "神圣鼓舞",
  "Sanctification": "圣言",
  "Unrelenting Charger": "冷酷战驹",
  "Bonds of Fellowship": "亲如手足",
  "Blessing of the Forge": "锻炉的祝福",
  "Blessed Assurance": "圣眷在握",
  "Divine Guidance": "神恩指引",
  "Rite of Sanctification": "圣言祭礼",
  "Rite of Adjuration": "恳求祭礼",
  "Hammer and Anvil": "槌砧战术",
  "Protective Growth": "防护愈合",
  "Dream Surge": "梦境涌现",
  "Maneuverability": "战术机动",
  "Vampiric Strike": "吸血鬼打击",
  "Prophet's Will": "预言者的意志",
  "Essence of the Blood Queen": "鲜血女王的精华",
  "Newly Turned": "返世新血",
  "Vampiric Speed": "吸血鬼之速",
  "Blood-Soaked Ground": "血染之地",
  "Frenzied Bloodthirst": "疯狂嗜血",
  "Vampiric Aura": "吸血光环",
  "Bloody Fortitude": "血腥之韧",
  "Dream Bloom": "梦境盛放",
  "Infliction of Sorrow": "苦痛凌虐",
  "Incite Terror": "煽动惊恐",
  "Gift of the San'layn": "萨莱因之赐",
  "Visceral Strength": "脏腑之力",
  "Power of the Dream": "梦境之力",
  "Control of the Dream": "梦境掌控",
  "The Blood is Life": "血为命源",
  "Pact of the San'layn": "萨莱因之契",
  "Sanguine Scent": "腥红气息",
  "Bombardments": "连环轰炸",
  "Summon Pit Lord": "召唤深渊领主",
  "Felseeker": "求邪无止",
  "Infernal Bolt": "狱火箭",
  "Transcendence: Linked Spirits": "魂体双分：链接之魂",
  "Grim Reaper": "冷面死神",
  "Steadfast as the Peaks": "千钧之峰",
  "Smothering Offense": "窒息攻势",
  "Icy Death Torrent": "死亡寒潮",
  "Thunder Blast": "雷霆轰击",
  "Ground Current": "贯地电流",
  "Thorim's Might": "托里姆之威",
  "Storm Bolts": "风暴众锤",
  "Gathering Clouds": "召云聚雷",
  "Mass Disintegrate": "群体裂解",
  "Azerite Surge": "艾泽里特涌动",
  "Demolish": "崩摧",
  "Dark Talons": "黑暗之爪",
  "Crashing Thunder": "崩解闪电",
  "Strength of the Mountain": "群山之力",
  "Flashing Skies": "断空霹雳",
  "Burst of Power": "能量爆发",
  "Death's Messenger": "死亡信使",
  "Avatar of the Storm": "风暴的化身",
  "Soul Rupture": "灵魂迸裂",
  "Feed": "喂食",
  "Mass Eruption": "大规模喷发",
  "Keep Your Feet on the Ground": "脚踏实地",
  "Storm Shield": "风暴护盾",
  "Thriving Growth": "兴荣生长",
  "Symbiotic Blooms": "共生绽华",
  "Bloodseeker Vines": "觅血缠藤",
  "Aurora": "极光",
  "Reaper's Mark": "死神印记",
  "Wave of Souls": "灵魂浪潮",
  "Hunt Beneath the Open Skies": "茫野猎手",
  "Resilient Flourishing": "坚毅兴荣",
  "Root Network": "根须网道",
  "Strategic Infusion": "战略灌注",
  "Entangling Vortex": "纠缠旋风",
  "Flower Walk": "万华疾行",
  "Wildstalker's Power": "荒野追猎者之力",
  "Bond with Nature": "自然牵绊",
  "Expelling Shield": "反斥之盾",
  "Bind in Darkness": "黑暗之缚",
  "Xalan's Cruelty": "萨拉恩的暴虐",
  "Blackened Soul": "黑化灵魂",
  "Xalan's Ferocity": "萨拉恩的凶狂",
  "Mark of Peroth'arn": "佩罗萨恩的印记",
  "Mark of Xavius": "萨维斯的印记",
  "Hatefury Rituals": "怨怒祭仪",
  "Bleakheart Tactics": "冷心策略",
  "Seeds of Their Demise": "葬身陨灭之种",
  "Curse of the Satyr": "萨特诅咒",
  "Aura of Enfeeblement": "虚弱光环",
  "Zevrim's Resilience": "瑟雷姆的坚韧",
  "Illhoof's Design": "邪蹄诡图",
  "Harmonious Constitution": "祥和体质",
  "Twin Sprouts": "孪生双芽",
  "Implant": "种植",
  "Vigorous Creepers": "茁壮植被",
  "Bursting Growth": "爆裂增生",
  "Powerful Enrage": "怒意生威",
  "Rune Carved Plates": "符刻坚甲",
  "Pact of the Deathbringer": "死亡使者契约",
  "Preventive Measures": "防微杜渐",
  "Save the Day": "救世时刻",
  "Divine Feathers": "神圣之羽",
  "Preemptive Care": "预见治疗",
  "Waste No Time": "分秒必争",
  "Foreseen Circumstances": "洞悉大局",
  "Twinsight": "双重视界",
  "Assured Safety": "安全无虞",
  "Earthquaker": "地崩山摧",
  "Veteran Vitality": "百战活力",
  "Arterial Bleed": "动脉出血",
  "Unseen Blade": "隐秘之刃",
  "Melt Armor": "熔化护甲",
  "Hardened Scales": "硬化鳞片",
  "Menacing Presence": "威慑英气",
  "Wingleader": "群龙之首",
  "Extended Battle": "持久鏖战",
  "Diverted Power": "力量分流",
  "Onslaught": "强攻",
  "Unrelenting Siege": "无情围攻",
  "Smoke": "烟雾",
  "Mirrors": "镜影",
  "Nimble Flyer": "灵巧飞行",
  "Devious Distractions": "调虎离山",
  "Surprising Strikes": "出其不意",
  "Disorienting Strikes": "惊惑突袭",
  "Flawless Form": "无瑕之形",
  "Thousand Cuts": "千刀万剐",
  "Flickerstrike": "闪烁打击",
  "Nimble Flurry": "身轻如燕",
  "Exterminate": "破灭",
  "No Scruples": "胆大包天",
  "So Tricky": "诡计多端",
  "Don't Be Suspicious": "不必多疑",
  "Coup de Grace": "致命一击",
  "Cloud Cover": "云雾笼罩",
  "Ravage": "毁灭",
  "Fount of Strength": "力量源泉",
  "Wildshape Mastery": "兽形精通",
  "Empowered Shapeshifting": "强化变形",
  "Wildpower Surge": "狂风奔涌",
  "Might of the Black Dragonflight": "黑龙军团之力",
  "Escalating Blade": "锋化之刃",
  "Dreadful Wound": "恐惧创痕",
  "Ruthless Aggression": "无情攻势",
  "Killing Strikes": "灭绝打击",
  "Aggravate Wounds": "加深伤口",
  "Claw Rampage": "利爪狂暴",
  "Bestial Strength": "野兽之力",
  "Pack's Endurance": "兽群韧性",
  "Strike for the Heart": "直取要害",
  "Tear Down the Mighty": "不畏强敌",
  "Wither Away": "枯败凋亡",
  "Art of the Glaive": "战刃绝技",
  "Reaver's Glaive": "收割者战刃",
  "Dark Hound": "黑暗猎犬",
  "Glaive Flurry": "战刃乱舞",
  "Rending Strike": "撕裂猛击",
  "Incisive Blade": "寒芒之刃",
  "Keen Engagement": "锐意交锋",
  "Warblade's Hunger": "战刃渴望",
  "Reaver's Mark": "收割者印记",
  "Aldrachi Tactics": "奥达奇战术",
  "Thrill of the Fight": "酣战热血",
  "Xuen's Guidance": "雪怒的指引",
  "Army Unto Oneself": "一人成军",
  "Fury of the Aldrachi": "奥达奇之怒",
  "Restore Balance": "恢复平衡",
  "Incorruptible Spirit": "不朽灵魂",
  "Temple Training": "闭关修行",
  "Niuzao's Protection": "砮皂之佑",
  "Wounded Quarry": "穷寇当逐",
  "Celestial Conduit": "天神御身",
  "Elune's Grace": "艾露恩的赐福",
  "Jade Sanctuary": "青玉庇护",
  "Courage of the White Tiger": "白虎之勇",
  "Strength of the Black Ox": "玄牛之力",
  "Abyssal Gluttony": "深渊饕餮",
  "Piety": "虔敬",
  "Lifespark": "生命火花",
  "Titan's Gift": "泰坦之赐",
  "Flight of the Red Crane": "朱鹤天翔",
  "Heart of the Jade Serpent": "青龙之心",
  "Elemental Reverb": "元素余响",
  "Ancient Fellowship": "万古情谊",
  "Spiritwalker's Momentum": "灵魂行者之势",
  "Earthen Communion": "大地汇同",
  "Natural Harmony": "自然和谐",
  "Heed My Call": "听从我的召唤",
  "Routine Communication": "例行交流",
  "Final Calling": "最终使命",
  "Maelstrom Supremacy": "漩涡统御",
  "Primordial Capacity": "始源并蓄",
  "Latent Wisdom": "潜在智慧",
  "Offering from Beyond": "彼岸供奉",
  "Ancestral Swiftness": "先祖迅捷",
  "Bolstering Light": "振奋之光",
  "Mereldar's Toll": "米雷达尔洪钟",
  "Swift and Painful": "凄惨痛快",
  "Chi-Ji's Swiftness": "赤精迅捷",
  "Inner Compass": "心怀四方",
  "Unity Within": "众神聚心",
  "Yu'lon's Knowledge": "玉珑之慧",
  "Frost Splinter": "冰霜裂片",
  "Splintering Sorcery": "裂解巫术",
  "Arcane Splinter": "奥术裂片",
  "Splinterstorm": "裂片风暴",
  "Writhing Armor Banding": "蠕动装甲带",
  "Rider's Champion": "冠军骑士",
  "On a Paler Horse": "告死苍驹",
  "Death Charge": "死亡冲锋",
  "Enkindle": "纵焰",
  "Burning Adrenaline": "燃烧刺激",
  "Whitemane's Famine": "怀特迈恩之饥荒",
  "Hungering Thirst": "贪噬饥渴",
  "Apocalypse Now": "天启现世",
  "Mograine's Might": "莫格莱尼的力量",
  "Nazgrim's Conquest": "纳兹戈林之征服",
  "Fury of the Horsemen": "天启骑士之怒",
  "A Feast of Souls": "飨魂",
  "Horsemen's Aid": "天启骑士的援助",
  "Pact of the Apocalypse": "天启契约",
  "Consume Flame": "吞噬烈焰",
  "Trollbane's Icy Fury": "托尔贝恩的冷冽怒火",
  "Mawsworn Menace": "渊誓恫吓",
  "Summon Mograine": "召唤莫格莱尼",
  "Summon Whitemane": "召唤怀特迈恩",
  "Summon Nazgrim": "召唤纳兹戈林",
  "Summon Trollbane": "召唤托尔贝恩",
  "Splintering Orbs": "裂片宝珠",
  "Lifecinders": "生命烬火",
  "Controlled Instincts": "受控本能",
  "Shifting Shards": "变易碎片",
  "Force of Will": "意志之力",
  "Slippery Slinging": "飘忽咒师",
  "Look Again": "蓦然回首",
  "Slayer's Dominance": "屠戮之霸",
  "Imminent Demise": "殒命在即",
  "Death Drive": "夺命动力",
  "Show No Mercy": "绝不留情",
  "Overwhelming Blades": "压制之锋",
  "Fierce Followthrough": "凶悍追击",
  "Opportunist": "趁虚而入",
  "Reap the Storm": "掠武风暴",
  "Relentless Pursuit": "冷酷追杀",
  "Vicious Agility": "奋勇矫健",
  "Culling Cyclone": "剔灭风暴",
  "Slayer's Malice": "屠戮者之怨",
  "Unrelenting Onslaught": "无情强袭",
  "Phantasmal Image": "幻形幻象",
  "Reactive Barrier": "反馈壁垒",
  "Conduit of Flame": "烈焰导体",
  "Expanded Lungs": "肺活猛增",
  "Evasive Action": "规避行动",
  "Unhindered Assault": "无拘强袭",
  "Spymaster's Web": "间谍大师裹网",
  "Archmage's Wrath": "大法师之怒",
  "Spellfrost Teachings": "法术冰霜之训",
  "Surging Totem": "涌动图腾",
  "Preemptive Strike": "先发制人",
  "Whirling Elements": "飞旋元素",
  "Totemic Rebound": "图腾反弹",
  "Oversized Totems": "巨型图腾",
  "Swift Recall": "迅捷召回",
  "Imbuement Mastery": "灌魔精通",
  "Amplification Core": "增效核心",
  "Oversurge": "涌动超载",
  "Wind Barrier": "轻风屏障",
  "Pulse Capacitor": "脉冲蓄容",
  "Supportive Imbuements": "辅助灌魔",
  "Lively Totems": "生机图腾",
  "Splitstream": "元素分流",
  "Totemic Coordination": "图腾协同",
  "Shape of Flame": "烈焰之形",
  "Blessing of An'she": "安瑟的祝福",
  "Wither": "枯萎",
  "Suspended Incubation": "暂停孵化",
  "Executioner": "处刑者",
  "Titanic Precision": "泰坦精准",
  "Draconic Instincts": "腾龙本能",
  "Brutal Finish": "残暴终结",
  "Crane Style": "鹤形拳",
  "Deep Clarity": "深彻明晰",
  "Burn to Ash": "焚烧成灰",
  "Thriving Vegetation": "欣荣植被",
  "Sacred Word": "圣洁之辞",
  "Radiant Aura": "璀璨光环",
  "Forge's Reckoning": "锻炉的清算",
  "Entropic Rift": "熵能裂隙",
  "Light of the Martyr": "殉道者之光",
  "Bestow Light": "赋予圣光",
  "Inner Quietus": "内心寂灭",
  "Collapsing Void": "崩塌虚空",
  "Spellfire Spheres": "法术火焰宝珠",
  "Authority of Radiant Power": "灿能威权",
  "Invocation: Arcane Phoenix": "祈咒：奥术凤凰",
  "Authority of Air": "空气威权",
  "Authority of Storms": "风暴威权",
  "Stormrider's Fury": "驭雷者之怒",
  "Storm's Fury": "风暴之怒",
  "Ursoc's Spirit": "乌索克之魂",
  "Instincts of the Claw": "利爪本能",
  "Lore of the Grove": "丛林智识",
  "Oakskin": "橡木树皮",
  "Fluid Form": "自如变形",
  "Authority of Fiery Resolve": "焰心威权",
  "Suffocating Darkness": "窒息黑暗",
  "Authority of the Depths": "邃渊威权",
  "Mana Cascade": "法力涌流",
  "Merely a Setback": "挫折而已",
  "Sunfury Execution": "日怒之刑",
  "Codex of the Sunstriders": "逐日者魔典",
  "Glorious Incandescence": "白炽耀焰",
  "Savor the Moment": "把握天时",
  "Coiled to Spring": "蓄势待发",
  "Meteorite": "陨星",
  "Lighter Than Air": "身轻如羽",
  "Rondurmancy": "辉圆火咒",
  "Demonic Soul": "恶魔之魂",
  "Memory of Al'ar": "奥之回忆",
  "Necrolyte Teachings": "通灵教义",
  "Soul Anathema": "蚀魂之咒",
  "Lessons in Debilitation": "衰竭之训",
  "Demoniac's Fervor": "恶魔师的狂热",
  "Wicked Reaping": "邪毒收割",
  "Quietus": "寂灭",
  "Sataiel's Volition": "萨泰尔的意志",
  "Shadow of Death": "死亡之影",
  "Savage Fury": "野蛮暴怒",
  "Gorebound Fortitude": "血缚之韧",
  "Friends In Dark Places": "黑暗中的朋友",
  "Shared Fate": "命运相连",
  "Eternal Servitude": "永恒奴役",
  "Succulent Soul": "诱人灵魂",
  "Divine Halo": "神圣光晕",
  "Energy Compression": "能量压缩",
  "Voidheart": "虚空之心",
  "Darkening Horizon": "黑化视界",
  "Cryptic Instructions": "密文指令",
  "Void Empowerment": "虚空增效",
  "Rushing Reflexes": "疾行反应",
  "Stellar Amplification": "星辰强化",
  "Void Blast": "虚空冲击",
  "Crashing Momentum": "迅威压迫",
  "Don't Look Back": "决意无悔",
  "Invigorating Pulse": "活力脉动",
  "Chi Proficiency": "真气熟稔",
  "Martial Instincts": "以武立身",
  "Pressure Points": "正中死穴",
  "Peace and Prosperity": "平和荣昌",
  "Quick Footed": "行如风",
  "Aspect of Harmony": "和谐化身",
  "Wind's Reach": "劲风展",
  "Bounding Agility": "敏捷跃进",
  "Coalescence": "大道同归",
  "Jade Walk": "踏玉步",
  "Harmony of the Heavens": "星月谐律",
  "Healing Winds": "治疗之风",
  "Flow of Chi": "真气流转",
  "Spirit's Essence": "精气萃华",
  "Astral Communion": "沟通星界",
  "Void Infusion": "虚空灌输",
  "Flurry Strikes": "疾风乱打",
  "Swift Art": "迅风行",
  "Energy Transfer": "能量转移",
  "Celestial Determination": "天神决意",
  "Scald": "灼焦",
  "Fire's Ire": "火焰之忿",
  "Purified Spirit": "净化之魂",
  "Harmonic Gambit": "以和致胜",
  "Manifestation": "化气凝形",
  "Balanced Stratagem": "平衡方略",
  "Endless Draught": "豪饮千杯",
  "Path of Resurgence": "复兴之路",
  "Way of a Thousand Strikes": "千击秘术",
  "Pride of Pandaria": "潘达利亚之豪",
  "High Impact": "拳劲贯体",
  "Against All Odds": "不惧万难",
  "Veteran's Eye": "精兵之目",
  "One Versus Many": "只身克众",
  "Efficient Training": "高效演武",
  "Martial Precision": "武技精准",
  "Whirling Steel": "钢铁漩涡",
  "Predictive Training": "先觉磨砺",
  "Vigilant Watch": "警戒戍望",
  "Clarity of Purpose": "清晰使命",
  "Overwhelming Force": "无匹之劲",
  "Mantra of Tenacity": "坚韧真言",
  "Burden of Power": "力量的重担",
  "Mantra of Purity": "纯净真言",
  "Arcane Soul": "奥术之魂",
  "Tiger's Vigor": "龙腾虎蹴",
  "Roar from the Heavens": "天威咆哮",
  "Spymaster's Report": "间谍大师的报告",
  "No Escape": "无路可逃",
  "Starlight Conduit": "星光导体",
  "Voidwraith": "虚空幽灵",
  "Flurry Strike": "疾风乱打",
  "Momentum Boost": "疾拳之势",
  "Void Leech": "虚空抽取",
  "Void Flay": "虚空鞭笞",
  "Pyromaniac": "纵火成性",
  "Brawler's Intensity": "勇夫之劲",
  "Energy Burst": "能量爆裂",
  "Sequenced Strikes": "川流不息",
  "Revolving Whirl": "旋升劲风",
  "Knowledge of the Broken Temple": "残寺秘学",
  "Embrace the Shadow": "怀抱暗影",
  "Singularly Focused Jade": "奇聚之碧",
  "Communion With Wind": "如风似岚",
  "Dual Threat": "拳脚齐施",
  "Devour Matter": "吞灭物质",
  "Spontaneous Combustion": "自燃",
  "Flurry of Xuen": "雪怒之捷",
  "Eureka": "灵光乍现",
  "Tempest": "狂风怒号",
  "Strand of the Lord": "尊将之束",
  "Strand of the Ascended": "扬升者之束",
  "Strand of the Queen": "女王之束",
  "Strand of the Sundered": "碎裂者之束",
  "Strand of the Sage": "贤者之束",
  "Demonsurge": "魔涌",
  "Wave of Debilitation": "衰竭波动",
  "Pursuit of Angriness": "怒意追击",
  "Focused Hatred": "专注仇恨",
  "Set Fire to the Pain": "沐焰为殇",
  "Improved Soul Rending": "强化灵魂劈裂",
  "Burning Blades": "燃烧剑刃",
  "Violent Transformation": "猛烈变形",
  "Enduring Torment": "弥久苦痛",
  "Untethered Fury": "无拘之怒",
  "Student of Suffering": "苦难修行",
  "Flamebound": "火缚",
  "Monster Rising": "怪物现身",
  "Demonic Intensity": "魔化强度",
  "Soul Sunder": "灵魂割裂",
  "Spirit Burst": "灵魂爆裂",
  "Fel Desolation": "邪能荒芜",
  "Consuming Fire": "吞噬之焰",
  "Sigil of Doom": "末日咒符",
  "Fight Through the Flames": "征战于烈焰",
  "Abyssal Gaze": "深渊凝视",
  "Hand of Fate": "命运之手",
  "Fatebound Coin (Tails)": "命运硬币（反面）",
  "Swift Artifice": "迅捷巧计",
  "Demonic Healthstone": "恶魔治疗石",
  "Energized Familiar": "聚能魔宠",
  "Improved Shadow Bolt": "强化暗影箭",
  "Malediction": "邪咒",
  "Contagion": "扩散",
  "Summoner's Embrace": "召唤者之拥",
  "Power Surge": "能量涌动",
  "Cunning Cruelty": "狡黠残酷",
  "Crystallization": "结晶化",
  "Whirling Fire": "飞旋之火",
  "Whirling Earth": "飞旋之土",
  "Whirling Water": "飞旋之水",
  "Whirling Air": "飞旋之气",
  "Mean Streak": "连环恶行",
  "Edge Case": "竖币稀景",
  "Priest Holy 11.0 Class Set 4pc": "神圣牧师11.0职业套装4件套",
  "Flametouched": "烈焰触痕",
  "Word of Supremacy": "至高真言",
  "Heightened Alteration": "强效升变",
  "Rune of Shadows": "暗影符文",
  "Manifested Power": "具象之力",
  "Empowered Surges": "强化涌动",
  "Improved Demonic Tactics": "强化恶魔战术",
  "Energy Cycle": "能量循环",
  "Resonant Energy": "共振能量",
  "Shock Pulse": "振荡脉冲",
  "Demonic Brutality": "魔性凶暴",
  "Perfected Form": "完美形态",
  "Incessant Screams": "无尽尖叫",
  "Sustained Potency": "持续效能",
  "Stormcaller": "风暴召唤者",
  "Electroshock": "电能震击",
  "Rolling Thunder": "滚雷",
  "Nature's Protection": "自然之护",
  "Tempted Fate": "挑战命运",
  "Surging Currents": "喷薄之流",
  "Deal Fate": "命运交易",
  "Inexorable March": "命不可违",
  "Death's Arrival": "绝命降临",
  "Destiny Defined": "命数已定",
  "August Blessing": "至尊之赐",
  "One With the Wind": "清风作伴",
  "Devastation": "湮灭",
  "Emberstorm": "余烬风暴",
  "Ice Prison": "寒冰牢笼",
  "Runic Protection": "符文防护",
  "Subduing Grasp": "镇压攫握",
  "Osmosis": "渗透",
  "Null Magic": "无效魔法",
  "Vestigial Shell": "存余护罩",
  "Voltaic Surge": "流电奔腾",
  "Memory of the Monastery": "禅院故思",
  "Arcane Reach": "奥术延展",
  "Ox Stance": "玄牛式",
  "Rapid Injection": "迅捷注射",
  "Storm Swell": "风暴涌浪",
  "Arc Discharge": "弧形放电",
  "Supercharge": "超荷充能",
  "Conductive Energy": "传导能量",
  "Awakening Storms": "觉醒风暴",
  "Menacing Magus": "阴险魔导师",
  "Elixir of Determination": "明志灵药",
  "Acrobatic Strikes": "杂耍打击",
  "Doomed Bidding": "末日难逃",
  "Foul Infections": "邪污感染",
  "Festering Scythe": "脓疮毒镰",
  "Barrier Diffusion": "屏障漫射",
  "Mark of Shatug": "沙图格的印记",
  "Mark of F'harg": "法尔格的印记",
  "Quickwick's Quick Trick Wick Walk": "迅芯的烛光微步",
  "Lethal Preservation": "极效防护",
  "Summon Gloomhound": "召唤阴暗恶犬",
  "Summon Charhound": "召唤灼焦恶犬",
  "Lethal Blows": "绝命打击",
  "Gloom Slash": "阴暗劈裂",
  "Expert Strategist": "战略奇才",
  "Earthsurge": "大地奔涌",
  "Tremor": "震颤",
  "Cenarius' Might": "塞纳留斯之力",
  "Frostbane": "冰霜灾祸",
  "Arctic Assault": "极地突袭",
  "Cryogenic Chamber": "低温冰冻",
  "Hyperpyrexia": "霜侵热毒",
  "The Long Winter": "漫漫严冬",
  "Snap Induction": "惊霆感应",
  "Protein Slurp": "蛋白奶昔",
  "Grab Viscera": "抓取脏器",
  "Improved Chaos Bolt": "强化混乱之箭",
  "Ethereal Cloak": "虚渺斗篷",
  "Bait and Switch": "诱导转向",
  "Deathstalker's Mark": "死亡猎手标记",
  "Hunt Them Down": "绝命猎杀",
  "Singular Focus": "殊刃同归",
  "Lingering Darkness": "徘徊黑暗",
  "Shadewalker": "影行者",
  "Darkest Night": "至黑之夜",
  "Symbolic Victory": "致胜符记",
  "Shroud of Night": "夜幕遮掩",
  "Momentum of Despair": "绝望追击",
  "Follow the Blood": "觅血寻踪",
  "Flow of Battle": "行云功法",
  "Tidecaller's Guard": "唤潮者的护卫",
  "Sanguine Stratagem": "血色谋策",
  "Mana Bomb": "法力炸弹",
  "Unyielding Will": "不屈意志",
  "Heat Shimmer": "热能闪光",
  "Molten Fury": "熔火之怒",
  "Improved Haunt": "强化鬼影缠身",
  "Radiant Glory": "光辉荣耀",
  "Lotus Infusion": "玉莲灌注",
  "Inspired Intellect": "启迪智慧",
  "Bone Collector": "集骨者",
  "Ferociousness": "虎威",
  "Desperate Measures": "孤注一掷",
  "Carnage": "屠戮",
  "Bloodied Blade": "染血利刃",
  "Ravenous Afflictions": "暴虐痛楚",
  "Padded Armor": "护身软甲",
  "Scout's Instincts": "斥候本能",
  "Tar-Coated Bindings": "焦油缚链",
  "Moment of Opportunity": "机遇时刻",
  "Serrated Tips": "锯齿尖锋",
  "Kindling Flare": "薪火照明弹",
  "Territorial Instincts": "领地意识",
  "Emergency Salve": "紧急药膏",
  "Unnatural Causes": "非自然原因",
  "Trigger Finger": "扳机指",
  "Specialized Arsenal": "特化军火库",
  "No Hard Feelings": "不要见怪",
  "Go for the Throat": "直取要害",
  "Laceration": "裂痕",
  "Phantom Reach": "幻影延展",
  "Thundering Hooves": "轰雷蹄踏",
  "Huntmaster's Call": "狩猎大师的召唤",
  "Penetrating Shots": "穿透射击",
  "Small Game Hunter": "肋排猎人",
  "Grenade Juggler": "榴弹杂耍",
  "Outland Venom": "外域之毒",
  "Flanker's Advantage": "侧翼优势",
  "Kodo Tranquilizer": "科多兽镇静剂",
  "Devilsaur Tranquilizer": "魔暴龙镇静剂",
  "Grotesque Vial": "怪诞之瓶",
  "Wildfire Infusion": "野火灌注",
  "Permafrost Lances": "永冻冰枪",
  "Wrench Evil": "扭转邪恶",
  "Light's Protection": "圣光之佑",
  "Overflowing Light": "满溢之光",
  "Glorious Dawn": "辉光黎明",
  "High Voltage": "高压",
  "Charged Missiles": "充能飞弹",
  "Focusing Crystal": "聚焦水晶",
  "Consortium's Bauble": "财团的点缀",
  "Brainstorm": "头脑风暴",
  "Truth Prevails": "真理永存",
  "Extrication": "解救",
  "Liberation": "解放",
  "Blackrock Munitions": "黑石军火",
  "Dispatch (Coup de Grace)": "斩击（致命一击）",
  "Hearty Well Fed": "丰盛进食充分",
  "Eviscerate (Coup de Grace)": "刺骨（致命一击）",
  "Elemental Resistance": "元素抗性",
  "Spouting Spirits": "喷涌灵魂",
  "Tidewaters": "涛流",
  "First Ascendant": "首席升腾者",
  "Preeminence": "飞升卓越",
  "Reactive Warding": "活性结界",
  "Howl of the Pack": "族群之嚎",
  "White Water": "急浪飞流",
  "Storm Frenzy": "风暴狂乱",
  "Thunderstrike Ward": "雷霆打击结界",
  "Encasing Cold": "凝霜缠身",
  "Arctic Snowstorm": "极地雪暴",
  "Ascending Air": "升涌气流",
  "Enhanced Imbues": "强化灌魔",
  "Jet Stream": "喷流",
  "Fusion of Elements": "元素融聚",
  "Skyfury": "天怒",
  "Lightning Capacitor": "闪电容蓄",
  "Elemental Unity": "元素团结",
  "Everlasting Elements": "恒久元素",
  "Tempest Overload": "风暴超载",
  "Avian Specialization": "飞禽专精",
  "Spotter's Mark": "瞭望印记",
  "Harrier's Cry": "鹞鹰尖啸",
  "Black Arrow": "黑蚀箭",
  "Withering Fire": "凋零射击",
  "Refreshment": "进食饮水",
  "Rushing Wind Kick": "疾风呼啸踢",
  "Jade Empowerment": "青玉赋能",
  "Rushing Winds": "疾啸狂风",
  "The Bell Tolls": "钟鸣厄至",
  "Bleak Arrows": "黯然箭矢",
  "Shadow Dagger": "暗影匕首",
  "Lightning Conduit": "雷电导管",
  "Ebon Bowstring": "乌黑弓弦",
  "Banshee's Mark": "女妖的印记",
  "Bleak Powder": "黯然火药",
  "Herald of the Storms": "风暴先驱",
  "Charged Conduit": "盈电导体",
  "Earthshatter": "裂地猛击",
  "Snakeskin Quiver": "蛇皮箭袋",
  "Serpentine Strikes": "毒蛇打击",
  "Whirling Stars": "旋荡星辰",
  "Sunseeker Mushroom": "向日蘑菇",
  "Hail of Stars": "星落似霰",
  "Worthy Sacrifice": "无悔牺牲",
  "Steed of Liberty": "自由之驹",
  "Eye for an Eye": "以眼还眼",
  "Stoicism": "淡泊",
  "Stand Against Evil": "抵御邪恶",
  "Righteous Protection": "正义保护",
  "Light's Countenance": "圣光面容",
  "Sacred Strength": "圣洁力量",
  "Divine Spurs": "神圣马刺",
  "A Just Reward": "公正嘉奖",
  "Lightbearer": "圣光使者",
  "Selfless Healer": "无私治愈",
  "Inspired Guard": "奋发卫士",
  "Holy Reprieve": "神圣喘息",
  "Divine Reach": "神圣触及",
  "Soul Drinker": "饮魂者",
  "Death Perception": "死亡感知",
  "Tempered in Battle": "战火淬炼",
  "Blessed Calling": "福佑召唤",
  "Lead the Charge": "带头冲锋",
  "Reaper's Onslaught": "死神强袭",
  "Barbed Scales": "尖刺鳞片",
  "Refining Fire": "精炼圣火",
  "Authoritative Rebuke": "权令责难",
  "Signature Spell": "招牌秘法",
  "Voltaic Blaze": "流电炽焰",
  "Coalescing Water": "聚合流水",
  "Supercharger": "超荷充能",
  "Improved Swiftmend": "强化迅捷治愈",
  "Renewing Surge": "愈合之涌",
  "Forced Induction": "强制增压",
  "Feathered Frenzy": "冲冠一怒",
  "Aspect of the Hydra": "多头蛇守护",
  "Void Metamorphosis": "虚空变形",
  "On Target": "锁定目标",
  "Obsidian Arrowhead": "黑曜石箭头",
  "Headshot": "一枪爆头",
  "Tensile Bowstring": "韧性弓弦",
  "Precision Detonation": "精确引爆",
  "Accuracy By Volume": "火力覆盖",
  "Ursol's Warding": "乌索尔之庇",
  "Lasting Words": "持久圣言",
  "Light in the Darkness": "黑暗中的光明",
  "Emperor's Favor": "皇帝的垂青",
  "Howl of the Pack Leader": "猎群领袖之嚎",
  "Wyvern's Cry": "双足飞龙之啸",
  "Boar Charge": "野猪冲锋",
  "Bear Summon": "巨熊召唤",
  "Rend Flesh": "撕裂肉体",
  "Dire Summons": "凶暴召唤",
  "Better Together": "强强联手",
  "Pack Mentality": "兽群思维",
  "Divine Procession": "神圣巡游",
  "Evangelism": "福音",
  "Ursine Fury": "巨熊之怒",
  "Fury of the Wyvern": "双足飞龙之怒",
  "Encroaching Shadows": "渗透暗影",
  "Hogstrider": "猪突猛进",
  "No Mercy": "从无怜悯",
  "Shell Cover": "龟壳庇护",
  "Slicked Shoes": "油滑之靴",
  "Horsehair Tether": "缰绳束缚",
  "Stampede!": "奔踏！",
  "Lead From the Front": "身先士卒",
  "Eagle's Accuracy": "鹰眼精准",
  "No Scope": "闭镜疾射",
  "Unstable Trigger": "险变扳机",
  "Windrunner Quiver": "风行者箭袋",
  "Consume": "吞噬",
  "Void Ray": "虚空射线",
  "Cunning": "狡诈",
  "Tenacious": "坚韧",
  "Grievous Wounds": "伤口恶化",
  "Circle of the Wild": "荒野之环",
  "Circle of the Heavens": "天堂之环",
  "Aessina's Renewal": "艾森娜的复苏",
  "Unerring Vision": "千里之目",
  "Solitary Companion": "独行伙伴",
  "Symbiotic Relationship": "共生关系",
  "Perfectly-Honed Instincts": "精准本能",
  "Devourer Demon Hunter": "噬灭恶魔猎手",
  "Demonfire Infusion": "恶魔之火注能",
  "Roll the Bones": "命运骨骰",
  "One of a Kind": "独一无二",
  "Double Trouble": "双重麻烦",
  "Triple Threat": "三重威胁",
  "Jackpot": "头奖",
  "Divinity": "圣洁",
  "Eternal Sanctity": "永恒圣洁",
  "Dispersing Light": "弥漫圣光",
  "Holy Celerity": "神圣迅捷",
  "Insurance!": "保险！",
  "Predator's Thirst": "掠食者的渴望",
  "Winning Streak!": "连胜！",
  "Freezing Winds": "冻结寒风",
  "Big Winner!!!": "大赢家！！！",
  "Slicing Winds": "切削之风",
  "Dire Cleave": "凶暴顺劈",
  "Devour": "吞噬",
  "Call Greater Dreadstalker": "召唤强能恐惧猎犬",
  "Therazane's Resilience": "塞拉赞恩的韧性",
  "Jackpot!": "头奖！",
  "Lifetreading": "生命流转",
  "Opportunistic Strike": "投机打击",
  "Primordial Storm": "始源风暴",
  "Primordial Fire": "始源火焰",
  "Primordial Frost": "始源冰霜",
  "Primordial Lightning": "始源闪电",
  "Fulminous Roar": "迅雷咆哮",
  "Azure Celerity": "碧蓝迅捷",
  "Screaming Brutality": "呼啸暴虐",
  "Phase Blink": "相位闪现",
  "Collapsing Star": "坍缩之星",
  "Freezing": "冻结",
  "Voidstep": "虚空瞬步",
  "Guile": "诡计",
  "Unbreakable Bond": "不破之谊",
  "Intuition": "敏锐直觉",
  "Waste Not": "杜绝浪费",
  "Lesser Rune of Twilight Devastation": "弱效暮光毁灭符文",
  "Eradicate": "根除",
  "Greater Rune of the Echoing Void": "强效虚空回响符文",
  "Reap": "收割",
  "Liadrin's Light": "莉亚德琳之光",
  "Greater Rune of Infinite Stars": "强效无尽之星符文",
  "Tentacle Slam": "触须猛击",
  "Greater Rune of the Void Ritual": "强效虚空仪式符文",
  "Shattered Souls": "破碎灵魂",
  "Impending Apocalypse": "天启将至",
  "Subservient Shadows": "仆侍之影",
  "Single-Button Assistant": "一键辅助",
  "Darkmoon Sigil: Hunt": "暗月徽记：狩猎",
  "Killing Streak": "血性大发",
  "Howling Blades": "啸风冰刃",
  "Icy Onslaught": "冷冽强袭",
  "Northwinds": "北境霜风",
  "Frostreaper": "掠霜使者",
  "Ancient Madness": "远古疯狂",
  "Pillars of Light": "圣光之柱",
  "Wildspeaker": "荒语者",
  "Lycara's Inspiration": "莱卡拉的启发",
  "Unmatched Precision": "不失毫厘",
  "Greater Rune of Twilight Devastation": "强效暮光毁灭符文",
  "Lunar Eclipse": "月蚀",
  "Solar Eclipse": "日蚀",
  "Lesser Rune of the Echoing Void": "弱效虚空回响符文",
  "Lesser Rune of Infinite Stars": "弱效无尽之星符文",
  "Lesser Rune of Gushing Wound": "弱效龟裂创伤符文",
  "Lesser Rune of the Twisted Appendage": "弱效扭曲的附肢符文",
  "Lesser Rune of the Void Ritual": "弱效虚空仪式符文",
  "Void Nova": "虚空新星",
  "Desecrate": "亵渎",
  "Silvermoon Health Potion": "银月城生命药水",
  "Armor Specialization": "护甲专精",
  "Shift": "变换",
  "Hunker Down": "蹲姿防御",
  "Spellbreaker": "破法者",
  "Unyielding Stance": "刚毅姿态",
  "Flask of Thalassian Resistance": "萨拉斯抗性合剂",
  "Heavy Handed": "遒劲猛击",
  "Flask of the Magisters": "魔导师合剂",
  "Flask of the Blood Knights": "血骑士合剂",
  "Flask of the Shattered Sun": "破碎残阳合剂",
  "Whirling Blade": "剑刃旋风",
  "Shadow Tap": "暗影分流",
  "Umbral Reach": "幽影之触",
  "Light's Preservation": "圣光之护",
  "Preparing to Strike": "准备出击",
  "Basic Rejuvenation Potion": "基础活力药水",
  "Light's Potential": "圣光潜力",
  "Lightfused Mana Potion": "光注法力药水",
  "Ravage Rampage": "蛮荒暴怒",
  "Potion of Recklessness": "鲁莽药水",
  "Draught of Rampant Abandon": "狂放恣意饮剂",
  "Thorn Bloom": "荆棘绽放",
  "Tempo Charged": "律节充能",
  "Potion of Zealotry": "狂热药水",
  "Moment of Craving": "噬欲时刻",
  "Frostbound Will": "霜缚意志",
  "Soulshaper": "塑灵者",
  "Demonic Oculus": "恶魔邪眼",
  "Mastery: Monster Within": "精通：内在恶魔",
  "Grave Mastery": "墓穴精通",
  "Jade Serpent's Blessing": "青龙的祝福",
  "Hungering Slash": "饥渴斩击",
  "Harmonic Surge": "和谐涌动",
  "Potion of Devoured Dreams": "吞噬之梦药水",
  "Eye Blast": "魔眼冲击",
  "Second Helping": "欲求难满",
  "Unshakable": "不可动摇",
  "Eclipse": "日月之蚀",
  "Soul Swipe": "灵魂交换",
  "Celestial Fire": "天界之火",
  "Sculpt the Stars": "雕刻星辰",
  "Master Summoner": "召唤大师",
  "Devourer's Bite": "吞噬者之咬",
  "Voidglare Boon": "虚空眩光之赐",
  "Focused Ray": "聚焦射线",
  "Star Fragments": "星辰碎片",
  "Total Eclipse": "全蚀",
  "Meteor Storm": "流星风暴",
  "Elune's Challenge": "艾露恩的挑战",
  "Death's Torment": "灭尽折磨",
  "Dark Thoughts": "黑暗思维",
  "Madness Weaving": "疯狂编织",
  "Improved Eclipse": "强化日月之蚀",
  "Meteorites": "陨星",
  "Dread Plague": "恐惧瘟疫",
  "Celestial Infusion": "天神灌注",
  "Niuzao's Resolve": "砮皂的决心",
  "Zen State": "禅悟状态",
  "Call of the Righteous": "正义召唤",
  "Ringing of the Heavens": "天堂回响",
  "Clawing Shadows": "暗影之爪",
  "Dream Simulacrum": "梦境幻影",
  "Wings of Liberty": "自由之翼",
  "Outnumber": "以众凌寡",
  "Seraphic Barrier": "炽天使屏障",
  "Frenzied Focus": "狂乱专注",
  "Glistening Radiance": "闪亮辉煌",
  "Unholy Devotion": "冒渎虔诚",
  "Soul Immolation": "灵魂献祭",
  "Vengeful Wrath": "愤怒复仇",
  "Hand of Divinity": "神性之手",
  "Twin Echoes": "双重回响",
  "Forbidden Knowledge": "禁断知识",
  "Necrotic Coil": "死灵缠绕",
  "Void Volley": "虚空齐射",
  "Midnight": "至暗之夜",
  "Emptiness": "万界空虚",
  "Calamitous": "灾厄临世",
  "Scourging": "邪灾鞭挞",
  "Descending Darkness": "降世黑暗",
  "Inner Flame": "心灵之火",
  "Sweet Release": "甜蜜的解脱",
  "Phantom Menace": "幻影威胁",
  "Instilled Doubt": "植入疑虑",
  "Jade Infusion": "玉龙灌注",
  "Voidrage": "虚空邪怒",
  "Horrific Vision": "惊魂幻象",
  "Vision of N'Zoth": "恩佐斯的幻象",
  "Way of the Serpent": "青龙之道",
  "Aether Attunement": "以太调谐",
  "Orb Mastery": "法球精通",
  "Aegwynn's Technique": "艾格文秘术",
  "Overflowing Insight": "洞见溢流",
  "Expanded Mind": "心智洞开",
  "Resonant Voice": "震音回荡",
  "Frantic Frenzy": "怒意狂乱",
  "Arcane Singularity": "奥术奇点",
  "Undying Embers": "不灭余烬",
  "Improved Conjuration": "强效咒术",
  "Spatial Manipulation": "空间操控",
  "Improved Ice Barrier": "强化寒冰护体",
  "Searing Sunlight": "灼日之光",
  "Time Walk": "时空漫步",
  "Interpose": "截拦掩护",
  "Temporal Realignment": "时光重组",
  "Disease Cloud": "疾病之云",
  "Charm of Aegwynn": "艾格文的护符",
  "Charm of Medivh": "麦迪文的护符",
  "Glacial Bulwark": "冰川壁垒",
  "Voidpurge": "虚空净化",
  "Devourer's Edge": "吞噬者之刃",
  "Rolling Torment": "翻滚折磨",
  "Chomp": "啃噬",
  "Practiced Chaos": "混沌研习",
  "Sweet Suffering": "甜蜜的痛苦",
  "Roaring Blaze": "咆哮烈焰",
  "Overpowered Missiles": "过载飞弹",
  "Improved Blink": "强化闪现",
  "Incorporeal Essence-Gorger": "虚体精华吞噬者",
  "Improved Havoc": "强化浩劫",
  "Blood Spattered": "鲜血飞溅",
  "Focused Frenzy": "专注狂乱",
  "Hunger for Battle": "战斗渴望",
  "Lacerating Claws": "裂爪猛击",
  "Chaotic Inferno": "混乱狱火",
  "Lake of Fire": "烈火之池",
  "Beacon of the Savior": "救世道标",
  "Destructive Rapidity": "迅捷毁灭",
  "Alythess's Ire": "奥蕾塞丝之怒",
  "Avatar of Destruction": "毁灭化身",
  "Vision of Sanctity": "圣洁幻象",
  "Voidblade": "虚空之刃",
  "Cull": "剔除",
  "Reaper's Toll": "死神丧钟",
  "Pierce the Veil": "穿刺帷幕",
  "Fiendish Cruelty": "魔性凶残",
  "Solace": "圣光慰藉",
  "Valiant Crusade": "英勇征伐",
  "Empyrean Authority": "苍穹之谕",
  "Sweeping Verdict": "扫荡裁决",
  "Ultimate Serenity": "至静化身",
  "Lightburst": "光芒爆裂",
  "Tempered Soul": "淬炼之魂",
  "Spontaneous Immolation": "自发献祭",
  "Scythe's Embrace": "镰刀之拥",
  "Duty Eternal": "永恒职责",
  "Prompt Prognosis": "迅愈祷言",
  "Improved Shatter": "强化碎裂",
  "Shatter": "碎裂",
  "Deep Shatter": "深度碎裂",
  "Frigid Focus": "严寒专注",
  "Cone of Frost": "寒霜冰锥",
  "Efficient Prayers": "祈愿精通",
  "Healing Focus": "治疗专注",
  "Spiritwell": "灵泉",
  "Crimson Tempest": "猩红风暴",
  "Putrefy": "腐化",
  "Soul Glutton": "灵魂饕餮",
  "Demonic Instinct": "恶魔本能",
  "Crystalline Refraction": "晶化折射",
  "Thermal Void": "热能真空",
  "Hailstones": "冰雹",
  "Rimecaster": "霜语者",
  "Glacial Attunement": "冰川调谐",
  "Improved Flurry": "强化冰风暴",
  "Glaciate": "冻结",
  "Heart of Ice": "寒冰之心",
  "Motivated Murderer": "嗜血杀意",
  "Heat Sink": "热能汇聚",
  "Dualcasting Adept": "双系精锐",
  "Blast Radius": "爆裂所及",
  "Cosmic Wave": "星界灵涌",
  "Guiding Light": "指引之光",
  "Skyfire Heel": "天火踢",
  "Crashing Fists": "霹雳拳",
  "Cyclone's Drift": "旋风流转",
  "Unshakeable Drive": "杀意不移",
  "Corrupt the Blood": "腐蚀血液",
  "Clear the Witnesses": "见者尽灭",
  "Frostbite": "冰霜撕咬",
  "Airborne Rhythm": "凌空韵动",
  "Hurricane's Vault": "飓风腾跃",
  "Lucky Coin": "幸运硬币",
  "Overflowing Purse": "金袋满盈",
  "Delivered Doom": "劫运降临",
  "Chosen's Revelry": "天选者盛宴",
  "Rush to the Inevitable": "宿命奔袭",
  "Fate Intertwined": "命途纠缠",
  "Focused Power": "聚焦能量",
  "Everlasting Light": "永续之光",
  "Zenith": "乾元之巅",
  "Razor Wire": "利刃铁丝",
  "Finish the Job": "乘胜追击",
  "Obsidian Spiral": "黑曜石螺旋",
  "Inspiring Strike": "鼓舞打击",
  "Harmonic Combo": "谐律连击",
  "Echo Technique": "回响技法",
  "Secondary Poisoning": "二次浸毒",
  "Purge the Wicked": "净化邪恶",
  "Deadly Momentum": "杀机涌现",
  "Occultist": "秘术师",
  "Frost Conditioning": "冰霜适应",
  "Poisoner's Drive": "淬毒冲动",
  "Regicide's Reward": "弑君之赏",
  "Avulsion": "撕脱",
  "Canny Strikes": "精明打击",
  "Elemental Tempo": "元素节奏",
  "Fel Intellect": "邪能才智",
  "Practiced Rituals": "练习仪式",
  "Spectral Illusion": "幽魂幻象",
  "Tormenting Whispers": "折磨低语",
  "Uplifting Words": "振奋圣言",
  "Angelic Touch": "天使之触",
  "Takedown": "狩魂一击",
  "Radiant Plea": "辉光祈请",
  "Void Tendrils": "虚空触须",
  "Imp Gang Boss": "小鬼首领",
  "False Autonomy": "虚假自主",
  "Spiritual Guidance": "精神指引",
  "Strength of Resolve": "坚毅之力",
  "Dark Enlightenment": "黑暗启迪",
  "Hellbent Commander": "冷酷统御",
  "Memory of Ysera": "伊瑟拉之忆",
  "Clairvoyant": "远景洞察",
  "Antoran Armaments": "安托兰军械",
  "Ward of the Forest": "林域庇护",
  "Mindpierce": "心灵穿刺",
  "Painful Invocation": "致痛祈咒",
  "Stormbind": "风暴束缚",
  "Twin Disciplines": "双生戒律",
  "Persistence": "延绵不绝",
  "Flamefang Pitch": "燎焰沥青",
  "Strike as One": "羁绊共狩",
  "Two Against Many": "以二敌多",
  "Summon Vilefiend": "召唤邪犬",
  "Strike As One": "羁绊共狩",
  "Gift of an Ancient Guardian": "远古守卫赠礼",
  "Storm Unleashed": "风暴释放",
  "Crash Lightning (Unleashed)": "毁灭闪电（释放）",
  "Hasty Hunt": "疾速狩猎",
  "Focused Hunt": "专注狩猎",
  "Masterful Hunt": "娴熟狩猎",
  "Versatile Hunt": "变通狩猎",
  "Wallop": "重击",
  "Akil'zon's Cry of Victory": "埃基尔松的胜利怒吼",
  "Calm Waters": "静水流深",
  "Red Moon": "赤红之月",
  "Soothing Rain": "宁静之雨",
  "Double Dip": "双重浸润",
  "Shellshock": "弹壳震击",
  "Wildfire Imbuement": "野火灌注",
  "Killing Blow": "致命一击",
  "Water Expulsion": "激流喷发",
  "Harnessed Rage": "驾驭怒火",
  "Razor Edge": "锋刃旋击",
  "Crashing Waves": "碎浪",
  "Current Control": "潮汐掌控",
  "Quickstream": "迅流",
  "Sic 'Em": "干掉他们",
  "Shrapnel Bomb": "散射炸弹",
  "Flamebreak": "断焰",
  "Voidfall": "虚落",
  "Meteoric Rise": "迅疾冲霄",
  "Meteoric Fall": "迅疾流星",
  "Path to Oblivion": "湮灭之路",
  "State of Matter": "物态",
  "Celestial Echoes": "天界回响",
  "Waking Nightmare": "梦魇乍醒",
  "Master the Darkness": "黑暗主宰",
  "Void Shield": "虚空之盾",
  "Crusade": "征伐",
  "Sentinel's Mark": "哨兵印记",
  "Swift Erasure": "迅捷抹消",
  "Doomsayer": "末日预言者",
  "Greater Smite": "强效惩击",
  "Lunar Storm": "皎月风暴",
  "Stargazer": "星眼",
  "Catastrophe": "大灭",
  "Sundering Roar": "碎甲咆哮",
  "Final Hour": "终末时刻",
  "Open Fire": "破空枪鸣",
  "Otherworldly Focus": "异界专注",
  "Moon's Blessing": "月神之赐",
  "Can't Miss, Won't Miss": "矢无虚发",
  "Sanctified Armaments": "圣洁武装",
  "Arcane Talons": "奥术利爪",
  "Conditioning": "环境适应",
  "Scout's Vigil": "斥候警戒",
  "Mongoose Rounds": "猫鼬弹药",
  "Kindling": "薪火",
  "Earthweaver": "大地编织者",
  "Rip Current": "激流涌动",
  "Burn It All": "尽数焚燃",
  "Blightburst": "腐化喷射",
  "Ignition": "燃烧",
  "Wildfire": "野火",
  "Deep Impact": "天地大冲撞",
  "Cinderstorm": "燃烬风暴",
  "Time Twist": "扭转时光",
  "Eye of the Drowning Void": "沉溺虚空之眼",
  "Phase Shift": "相位变换",
  "Mass Acceleration": "质量加速",
  "Dark Matter": "暗物质",
  "World Killer": "灭世灾星",
  "Merithra's Blessing": "麦琳瑟拉的祝福",
  "Menacing Rush": "威势突袭",
  "Lord of the Dead": "亡者之主",
  "Flanked": "侧翼夹击",
  "Dark Harvest": "幽冥收割",
  "Fired Up": "焚烧殆尽",
  "Touch of the Archmage": "大法师之抚",
  "Touch of Grass": "青草之触",
  "Catlike Reflexes": "灵猫敏捷",
  "Improved Aspect of the Cheetah": "强化猎豹守护",
  "Improved Aspect of the Turtle": "强化灵龟守护",
  "Improved Feign Death": "强化假死",
  "Guttural Roar": "低沉咆哮",
  "Void Suffusion": "虚空弥散",
  "Molten Wrath": "熔岩之怒",
  "Storm Infusion": "风暴灌注",
  "Elemental Resonance": "元素共鸣",
  "Tectonic Collapse": "大地坍缩",
  "Raptor Swipe": "猛禽横扫",
  "Inferno Arc": "炼狱弧光",
  "Duplicate": "复制",
  "Predator's Wake": "掠食者尾迹",
  "Find an Opening": "洞察先机",
  "Heightened Rush": "亢奋之血",
  "Grand Melee": "大乱斗",
  "Purging Flames": "净化烈焰",
  "Fast Action": "迅捷行动",
  "Dragon-Bone Dice": "龙骨骰子",
  "Zero In": "锁定",
  "Flickering Steel": "闪烁钢铁",
  "Expert Duelist": "专家决斗者",
  "Crescendo of Violence": "暴戾狂潮",
  "Deadly Pursuit": "致命追击",
  "Practiced Pestilence": "娴熟疫疾",
  "Potent Soul Shards": "强力的灵魂碎片",
  "Shared Agony": "苦痛共享",
  "Seeds of Destruction": "毁灭之种",
  "Cull the Weak": "恃强凌弱",
  "Grim Focus": "冷酷专注",
  "Sudden Onset": "钻心剧痛",
  "Fatal Echoes": "致命回响",
  "Shard Instability": "碎片动荡",
  "Nocturnal Yield": "幽影蒙福",
  "Ashes of Inspiration": "灵感灰烬",
  "Lesser Time Warp": "弱效时间扭曲",
  "Patient Zero": "零号病患",
  "Divine Exaction": "神圣之征",
  "Chronoboon": "时光赐福",
  "Spiritfont": "灵泉",
  "Spellfire Salvo": "咒焰齐射",
  "Elevated Stagger": "强化醉拳",
  "Totemic Momentum": "图腾势能",
  "Overclock": "超频",
  "Pyrocosm": "烬灭寰宇",
  "Command Squadron": "特遣动员",
  "Primal Catalyst": "原始催化",
  "Brute Force": "野蛮之力",
  "Efficiency": "高超效率",
  "Just Warming Up": "战前热身",
  "Broad Strokes": "广域打击",
  "Powerful Momentum": "奔战之姿",
  "Tactical Edge": "战术优势",
  "Crushing Combo": "粉碎连击",
  "Master Tactician": "战术大师",
  "Infused Splinters": "注能碎片",
  "Polished Focus": "磨砺专注",
  "Attuned Familiar": "调和使者",
  "Light Within": "内在之光",
  "Cascading Calamity": "灾难瀑流",
  "Malefic Grasp": "灾难之握",
  "Boomstick": "爆裂火铳",
  "Wildfire Shells": "野火弹药",
  "Refined Essence": "提炼精华",
  "Light's Judicator": "圣光执行官",
  "Ascendant Eclipses": "蚀相升格",
  "Entropy": "熵灭",
  "Tigereye Brew": "虎眼酒",
  "Shadow of Nathreza": "纳斯雷萨之影",
  "Fuel on the Fire": "火上浇油",
  "Gift of the Wild": "野性赐福",
  "Empty the Cellar": "清空地窖",
  "Jade Flash": "青翠玉闪",
  "Lethal Calibration": "致命校准",
  "Bonding": "野兽之心",
  "Stand Ready": "准备就绪",
  "Weapons of the Wall": "城壁兵械",
  "Shado Over the Battlefield": "战场隐踪",
  "Awakening Spirit": "觉醒之魂",
  "Thunder Capacitor": "雷霆容蓄",
  "Vital Flame": "生命之焰",
  "Yu'lon's Avatar": "玉珑化身",
  "Flowing Wisdom": "流转之智",
  "Benediction": "祈福",
  "Stampede of the Ancients": "远古奔踏",
  "Duality": "成双成对",
  "Molten Chill": "熔融寒意",
  "Elemental Conduit": "元素导能",
  "Potent Healing Potion": "强效治疗药水",
  "Hand of Frost": "寒冰之手",
  "Amani Extract": "阿曼尼提取物",
  "Heart of the Ox": "玄牛之心",
  "Seal of the Templar": "圣殿骑士圣印",
  "Elemental Attunement": "元素协调",
  "Swift as a Coursing River": "利涉大川",
  "Celestial Flames": "天神烈焰",
  "Abomination Limb": "憎恶附肢",
  "Unseen Predator": "隐秘捕食者",
  "Blood Mist": "血腥之雾",
  "Sanguinary Burst": "血腥爆裂",
  "Walk Into Light": "向光而行",
  "Endless Gleam": "无尽辉光",
  "Nature's Bounty": "自然的慷慨",
  "Born in Sunlight": "诞于日光",
  "Fel Armaments": "邪能装备",
  "Infernal Rapidity": "迅捷狱火",
  "Void Apparitions": "虚空幻灵",
  "Deadly Reach": "致命延伸",
  "Legacy of the Lifebinder": "生命缚誓者的传承",
  "Corpsecaller": "唤尸者",
  "Wailing Dead": "哀嚎死者",
  "Blighted Quiver": "枯萎箭袋",
  "Lifeblood": "生命之血",
  "Deep Exhalation": "深层吐息",
  "Devastating Focus": "毁灭专注",
  "Dark Minion": "黑暗爪牙",
  "Dance of Midnight": "午夜舞步",
  "Shoot": "射击",
  "Wild Thrash": "狂野鞭笞",
  "Blighted Arrow": "枯萎箭矢",
  "Ashes in Motion": "飞灰流转",
  "Unravel": "拆解",
  "Lashe Macabre": "断魂刃舞",
  "Sylvan Beckoning": "森野感召",
  "Intensity": "强效",
  "Descending Skies": "天穹崩落",
  "Pact of the Hollow": "空洞契约",
  "Natural Gift": "自然赠礼",
  "Stormwell": "风暴之井",
  "Shuriken Tornado": "袖剑旋风",
  "Sharpened Fangs": "尖锐獠牙",
  "Dryad's Dance": "树妖之舞",
  "Lethal Barbs": "致命倒钩",
  "Wyvern's Gaze": "双足飞龙之视",
  "Hoof and Blade": "铁蹄利刃",
  "Spirit of the Thicket": "林地仙灵",
  "Moonlight Chakram": "月光战轮",
  "Radiant Edge": "光耀之锋",
  "Twilight Requiem": "暮光安魂曲",
  "Cosmic Crescendo": "宇宙潮音",
  "Cosmic Hymn": "宇宙圣歌",
  "Jagged Wounds": "锯齿创伤",
  "Razor Sharp": "嗜血利齿",
  "Bring Me Another": "再来一桶",
  "Empty Barrel": "空酒桶",
  "Ragedrinker": "啜饮怒火",
  "Rampaging Ruin": "暴怒毁灭",
  "Surge of Adrenaline": "蛮力爆发",
  "Kill or Be Killed": "生死决战",
  "Implacable": "无赦",
  "Permafrost Bauble": "永冻缀饰",
  "Fear No Evil": "不惧妖邪",
  "Thrill of Blood": "血腥刺激",
  "Brought to Light": "皈依圣光",
  "Executioner's Wrath": "处决者的愤怒",
  "Transfusion": "鲜血灌注",
  "Chosen of Frostbrood": "霜巢之眷",
  "Embers of Nihilam": "奈兰之烬",
  "Boiling Point": "沸点",
  "Blight of Weakness": "虚弱灾厄",
  "Tempered Steel": "淬炼钢铁",
  "Frequent Traveler": "旅行常客",
  "Shattering Stars": "碎裂星辰",
  "Shattering Star": "碎裂星辰",
  "Infernal Beneficiary": "狱火之益",
  "Foul Mouth": "邪污巨口",
  "Improved Mortal Coil": "强化死亡缠绕",
  "Vengeful Beast": "复仇凶兽",
  "Star Salvo": "星辰齐射",
  "Echoing Fury": "回响狂怒",
  "Frigid Resolve": "冷冽决心",
  "Gravedigger": "掘墓者",
  "Azure Sweep": "碧蓝横扫",
  "Plague Infusion": "瘟疫灌注",
  "Deathly Blows": "致命打击",
  "Let Terror Reign": "恐惧之治",
  "Potent Powder": "强效火药",
  "Ride or Die!": "生死驰骋",
  "Unholy Armaments": "邪恶军备",
  "Twin Flame": "孪生烈焰",
  "Fire Torrent": "烈火洪流",
  "Essence Well": "精华之泉",
  "Stalk and Strike": "潜隐突袭",
  "Strafing Run": "掠空扫射",
  "Focused Ire": "凝神之怒",
  "Fanatical Inspiration": "狂热灵感",
  "Burn It Out": "幽焰祛除",
  "Furious": "狂怒",
  "Remorseless": "无悯",
  "Demon Muzzle": "恶魔笼头",
  "Soul Splitter": "灵魂分裂者",
  "Wings of Wrath": "盛怒之翼",
  "Soul Cleanse": "灵魂净化",
  "First In, Last Out": "陷阵殿后",
  "Final Breath": "终结吐息",
  "Silent Sanctuary": "静谧圣所",
  "Stillstep Coil": "盘蛇静步",
  "Serene Surge": "静水奔流",
  "Vital Clarity": "心神澄明",
  "Felbound": "邪能束缚",
  "Through the Felvine": "邪蔓穿行",
  "Alzzin's Iniquity": "奥兹恩的罪孽",
  "Devil Fruit": "恶魔果实",
  "Mist Caller": "召雾者",
  "Death Defiance": "违抗死亡",
  "Death Notes": "死亡笔记",
  "Quickened Pulse": "加速脉冲",
  "Touch of the Void": "虚空之触",
  "Overwhelming Shadows": "暗影压制",
  "Precision Strikes": "精准打击",
  "Stormstream Totem": "风暴涌流图腾",
  "Blood Bond": "鲜血羁绊",
  "Toxic Stiletto": "剧毒短匕",
  "Glory of the Vanguard": "先锋军荣耀",
  "Strike from Above": "凌空突袭",
  "Quick Fingers": "迅捷之手",
  "Deep Cuts": "深可见骨",
  "Shell Wall": "甲壳壁垒",
  "Danger Sense": "危险感知",
  "Cold Feet": "临阵畏缩",
  "Stormswell": "风暴激荡",
  "Masterful Call": "娴熟召唤",
  "Diabolic Oculi": "天魔邪眼",
  "Looks That Kill": "致命凝视",
  "Mind's Eyes": "心灵之眼",
  "Emperor's Elixir": "皇帝琼浆",
  "Misty Coalescence": "凝雾汇涌",
  "Improved Snaring": "强化诱捕",
  "Combat Experience": "实战经验",
  "Improved Defy Fate": "强化驳斥命运",
  "Manifested Avarice": "具现贪欲",
  "Shared Vessel": "共享容器",
  "Eternal Hunger": "无尽饥渴",
  "Crackling Fury": "爆裂狂怒",
  "Master of Warfare": "战争大师",
  "Rampaging Berserker": "怒火狂战",
  "Phalanx": "英武方阵",
  "Amped Up": "能量超载",
  "Path of the Seer": "先知之路",
  "Heroic Strike": "英勇打击",
  "Wild Guardian": "荒野守护者",
  "Feedback Loop": "反馈连锁",
  "Oppressive Darkness": "窒息之暗",
  "Instinctive Imbuements": "本能灌注",
  "Spiritual Awakening": "魂之启迪",
  "Untethered Rage": "无羁邪怒",
  "Ancestral Influence": "先祖加持",
  "Windspeaker": "风语者",
  "Mystic Knowledge": "灵性学识",
  "Green Thumb": "护花能手",
  "Rampancy": "恣意蔓生",
  "Patient Custodian": "恒久守护",
  "Tranquil Tea": "宁神茶",
  "Pact of the Nathrezim": "纳斯雷兹姆契约",
  "Pact of the Satyr": "萨特契约",
  "Pact of the Annihilan": "安尼赫兰契约",
  "Pact of the Eredar": "艾瑞达契约",
  "Gorefiend's Avarice": "血魔贪欲",
  "Decimator": "屠戮殆尽",
  "Cut to the Bone": "削肉剔骨",
  "Celeritous Conclusion": "凌厉终结",
  "Violent Euphoria": "狂烈快感",
  "Deadly Focus": "致命专注",
  "Conductivity": "导电",
  "Capacitance": "电容",
  "Improved Spellsteal": "强化法术吸取",
  "Reflection": "闪回",
  "Mana Confluence": "法力汇流",
  "Improved Remove Curse": "强化解除诅咒",
  "Improved Counterspell": "强化法术反制",
  "Captured Thoughts": "俘获思绪",
  "Eternal Hunt": "永恒追猎",
  "Divine Favor": "神恩术",
  "Seek Deliverance": "寻求超脱",
  "Potential Energy": "潜在能量",
  "Divine Overload": "神圣过载",
  "Earthen Accord": "大地之律",
  "Meditative Focus": "冥想专注",
  "Empowered Eye Beam": "强化眼棱",
  "Conflagration": "洪荒烈火",
  "Star Cascade": "星辰奔流",
  "Penumbral Swell": "半影汹潮",
  "Bask in Moonlight": "沐浴月光",
  "Masterwork": "大师杰作",
  "Amplified Rush": "强化突进",
  "Reflection of Radiance": "光辉映象",
  "Limb from Limb": "肢体撕裂",
  "Resounding Strike": "回响打击",
  "Twin Claw": "双重爪击",
  "Rising Fury": "冲天怒火",
  "Empowered Drain Life": "强化生命吸取",
  "Fortified Soul": "强韧灵魂",
  "Empowered Healthstone": "强化治疗石",
  "Risen Fury": "渐怒",
  "Blight of Tongues": "语言灾厄",
  "Exacerbating Wounds": "创伤加剧",
  "Fearless": "无所畏惧",
  "Field Dressing": "战场急救",
  "Javelineer": "破天投枪",
  "Blightfall": "瘟疫降临",
  "Guardian's Hide": "守护者之皮",
  "Thunderous Velocity": "雷霆急速",
  "Quick Reload": "迅捷装填",
  "Keen Edge": "利刃",
  "Twin Fangs": "双生利牙",
  "Broken Spirit": "碎裂精魂",
  "Bladecraft": "利刃之艺",
  "Primal Surge": "原初涌动",
  "Universal Energy": "宇宙能量",
  "Energy Conservation": "能量储备",
  "Focused Outburst": "专注爆发",
  "Realized Potential": "成真的潜力",
  "Words of the Wise": "睿智之语",
  "Prophet's Insight": "预言者的洞察",
  "Unfolding Vision": "展开视界",
  "Blind Focus": "盲眼专注",
  "Sunfire Spiral": "阳炎螺旋",
  "Voidrush": "虚空奔涌",
  "Soulforged Blades": "灵魂锻刃",
  "Chi Transfer": "真气转移",
  "Volatile Instinct": "暴烈本能",
  "Extra Kick": "烈酒连踢",
  "Weapon of Wind": "风之武器",
  "Martial Agility": "尚武敏捷",
  "Zenith Stomp": "乾元镇踏",
  "Singular Strikes": "奇点斩击",
  "Tiger Fang": "猛虎之牙",
  "Improved Consume": "强化吞噬",
  "Wisdom of the Wall": "城壁之智",
  "Singed Spirit": "灼烧灵魂",
  "Umbral Blade": "晦暗之刃",
  "Combat Stance": "作战姿态",
  "Gift of the Void": "虚空之赐",
  "Initiator's Edge": "意到锋至",
  "Precise Killer": "精准杀手",
  "Quietus Celeris": "迅速寂灭",
  "Mass Casualty": "绝命屠戮",
  "Nature's Ally": "自然之友",
  "Martial Prowess": "武技神威",
  "Mass Execution": "全面处决",
  "Take Aim": "凝神瞄准",
  "Path of the Falling Star": "流星轨迹",
  "Raptor Swipe!": "猛禽横扫！",
  "Lava Flows": "熔岩涌流",
  "Dominion of Argus": "阿古斯支配",
  "Dominant Hand": "支配之手",
  "Grimoire: Imp Lord": "魔典：小鬼领主",
  "Grimoire: Fel Ravager": "魔典：邪能破坏者",
  "Explosion of the Soul": "灵魂爆炸",
  "Hoodwink": "欺瞒",
  "Flashing Steel": "闪刃",
  "Stabilized Portals": "稳定传送门",
  "Clever Combatant": "灵巧争斗者",
  "Tyrant's Oblation": "暴君的献祭",
  "Reign of Tyranny": "暴君统治",
  "Ravenholdt Mint": "拉文霍德薄荷糖",
  "Controlled Chaos": "约束混沌",
  "Imbued Shield": "灌魔盾牌",
  "Blighted Maw": "凋零巨口",
  "Adjudication": "裁定",
  "Sometimes Lucky": "时至运来",
  "Instrument of the Divine": "圣裁之器",
  "Morning Breeze": "晨风拂露",
  "Armory of Light": "圣光神兵",
  "Chi Warding": "真气结界",
  "Voidlust": "虚空欲望",
  "Focus Fire": "集中火力",
  "Unload": "火力倾泻",
  "Through the Eyes": "千里猎目",
  "Critical Precision": "透颅穿心",
  "Demonic Wards": "恶魔结界",
  "Preparation": "伺机待发",
  "Natural Resilience": "自然韧性",
  "Dream Guide": "梦境向导",
  "Harness the Cosmos": "掌驭宇宙",
  "Invoked Nightmare": "被唤起的梦魇",
  "Maddening Tentacles": "疯狂触须",
  "Crushing Void": "碾压虚空",
  "Haunting Shadows": "捕风捉影",
  "Improved Secret Technique": "强化影分身",
  "Niskaran Methods": "尼斯卡兰术法",
  "Eye Contract": "邪眼契约",
  "Empowered Felstorm": "强化邪能风暴",
  "Bloody Reflection": "鲜血反射",
  "Primordial Bond": "始源羁绊",
  "Searing Light": "灼热之光",
  "Augury Abounds": "满目征兆",
  "Mistline": "灵雾通径",
  "Panther's Guile": "黑豹的诡计",
  "Inferno": "地狱火",
  "Inevitable": "无法阻挡",
  "Nether Plating": "虚空铠甲",
  "Glacial Chill": "冰川之寒",
  "Glacial Shatter": "冰川粉碎",
  "Dimensional Rift": "次元裂隙",
  "Stance Mastery": "姿态掌握",
  "Umbral Edge": "幽影之锋",
  "To Hell and Back": "地狱一游",
  "White Out": "雪茫危机",
  "Holy Armaments": "神圣军备",
  "Cycle of Death": "死亡轮回",
  "Mighty Inferno": "强盛狱火",
  "Chronal Dynamo": "时空发电机",
  "Temporal Barrier": "时光屏障",
  "Negotiable Contract": "可协商契约",
  "Sanguine Vial": "嗜血之瓶"
};
